// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 2.7.1 (commit 8ecd3c3bac427a49a9d9b13671bf83324afa59ba).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import all reducer arg schemas
import AbandonDutyMissionReducer from "./abandon_duty_mission_reducer";
import AbandonGroundContractReducer from "./abandon_ground_contract_reducer";
import AbandonMissionReducer from "./abandon_mission_reducer";
import AbandonResearchTenderReducer from "./abandon_research_tender_reducer";
import AbandonWarSupplyReducer from "./abandon_war_supply_reducer";
import AbortTravelReducer from "./abort_travel_reducer";
import AcceptCourierContractReducer from "./accept_courier_contract_reducer";
import AcceptFavorReducer from "./accept_favor_reducer";
import AcceptResearchTenderReducer from "./accept_research_tender_reducer";
import AcceptStationServiceReducer from "./accept_station_service_reducer";
import AddBookmarkReducer from "./add_bookmark_reducer";
import AddForgeInstanceReducer from "./add_forge_instance_reducer";
import AddMemoryEntryReducer from "./add_memory_entry_reducer";
import AddRenderAssetTextureTierReducer from "./add_render_asset_texture_tier_reducer";
import AddRenderAssetVariantReducer from "./add_render_asset_variant_reducer";
import AdminDeleteObjectReducer from "./admin_delete_object_reducer";
import AdminPlaceObjectReducer from "./admin_place_object_reducer";
import AdminTransformObjectReducer from "./admin_transform_object_reducer";
import AdvanceFactionArcReducer from "./advance_faction_arc_reducer";
import AdvanceOnboardingReducer from "./advance_onboarding_reducer";
import AirSupportKillReducer from "./air_support_kill_reducer";
import AmbushKillReducer from "./ambush_kill_reducer";
import AnswerGroundWarReducer from "./answer_ground_war_reducer";
import AnswerGuildApplicationReducer from "./answer_guild_application_reducer";
import ApologizeToVersonaReducer from "./apologize_to_versona_reducer";
import AppealQuarantineReducer from "./appeal_quarantine_reducer";
import ApplyForLoanReducer from "./apply_for_loan_reducer";
import ApplyToGuildReducer from "./apply_to_guild_reducer";
import ApproachMerchantReducer from "./approach_merchant_reducer";
import ArchiveEphemeralWorldReducer from "./archive_ephemeral_world_reducer";
import ArenaLeaveReducer from "./arena_leave_reducer";
import ArenaQueueJoinReducer from "./arena_queue_join_reducer";
import ArenaQueueLeaveReducer from "./arena_queue_leave_reducer";
import ArenaReadyReducer from "./arena_ready_reducer";
import AscendToSpaceReducer from "./ascend_to_space_reducer";
import AssignGuildJobReducer from "./assign_guild_job_reducer";
import AssignVersonaToCityReducer from "./assign_versona_to_city_reducer";
import AttachScriptReducer from "./attach_script_reducer";
import AttackSpaceStructureReducer from "./attack_space_structure_reducer";
import AuthBumpEpochReducer from "./auth_bump_epoch_reducer";
import AuthClaimReducer from "./auth_claim_reducer";
import AuthRecordFailureReducer from "./auth_record_failure_reducer";
import AuthRecordSuccessReducer from "./auth_record_success_reducer";
import AuthRegisterReducer from "./auth_register_reducer";
import AuthSetRecoveryReducer from "./auth_set_recovery_reducer";
import AuthSetResetReducer from "./auth_set_reset_reducer";
import AuthSetSecretReducer from "./auth_set_secret_reducer";
import BackfillMatchReducer from "./backfill_match_reducer";
import BankDepositReducer from "./bank_deposit_reducer";
import BankTransferReducer from "./bank_transfer_reducer";
import BankWithdrawReducer from "./bank_withdraw_reducer";
import BeginUploadReducer from "./begin_upload_reducer";
import BlockPlayerReducer from "./block_player_reducer";
import BoardShipReducer from "./board_ship_reducer";
import BoardTurretReducer from "./board_turret_reducer";
import BountyHunterHitReducer from "./bounty_hunter_hit_reducer";
import BountyHunterWindupReducer from "./bounty_hunter_windup_reducer";
import BountyHunterWonReducer from "./bounty_hunter_won_reducer";
import BountyReportShelterReducer from "./bounty_report_shelter_reducer";
import BoxStoreItemReducer from "./box_store_item_reducer";
import BoxStoreStackReducer from "./box_store_stack_reducer";
import BoxTakeReducer from "./box_take_reducer";
import BreakTermDepositReducer from "./break_term_deposit_reducer";
import BridgeAssetReducer from "./bridge_asset_reducer";
import BrokerReunificationReducer from "./broker_reunification_reducer";
import BuyAbyssalFilamentReducer from "./buy_abyssal_filament_reducer";
import BuyFromDroidReducer from "./buy_from_droid_reducer";
import BuyFurnishPackReducer from "./buy_furnish_pack_reducer";
import BuyGamePassReducer from "./buy_game_pass_reducer";
import BuyHereReducer from "./buy_here_reducer";
import BuyIntelLicenceReducer from "./buy_intel_licence_reducer";
import BuyListingReducer from "./buy_listing_reducer";
import BuyListing2Reducer from "./buy_listing_2_reducer";
import BuyMerchantListingReducer from "./buy_merchant_listing_reducer";
import BuyRepoLotReducer from "./buy_repo_lot_reducer";
import BuySchematicReducer from "./buy_schematic_reducer";
import BuyShipReducer from "./buy_ship_reducer";
import BuyTicketReducer from "./buy_ticket_reducer";
import BuyVersonaListingReducer from "./buy_versona_listing_reducer";
import CampaignKillReducer from "./campaign_kill_reducer";
import CancelCourierContractReducer from "./cancel_courier_contract_reducer";
import CancelFabJobReducer from "./cancel_fab_job_reducer";
import CancelFreelanceProjectReducer from "./cancel_freelance_project_reducer";
import CancelGroundContractReducer from "./cancel_ground_contract_reducer";
import CancelGuildOrderReducer from "./cancel_guild_order_reducer";
import CancelListingReducer from "./cancel_listing_reducer";
import CancelMarketOrderReducer from "./cancel_market_order_reducer";
import CancelPlayerBountyReducer from "./cancel_player_bounty_reducer";
import CancelShipRepairReducer from "./cancel_ship_repair_reducer";
import CancelSpaceOperationReducer from "./cancel_space_operation_reducer";
import CancelStationServiceReducer from "./cancel_station_service_reducer";
import CarryCampaignMessageReducer from "./carry_campaign_message_reducer";
import CastCityFederalVoteReducer from "./cast_city_federal_vote_reducer";
import CastCivicVoteReducer from "./cast_civic_vote_reducer";
import CastCouncilVoteReducer from "./cast_council_vote_reducer";
import CastFederalPreferenceReducer from "./cast_federal_preference_reducer";
import CastGuildVoteReducer from "./cast_guild_vote_reducer";
import CastLineReducer from "./cast_line_reducer";
import CastMayorPreferenceReducer from "./cast_mayor_preference_reducer";
import ChallengeCharterReducer from "./challenge_charter_reducer";
import ChangeDisplayNameReducer from "./change_display_name_reducer";
import ChargeSubscriptionsReducer from "./charge_subscriptions_reducer";
import ChargebackEscrowReducer from "./chargeback_escrow_reducer";
import CharterCityBankReducer from "./charter_city_bank_reducer";
import CheckInReducer from "./check_in_reducer";
import CityBankProfitReducer from "./city_bank_profit_reducer";
import ClaimAbyssalRoomReducer from "./claim_abyssal_room_reducer";
import ClaimDailyPulseRewardReducer from "./claim_daily_pulse_reward_reducer";
import ClaimDutyMissionReducer from "./claim_duty_mission_reducer";
import ClaimFreelanceKillsReducer from "./claim_freelance_kills_reducer";
import ClearFurnishPackReducer from "./clear_furnish_pack_reducer";
import CloseCityBankReducer from "./close_city_bank_reducer";
import CloseConflictSectorReducer from "./close_conflict_sector_reducer";
import CloseMayorElectionReducer from "./close_mayor_election_reducer";
import CloseVoiceRoomReducer from "./close_voice_room_reducer";
import CollectExtractorReducer from "./collect_extractor_reducer";
import CollectFabJobReducer from "./collect_fab_job_reducer";
import CollectGuildLotsReducer from "./collect_guild_lots_reducer";
import CollectGuildStoreReducer from "./collect_guild_store_reducer";
import CollectMoonChunkReducer from "./collect_moon_chunk_reducer";
import CollectParcelReducer from "./collect_parcel_reducer";
import CompileContractReducer from "./compile_contract_reducer";
import CompileForgeReducer from "./compile_forge_reducer";
import CompileLuaContractReducer from "./compile_lua_contract_reducer";
import CompleteEscortReducer from "./complete_escort_reducer";
import CompleteMissionReducer from "./complete_mission_reducer";
import CompleteSafetyTutorialReducer from "./complete_safety_tutorial_reducer";
import CompleteStationServiceReducer from "./complete_station_service_reducer";
import CompleteTravelReducer from "./complete_travel_reducer";
import CompleteWarBannerReducer from "./complete_war_banner_reducer";
import ConverseWithVersonaReducer from "./converse_with_versona_reducer";
import CouncilActReducer from "./council_act_reducer";
import CraftItemReducer from "./craft_item_reducer";
import CrashShipReducer from "./crash_ship_reducer";
import CreateAccountReducer from "./create_account_reducer";
import CreateAssetReducer from "./create_asset_reducer";
import CreateAudioZoneReducer from "./create_audio_zone_reducer";
import CreateCourierContractReducer from "./create_courier_contract_reducer";
import CreateEventReducer from "./create_event_reducer";
import CreateForgeProjectReducer from "./create_forge_project_reducer";
import CreateFreelanceProjectReducer from "./create_freelance_project_reducer";
import CreateGamePassReducer from "./create_game_pass_reducer";
import CreateGuildReducer from "./create_guild_reducer";
import CreateInviteReducer from "./create_invite_reducer";
import CreateVoiceRoomReducer from "./create_voice_room_reducer";
import CreateWaypointReducer from "./create_waypoint_reducer";
import CrewAcceptReducer from "./crew_accept_reducer";
import CrewDeclineReducer from "./crew_decline_reducer";
import CrewInviteReducer from "./crew_invite_reducer";
import CrewReleaseReducer from "./crew_release_reducer";
import CrewRevokeReducer from "./crew_revoke_reducer";
import CrewRoutePowerReducer from "./crew_route_power_reducer";
import DebugAddCitizenReducer from "./debug_add_citizen_reducer";
import DebugAddVersonaResidentReducer from "./debug_add_versona_resident_reducer";
import DebugAdminGrantSovReducer from "./debug_admin_grant_sov_reducer";
import DebugAdvanceReceiptsReducer from "./debug_advance_receipts_reducer";
import DebugAgeAmbushReducer from "./debug_age_ambush_reducer";
import DebugAgeBattleReducer from "./debug_age_battle_reducer";
import DebugAgeBountyTakesReducer from "./debug_age_bounty_takes_reducer";
import DebugAgeDenReducer from "./debug_age_den_reducer";
import DebugAgeDenSlotReducer from "./debug_age_den_slot_reducer";
import DebugAgeDepotReducer from "./debug_age_depot_reducer";
import DebugAgeExpeditionLogReducer from "./debug_age_expedition_log_reducer";
import DebugAgeFabJobReducer from "./debug_age_fab_job_reducer";
import DebugAgeFederalReducer from "./debug_age_federal_reducer";
import DebugAgeGroundContractReducer from "./debug_age_ground_contract_reducer";
import DebugAgeHaulReducer from "./debug_age_haul_reducer";
import DebugAgeIntelReducer from "./debug_age_intel_reducer";
import DebugAgeLodReducer from "./debug_age_lod_reducer";
import DebugAgePairReducer from "./debug_age_pair_reducer";
import DebugAgePlanterReducer from "./debug_age_planter_reducer";
import DebugAgePostReducer from "./debug_age_post_reducer";
import DebugAgeServiceJobReducer from "./debug_age_service_job_reducer";
import DebugAgeShipmentReducer from "./debug_age_shipment_reducer";
import DebugAgeTravelReducer from "./debug_age_travel_reducer";
import DebugAgeWarSupplyReducer from "./debug_age_war_supply_reducer";
import DebugAirExchangeReducer from "./debug_air_exchange_reducer";
import DebugBackdateBountyReducer from "./debug_backdate_bounty_reducer";
import DebugBackdateCaseReducer from "./debug_backdate_case_reducer";
import DebugBackdateCharterVoteReducer from "./debug_backdate_charter_vote_reducer";
import DebugBackdateChroniclerReducer from "./debug_backdate_chronicler_reducer";
import DebugBackdateCityReducer from "./debug_backdate_city_reducer";
import DebugBackdateElectionReducer from "./debug_backdate_election_reducer";
import DebugBackdateEscrowReducer from "./debug_backdate_escrow_reducer";
import DebugBackdateExtractorReducer from "./debug_backdate_extractor_reducer";
import DebugBackdateGroupReviewReducer from "./debug_backdate_group_review_reducer";
import DebugBackdateLastSeenReducer from "./debug_backdate_last_seen_reducer";
import DebugBackdateOnboardingReducer from "./debug_backdate_onboarding_reducer";
import DebugBackdateOrbitReducer from "./debug_backdate_orbit_reducer";
import DebugBackdatePulseReducer from "./debug_backdate_pulse_reducer";
import DebugBackdateRaceReducer from "./debug_backdate_race_reducer";
import DebugBackdateSessionReducer from "./debug_backdate_session_reducer";
import DebugBackdateSettlementReducer from "./debug_backdate_settlement_reducer";
import DebugBackdateSkyReducer from "./debug_backdate_sky_reducer";
import DebugBackdateSocialReducer from "./debug_backdate_social_reducer";
import DebugBackdateStructureMaintReducer from "./debug_backdate_structure_maint_reducer";
import DebugBackdateSubscriptionReducer from "./debug_backdate_subscription_reducer";
import DebugBackdateTicketReducer from "./debug_backdate_ticket_reducer";
import DebugBackdateWarReducer from "./debug_backdate_war_reducer";
import DebugBackdateWorldCreatedReducer from "./debug_backdate_world_created_reducer";
import DebugBankAgeReducer from "./debug_bank_age_reducer";
import DebugBankAgeRepoReducer from "./debug_bank_age_repo_reducer";
import DebugBankSweepReducer from "./debug_bank_sweep_reducer";
import DebugBankWriteOffReducer from "./debug_bank_write_off_reducer";
import DebugBattleAdviseReducer from "./debug_battle_advise_reducer";
import DebugBattleMusterReducer from "./debug_battle_muster_reducer";
import DebugBattleRoundsReducer from "./debug_battle_rounds_reducer";
import DebugBattleWithdrawReducer from "./debug_battle_withdraw_reducer";
import DebugBattleWoundReducer from "./debug_battle_wound_reducer";
import DebugBountyInspectReducer from "./debug_bounty_inspect_reducer";
import DebugBountyNudgeReducer from "./debug_bounty_nudge_reducer";
import DebugBumpCheckedInCountReducer from "./debug_bump_checked_in_count_reducer";
import DebugBumpSequencesReducer from "./debug_bump_sequences_reducer";
import DebugCampaignAgeReducer from "./debug_campaign_age_reducer";
import DebugCampaignDeleteReducer from "./debug_campaign_delete_reducer";
import DebugCampaignOpenReducer from "./debug_campaign_open_reducer";
import DebugCampaignReopenReducer from "./debug_campaign_reopen_reducer";
import DebugCampaignResolveReducer from "./debug_campaign_resolve_reducer";
import DebugCampaignSandboxReducer from "./debug_campaign_sandbox_reducer";
import DebugCampaignSetAliveReducer from "./debug_campaign_set_alive_reducer";
import DebugCampaignSetEscortsReducer from "./debug_campaign_set_escorts_reducer";
import DebugCampaignSetStanceReducer from "./debug_campaign_set_stance_reducer";
import DebugCampaignStepReducer from "./debug_campaign_step_reducer";
import DebugCampaignSweepReducer from "./debug_campaign_sweep_reducer";
import DebugCampaignUnsettleReducer from "./debug_campaign_unsettle_reducer";
import DebugCertifyReducer from "./debug_certify_reducer";
import DebugCharterVersonaGuildReducer from "./debug_charter_versona_guild_reducer";
import DebugClearAffectReducer from "./debug_clear_affect_reducer";
import DebugClearDroidLoadReducer from "./debug_clear_droid_load_reducer";
import DebugClearInventoryReducer from "./debug_clear_inventory_reducer";
import DebugClearSeededWorldsReducer from "./debug_clear_seeded_worlds_reducer";
import DebugCloseGuildElectionReducer from "./debug_close_guild_election_reducer";
import DebugCorruptContractBytecodeReducer from "./debug_corrupt_contract_bytecode_reducer";
import DebugCorruptForgeArtifactReducer from "./debug_corrupt_forge_artifact_reducer";
import DebugCorruptForgeBuildReducer from "./debug_corrupt_forge_build_reducer";
import DebugCorruptRanksReducer from "./debug_corrupt_ranks_reducer";
import DebugDespawnCreaturesReducer from "./debug_despawn_creatures_reducer";
import DebugDisbandCityReducer from "./debug_disband_city_reducer";
import DebugDissolveGuildReducer from "./debug_dissolve_guild_reducer";
import DebugDissolveUnionReducer from "./debug_dissolve_union_reducer";
import DebugDissolveVersonaGuildReducer from "./debug_dissolve_versona_guild_reducer";
import DebugDownConvoyReducer from "./debug_down_convoy_reducer";
import DebugDownWarAirReducer from "./debug_down_war_air_reducer";
import DebugDroidAdvanceReducer from "./debug_droid_advance_reducer";
import DebugDroidCorruptReducer from "./debug_droid_corrupt_reducer";
import DebugDroidDamageReducer from "./debug_droid_damage_reducer";
import DebugElicitEmotionReducer from "./debug_elicit_emotion_reducer";
import DebugEndEventReducer from "./debug_end_event_reducer";
import DebugEngineeringAgeReducer from "./debug_engineering_age_reducer";
import DebugEnterSpaceReducer from "./debug_enter_space_reducer";
import DebugEquipVersonaReducer from "./debug_equip_versona_reducer";
import DebugEscortSampleReducer from "./debug_escort_sample_reducer";
import DebugEwResetReducer from "./debug_ew_reset_reducer";
import DebugEwSweepReducer from "./debug_ew_sweep_reducer";
import DebugExpireAbyssalReducer from "./debug_expire_abyssal_reducer";
import DebugExpireMerchantLotReducer from "./debug_expire_merchant_lot_reducer";
import DebugExpirePlayerBountyReducer from "./debug_expire_player_bounty_reducer";
import DebugFeedReservesReducer from "./debug_feed_reserves_reducer";
import DebugFestivalAttendReducer from "./debug_festival_attend_reducer";
import DebugFinishTrainingReducer from "./debug_finish_training_reducer";
import DebugFishBiteReducer from "./debug_fish_bite_reducer";
import DebugFootprintProbeReducer from "./debug_footprint_probe_reducer";
import DebugForceApprenticeReducer from "./debug_force_apprentice_reducer";
import DebugForceBattleReducer from "./debug_force_battle_reducer";
import DebugForceBirthReducer from "./debug_force_birth_reducer";
import DebugForceBountyReducer from "./debug_force_bounty_reducer";
import DebugForceCaravanReducer from "./debug_force_caravan_reducer";
import DebugForceCargoConvoyReducer from "./debug_force_cargo_convoy_reducer";
import DebugForceCivicSweepReducer from "./debug_force_civic_sweep_reducer";
import DebugForceClashReducer from "./debug_force_clash_reducer";
import DebugForceColonyReducer from "./debug_force_colony_reducer";
import DebugForceCongressReducer from "./debug_force_congress_reducer";
import DebugForceCrierReducer from "./debug_force_crier_reducer";
import DebugForceDeliberationReducer from "./debug_force_deliberation_reducer";
import DebugForceDiplomacyReducer from "./debug_force_diplomacy_reducer";
import DebugForceFeastReducer from "./debug_force_feast_reducer";
import DebugForceFederalSessionReducer from "./debug_force_federal_session_reducer";
import DebugForceGossipReducer from "./debug_force_gossip_reducer";
import DebugForceGuildmasterReducer from "./debug_force_guildmaster_reducer";
import DebugForceIntroduceReducer from "./debug_force_introduce_reducer";
import DebugForceLegendNightReducer from "./debug_force_legend_night_reducer";
import DebugForceMarketDayReducer from "./debug_force_market_day_reducer";
import DebugForceMigrationReducer from "./debug_force_migration_reducer";
import DebugForceNaturalDeathReducer from "./debug_force_natural_death_reducer";
import DebugForcePersuadeReducer from "./debug_force_persuade_reducer";
import DebugForcePolitySweepReducer from "./debug_force_polity_sweep_reducer";
import DebugForceRentReducer from "./debug_force_rent_reducer";
import DebugForceRetrainReducer from "./debug_force_retrain_reducer";
import DebugForceRiteReducer from "./debug_force_rite_reducer";
import DebugForceRumorReducer from "./debug_force_rumor_reducer";
import DebugForceSlanderReducer from "./debug_force_slander_reducer";
import DebugForceSocietyDayReducer from "./debug_force_society_day_reducer";
import DebugForceSpyReducer from "./debug_force_spy_reducer";
import DebugForceTheftReducer from "./debug_force_theft_reducer";
import DebugForceTrialReducer from "./debug_force_trial_reducer";
import DebugForceTribunalScanReducer from "./debug_force_tribunal_scan_reducer";
import DebugForceUnionReducer from "./debug_force_union_reducer";
import DebugForceVersonaCraftReducer from "./debug_force_versona_craft_reducer";
import DebugForceWarCouncilReducer from "./debug_force_war_council_reducer";
import DebugForgetLaneLossesReducer from "./debug_forget_lane_losses_reducer";
import DebugForgetMemoryReducer from "./debug_forget_memory_reducer";
import DebugForgetSchematicReducer from "./debug_forget_schematic_reducer";
import DebugForgetStationsReducer from "./debug_forget_stations_reducer";
import DebugFoundVersonaGuildsReducer from "./debug_found_versona_guilds_reducer";
import DebugFundGuildReducer from "./debug_fund_guild_reducer";
import DebugFundTreasuryReducer from "./debug_fund_treasury_reducer";
import DebugGrantCargoReducer from "./debug_grant_cargo_reducer";
import DebugGrantCommonsAdminReducer from "./debug_grant_commons_admin_reducer";
import DebugGrantFabOreReducer from "./debug_grant_fab_ore_reducer";
import DebugGrantFirmOreReducer from "./debug_grant_firm_ore_reducer";
import DebugGrantInfReducer from "./debug_grant_inf_reducer";
import DebugGrantItemReducer from "./debug_grant_item_reducer";
import DebugGrantLotsReducer from "./debug_grant_lots_reducer";
import DebugGrantResourceReducer from "./debug_grant_resource_reducer";
import DebugGrantSchematicReducer from "./debug_grant_schematic_reducer";
import DebugGrantShipReducer from "./debug_grant_ship_reducer";
import DebugGrantSovReducer from "./debug_grant_sov_reducer";
import DebugGroundContractSweepReducer from "./debug_ground_contract_sweep_reducer";
import DebugGroundWarAgeReducer from "./debug_ground_war_age_reducer";
import DebugGuildAgeReducer from "./debug_guild_age_reducer";
import DebugGuildAgeHistoryReducer from "./debug_guild_age_history_reducer";
import DebugGuildSweepReducer from "./debug_guild_sweep_reducer";
import DebugGuildWorkTickReducer from "./debug_guild_work_tick_reducer";
import DebugIncursionSeedReducer from "./debug_incursion_seed_reducer";
import DebugIndoorBenchReducer from "./debug_indoor_bench_reducer";
import DebugIndoorSightReducer from "./debug_indoor_sight_reducer";
import DebugInjectEventReducer from "./debug_inject_event_reducer";
import DebugInjectRatingReducer from "./debug_inject_rating_reducer";
import DebugInjectReviewReducer from "./debug_inject_review_reducer";
import DebugInteriorAgeReducer from "./debug_interior_age_reducer";
import DebugInteriorRelationReducer from "./debug_interior_relation_reducer";
import DebugInteriorSweepReducer from "./debug_interior_sweep_reducer";
import DebugJourneymanReducer from "./debug_journeyman_reducer";
import DebugLapseHireReducer from "./debug_lapse_hire_reducer";
import DebugLodSweepReducer from "./debug_lod_sweep_reducer";
import DebugMarketSweepsReducer from "./debug_market_sweeps_reducer";
import DebugOfferFavorReducer from "./debug_offer_favor_reducer";
import DebugOpenCityBankReducer from "./debug_open_city_bank_reducer";
import DebugOpenElectionRaceReducer from "./debug_open_election_race_reducer";
import DebugOpsAgeExtractionReducer from "./debug_ops_age_extraction_reducer";
import DebugOpsDeleteReducer from "./debug_ops_delete_reducer";
import DebugOpsPinCampaignReducer from "./debug_ops_pin_campaign_reducer";
import DebugPortResetDrainReducer from "./debug_port_reset_drain_reducer";
import DebugPortTickReducer from "./debug_port_tick_reducer";
import DebugPostCustomerReducer from "./debug_post_customer_reducer";
import DebugPostWarSupplyReducer from "./debug_post_war_supply_reducer";
import DebugProfileDroidTickReducer from "./debug_profile_droid_tick_reducer";
import DebugProfileSimTickReducer from "./debug_profile_sim_tick_reducer";
import DebugProfileVersonaAiReducer from "./debug_profile_versona_ai_reducer";
import DebugPruneProjectPlacementsReducer from "./debug_prune_project_placements_reducer";
import DebugPruneWildStructuresReducer from "./debug_prune_wild_structures_reducer";
import DebugPvpBackdateReducer from "./debug_pvp_backdate_reducer";
import DebugQualifyLegacyReducer from "./debug_qualify_legacy_reducer";
import DebugRaceBackdateReducer from "./debug_race_backdate_reducer";
import DebugRaceScheduleReducer from "./debug_race_schedule_reducer";
import DebugReapOrphanCognitionReducer from "./debug_reap_orphan_cognition_reducer";
import DebugRecordMatchResultReducer from "./debug_record_match_result_reducer";
import DebugRefillWeaponFeedReducer from "./debug_refill_weapon_feed_reducer";
import DebugRemoveStructureReducer from "./debug_remove_structure_reducer";
import DebugRemoveSyntheticCitizensReducer from "./debug_remove_synthetic_citizens_reducer";
import DebugRentalAgeReducer from "./debug_rental_age_reducer";
import DebugRentalSweepReducer from "./debug_rental_sweep_reducer";
import DebugReplotGravesReducer from "./debug_replot_graves_reducer";
import DebugResetMysteryReducer from "./debug_reset_mystery_reducer";
import DebugResolveBattleAsReducer from "./debug_resolve_battle_as_reducer";
import DebugResolveFestivalReducer from "./debug_resolve_festival_reducer";
import DebugRevealSigReducer from "./debug_reveal_sig_reducer";
import DebugRoomPlanReducer from "./debug_room_plan_reducer";
import DebugRotateSpawnsReducer from "./debug_rotate_spawns_reducer";
import DebugSeedLowPulseReducer from "./debug_seed_low_pulse_reducer";
import DebugSeedSchismsReducer from "./debug_seed_schisms_reducer";
import DebugSeedVerifiedScoreReducer from "./debug_seed_verified_score_reducer";
import DebugSeedWorldsReducer from "./debug_seed_worlds_reducer";
import DebugSetAgentJobReducer from "./debug_set_agent_job_reducer";
import DebugSetAgentStatReducer from "./debug_set_agent_stat_reducer";
import DebugSetArcadeTabReducer from "./debug_set_arcade_tab_reducer";
import DebugSetBountyHunterHpReducer from "./debug_set_bounty_hunter_hp_reducer";
import DebugSetDelistedReducer from "./debug_set_delisted_reducer";
import DebugSetDenReducer from "./debug_set_den_reducer";
import DebugSetDepositReducer from "./debug_set_deposit_reducer";
import DebugSetFederalWarReducer from "./debug_set_federal_war_reducer";
import DebugSetFirmHullsReducer from "./debug_set_firm_hulls_reducer";
import DebugSetFirmSovReducer from "./debug_set_firm_sov_reducer";
import DebugSetFundReducer from "./debug_set_fund_reducer";
import DebugSetGoodwillReducer from "./debug_set_goodwill_reducer";
import DebugSetGrievanceReducer from "./debug_set_grievance_reducer";
import DebugSetGrudgeReducer from "./debug_set_grudge_reducer";
import DebugSetItemCountReducer from "./debug_set_item_count_reducer";
import DebugSetLeanReducer from "./debug_set_lean_reducer";
import DebugSetLiMaxReducer from "./debug_set_li_max_reducer";
import DebugSetMemoryReducer from "./debug_set_memory_reducer";
import DebugSetOccupationReducer from "./debug_set_occupation_reducer";
import DebugSetPairReducer from "./debug_set_pair_reducer";
import DebugSetPortCoinsReducer from "./debug_set_port_coins_reducer";
import DebugSetPortExportedReducer from "./debug_set_port_exported_reducer";
import DebugSetPortStateReducer from "./debug_set_port_state_reducer";
import DebugSetRatingReducer from "./debug_set_rating_reducer";
import DebugSetRelationReducer from "./debug_set_relation_reducer";
import DebugSetRelationForReducer from "./debug_set_relation_for_reducer";
import DebugSetReliefReducer from "./debug_set_relief_reducer";
import DebugSetReserveReducer from "./debug_set_reserve_reducer";
import DebugSetSessionResultReducer from "./debug_set_session_result_reducer";
import DebugSetShelfReducer from "./debug_set_shelf_reducer";
import DebugSetShipmentAmbushReducer from "./debug_set_shipment_ambush_reducer";
import DebugSetShipmentRollReducer from "./debug_set_shipment_roll_reducer";
import DebugSetSiegeReducer from "./debug_set_siege_reducer";
import DebugSetSkillReducer from "./debug_set_skill_reducer";
import DebugSetSkyCycleReducer from "./debug_set_sky_cycle_reducer";
import DebugSetSkyTimeReducer from "./debug_set_sky_time_reducer";
import DebugSetStanceReducer from "./debug_set_stance_reducer";
import DebugSetStandingReducer from "./debug_set_standing_reducer";
import DebugSetStandingForReducer from "./debug_set_standing_for_reducer";
import DebugSetSubsystemsReducer from "./debug_set_subsystems_reducer";
import DebugSetTownScoreReducer from "./debug_set_town_score_reducer";
import DebugSetTreatyReducer from "./debug_set_treaty_reducer";
import DebugSetTrustReducer from "./debug_set_trust_reducer";
import DebugSetVitalsReducer from "./debug_set_vitals_reducer";
import DebugSetWarPetitionReducer from "./debug_set_war_petition_reducer";
import DebugSetWorldSizeReducer from "./debug_set_world_size_reducer";
import DebugSetWorldTemplateReducer from "./debug_set_world_template_reducer";
import DebugSiteVersionReducer from "./debug_site_version_reducer";
import DebugSpaceAdviseReducer from "./debug_space_advise_reducer";
import DebugSpaceEconomyTickReducer from "./debug_space_economy_tick_reducer";
import DebugSpaceIntelSweepReducer from "./debug_space_intel_sweep_reducer";
import DebugSpaceOpsResetReducer from "./debug_space_ops_reset_reducer";
import DebugSpaceOpsSweepReducer from "./debug_space_ops_sweep_reducer";
import DebugSpaceOpsTickReducer from "./debug_space_ops_tick_reducer";
import DebugSpaceTeleportReducer from "./debug_space_teleport_reducer";
import DebugSpawnCreatureReducer from "./debug_spawn_creature_reducer";
import DebugSpawnDroidLoadReducer from "./debug_spawn_droid_load_reducer";
import DebugStageEventReducer from "./debug_stage_event_reducer";
import DebugStageFestivalReducer from "./debug_stage_festival_reducer";
import DebugStartBattleAtReducer from "./debug_start_battle_at_reducer";
import DebugStartJourneyReducer from "./debug_start_journey_reducer";
import DebugStartWarAtReducer from "./debug_start_war_at_reducer";
import DebugStationServiceSweepReducer from "./debug_station_service_sweep_reducer";
import DebugStockStallReducer from "./debug_stock_stall_reducer";
import DebugStrikeReducer from "./debug_strike_reducer";
import DebugSurveyAgeReducer from "./debug_survey_age_reducer";
import DebugSurveySweepReducer from "./debug_survey_sweep_reducer";
import DebugTeleportReducer from "./debug_teleport_reducer";
import DebugTeleportToVersonaReducer from "./debug_teleport_to_versona_reducer";
import DebugTradeSweepReducer from "./debug_trade_sweep_reducer";
import DebugVersonaGuildTickReducer from "./debug_versona_guild_tick_reducer";
import DebugVoiceAgeReducer from "./debug_voice_age_reducer";
import DebugVoiceSweepReducer from "./debug_voice_sweep_reducer";
import DebugWarAuthorityClearReducer from "./debug_war_authority_clear_reducer";
import DebugWarAuthorityPinReducer from "./debug_war_authority_pin_reducer";
import DebugWarLifeHpReducer from "./debug_war_life_hp_reducer";
import DebugWarSkyClearReducer from "./debug_war_sky_clear_reducer";
import DebugWarSkySweepReducer from "./debug_war_sky_sweep_reducer";
import DebugWarSkyWriteReducer from "./debug_war_sky_write_reducer";
import DecayAndSatisfyPulseReducer from "./decay_and_satisfy_pulse_reducer";
import DeclareCityAllegianceReducer from "./declare_city_allegiance_reducer";
import DeclareGroundWarReducer from "./declare_ground_war_reducer";
import DeclareGuildWarReducer from "./declare_guild_war_reducer";
import DeclareInstanceGroupReducer from "./declare_instance_group_reducer";
import DeclareResidenceReducer from "./declare_residence_reducer";
import DeleteAudioZoneReducer from "./delete_audio_zone_reducer";
import DeleteDeviceReducer from "./delete_device_reducer";
import DeleteDroidReportReducer from "./delete_droid_report_reducer";
import DeleteNpcReducer from "./delete_npc_reducer";
import DeletePartReducer from "./delete_part_reducer";
import DeleteVersonaReducer from "./delete_versona_reducer";
import DeleteWaypointReducer from "./delete_waypoint_reducer";
import DeleteWorldReducer from "./delete_world_reducer";
import DeleteWorldScriptReducer from "./delete_world_script_reducer";
import DeliverCourierReducer from "./deliver_courier_reducer";
import DeliverCourierContractReducer from "./deliver_courier_contract_reducer";
import DeliverFreelanceGoodsReducer from "./deliver_freelance_goods_reducer";
import DeliverResearchTenderReducer from "./deliver_research_tender_reducer";
import DeliverSupplyReducer from "./deliver_supply_reducer";
import DeliverWarSupplyReducer from "./deliver_war_supply_reducer";
import DenHullSyncReducer from "./den_hull_sync_reducer";
import DeployDroidReducer from "./deploy_droid_reducer";
import DeploySpaceStructureReducer from "./deploy_space_structure_reducer";
import DeployStructureReducer from "./deploy_structure_reducer";
import DescendToAtmosphereReducer from "./descend_to_atmosphere_reducer";
import DescribeAssetReducer from "./describe_asset_reducer";
import DesignateMilitiaReducer from "./designate_militia_reducer";
import DismissGuildVersonaReducer from "./dismiss_guild_versona_reducer";
import DismountVehicleReducer from "./dismount_vehicle_reducer";
import DockAtStationReducer from "./dock_at_station_reducer";
import DonateToGuildReducer from "./donate_to_guild_reducer";
import DonateTreasuryReducer from "./donate_treasury_reducer";
import DroidCommandReducer from "./droid_command_reducer";
import DroidDefundReducer from "./droid_defund_reducer";
import DroidFundReducer from "./droid_fund_reducer";
import DroidLoadItemReducer from "./droid_load_item_reducer";
import DroidLoadStackReducer from "./droid_load_stack_reducer";
import DroidProgramReducer from "./droid_program_reducer";
import DroidRepairReducer from "./droid_repair_reducer";
import DroidSetPriceReducer from "./droid_set_price_reducer";
import DroidUnloadReducer from "./droid_unload_reducer";
import DropPlayerBountyReducer from "./drop_player_bounty_reducer";
import DuelCancelReducer from "./duel_cancel_reducer";
import DuelInviteReducer from "./duel_invite_reducer";
import DuelReadyReducer from "./duel_ready_reducer";
import DuelRespondReducer from "./duel_respond_reducer";
import DuelSurrenderReducer from "./duel_surrender_reducer";
import EditDeviceReducer from "./edit_device_reducer";
import EditNpcReducer from "./edit_npc_reducer";
import EditPartReducer from "./edit_part_reducer";
import EditTerrainReducer from "./edit_terrain_reducer";
import EmitWorldEventReducer from "./emit_world_event_reducer";
import EndRentalReducer from "./end_rental_reducer";
import EnqueueMatchReducer from "./enqueue_match_reducer";
import EnqueuePartyReducer from "./enqueue_party_reducer";
import EnrollSpaceOperationReducer from "./enroll_space_operation_reducer";
import EnsureCommonsReserveReducer from "./ensure_commons_reserve_reducer";
import EnsureMerchantHiveReducer from "./ensure_merchant_hive_reducer";
import EnterAbyssalReducer from "./enter_abyssal_reducer";
import EnterFestivalContestReducer from "./enter_festival_contest_reducer";
import EnterInteriorRoomReducer from "./enter_interior_room_reducer";
import EnterSpaceReducer from "./enter_space_reducer";
import EnterWorldReducer from "./enter_world_reducer";
import EquipShipComponentReducer from "./equip_ship_component_reducer";
import EscortShipmentReducer from "./escort_shipment_reducer";
import EvictTenantReducer from "./evict_tenant_reducer";
import EvictVersonaResidentReducer from "./evict_versona_resident_reducer";
import EwBurstReducer from "./ew_burst_reducer";
import EwJamReducer from "./ew_jam_reducer";
import ExecuteSpendReducer from "./execute_spend_reducer";
import ExitAbyssalReducer from "./exit_abyssal_reducer";
import ExitSpaceReducer from "./exit_space_reducer";
import ExpireOrbitsReducer from "./expire_orbits_reducer";
import ExportToForgeReducer from "./export_to_forge_reducer";
import FailChatTranslationReducer from "./fail_chat_translation_reducer";
import FestivalPresenceReducer from "./festival_presence_reducer";
import FieldEnrollReducer from "./field_enroll_reducer";
import FieldLeaveReducer from "./field_leave_reducer";
import FileScoutReportReducer from "./file_scout_report_reducer";
import FinalizeUploadAssetReducer from "./finalize_upload_asset_reducer";
import FireWeaponReducer from "./fire_weapon_reducer";
import FlyMoveReducer from "./fly_move_reducer";
import FormOrbitReducer from "./form_orbit_reducer";
import FoundCityReducer from "./found_city_reducer";
import FriendRemoveReducer from "./friend_remove_reducer";
import FriendRequestReducer from "./friend_request_reducer";
import FriendRespondReducer from "./friend_respond_reducer";
import FulfillFavorReducer from "./fulfill_favor_reducer";
import FundPortReducer from "./fund_port_reducer";
import FundResearchPostReducer from "./fund_research_post_reducer";
import GetCompileResultReducer from "./get_compile_result_reducer";
import GiveGiftToVersonaReducer from "./give_gift_to_versona_reducer";
import GrantContractCapsReducer from "./grant_contract_caps_reducer";
import GrantDeedReducer from "./grant_deed_reducer";
import GrantLegacyReducer from "./grant_legacy_reducer";
import GrantNewPlayerReducer from "./grant_new_player_reducer";
import GrantVoiceSfuRoleReducer from "./grant_voice_sfu_role_reducer";
import GrantZoningReducer from "./grant_zoning_reducer";
import HandInRelayReducer from "./hand_in_relay_reducer";
import HarvestPlanterReducer from "./harvest_planter_reducer";
import HireBountyHunterReducer from "./hire_bounty_hunter_reducer";
import HoldEscrowReducer from "./hold_escrow_reducer";
import HoldMerchantListingReducer from "./hold_merchant_listing_reducer";
import ImportMeshReducer from "./import_mesh_reducer";
import ImportToCanvasReducer from "./import_to_canvas_reducer";
import IncursionKillReducer from "./incursion_kill_reducer";
import InitOnboardingReducer from "./init_onboarding_reducer";
import InitiateForkReducer from "./initiate_fork_reducer";
import InstantiateTemplateReducer from "./instantiate_template_reducer";
import InstitutionalizeRitualReducer from "./institutionalize_ritual_reducer";
import InsureShipReducer from "./insure_ship_reducer";
import InvitePartyMemberReducer from "./invite_party_member_reducer";
import InviteToVoiceRoomReducer from "./invite_to_voice_room_reducer";
import InviteVersonaToCityReducer from "./invite_versona_to_city_reducer";
import JoinCivilizationReducer from "./join_civilization_reducer";
import JoinGuildReducer from "./join_guild_reducer";
import JoinRaceQueueReducer from "./join_race_queue_reducer";
import JoinTeamVoiceReducer from "./join_team_voice_reducer";
import JoinVoiceRoomReducer from "./join_voice_room_reducer";
import KickFromVoiceRoomReducer from "./kick_from_voice_room_reducer";
import KickGuildMemberReducer from "./kick_guild_member_reducer";
import LandOnWorldReducer from "./land_on_world_reducer";
import LandShipReducer from "./land_ship_reducer";
import LaunchFireworkReducer from "./launch_firework_reducer";
import LaunchFireworkShowReducer from "./launch_firework_show_reducer";
import LeaseResidencyReducer from "./lease_residency_reducer";
import LeaseSiteReducer from "./lease_site_reducer";
import LeaveCityReducer from "./leave_city_reducer";
import LeaveCivilizationReducer from "./leave_civilization_reducer";
import LeaveGuildReducer from "./leave_guild_reducer";
import LeaveInteriorReducer from "./leave_interior_reducer";
import LeaveMerchantReducer from "./leave_merchant_reducer";
import LeaveRaceQueueReducer from "./leave_race_queue_reducer";
import LeaveRentalReducer from "./leave_rental_reducer";
import LeaveServicePostReducer from "./leave_service_post_reducer";
import LeaveSessionReducer from "./leave_session_reducer";
import LeaveSpaceOperationReducer from "./leave_space_operation_reducer";
import LeaveTurretReducer from "./leave_turret_reducer";
import LeaveVoiceRoomReducer from "./leave_voice_room_reducer";
import LinkPartsReducer from "./link_parts_reducer";
import ListAssetReducer from "./list_asset_reducer";
import ListDeedReducer from "./list_deed_reducer";
import ListItemReducer from "./list_item_reducer";
import ListRentalUnitReducer from "./list_rental_unit_reducer";
import ListResourceReducer from "./list_resource_reducer";
import LoadCargoReducer from "./load_cargo_reducer";
import LoadHoldFromGroundReducer from "./load_hold_from_ground_reducer";
import LoadPublishedExperienceReducer from "./load_published_experience_reducer";
import LootCargoWreckReducer from "./loot_cargo_wreck_reducer";
import MarkBountyStrikeReducer from "./mark_bounty_strike_reducer";
import MarkOrbitInteractionReducer from "./mark_orbit_interaction_reducer";
import MatchmakeReducer from "./matchmake_reducer";
import MigrateDroidPursesReducer from "./migrate_droid_purses_reducer";
import ModerateAssetReducer from "./moderate_asset_reducer";
import MoveReducer from "./move_reducer";
import MoveStepsReducer from "./move_steps_reducer";
import MoveSteps2Reducer from "./move_steps_2_reducer";
import MoveStructureItemReducer from "./move_structure_item_reducer";
import MoveVersonaReducer from "./move_versona_reducer";
import MusterAtFortReducer from "./muster_at_fort_reducer";
import MuteRitualInvitesReducer from "./mute_ritual_invites_reducer";
import NpcAskVersonaReducer from "./npc_ask_versona_reducer";
import NpcSimTickReducer from "./npc_sim_tick_reducer";
import OfferIntelLicenceReducer from "./offer_intel_licence_reducer";
import OfficeBuyGoodsReducer from "./office_buy_goods_reducer";
import OfficeSellGoodsReducer from "./office_sell_goods_reducer";
import OpExtractionBeatReducer from "./op_extraction_beat_reducer";
import OpScoutBeatReducer from "./op_scout_beat_reducer";
import OpStartExtractionReducer from "./op_start_extraction_reducer";
import OpSubmitEvidenceReducer from "./op_submit_evidence_reducer";
import OpenConflictSectorReducer from "./open_conflict_sector_reducer";
import OpenContainerReducer from "./open_container_reducer";
import OpenCouncilTermReducer from "./open_council_term_reducer";
import OpenGuildElectionReducer from "./open_guild_election_reducer";
import OpenMayorElectionReducer from "./open_mayor_election_reducer";
import OpenRentalStorageReducer from "./open_rental_storage_reducer";
import OpenSessionReducer from "./open_session_reducer";
import OpenTermDepositReducer from "./open_term_deposit_reducer";
import PartyCreateReducer from "./party_create_reducer";
import PartyDisbandReducer from "./party_disband_reducer";
import PartyKickReducer from "./party_kick_reducer";
import PartyLeaveReducer from "./party_leave_reducer";
import PartyPingClearReducer from "./party_ping_clear_reducer";
import PartyQueueAcceptReducer from "./party_queue_accept_reducer";
import PartyQueueRevokeReducer from "./party_queue_revoke_reducer";
import PartyReadyReducer from "./party_ready_reducer";
import PartyRespondReducer from "./party_respond_reducer";
import PartyTransferLeadReducer from "./party_transfer_lead_reducer";
import PayMaintenanceReducer from "./pay_maintenance_reducer";
import PayRentReducer from "./pay_rent_reducer";
import PaySaleRoyaltyReducer from "./pay_sale_royalty_reducer";
import PenalizeCheaterReducer from "./penalize_cheater_reducer";
import PerfLegEndReducer from "./perf_leg_end_reducer";
import PerfLegStartReducer from "./perf_leg_start_reducer";
import PerfPruneReducer from "./perf_prune_reducer";
import PerfRecordSampleReducer from "./perf_record_sample_reducer";
import PerfRunEndReducer from "./perf_run_end_reducer";
import PerfRunStartReducer from "./perf_run_start_reducer";
import PickupFurnitureReducer from "./pickup_furniture_reducer";
import PinArcadeGameReducer from "./pin_arcade_game_reducer";
import PingReducer from "./ping_reducer";
import PirateCargoConvoyReducer from "./pirate_cargo_convoy_reducer";
import PitchCampReducer from "./pitch_camp_reducer";
import PlaceBountyReducer from "./place_bounty_reducer";
import PlaceCivicStructureReducer from "./place_civic_structure_reducer";
import PlaceDeckItemReducer from "./place_deck_item_reducer";
import PlaceDeviceReducer from "./place_device_reducer";
import PlaceFurnitureReducer from "./place_furniture_reducer";
import PlaceGuildStructureReducer from "./place_guild_structure_reducer";
import PlaceMarketOrderReducer from "./place_market_order_reducer";
import PlaceNpcReducer from "./place_npc_reducer";
import PlaceObjectReducer from "./place_object_reducer";
import PlaceStructureItemReducer from "./place_structure_item_reducer";
import PlaceVersonaReducer from "./place_versona_reducer";
import PlantSeedReducer from "./plant_seed_reducer";
import PlantWarBannerReducer from "./plant_war_banner_reducer";
import PlatformDeleteWorldReducer from "./platform_delete_world_reducer";
import PortAcceptReducer from "./port_accept_reducer";
import PortAcceptTermsReducer from "./port_accept_terms_reducer";
import PortDeliverReducer from "./port_deliver_reducer";
import PortRelayReducer from "./port_relay_reducer";
import PortRelayOfferReducer from "./port_relay_offer_reducer";
import PortRelayRevokeReducer from "./port_relay_revoke_reducer";
import PostCourierContractReducer from "./post_courier_contract_reducer";
import PostDutyPingReducer from "./post_duty_ping_reducer";
import PostEscortContractReducer from "./post_escort_contract_reducer";
import PostLedgerReducer from "./post_ledger_reducer";
import PostPlayerBountyReducer from "./post_player_bounty_reducer";
import ProposeCivilizationReducer from "./propose_civilization_reducer";
import ProposeGroundPeaceReducer from "./propose_ground_peace_reducer";
import ProposeGroupReducer from "./propose_group_reducer";
import ProposeGuildBidReducer from "./propose_guild_bid_reducer";
import ProposeGuildMotionReducer from "./propose_guild_motion_reducer";
import ProposeSpaceOperationReducer from "./propose_space_operation_reducer";
import ProposeSpendReducer from "./propose_spend_reducer";
import PublishForgeReducer from "./publish_forge_reducer";
import PutChatTranslationReducer from "./put_chat_translation_reducer";
import QuoteStationRepairReducer from "./quote_station_repair_reducer";
import QuoteWreckRecoveryReducer from "./quote_wreck_recovery_reducer";
import RaceGateReducer from "./race_gate_reducer";
import RaidEssBankReducer from "./raid_ess_bank_reducer";
import RaiseVoiceHandReducer from "./raise_voice_hand_reducer";
import RankHotFeedReducer from "./rank_hot_feed_reducer";
import RateWorldReducer from "./rate_world_reducer";
import ReadRelayLogReducer from "./read_relay_log_reducer";
import ReadSurveyCensusReducer from "./read_survey_census_reducer";
import RebuildLeaderboardIndexReducer from "./rebuild_leaderboard_index_reducer";
import RecallDroidReducer from "./recall_droid_reducer";
import RecallShipReducer from "./recall_ship_reducer";
import RecomputeRegionAssetSetsReducer from "./recompute_region_asset_sets_reducer";
import RecomputeReputationHourlyReducer from "./recompute_reputation_hourly_reducer";
import RecomputeWorldMetricsReducer from "./recompute_world_metrics_reducer";
import RecookRenderAssetReducer from "./recook_render_asset_reducer";
import RecordBetrayalReducer from "./record_betrayal_reducer";
import RecordEmbezzlementReducer from "./record_embezzlement_reducer";
import RecordSatisfactionReducer from "./record_satisfaction_reducer";
import RecordSightingReducer from "./record_sighting_reducer";
import RecordVisitReducer from "./record_visit_reducer";
import RecruitGuildVersonaReducer from "./recruit_guild_versona_reducer";
import RedeedStructureReducer from "./redeed_structure_reducer";
import RedeemFleetTokensReducer from "./redeem_fleet_tokens_reducer";
import RedeemInviteReducer from "./redeem_invite_reducer";
import RedeemLoyaltyReducer from "./redeem_loyalty_reducer";
import ReelInReducer from "./reel_in_reducer";
import RefineItemReducer from "./refine_item_reducer";
import RefitStructureLayoutReducer from "./refit_structure_layout_reducer";
import RegisterArcadeGameReducer from "./register_arcade_game_reducer";
import RegisterAssetPackReducer from "./register_asset_pack_reducer";
import RegisterRenderAssetReducer from "./register_render_asset_reducer";
import ReleaseEscrowReducer from "./release_escrow_reducer";
import ReleaseGuildStructureReducer from "./release_guild_structure_reducer";
import ReleaseMerchantLotReducer from "./release_merchant_lot_reducer";
import ReleaseSiteLeaseReducer from "./release_site_lease_reducer";
import ReloadWeaponReducer from "./reload_weapon_reducer";
import RemixAssetReducer from "./remix_asset_reducer";
import RemoveBookmarkReducer from "./remove_bookmark_reducer";
import RemoveDeckItemReducer from "./remove_deck_item_reducer";
import RemoveMerchantListingReducer from "./remove_merchant_listing_reducer";
import RemoveStructureItemReducer from "./remove_structure_item_reducer";
import RemoveStructurePermissionReducer from "./remove_structure_permission_reducer";
import RenameShipReducer from "./rename_ship_reducer";
import RenameWaypointReducer from "./rename_waypoint_reducer";
import RenewMerchantLotReducer from "./renew_merchant_lot_reducer";
import RentMerchantLotReducer from "./rent_merchant_lot_reducer";
import RentUnitReducer from "./rent_unit_reducer";
import RepairSpaceStructureReducer from "./repair_space_structure_reducer";
import RepayLoanReducer from "./repay_loan_reducer";
import ReportPlayerReducer from "./report_player_reducer";
import ReportShipDamageReducer from "./report_ship_damage_reducer";
import ReportWorldReducer from "./report_world_reducer";
import RequestChatTranslationReducer from "./request_chat_translation_reducer";
import RequestCreatorCertReducer from "./request_creator_cert_reducer";
import RequestTravelReducer from "./request_travel_reducer";
import RequestVoiceTicketReducer from "./request_voice_ticket_reducer";
import ReserveFabJobReducer from "./reserve_fab_job_reducer";
import ResetNpcEconomyReducer from "./reset_npc_economy_reducer";
import ResetWorldEnvironmentReducer from "./reset_world_environment_reducer";
import ResetWorldRulesReducer from "./reset_world_rules_reducer";
import ResolveDeliberationReducer from "./resolve_deliberation_reducer";
import ResolveForkReducer from "./resolve_fork_reducer";
import ResolveStructureModelReducer from "./resolve_structure_model_reducer";
import RestOnBedReducer from "./rest_on_bed_reducer";
import RestoreSubsystemsAtDockReducer from "./restore_subsystems_at_dock_reducer";
import ResupplyAtDepotReducer from "./resupply_at_depot_reducer";
import ReturnFromTravelReducer from "./return_from_travel_reducer";
import RevealTheLieReducer from "./reveal_the_lie_reducer";
import ReverseEngineerItemReducer from "./reverse_engineer_item_reducer";
import ReverseEngineerShipReducer from "./reverse_engineer_ship_reducer";
import RevokeInviteReducer from "./revoke_invite_reducer";
import RevokeVoiceSfuRoleReducer from "./revoke_voice_sfu_role_reducer";
import RevokeVouchReducer from "./revoke_vouch_reducer";
import RezCatalogPartReducer from "./rez_catalog_part_reducer";
import RezInWorldReducer from "./rez_in_world_reducer";
import RezObjectReducer from "./rez_object_reducer";
import RezPartReducer from "./rez_part_reducer";
import RezUploadedPartReducer from "./rez_uploaded_part_reducer";
import RollbackForgeReducer from "./rollback_forge_reducer";
import RolloverArcadeSeasonReducer from "./rollover_arcade_season_reducer";
import RolloverSeasonReducer from "./rollover_season_reducer";
import RotateCompassReducer from "./rotate_compass_reducer";
import RotateStructureItemReducer from "./rotate_structure_item_reducer";
import RunCompileJobReducer from "./run_compile_job_reducer";
import RunContractTickReducer from "./run_contract_tick_reducer";
import RunExploitCanonReducer from "./run_exploit_canon_reducer";
import RunForGuildOfficeReducer from "./run_for_guild_office_reducer";
import SampleResourceReducer from "./sample_resource_reducer";
import SayToVersonaReducer from "./say_to_versona_reducer";
import ScanPingReducer from "./scan_ping_reducer";
import ScoopSpaceStructureReducer from "./scoop_space_structure_reducer";
import ScrapShipReducer from "./scrap_ship_reducer";
import SeatCouncilReducer from "./seat_council_reducer";
import SeedCommonsEnvironmentReducer from "./seed_commons_environment_reducer";
import SeedCommonsSettlementsReducer from "./seed_commons_settlements_reducer";
import SeedLinkSecretReducer from "./seed_link_secret_reducer";
import SeedNpcAgentsReducer from "./seed_npc_agents_reducer";
import SellResourceToTownReducer from "./sell_resource_to_town_reducer";
import SendChatReducer from "./send_chat_reducer";
import SendFleetChatReducer from "./send_fleet_chat_reducer";
import SendLocalChatReducer from "./send_local_chat_reducer";
import SendPartyMessageReducer from "./send_party_message_reducer";
import SendPartyPingReducer from "./send_party_ping_reducer";
import SendStandingInvitesReducer from "./send_standing_invites_reducer";
import SendVoiceSignalReducer from "./send_voice_signal_reducer";
import SendWaveReducer from "./send_wave_reducer";
import SendWhisperReducer from "./send_whisper_reducer";
import ServePostRequestReducer from "./serve_post_request_reducer";
import SetActiveShipReducer from "./set_active_ship_reducer";
import SetArcadeJurisdictionReducer from "./set_arcade_jurisdiction_reducer";
import SetAssetColliderReducer from "./set_asset_collider_reducer";
import SetAvatarReducer from "./set_avatar_reducer";
import SetCastShadowReducer from "./set_cast_shadow_reducer";
import SetChatLanguageReducer from "./set_chat_language_reducer";
import SetCityBankTermsReducer from "./set_city_bank_terms_reducer";
import SetCityCoinTaxReducer from "./set_city_coin_tax_reducer";
import SetCityTaxReducer from "./set_city_tax_reducer";
import SetCivBuildingTraditionReducer from "./set_civ_building_tradition_reducer";
import SetCivTitheReducer from "./set_civ_tithe_reducer";
import SetCompassPublicReducer from "./set_compass_public_reducer";
import SetContractBudgetReducer from "./set_contract_budget_reducer";
import SetDeviceTierReducer from "./set_device_tier_reducer";
import SetDiscoveryPrefsReducer from "./set_discovery_prefs_reducer";
import SetExpeditionPublicReducer from "./set_expedition_public_reducer";
import SetFidelityTierReducer from "./set_fidelity_tier_reducer";
import SetForgeMonetizationReducer from "./set_forge_monetization_reducer";
import SetForgeScriptReducer from "./set_forge_script_reducer";
import SetGovernanceReducer from "./set_governance_reducer";
import SetGroupSrpReducer from "./set_group_srp_reducer";
import SetGuardReducer from "./set_guard_reducer";
import SetGuildMotdReducer from "./set_guild_motd_reducer";
import SetInteriorMarkerReducer from "./set_interior_marker_reducer";
import SetLifecycleReducer from "./set_lifecycle_reducer";
import SetLoanAutopayReducer from "./set_loan_autopay_reducer";
import SetMerchantListingReducer from "./set_merchant_listing_reducer";
import SetNeedSatisfierReducer from "./set_need_satisfier_reducer";
import SetNoBuildZoneReducer from "./set_no_build_zone_reducer";
import SetNpcScriptReducer from "./set_npc_script_reducer";
import SetPilotFactionReducer from "./set_pilot_faction_reducer";
import SetPlatformFlagReducer from "./set_platform_flag_reducer";
import SetPrefabModelReducer from "./set_prefab_model_reducer";
import SetPreferInstancedReducer from "./set_prefer_instanced_reducer";
import SetPulseVisibilityReducer from "./set_pulse_visibility_reducer";
import SetRegionAssetSetReducer from "./set_region_asset_set_reducer";
import SetRenderAssetStatusReducer from "./set_render_asset_status_reducer";
import SetSessionStateReducer from "./set_session_state_reducer";
import SetSettlementNameReducer from "./set_settlement_name_reducer";
import SetSkyLightingProfileReducer from "./set_sky_lighting_profile_reducer";
import SetSpecializationReducer from "./set_specialization_reducer";
import SetStructureEntryReducer from "./set_structure_entry_reducer";
import SetStructureNameReducer from "./set_structure_name_reducer";
import SetStructurePermissionReducer from "./set_structure_permission_reducer";
import SetSubsystemAimReducer from "./set_subsystem_aim_reducer";
import SetTerrainRegionReducer from "./set_terrain_region_reducer";
import SetTierReducer from "./set_tier_reducer";
import SetUploadStatusReducer from "./set_upload_status_reducer";
import SetValidationLimitsReducer from "./set_validation_limits_reducer";
import SetVersonaBiasReducer from "./set_versona_bias_reducer";
import SetVersonaGoalReducer from "./set_versona_goal_reducer";
import SetVersonaProfileReducer from "./set_versona_profile_reducer";
import SetVoiceRoleReducer from "./set_voice_role_reducer";
import SetVoiceRoomReducer from "./set_voice_room_reducer";
import SetVoiceServerMuteReducer from "./set_voice_server_mute_reducer";
import SetWeatherReducer from "./set_weather_reducer";
import SetWeatherProfileReducer from "./set_weather_profile_reducer";
import SetWorldEnvironmentReducer from "./set_world_environment_reducer";
import SetWorldPresetReducer from "./set_world_preset_reducer";
import SetWorldRoleReducer from "./set_world_role_reducer";
import SetWorldRulesReducer from "./set_world_rules_reducer";
import SetWorldScriptReducer from "./set_world_script_reducer";
import SetWorldVisibilityReducer from "./set_world_visibility_reducer";
import SettleDailyReducer from "./settle_daily_reducer";
import SettleMerchantHoldReducer from "./settle_merchant_hold_reducer";
import ShipRepairBeatReducer from "./ship_repair_beat_reducer";
import ShipSetPowerReducer from "./ship_set_power_reducer";
import ShipStrikeCreatureReducer from "./ship_strike_creature_reducer";
import ShootBountyHunterReducer from "./shoot_bounty_hunter_reducer";
import ShootWarAirUnitReducer from "./shoot_war_air_unit_reducer";
import ShuttleTravelReducer from "./shuttle_travel_reducer";
import SignCharterReducer from "./sign_charter_reducer";
import SignGuestbookReducer from "./sign_guestbook_reducer";
import SignRecallPetitionReducer from "./sign_recall_petition_reducer";
import SignWarPetitionReducer from "./sign_war_petition_reducer";
import SkyShipLiftReducer from "./sky_ship_lift_reducer";
import SlotRigCoreReducer from "./slot_rig_core_reducer";
import SpaceEjectReducer from "./space_eject_reducer";
import SpaceHitReducer from "./space_hit_reducer";
import SpaceKillReducer from "./space_kill_reducer";
import SpaceMarketBuyReducer from "./space_market_buy_reducer";
import SpaceMarketSellReducer from "./space_market_sell_reducer";
import SpaceMineReducer from "./space_mine_reducer";
import SpaceMoveReducer from "./space_move_reducer";
import SpacePresencePingReducer from "./space_presence_ping_reducer";
import SpacePvpStrikeReducer from "./space_pvp_strike_reducer";
import SpaceRefineReducer from "./space_refine_reducer";
import SpaceRepairReducer from "./space_repair_reducer";
import SpaceSalvageReducer from "./space_salvage_reducer";
import SpaceScanLootReducer from "./space_scan_loot_reducer";
import SpaceShipDestroyedReducer from "./space_ship_destroyed_reducer";
import SpaceStripWreckReducer from "./space_strip_wreck_reducer";
import SpawnVersonaReducer from "./spawn_versona_reducer";
import SpawnWorldReducer from "./spawn_world_reducer";
import SpreadRumorReducer from "./spread_rumor_reducer";
import SpreadSettlementLifeReducer from "./spread_settlement_life_reducer";
import StampStructureLayoutReducer from "./stamp_structure_layout_reducer";
import StartRentalReducer from "./start_rental_reducer";
import StartShipRepairReducer from "./start_ship_repair_reducer";
import StoreItemReducer from "./store_item_reducer";
import StoreRentalItemReducer from "./store_rental_item_reducer";
import StoreRentalStackReducer from "./store_rental_stack_reducer";
import StoreStackReducer from "./store_stack_reducer";
import StrikeBountyHunterReducer from "./strike_bounty_hunter_reducer";
import StrikeCampReducer from "./strike_camp_reducer";
import StrikeCreatureReducer from "./strike_creature_reducer";
import StrikeLineReducer from "./strike_line_reducer";
import StrikePlayerReducer from "./strike_player_reducer";
import StrikeVersonaReducer from "./strike_versona_reducer";
import SubmitForModerationReducer from "./submit_for_moderation_reducer";
import SubmitIntentReducer from "./submit_intent_reducer";
import SubmitMatchResultReducer from "./submit_match_result_reducer";
import SubmitReviewReducer from "./submit_review_reducer";
import SubscribeReducer from "./subscribe_reducer";
import SuggestBeginnerMixersReducer from "./suggest_beginner_mixers_reducer";
import SurrenderGroundWarReducer from "./surrender_ground_war_reducer";
import SurrenderGuildWarReducer from "./surrender_guild_war_reducer";
import SurveyWorkReducer from "./survey_work_reducer";
import SwapWeaponReducer from "./swap_weapon_reducer";
import SyncInteriorOccupantReducer from "./sync_interior_occupant_reducer";
import TacklePilotReducer from "./tackle_pilot_reducer";
import TakeDutyMissionReducer from "./take_duty_mission_reducer";
import TakeGroundContractReducer from "./take_ground_contract_reducer";
import TakeItemReducer from "./take_item_reducer";
import TakeMissionReducer from "./take_mission_reducer";
import TakePlayerBountyReducer from "./take_player_bounty_reducer";
import TakeRentalItemReducer from "./take_rental_item_reducer";
import TakeRentalStackReducer from "./take_rental_stack_reducer";
import TakeServicePostReducer from "./take_service_post_reducer";
import TakeStackReducer from "./take_stack_reducer";
import TakeWarSupplyReducer from "./take_war_supply_reducer";
import TallyGuildElectionReducer from "./tally_guild_election_reducer";
import TerrainEditClearReducer from "./terrain_edit_clear_reducer";
import TerrainEditUndoReducer from "./terrain_edit_undo_reducer";
import TerrainSculptReducer from "./terrain_sculpt_reducer";
import TickChroniclerReducer from "./tick_chronicler_reducer";
import TickCityUpdateReducer from "./tick_city_update_reducer";
import TickDroidsReducer from "./tick_droids_reducer";
import TickGuardedReducer from "./tick_guarded_reducer";
import TickSkyReducer from "./tick_sky_reducer";
import TickStructureMaintenanceReducer from "./tick_structure_maintenance_reducer";
import TickVersonaAiReducer from "./tick_versona_ai_reducer";
import TickVersonaTravelReducer from "./tick_versona_travel_reducer";
import TipReducer from "./tip_reducer";
import TopUpSettlementLifeReducer from "./top_up_settlement_life_reducer";
import TracePlayerBountyReducer from "./trace_player_bounty_reducer";
import TradeCancelReducer from "./trade_cancel_reducer";
import TradeConfirmReducer from "./trade_confirm_reducer";
import TradeOfferReducer from "./trade_offer_reducer";
import TradeRequestReducer from "./trade_request_reducer";
import TradeRespondReducer from "./trade_respond_reducer";
import TrainSkillReducer from "./train_skill_reducer";
import TransferItemReducer from "./transfer_item_reducer";
import TravelToMerchantHiveReducer from "./travel_to_merchant_hive_reducer";
import TuneExtractorReducer from "./tune_extractor_reducer";
import UnblockPlayerReducer from "./unblock_player_reducer";
import UndoWorldEditReducer from "./undo_world_edit_reducer";
import UndockReducer from "./undock_reducer";
import UnequipItemReducer from "./unequip_item_reducer";
import UnequipShipComponentReducer from "./unequip_ship_component_reducer";
import UnlinkPartsReducer from "./unlink_parts_reducer";
import UnlistRentalUnitReducer from "./unlist_rental_unit_reducer";
import UnloadCargoReducer from "./unload_cargo_reducer";
import UnlockArcadeTabReducer from "./unlock_arcade_tab_reducer";
import UnstickNudgeReducer from "./unstick_nudge_reducer";
import UnstickRescueReducer from "./unstick_rescue_reducer";
import UpdateForgeInstanceReducer from "./update_forge_instance_reducer";
import UpdateLeaderboardReducer from "./update_leaderboard_reducer";
import UpdateRatingsReducer from "./update_ratings_reducer";
import UseDeviceReducer from "./use_device_reducer";
import UseItemReducer from "./use_item_reducer";
import UseRollbackTokenReducer from "./use_rollback_token_reducer";
import VehicleMoveReducer from "./vehicle_move_reducer";
import VerifyMatchReducer from "./verify_match_reducer";
import VersonaSayReducer from "./versona_say_reducer";
import VoiceSfuAdmitReducer from "./voice_sfu_admit_reducer";
import VoiceSfuBeatReducer from "./voice_sfu_beat_reducer";
import VoiceSfuConnectedReducer from "./voice_sfu_connected_reducer";
import VoiceSfuDisconnectedReducer from "./voice_sfu_disconnected_reducer";
import VoiceSfuHelloReducer from "./voice_sfu_hello_reducer";
import VoiceSfuResetReducer from "./voice_sfu_reset_reducer";
import VoiceSfuRosterReducer from "./voice_sfu_roster_reducer";
import VoteForkReducer from "./vote_fork_reducer";
import VoteGuildMotionReducer from "./vote_guild_motion_reducer";
import VoteMayorReducer from "./vote_mayor_reducer";
import VoteSpendReducer from "./vote_spend_reducer";
import VouchForReducer from "./vouch_for_reducer";
import WarContributionReducer from "./war_contribution_reducer";
import WarShotReducer from "./war_shot_reducer";
import WarmByFireReducer from "./warm_by_fire_reducer";
import WarpToWorldReducer from "./warp_to_world_reducer";
import WildsTickReducer from "./wilds_tick_reducer";
import WithdrawFederalPreferenceReducer from "./withdraw_federal_preference_reducer";
import WithdrawGuildApprovalReducer from "./withdraw_guild_approval_reducer";
import WithdrawIntelOfferReducer from "./withdraw_intel_offer_reducer";
import WitnessCivicEventReducer from "./witness_civic_event_reducer";
import WormholeJumpReducer from "./wormhole_jump_reducer";
import XrTeleportReducer from "./xr_teleport_reducer";

// Import all procedure arg schemas

// Import all table schema definitions
import AbyssalHullRow from "./abyssal_hull_table";
import AbyssalRunRow from "./abyssal_run_table";
import AccountRow from "./account_table";
import ActivityStationRow from "./activity_station_table";
import AdminPlacementRow from "./admin_placement_table";
import AirStrikeRow from "./air_strike_table";
import ArcadeGameRow from "./arcade_game_table";
import ArcadeGameDefRow from "./arcade_game_def_table";
import ArcadeSeasonRow from "./arcade_season_table";
import ArcadeTabStateRow from "./arcade_tab_state_table";
import AssetRow from "./asset_table";
import AssetBridgeRow from "./asset_bridge_table";
import AssetColliderRow from "./asset_collider_table";
import AssetFormatRow from "./asset_format_table";
import AssetPackRow from "./asset_pack_table";
import AssetUploadRow from "./asset_upload_table";
import AssetValidationLimitsRow from "./asset_validation_limits_table";
import AudioZoneRow from "./audio_zone_table";
import AvatarRow from "./avatar_table";
import BankRow from "./bank_table";
import BankAccountRow from "./bank_account_table";
import BankCustodyRow from "./bank_custody_table";
import BankLoanRow from "./bank_loan_table";
import BankRepoLotRow from "./bank_repo_lot_table";
import BankTermDepositRow from "./bank_term_deposit_table";
import BankTxnRow from "./bank_txn_table";
import BattleRow from "./battle_table";
import BattleAdviceRow from "./battle_advice_table";
import BattleCallRow from "./battle_call_table";
import BattleEventRow from "./battle_event_table";
import BattleLookRow from "./battle_look_table";
import BattleObjectiveRow from "./battle_objective_table";
import BattleOutpostRow from "./battle_outpost_table";
import BattleRecordRow from "./battle_record_table";
import BattleSquadRow from "./battle_squad_table";
import BattleUnitRow from "./battle_unit_table";
import BeginnerMixerSuggestionRow from "./beginner_mixer_suggestion_table";
import BetrayalRecordRow from "./betrayal_record_table";
import BountyContractRow from "./bounty_contract_table";
import BountyCueRow from "./bounty_cue_table";
import BountyDebugRow from "./bounty_debug_table";
import BountyEventRow from "./bounty_event_table";
import BountyHuntRow from "./bounty_hunt_table";
import BridgeAuditRow from "./bridge_audit_table";
import CampaignAarRow from "./campaign_aar_table";
import CampaignCapitalRow from "./campaign_capital_table";
import CampaignEscortRow from "./campaign_escort_table";
import CampaignOpsPinRow from "./campaign_ops_pin_table";
import CampaignReceiptRow from "./campaign_receipt_table";
import CampaignSideRow from "./campaign_side_table";
import CampaignSkyRow from "./campaign_sky_table";
import CampaignStanceRow from "./campaign_stance_table";
import CaravanRowRow from "./caravan_row_table";
import CargoConvoyRow from "./cargo_convoy_table";
import CargoLotRow from "./cargo_lot_table";
import CharterChallengeRow from "./charter_challenge_table";
import CharterClauseRow from "./charter_clause_table";
import ChatLangRow from "./chat_lang_table";
import ChatMessageRow from "./chat_message_table";
import ChatTranslateRequestRow from "./chat_translate_request_table";
import ChatTranslationRow from "./chat_translation_table";
import CheatFlagRow from "./cheat_flag_table";
import ChronicleRow from "./chronicle_table";
import ChroniclerEventRow from "./chronicler_event_table";
import CitizenRow from "./citizen_table";
import CityRow from "./city_table";
import CityAllegianceRow from "./city_allegiance_table";
import CitySpecRow from "./city_spec_table";
import CityTurretShotRow from "./city_turret_shot_table";
import CityVersonaResidentRow from "./city_versona_resident_table";
import CivFlipLogRow from "./civ_flip_log_table";
import CivOperationRow from "./civ_operation_table";
import CivReserveRow from "./civ_reserve_table";
import CivTreatyRow from "./civ_treaty_table";
import CivicSignRow from "./civic_sign_table";
import CivicStructureRow from "./civic_structure_table";
import CoinIssuanceRow from "./coin_issuance_table";
import CombatActionRow from "./combat_action_table";
import CombatActorRow from "./combat_actor_table";
import CombatResultRow from "./combat_result_table";
import CompassRow from "./compass_table";
import ContactBlockRow from "./contact_block_table";
import ContactEdgeRow from "./contact_edge_table";
import ContainerItemRow from "./container_item_table";
import ContingentRequestRow from "./contingent_request_table";
import ContractRow from "./contract_table";
import ContractEventRow from "./contract_event_table";
import ContractStateRow from "./contract_state_table";
import CouncilActionRow from "./council_action_table";
import CouncilSeatRow from "./council_seat_table";
import CouncilTermRow from "./council_term_table";
import CouncilVoteRow from "./council_vote_table";
import CourierContractRow from "./courier_contract_table";
import CreatorCertRow from "./creator_cert_table";
import CreatureRow from "./creature_table";
import CreditFileRow from "./credit_file_table";
import CrewLeaseRow from "./crew_lease_table";
import CrimeCaseRow from "./crime_case_table";
import DailySettlementRow from "./daily_settlement_table";
import DefeatReceiptRow from "./defeat_receipt_table";
import DenHullRow from "./den_hull_table";
import DenSlotRow from "./den_slot_table";
import DenStateRow from "./den_state_table";
import DepotResupplyRow from "./depot_resupply_table";
import DeviceTierHintRow from "./device_tier_hint_table";
import DirectMessageRow from "./direct_message_table";
import DiscoveryPrefsRow from "./discovery_prefs_table";
import DisplayNameChangeRow from "./display_name_change_table";
import DroidBrainRow from "./droid_brain_table";
import DroidCargoRow from "./droid_cargo_table";
import DroidLogRow from "./droid_log_table";
import DroidPosRow from "./droid_pos_table";
import DroidPurseRow from "./droid_purse_table";
import DroidReportRow from "./droid_report_table";
import DroidRouteRow from "./droid_route_table";
import DroidSayRow from "./droid_say_table";
import DroidSourceRow from "./droid_source_table";
import DroidUnitRow from "./droid_unit_table";
import DroidVitalsRow from "./droid_vitals_table";
import EconHealthRow from "./econ_health_table";
import ElectionRaceRow from "./election_race_table";
import EntitlementRow from "./entitlement_table";
import EscortExtractionRow from "./escort_extraction_table";
import EscrowRow from "./escrow_table";
import EssBankRow from "./ess_bank_table";
import EventRow from "./event_table";
import EventAttendanceRow from "./event_attendance_table";
import EwEffectRow from "./ew_effect_table";
import EwPilotRow from "./ew_pilot_table";
import ExchangeOfficeRow from "./exchange_office_table";
import ExpeditionLogRow from "./expedition_log_table";
import ExpeditionProfileRow from "./expedition_profile_table";
import ExpeditionPublicRow from "./expedition_public_table";
import ExploitActionRow from "./exploit_action_table";
import ExtractorModRow from "./extractor_mod_table";
import ExtractorStateRow from "./extractor_state_table";
import FabJobRow from "./fab_job_table";
import FaithAdherenceRow from "./faith_adherence_table";
import FederalBillRow from "./federal_bill_table";
import FederalBlocVoteRow from "./federal_bloc_vote_table";
import FederalBudgetRow from "./federal_budget_table";
import FederalChoiceRow from "./federal_choice_table";
import FederalCityVoteRow from "./federal_city_vote_table";
import FederalMemberRow from "./federal_member_table";
import FederalOfficeRow from "./federal_office_table";
import FederalPrefRow from "./federal_pref_table";
import FederalPromiseRow from "./federal_promise_table";
import FederalStateRow from "./federal_state_table";
import FederalWorkRow from "./federal_work_table";
import FeedRankRow from "./feed_rank_table";
import FestivalAttendanceRow from "./festival_attendance_table";
import FestivalEntryRow from "./festival_entry_table";
import FestivalKeepsakeRow from "./festival_keepsake_table";
import FieldGuideRow from "./field_guide_table";
import FireworkLaunchRow from "./firework_launch_table";
import FirmConsignmentRow from "./firm_consignment_table";
import FirmPlanRow from "./firm_plan_table";
import FirmPolicyRow from "./firm_policy_table";
import FishingCastRow from "./fishing_cast_table";
import ForgeArtifactRow from "./forge_artifact_table";
import ForgeBuildRow from "./forge_build_table";
import ForgeCompileJobRow from "./forge_compile_job_table";
import ForgeInstanceRow from "./forge_instance_table";
import ForgeProjectRow from "./forge_project_table";
import ForgeReleaseRow from "./forge_release_table";
import ForgeSceneRow from "./forge_scene_table";
import ForgeScriptRow from "./forge_script_table";
import ForgeValidationRow from "./forge_validation_table";
import ForkBallotRow from "./fork_ballot_table";
import ForkVoteRow from "./fork_vote_table";
import FreelanceProjectRow from "./freelance_project_table";
import FunctionLedgerRow from "./function_ledger_table";
import GamePassRow from "./game_pass_table";
import GamePassOwnerRow from "./game_pass_owner_table";
import GameSessionRow from "./game_session_table";
import GovernanceAuditRow from "./governance_audit_table";
import GraveRow from "./grave_table";
import GroundContractRow from "./ground_contract_table";
import GroundEscortRow from "./ground_escort_table";
import GroundParcelRow from "./ground_parcel_table";
import GroundWarRow from "./ground_war_table";
import GroundWarEventRow from "./ground_war_event_table";
import GroupRow from "./group_table";
import GroupMemberRow from "./group_member_table";
import GroupSignatureRow from "./group_signature_table";
import GroupSrpRow from "./group_srp_table";
import GuideMessageRow from "./guide_message_table";
import GuildRow from "./guild_table";
import GuildApplicationRow from "./guild_application_table";
import GuildCandidateRow from "./guild_candidate_table";
import GuildCourtRow from "./guild_court_table";
import GuildElectionRow from "./guild_election_table";
import GuildMemberRow from "./guild_member_table";
import GuildMotionRow from "./guild_motion_table";
import GuildMotionVoteRow from "./guild_motion_vote_table";
import GuildStoreRow from "./guild_store_table";
import GuildStructureRow from "./guild_structure_table";
import GuildTerritoryRow from "./guild_territory_table";
import GuildVersonaRow from "./guild_versona_table";
import GuildVoteRow from "./guild_vote_table";
import GuildWarRow from "./guild_war_table";
import HouseholdRow from "./household_table";
import HouseholdMemberRow from "./household_member_table";
import IncursionStateRow from "./incursion_state_table";
import InstanceGroupRow from "./instance_group_table";
import IntelLicenceRow from "./intel_licence_table";
import IntelOfferRow from "./intel_offer_table";
import InteriorMarkerRow from "./interior_marker_table";
import InteriorOccupantRow from "./interior_occupant_table";
import InventoryItemRow from "./inventory_item_table";
import JobSlotRow from "./job_slot_table";
import KillRecordRow from "./kill_record_table";
import KinshipRow from "./kinship_table";
import LeaderboardRow from "./leaderboard_table";
import LeaderboardSnapshotRow from "./leaderboard_snapshot_table";
import LedgerEntryRow from "./ledger_entry_table";
import LedgerTxRow from "./ledger_tx_table";
import LegacyGrantRow from "./legacy_grant_table";
import LinksetRow from "./linkset_table";
import LivingEventRow from "./living_event_table";
import LotBudgetRow from "./lot_budget_table";
import MarketBookRevRow from "./market_book_rev_table";
import MarketFillRow from "./market_fill_table";
import MarketLinkRow from "./market_link_table";
import MarketListingRow from "./market_listing_table";
import MarketObservationRow from "./market_observation_table";
import MarketOrderRow from "./market_order_table";
import MarketReceiptRow from "./market_receipt_table";
import MarketRoundRow from "./market_round_table";
import MarketSummaryRow from "./market_summary_table";
import MatchEventRow from "./match_event_table";
import MatchParticipantRow from "./match_participant_table";
import MatchProposalRow from "./match_proposal_table";
import MatchResultRow from "./match_result_table";
import MatchScoreRow from "./match_score_table";
import MatchTicketRow from "./match_ticket_table";
import MatchVerdictRow from "./match_verdict_table";
import MayorAuditRow from "./mayor_audit_table";
import MayorElectionRow from "./mayor_election_table";
import MayorRecordRow from "./mayor_record_table";
import MayorVoteRow from "./mayor_vote_table";
import MemoryEntryRow from "./memory_entry_table";
import MemoryProvenanceRow from "./memory_provenance_table";
import MerchantHoldRow from "./merchant_hold_table";
import MerchantListingRow from "./merchant_listing_table";
import MerchantLotRow from "./merchant_lot_table";
import MerchantQueueRow from "./merchant_queue_table";
import MerchantReceiptRow from "./merchant_receipt_table";
import MerchantSaleRow from "./merchant_sale_table";
import MerchantServiceRow from "./merchant_service_table";
import MigrationLogRow from "./migration_log_table";
import MissionHoldRow from "./mission_hold_table";
import ModerationQueueRow from "./moderation_queue_table";
import MourningRow from "./mourning_table";
import MysteryClueRow from "./mystery_clue_table";
import MysteryStateRow from "./mystery_state_table";
import NeedSatisfierRow from "./need_satisfier_table";
import NoBuildZoneRow from "./no_build_zone_table";
import NpcAgentRow from "./npc_agent_table";
import NpcCombatRow from "./npc_combat_table";
import NpcEventRow from "./npc_event_table";
import NpcHostRow from "./npc_host_table";
import NpcMindRow from "./npc_mind_table";
import NpcMoodRow from "./npc_mood_table";
import NpcPackRow from "./npc_pack_table";
import NpcPantryRow from "./npc_pantry_table";
import NpcSkillRow from "./npc_skill_table";
import NpcStrikeRow from "./npc_strike_table";
import NpcUnitRow from "./npc_unit_table";
import OccupationRow from "./occupation_table";
import OnboardingRow from "./onboarding_table";
import OpEnrollmentRow from "./op_enrollment_table";
import OpMeterRow from "./op_meter_table";
import OpObjectiveRow from "./op_objective_table";
import OpReceiptRow from "./op_receipt_table";
import OrbitRow from "./orbit_table";
import OrbitMemberRow from "./orbit_member_table";
import PartRow from "./part_table";
import PartScriptRow from "./part_script_table";
import PartyRow from "./party_table";
import PartyHistoryRow from "./party_history_table";
import PartyInviteRow from "./party_invite_table";
import PartyMemberRow from "./party_member_table";
import PartyMessageRow from "./party_message_table";
import PartyPingRow from "./party_ping_table";
import PartyQueueIntentRow from "./party_queue_intent_table";
import PerfLegRow from "./perf_leg_table";
import PerfRunRow from "./perf_run_table";
import PerfSampleRow from "./perf_sample_table";
import PilotLoyaltyRow from "./pilot_loyalty_table";
import PilotMissionRow from "./pilot_mission_table";
import PilotSkillRow from "./pilot_skill_table";
import PilotStateRow from "./pilot_state_table";
import PilotTrainingRow from "./pilot_training_table";
import PlanetaryPortRow from "./planetary_port_table";
import PlatformFlagRow from "./platform_flag_table";
import PlayerActionRow from "./player_action_table";
import PlayerBountyRow from "./player_bounty_table";
import PlayerBountyHunterRow from "./player_bounty_hunter_table";
import PlayerBountyTraceRow from "./player_bounty_trace_table";
import PlayerCampRow from "./player_camp_table";
import PlayerCivRow from "./player_civ_table";
import PlayerCivMemberRow from "./player_civ_member_table";
import PlayerCivStyleRow from "./player_civ_style_table";
import PlayerEquipmentRow from "./player_equipment_table";
import PlayerFavorRow from "./player_favor_table";
import PlayerInteriorRow from "./player_interior_table";
import PlayerInviteRow from "./player_invite_table";
import PlayerItemRow from "./player_item_table";
import PlayerPostRow from "./player_post_table";
import PlayerRelationRow from "./player_relation_table";
import PlayerRelationEventRow from "./player_relation_event_table";
import PlayerReportRow from "./player_report_table";
import PlayerResourceRow from "./player_resource_table";
import PlayerSchematicRow from "./player_schematic_table";
import PlayerShipRow from "./player_ship_table";
import PlayerStanceRow from "./player_stance_table";
import PlayerStandingRow from "./player_standing_table";
import PlayerStateRow from "./player_state_table";
import PlayerTaleRow from "./player_tale_table";
import PlayerVitalsRow from "./player_vitals_table";
import PortHaulRow from "./port_haul_table";
import PortHaulTermsRow from "./port_haul_terms_table";
import PortReceiptRow from "./port_receipt_table";
import PortStatusRow from "./port_status_table";
import PostRequestRow from "./post_request_table";
import PrefabModelRow from "./prefab_model_table";
import PresenceRow from "./presence_table";
import PriceBeliefRow from "./price_belief_table";
import ProvenanceEventRow from "./provenance_event_table";
import PublishedExperienceRow from "./published_experience_table";
import PulseRow from "./pulse_table";
import PvpArenaMatchRow from "./pvp_arena_match_table";
import PvpArenaMemberRow from "./pvp_arena_member_table";
import PvpArenaQueueRow from "./pvp_arena_queue_table";
import PvpDuelRow from "./pvp_duel_table";
import PvpEnrollmentRow from "./pvp_enrollment_table";
import PvpObjectiveReceiptRow from "./pvp_objective_receipt_table";
import PvpRecordRow from "./pvp_record_table";
import PvpSectorRow from "./pvp_sector_table";
import RaceEntryRow from "./race_entry_table";
import RaceEventRow from "./race_event_table";
import RaceStandingRow from "./race_standing_table";
import RatingRow from "./rating_table";
import RecallPetitionRow from "./recall_petition_table";
import RegionAssetSetRow from "./region_asset_set_table";
import RenderAssetRow from "./render_asset_table";
import RenderAssetTextureTierRow from "./render_asset_texture_tier_table";
import RenderAssetVariantRow from "./render_asset_variant_table";
import RentalRow from "./rental_table";
import RentalContainerRow from "./rental_container_table";
import RentalLeaseRow from "./rental_lease_table";
import RentalReceiptRow from "./rental_receipt_table";
import RentalStoredRow from "./rental_stored_table";
import RentalUnitRow from "./rental_unit_table";
import ReputationRow from "./reputation_table";
import ResearchPostRow from "./research_post_table";
import ResearchTenderRow from "./research_tender_table";
import ResidencyRow from "./residency_table";
import ResourceListingRow from "./resource_listing_table";
import ResourceNodeRow from "./resource_node_table";
import ResourceSpawnRow from "./resource_spawn_table";
import ReviewRow from "./review_table";
import RewardReceiptRow from "./reward_receipt_table";
import RitualRow from "./ritual_table";
import RitualMuteRow from "./ritual_mute_table";
import RoyaltyRow from "./royalty_table";
import ScanStateRow from "./scan_state_table";
import SeasonRow from "./season_table";
import SeasonFestivalRow from "./season_festival_table";
import SeasonScoreRow from "./season_score_table";
import SectorControlRow from "./sector_control_table";
import ServiceJobRow from "./service_job_table";
import ServiceQuoteRow from "./service_quote_table";
import SettlementCivRow from "./settlement_civ_table";
import SettlementEconRow from "./settlement_econ_table";
import SettlementGoodwillRow from "./settlement_goodwill_table";
import SettlementMindRow from "./settlement_mind_table";
import SettlementNameRow from "./settlement_name_table";
import SettlementNormRow from "./settlement_norm_table";
import SettlementOfficeRow from "./settlement_office_table";
import SettlementPartyRow from "./settlement_party_table";
import SettlementResidueRow from "./settlement_residue_table";
import SettlementRivalryRow from "./settlement_rivalry_table";
import SettlementScoreRow from "./settlement_score_table";
import SettlementStockRow from "./settlement_stock_table";
import SettlementTreatyRow from "./settlement_treaty_table";
import ShipBerthRow from "./ship_berth_table";
import ShipComponentRow from "./ship_component_table";
import ShipDeckItemRow from "./ship_deck_item_table";
import ShipInsuranceRow from "./ship_insurance_table";
import ShipPowerRow from "./ship_power_table";
import ShipSubsystemRow from "./ship_subsystem_table";
import ShipWreckRow from "./ship_wreck_table";
import SigRevealRow from "./sig_reveal_table";
import SimLodRow from "./sim_lod_table";
import SimTickLedgerRow from "./sim_tick_ledger_table";
import SkyLightingProfileRow from "./sky_lighting_profile_table";
import SkyShipStateRow from "./sky_ship_state_table";
import SkyStateRow from "./sky_state_table";
import SpaceAdviceRow from "./space_advice_table";
import SpaceAmbushRow from "./space_ambush_table";
import SpaceBookmarkRow from "./space_bookmark_table";
import SpaceBountyRow from "./space_bounty_table";
import SpaceCampaignRow from "./space_campaign_table";
import SpaceClaimRow from "./space_claim_table";
import SpaceCrewRow from "./space_crew_table";
import SpaceDepositRow from "./space_deposit_table";
import SpaceFirmRow from "./space_firm_table";
import SpaceIntelRow from "./space_intel_table";
import SpaceLocationRow from "./space_location_table";
import SpaceMarketDepthRow from "./space_market_depth_table";
import SpaceOperationRow from "./space_operation_table";
import SpacePresenceRow from "./space_presence_table";
import SpacePriceModRow from "./space_price_mod_table";
import SpacePvpHitRow from "./space_pvp_hit_table";
import SpaceSessionRow from "./space_session_table";
import SpaceShipmentRow from "./space_shipment_table";
import SpaceStructureRow from "./space_structure_table";
import SpaceTackleRow from "./space_tackle_table";
import SpendVoteRow from "./spend_vote_table";
import SpyMissionRow from "./spy_mission_table";
import StarterKitRow from "./starter_kit_table";
import StationMusterRow from "./station_muster_table";
import StationServiceRow from "./station_service_table";
import StructureRow from "./structure_table";
import StructureContainerRow from "./structure_container_table";
import StructureDeedRow from "./structure_deed_table";
import StructureFurnishRow from "./structure_furnish_table";
import StructureItemRow from "./structure_item_table";
import StructureLayoutRow from "./structure_layout_table";
import StructureMetaRow from "./structure_meta_table";
import StructureNoteRow from "./structure_note_table";
import StructurePermissionRow from "./structure_permission_table";
import StructurePlanterRow from "./structure_planter_table";
import StructureSiegeRow from "./structure_siege_table";
import SubscriptionRow from "./subscription_table";
import SubsystemAimRow from "./subsystem_aim_table";
import SubsystemJobRow from "./subsystem_job_table";
import SubsystemReceiptRow from "./subsystem_receipt_table";
import SurveyLeaseRow from "./survey_lease_table";
import SurveyViewRow from "./survey_view_table";
import TerrainEditRow from "./terrain_edit_table";
import TerrainRegionRow from "./terrain_region_table";
import TicketPartyRow from "./ticket_party_table";
import TipRecordRow from "./tip_record_table";
import TradeRow from "./trade_table";
import TradeOrderRow from "./trade_order_table";
import TravelOrderRow from "./travel_order_table";
import TravelReturnRow from "./travel_return_table";
import TreasurySpendRow from "./treasury_spend_table";
import TribunalCaseRow from "./tribunal_case_table";
import UnitConditionRow from "./unit_condition_table";
import UnstickRescueStateRow from "./unstick_rescue_state_table";
import UnstickStateRow from "./unstick_state_table";
import VersonaRow from "./versona_table";
import VersonaAspirationRow from "./versona_aspiration_table";
import VersonaBeliefRow from "./versona_belief_table";
import VersonaChatRow from "./versona_chat_table";
import VersonaDeliberationRow from "./versona_deliberation_table";
import VersonaEmotionRow from "./versona_emotion_table";
import VersonaEncounterRow from "./versona_encounter_table";
import VersonaEquipmentRow from "./versona_equipment_table";
import VersonaFavorRow from "./versona_favor_table";
import VersonaGoalRow from "./versona_goal_table";
import VersonaGrudgeRow from "./versona_grudge_table";
import VersonaGuildRow from "./versona_guild_table";
import VersonaGuildMemberRow from "./versona_guild_member_table";
import VersonaInjuryRow from "./versona_injury_table";
import VersonaIntentRow from "./versona_intent_table";
import VersonaJourneyRow from "./versona_journey_table";
import VersonaLineageRow from "./versona_lineage_table";
import VersonaListingRow from "./versona_listing_table";
import VersonaMadeItemRow from "./versona_made_item_table";
import VersonaMemoryRow from "./versona_memory_table";
import VersonaOpinionRow from "./versona_opinion_table";
import VersonaOriginRow from "./versona_origin_table";
import VersonaPairRow from "./versona_pair_table";
import VersonaProfileRow from "./versona_profile_table";
import VersonaRouteRow from "./versona_route_table";
import VersonaStanceRow from "./versona_stance_table";
import VersonaStateRow from "./versona_state_table";
import VersonaThoughtRow from "./versona_thought_table";
import VoiceRoomRow from "./voice_room_table";
import VoiceRoomBanRow from "./voice_room_ban_table";
import VoiceRoomInviteRow from "./voice_room_invite_table";
import VoiceRoomMemberRow from "./voice_room_member_table";
import VoiceSfuAdmissionRow from "./voice_sfu_admission_table";
import VoiceSfuBlockRow from "./voice_sfu_block_table";
import VoiceSfuStateRow from "./voice_sfu_state_table";
import VoiceSignalRow from "./voice_signal_table";
import VoiceTicketRow from "./voice_ticket_table";
import VouchRow from "./vouch_table";
import WalletRow from "./wallet_table";
import WarAirClockRow from "./war_air_clock_table";
import WarAirDuelRow from "./war_air_duel_table";
import WarAirUnitRow from "./war_air_unit_table";
import WarAssignmentRow from "./war_assignment_table";
import WarAuthorityRow from "./war_authority_table";
import WarBondRow from "./war_bond_table";
import WarClashRow from "./war_clash_table";
import WarLifeRow from "./war_life_table";
import WarMemorialRow from "./war_memorial_table";
import WarPetitionRow from "./war_petition_table";
import WarReadinessRow from "./war_readiness_table";
import WarScheduleRow from "./war_schedule_table";
import WarStakeRow from "./war_stake_table";
import WarStateRow from "./war_state_table";
import WarSupplyRunRow from "./war_supply_run_table";
import WaveRow from "./wave_table";
import WaypointRow from "./waypoint_table";
import WeaponFeedRow from "./weapon_feed_table";
import WeaponStateRow from "./weapon_state_table";
import WeatherProfileRow from "./weather_profile_table";
import WildsStateRow from "./wilds_state_table";
import WorldRow from "./world_table";
import WorldBuildBudgetRow from "./world_build_budget_table";
import WorldCoAuthorRow from "./world_co_author_table";
import WorldDeviceRow from "./world_device_table";
import WorldEnvironmentRow from "./world_environment_table";
import WorldGovernanceRow from "./world_governance_table";
import WorldMetricRow from "./world_metric_table";
import WorldObjectRow from "./world_object_table";
import WorldPatchRow from "./world_patch_table";
import WorldPresetRow from "./world_preset_table";
import WorldRatingRow from "./world_rating_table";
import WorldReportRow from "./world_report_table";
import WorldRoleRow from "./world_role_table";
import WorldRulesRow from "./world_rules_table";
import WorldScriptRow from "./world_script_table";
import WorldSnapshotRow from "./world_snapshot_table";
import WorldVisitRow from "./world_visit_table";
import WormholeFluxRow from "./wormhole_flux_table";
import ZoningGrantRow from "./zoning_grant_table";

/** Type-only namespace exports for generated type groups. */

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema({
  abyssalHull: __table({
    name: 'abyssal_hull',
    indexes: [
      { accessor: 'runId', name: 'abyssal_hull_run_id_idx_btree', algorithm: 'btree', columns: [
        'runId',
      ] },
    ],
    constraints: [
      { name: 'abyssal_hull_run_id_key', constraint: 'unique', columns: ['runId'] },
    ],
  }, AbyssalHullRow),
  abyssalRun: __table({
    name: 'abyssal_run',
    indexes: [
      { accessor: 'abyssalByIdentity', name: 'abyssal_run_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'runId', name: 'abyssal_run_run_id_idx_btree', algorithm: 'btree', columns: [
        'runId',
      ] },
    ],
    constraints: [
      { name: 'abyssal_run_run_id_key', constraint: 'unique', columns: ['runId'] },
    ],
  }, AbyssalRunRow),
  account: __table({
    name: 'account',
    indexes: [
      { accessor: 'accountId', name: 'account_account_id_idx_btree', algorithm: 'btree', columns: [
        'accountId',
      ] },
      { accessor: 'identity', name: 'account_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'username', name: 'account_username_idx_btree', algorithm: 'btree', columns: [
        'username',
      ] },
    ],
    constraints: [
      { name: 'account_account_id_key', constraint: 'unique', columns: ['accountId'] },
      { name: 'account_identity_key', constraint: 'unique', columns: ['identity'] },
      { name: 'account_username_key', constraint: 'unique', columns: ['username'] },
    ],
  }, AccountRow),
  activityStation: __table({
    name: 'activity_station',
    indexes: [
      { accessor: 'activityStationBySettlement', name: 'activity_station_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
      { accessor: 'stationId', name: 'activity_station_station_id_idx_btree', algorithm: 'btree', columns: [
        'stationId',
      ] },
    ],
    constraints: [
      { name: 'activity_station_station_id_key', constraint: 'unique', columns: ['stationId'] },
    ],
  }, ActivityStationRow),
  adminPlacement: __table({
    name: 'admin_placement',
    indexes: [
      { accessor: 'placementId', name: 'admin_placement_placement_id_idx_btree', algorithm: 'btree', columns: [
        'placementId',
      ] },
      { accessor: 'adminPlacementByWorld', name: 'admin_placement_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'admin_placement_placement_id_key', constraint: 'unique', columns: ['placementId'] },
    ],
  }, AdminPlacementRow),
  airStrike: __table({
    name: 'air_strike',
    indexes: [
      { accessor: 'airId', name: 'air_strike_air_id_idx_btree', algorithm: 'btree', columns: [
        'airId',
      ] },
    ],
    constraints: [
      { name: 'air_strike_air_id_key', constraint: 'unique', columns: ['airId'] },
    ],
  }, AirStrikeRow),
  arcadeGame: __table({
    name: 'arcade_game',
    indexes: [
      { accessor: 'arcadeGameByCreator', name: 'arcade_game_creator_idx_btree', algorithm: 'btree', columns: [
        'creator',
      ] },
      { accessor: 'gameId', name: 'arcade_game_game_id_idx_btree', algorithm: 'btree', columns: [
        'gameId',
      ] },
      { accessor: 'arcadeGameByPinned', name: 'arcade_game_pinned_to_idx_btree', algorithm: 'btree', columns: [
        'pinnedTo',
      ] },
    ],
    constraints: [
      { name: 'arcade_game_game_id_key', constraint: 'unique', columns: ['gameId'] },
    ],
  }, ArcadeGameRow),
  arcadeGameDef: __table({
    name: 'arcade_game_def',
    indexes: [
      { accessor: 'gameId', name: 'arcade_game_def_game_id_idx_btree', algorithm: 'btree', columns: [
        'gameId',
      ] },
    ],
    constraints: [
      { name: 'arcade_game_def_game_id_key', constraint: 'unique', columns: ['gameId'] },
    ],
  }, ArcadeGameDefRow),
  arcadeSeason: __table({
    name: 'arcade_season',
    indexes: [
      { accessor: 'arcadeSeasonByGame', name: 'arcade_season_game_id_idx_btree', algorithm: 'btree', columns: [
        'gameId',
      ] },
      { accessor: 'seasonId', name: 'arcade_season_season_id_idx_btree', algorithm: 'btree', columns: [
        'seasonId',
      ] },
    ],
    constraints: [
      { name: 'arcade_season_season_id_key', constraint: 'unique', columns: ['seasonId'] },
    ],
  }, ArcadeSeasonRow),
  arcadeTabState: __table({
    name: 'arcade_tab_state',
    indexes: [
      { accessor: 'id', name: 'arcade_tab_state_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'arcade_tab_state_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ArcadeTabStateRow),
  asset: __table({
    name: 'asset',
    indexes: [
      { accessor: 'assetId', name: 'asset_asset_id_idx_btree', algorithm: 'btree', columns: [
        'assetId',
      ] },
      { accessor: 'assetByCreator', name: 'asset_creator_idx_btree', algorithm: 'btree', columns: [
        'creator',
      ] },
      { accessor: 'assetByKind', name: 'asset_kind_idx_btree', algorithm: 'btree', columns: [
        'kind',
      ] },
      { accessor: 'assetByParent', name: 'asset_parent_asset_id_idx_btree', algorithm: 'btree', columns: [
        'parentAssetId',
      ] },
    ],
    constraints: [
      { name: 'asset_asset_id_key', constraint: 'unique', columns: ['assetId'] },
    ],
  }, AssetRow),
  assetBridge: __table({
    name: 'asset_bridge',
    indexes: [
      { accessor: 'assetBridgeByAsset', name: 'asset_bridge_asset_id_idx_btree', algorithm: 'btree', columns: [
        'assetId',
      ] },
      { accessor: 'bridgeId', name: 'asset_bridge_bridge_id_idx_btree', algorithm: 'btree', columns: [
        'bridgeId',
      ] },
    ],
    constraints: [
      { name: 'asset_bridge_bridge_id_key', constraint: 'unique', columns: ['bridgeId'] },
    ],
  }, AssetBridgeRow),
  assetCollider: __table({
    name: 'asset_collider',
    indexes: [
      { accessor: 'assetId', name: 'asset_collider_asset_id_idx_btree', algorithm: 'btree', columns: [
        'assetId',
      ] },
    ],
    constraints: [
      { name: 'asset_collider_asset_id_key', constraint: 'unique', columns: ['assetId'] },
    ],
  }, AssetColliderRow),
  assetFormat: __table({
    name: 'asset_format',
    indexes: [
      { accessor: 'assetId', name: 'asset_format_asset_id_idx_btree', algorithm: 'btree', columns: [
        'assetId',
      ] },
    ],
    constraints: [
      { name: 'asset_format_asset_id_key', constraint: 'unique', columns: ['assetId'] },
    ],
  }, AssetFormatRow),
  assetPack: __table({
    name: 'asset_pack',
    indexes: [
      { accessor: 'assetPackByName', name: 'asset_pack_name_idx_btree', algorithm: 'btree', columns: [
        'name',
      ] },
      { accessor: 'packId', name: 'asset_pack_pack_id_idx_btree', algorithm: 'btree', columns: [
        'packId',
      ] },
    ],
    constraints: [
      { name: 'asset_pack_pack_id_key', constraint: 'unique', columns: ['packId'] },
    ],
  }, AssetPackRow),
  assetUpload: __table({
    name: 'asset_upload',
    indexes: [
      { accessor: 'uploadId', name: 'asset_upload_upload_id_idx_btree', algorithm: 'btree', columns: [
        'uploadId',
      ] },
      { accessor: 'assetUploadByUploader', name: 'asset_upload_uploader_idx_btree', algorithm: 'btree', columns: [
        'uploader',
      ] },
    ],
    constraints: [
      { name: 'asset_upload_upload_id_key', constraint: 'unique', columns: ['uploadId'] },
    ],
  }, AssetUploadRow),
  assetValidationLimits: __table({
    name: 'asset_validation_limits',
    indexes: [
      { accessor: 'useClass', name: 'asset_validation_limits_use_class_idx_btree', algorithm: 'btree', columns: [
        'useClass',
      ] },
    ],
    constraints: [
      { name: 'asset_validation_limits_use_class_key', constraint: 'unique', columns: ['useClass'] },
    ],
  }, AssetValidationLimitsRow),
  audioZone: __table({
    name: 'audio_zone',
    indexes: [
      { accessor: 'audioZoneByWorld', name: 'audio_zone_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
      { accessor: 'zoneId', name: 'audio_zone_zone_id_idx_btree', algorithm: 'btree', columns: [
        'zoneId',
      ] },
    ],
    constraints: [
      { name: 'audio_zone_zone_id_key', constraint: 'unique', columns: ['zoneId'] },
    ],
  }, AudioZoneRow),
  avatar: __table({
    name: 'avatar',
    indexes: [
      { accessor: 'identity', name: 'avatar_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'avatar_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, AvatarRow),
  bank: __table({
    name: 'bank',
    indexes: [
      { accessor: 'bankId', name: 'bank_bank_id_idx_btree', algorithm: 'btree', columns: [
        'bankId',
      ] },
    ],
    constraints: [
      { name: 'bank_bank_id_key', constraint: 'unique', columns: ['bankId'] },
    ],
  }, BankRow),
  bankAccount: __table({
    name: 'bank_account',
    indexes: [
      { accessor: 'accountKey', name: 'bank_account_account_key_idx_btree', algorithm: 'btree', columns: [
        'accountKey',
      ] },
      { accessor: 'bankAccountByBank', name: 'bank_account_bank_id_idx_btree', algorithm: 'btree', columns: [
        'bankId',
      ] },
      { accessor: 'bankAccountByIdentity', name: 'bank_account_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'bank_account_account_key_key', constraint: 'unique', columns: ['accountKey'] },
    ],
  }, BankAccountRow),
  bankCustody: __table({
    name: 'bank_custody',
    indexes: [
      { accessor: 'entryId', name: 'bank_custody_entry_id_idx_btree', algorithm: 'btree', columns: [
        'entryId',
      ] },
      { accessor: 'bankCustodyByIdentity', name: 'bank_custody_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'bankCustodyByLoan', name: 'bank_custody_loan_id_idx_btree', algorithm: 'btree', columns: [
        'loanId',
      ] },
    ],
    constraints: [
      { name: 'bank_custody_entry_id_key', constraint: 'unique', columns: ['entryId'] },
    ],
  }, BankCustodyRow),
  bankLoan: __table({
    name: 'bank_loan',
    indexes: [
      { accessor: 'bankLoanByBank', name: 'bank_loan_bank_id_idx_btree', algorithm: 'btree', columns: [
        'bankId',
      ] },
      { accessor: 'bankLoanByBorrower', name: 'bank_loan_borrower_idx_btree', algorithm: 'btree', columns: [
        'borrower',
      ] },
      { accessor: 'loanId', name: 'bank_loan_loan_id_idx_btree', algorithm: 'btree', columns: [
        'loanId',
      ] },
    ],
    constraints: [
      { name: 'bank_loan_loan_id_key', constraint: 'unique', columns: ['loanId'] },
    ],
  }, BankLoanRow),
  bankRepoLot: __table({
    name: 'bank_repo_lot',
    indexes: [
      { accessor: 'bankRepoLotByBank', name: 'bank_repo_lot_bank_id_idx_btree', algorithm: 'btree', columns: [
        'bankId',
      ] },
      { accessor: 'lotId', name: 'bank_repo_lot_lot_id_idx_btree', algorithm: 'btree', columns: [
        'lotId',
      ] },
    ],
    constraints: [
      { name: 'bank_repo_lot_lot_id_key', constraint: 'unique', columns: ['lotId'] },
    ],
  }, BankRepoLotRow),
  bankTermDeposit: __table({
    name: 'bank_term_deposit',
    indexes: [
      { accessor: 'bankTermDepositByBank', name: 'bank_term_deposit_bank_id_idx_btree', algorithm: 'btree', columns: [
        'bankId',
      ] },
      { accessor: 'cdId', name: 'bank_term_deposit_cd_id_idx_btree', algorithm: 'btree', columns: [
        'cdId',
      ] },
      { accessor: 'bankTermDepositByIdentity', name: 'bank_term_deposit_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'bank_term_deposit_cd_id_key', constraint: 'unique', columns: ['cdId'] },
    ],
  }, BankTermDepositRow),
  bankTxn: __table({
    name: 'bank_txn',
    indexes: [
      { accessor: 'bankTxnByIdentity', name: 'bank_txn_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'txnId', name: 'bank_txn_txn_id_idx_btree', algorithm: 'btree', columns: [
        'txnId',
      ] },
    ],
    constraints: [
      { name: 'bank_txn_txn_id_key', constraint: 'unique', columns: ['txnId'] },
    ],
  }, BankTxnRow),
  battle: __table({
    name: 'battle',
    indexes: [
      { accessor: 'battleId', name: 'battle_battle_id_idx_btree', algorithm: 'btree', columns: [
        'battleId',
      ] },
      { accessor: 'battleByWar', name: 'battle_war_id_idx_btree', algorithm: 'btree', columns: [
        'warId',
      ] },
    ],
    constraints: [
      { name: 'battle_battle_id_key', constraint: 'unique', columns: ['battleId'] },
    ],
  }, BattleRow),
  battleAdvice: __table({
    name: 'battle_advice',
    indexes: [
      { accessor: 'adviceId', name: 'battle_advice_advice_id_idx_btree', algorithm: 'btree', columns: [
        'adviceId',
      ] },
      { accessor: 'battleAdviceByBattle', name: 'battle_advice_battle_id_idx_btree', algorithm: 'btree', columns: [
        'battleId',
      ] },
    ],
    constraints: [
      { name: 'battle_advice_advice_id_key', constraint: 'unique', columns: ['adviceId'] },
    ],
  }, BattleAdviceRow),
  battleCall: __table({
    name: 'battle_call',
    indexes: [
      { accessor: 'battleCallByBattle', name: 'battle_call_battle_id_idx_btree', algorithm: 'btree', columns: [
        'battleId',
      ] },
      { accessor: 'callId', name: 'battle_call_call_id_idx_btree', algorithm: 'btree', columns: [
        'callId',
      ] },
    ],
    constraints: [
      { name: 'battle_call_call_id_key', constraint: 'unique', columns: ['callId'] },
    ],
  }, BattleCallRow),
  battleEvent: __table({
    name: 'battle_event',
    indexes: [
      { accessor: 'battleEventByBattle', name: 'battle_event_battle_id_idx_btree', algorithm: 'btree', columns: [
        'battleId',
      ] },
      { accessor: 'eventId', name: 'battle_event_event_id_idx_btree', algorithm: 'btree', columns: [
        'eventId',
      ] },
    ],
    constraints: [
      { name: 'battle_event_event_id_key', constraint: 'unique', columns: ['eventId'] },
    ],
  }, BattleEventRow),
  battleLook: __table({
    name: 'battle_look',
    indexes: [
      { accessor: 'battleLookByBattle', name: 'battle_look_battle_id_idx_btree', algorithm: 'btree', columns: [
        'battleId',
      ] },
      { accessor: 'lookId', name: 'battle_look_look_id_idx_btree', algorithm: 'btree', columns: [
        'lookId',
      ] },
    ],
    constraints: [
      { name: 'battle_look_look_id_key', constraint: 'unique', columns: ['lookId'] },
    ],
  }, BattleLookRow),
  battleObjective: __table({
    name: 'battle_objective',
    indexes: [
      { accessor: 'battleObjectiveByBattle', name: 'battle_objective_battle_id_idx_btree', algorithm: 'btree', columns: [
        'battleId',
      ] },
      { accessor: 'objectiveId', name: 'battle_objective_objective_id_idx_btree', algorithm: 'btree', columns: [
        'objectiveId',
      ] },
    ],
    constraints: [
      { name: 'battle_objective_objective_id_key', constraint: 'unique', columns: ['objectiveId'] },
    ],
  }, BattleObjectiveRow),
  battleOutpost: __table({
    name: 'battle_outpost',
    indexes: [
      { accessor: 'battleOutpostByBattle', name: 'battle_outpost_battle_id_idx_btree', algorithm: 'btree', columns: [
        'battleId',
      ] },
      { accessor: 'outpostId', name: 'battle_outpost_outpost_id_idx_btree', algorithm: 'btree', columns: [
        'outpostId',
      ] },
    ],
    constraints: [
      { name: 'battle_outpost_outpost_id_key', constraint: 'unique', columns: ['outpostId'] },
    ],
  }, BattleOutpostRow),
  battleRecord: __table({
    name: 'battle_record',
    indexes: [
      { accessor: 'battleId', name: 'battle_record_battle_id_idx_btree', algorithm: 'btree', columns: [
        'battleId',
      ] },
    ],
    constraints: [
      { name: 'battle_record_battle_id_key', constraint: 'unique', columns: ['battleId'] },
    ],
  }, BattleRecordRow),
  battleSquad: __table({
    name: 'battle_squad',
    indexes: [
      { accessor: 'battleSquadByBattle', name: 'battle_squad_battle_id_idx_btree', algorithm: 'btree', columns: [
        'battleId',
      ] },
      { accessor: 'squadId', name: 'battle_squad_squad_id_idx_btree', algorithm: 'btree', columns: [
        'squadId',
      ] },
    ],
    constraints: [
      { name: 'battle_squad_squad_id_key', constraint: 'unique', columns: ['squadId'] },
    ],
  }, BattleSquadRow),
  battleUnit: __table({
    name: 'battle_unit',
    indexes: [
      { accessor: 'battleUnitByBattle', name: 'battle_unit_battle_id_idx_btree', algorithm: 'btree', columns: [
        'battleId',
      ] },
      { accessor: 'unitId', name: 'battle_unit_unit_id_idx_btree', algorithm: 'btree', columns: [
        'unitId',
      ] },
    ],
    constraints: [
      { name: 'battle_unit_unit_id_key', constraint: 'unique', columns: ['unitId'] },
    ],
  }, BattleUnitRow),
  beginnerMixerSuggestion: __table({
    name: 'beginner_mixer_suggestion',
    indexes: [
      { accessor: 'mixerSuggestionByIdentity', name: 'beginner_mixer_suggestion_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'sugId', name: 'beginner_mixer_suggestion_sug_id_idx_btree', algorithm: 'btree', columns: [
        'sugId',
      ] },
    ],
    constraints: [
      { name: 'beginner_mixer_suggestion_sug_id_key', constraint: 'unique', columns: ['sugId'] },
    ],
  }, BeginnerMixerSuggestionRow),
  betrayalRecord: __table({
    name: 'betrayal_record',
    indexes: [
      { accessor: 'betrayalByBetrayer', name: 'betrayal_record_betrayer_idx_btree', algorithm: 'btree', columns: [
        'betrayer',
      ] },
      { accessor: 'recordId', name: 'betrayal_record_record_id_idx_btree', algorithm: 'btree', columns: [
        'recordId',
      ] },
      { accessor: 'betrayalByVictim', name: 'betrayal_record_victim_idx_btree', algorithm: 'btree', columns: [
        'victim',
      ] },
    ],
    constraints: [
      { name: 'betrayal_record_record_id_key', constraint: 'unique', columns: ['recordId'] },
    ],
  }, BetrayalRecordRow),
  bountyContract: __table({
    name: 'bounty_contract',
    indexes: [
      { accessor: 'bountyId', name: 'bounty_contract_bounty_id_idx_btree', algorithm: 'btree', columns: [
        'bountyId',
      ] },
      { accessor: 'bountyByState', name: 'bounty_contract_state_idx_btree', algorithm: 'btree', columns: [
        'state',
      ] },
      { accessor: 'bountyByTarget', name: 'bounty_contract_target_idx_btree', algorithm: 'btree', columns: [
        'target',
      ] },
    ],
    constraints: [
      { name: 'bounty_contract_bounty_id_key', constraint: 'unique', columns: ['bountyId'] },
    ],
  }, BountyContractRow),
  bountyCue: __table({
    name: 'bounty_cue',
    indexes: [
      { accessor: 'cueId', name: 'bounty_cue_cue_id_idx_btree', algorithm: 'btree', columns: [
        'cueId',
      ] },
      { accessor: 'bountyCueByTarget', name: 'bounty_cue_target_idx_btree', algorithm: 'btree', columns: [
        'target',
      ] },
    ],
    constraints: [
      { name: 'bounty_cue_cue_id_key', constraint: 'unique', columns: ['cueId'] },
    ],
  }, BountyCueRow),
  bountyDebug: __table({
    name: 'bounty_debug',
    indexes: [
      { accessor: 'bountyId', name: 'bounty_debug_bounty_id_idx_btree', algorithm: 'btree', columns: [
        'bountyId',
      ] },
    ],
    constraints: [
      { name: 'bounty_debug_bounty_id_key', constraint: 'unique', columns: ['bountyId'] },
    ],
  }, BountyDebugRow),
  bountyEvent: __table({
    name: 'bounty_event',
    indexes: [
      { accessor: 'bountyEventByBounty', name: 'bounty_event_bounty_id_idx_btree', algorithm: 'btree', columns: [
        'bountyId',
      ] },
      { accessor: 'eventId', name: 'bounty_event_event_id_idx_btree', algorithm: 'btree', columns: [
        'eventId',
      ] },
      { accessor: 'bountyEventByTarget', name: 'bounty_event_target_idx_btree', algorithm: 'btree', columns: [
        'target',
      ] },
    ],
    constraints: [
      { name: 'bounty_event_event_id_key', constraint: 'unique', columns: ['eventId'] },
    ],
  }, BountyEventRow),
  bountyHunt: __table({
    name: 'bounty_hunt',
    indexes: [
      { accessor: 'bountyId', name: 'bounty_hunt_bounty_id_idx_btree', algorithm: 'btree', columns: [
        'bountyId',
      ] },
      { accessor: 'bountyHuntByTarget', name: 'bounty_hunt_target_idx_btree', algorithm: 'btree', columns: [
        'target',
      ] },
    ],
    constraints: [
      { name: 'bounty_hunt_bounty_id_key', constraint: 'unique', columns: ['bountyId'] },
    ],
  }, BountyHuntRow),
  bridgeAudit: __table({
    name: 'bridge_audit',
    indexes: [
      { accessor: 'auditId', name: 'bridge_audit_audit_id_idx_btree', algorithm: 'btree', columns: [
        'auditId',
      ] },
      { accessor: 'bridgeAuditBySettlement', name: 'bridge_audit_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'bridge_audit_audit_id_key', constraint: 'unique', columns: ['auditId'] },
    ],
  }, BridgeAuditRow),
  campaignAar: __table({
    name: 'campaign_aar',
    indexes: [
      { accessor: 'aarKey', name: 'campaign_aar_aar_key_idx_btree', algorithm: 'btree', columns: [
        'aarKey',
      ] },
      { accessor: 'campaignAarByCampaign', name: 'campaign_aar_campaign_id_idx_btree', algorithm: 'btree', columns: [
        'campaignId',
      ] },
    ],
    constraints: [
      { name: 'campaign_aar_aar_key_key', constraint: 'unique', columns: ['aarKey'] },
    ],
  }, CampaignAarRow),
  campaignCapital: __table({
    name: 'campaign_capital',
    indexes: [
      { accessor: 'campaignCapitalByCampaign', name: 'campaign_capital_campaign_id_idx_btree', algorithm: 'btree', columns: [
        'campaignId',
      ] },
      { accessor: 'capId', name: 'campaign_capital_cap_id_idx_btree', algorithm: 'btree', columns: [
        'capId',
      ] },
    ],
    constraints: [
      { name: 'campaign_capital_cap_id_key', constraint: 'unique', columns: ['capId'] },
    ],
  }, CampaignCapitalRow),
  campaignEscort: __table({
    name: 'campaign_escort',
    indexes: [
      { accessor: 'campaignEscortByCampaign', name: 'campaign_escort_campaign_id_idx_btree', algorithm: 'btree', columns: [
        'campaignId',
      ] },
      { accessor: 'escortId', name: 'campaign_escort_escort_id_idx_btree', algorithm: 'btree', columns: [
        'escortId',
      ] },
    ],
    constraints: [
      { name: 'campaign_escort_escort_id_key', constraint: 'unique', columns: ['escortId'] },
    ],
  }, CampaignEscortRow),
  campaignOpsPin: __table({
    name: 'campaign_ops_pin',
    indexes: [
      { accessor: 'campaignId', name: 'campaign_ops_pin_campaign_id_idx_btree', algorithm: 'btree', columns: [
        'campaignId',
      ] },
    ],
    constraints: [
      { name: 'campaign_ops_pin_campaign_id_key', constraint: 'unique', columns: ['campaignId'] },
    ],
  }, CampaignOpsPinRow),
  campaignReceipt: __table({
    name: 'campaign_receipt',
    indexes: [
      { accessor: 'campaignReceiptByCampaign', name: 'campaign_receipt_campaign_id_idx_btree', algorithm: 'btree', columns: [
        'campaignId',
      ] },
      { accessor: 'campaignReceiptByIdentity', name: 'campaign_receipt_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'receiptId', name: 'campaign_receipt_receipt_id_idx_btree', algorithm: 'btree', columns: [
        'receiptId',
      ] },
    ],
    constraints: [
      { name: 'campaign_receipt_receipt_id_key', constraint: 'unique', columns: ['receiptId'] },
    ],
  }, CampaignReceiptRow),
  campaignSide: __table({
    name: 'campaign_side',
    indexes: [
      { accessor: 'campaignSideByCampaign', name: 'campaign_side_campaign_id_idx_btree', algorithm: 'btree', columns: [
        'campaignId',
      ] },
      { accessor: 'sideId', name: 'campaign_side_side_id_idx_btree', algorithm: 'btree', columns: [
        'sideId',
      ] },
    ],
    constraints: [
      { name: 'campaign_side_side_id_key', constraint: 'unique', columns: ['sideId'] },
    ],
  }, CampaignSideRow),
  campaignSky: __table({
    name: 'campaign_sky',
    indexes: [
      { accessor: 'cyc', name: 'campaign_sky_cyc_idx_btree', algorithm: 'btree', columns: [
        'cyc',
      ] },
    ],
    constraints: [
      { name: 'campaign_sky_cyc_key', constraint: 'unique', columns: ['cyc'] },
    ],
  }, CampaignSkyRow),
  campaignStance: __table({
    name: 'campaign_stance',
    indexes: [
      { accessor: 'campaignStanceByCampaign', name: 'campaign_stance_campaign_id_idx_btree', algorithm: 'btree', columns: [
        'campaignId',
      ] },
      { accessor: 'stanceId', name: 'campaign_stance_stance_id_idx_btree', algorithm: 'btree', columns: [
        'stanceId',
      ] },
    ],
    constraints: [
      { name: 'campaign_stance_stance_id_key', constraint: 'unique', columns: ['stanceId'] },
    ],
  }, CampaignStanceRow),
  caravanRow: __table({
    name: 'caravan',
    indexes: [
      { accessor: 'caravanId', name: 'caravan_caravan_id_idx_btree', algorithm: 'btree', columns: [
        'caravanId',
      ] },
      { accessor: 'caravanByDest', name: 'caravan_to_sid_idx_btree', algorithm: 'btree', columns: [
        'toSid',
      ] },
    ],
    constraints: [
      { name: 'caravan_caravan_id_key', constraint: 'unique', columns: ['caravanId'] },
    ],
  }, CaravanRowRow),
  cargoConvoy: __table({
    name: 'cargo_convoy',
    indexes: [
      { accessor: 'convoyId', name: 'cargo_convoy_convoy_id_idx_btree', algorithm: 'btree', columns: [
        'convoyId',
      ] },
      { accessor: 'cargoConvoyByStatus', name: 'cargo_convoy_status_idx_btree', algorithm: 'btree', columns: [
        'status',
      ] },
    ],
    constraints: [
      { name: 'cargo_convoy_convoy_id_key', constraint: 'unique', columns: ['convoyId'] },
    ],
  }, CargoConvoyRow),
  cargoLot: __table({
    name: 'cargo_lot',
    indexes: [
      { accessor: 'cargoLotByFamily', name: 'cargo_lot_family_key_idx_btree', algorithm: 'btree', columns: [
        'familyKey',
      ] },
      { accessor: 'cargoLotByLoc', name: 'cargo_lot_loc_id_idx_btree', algorithm: 'btree', columns: [
        'locId',
      ] },
      { accessor: 'lotId', name: 'cargo_lot_lot_id_idx_btree', algorithm: 'btree', columns: [
        'lotId',
      ] },
      { accessor: 'cargoLotByOwner', name: 'cargo_lot_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'cargoLotByTag', name: 'cargo_lot_tag_idx_btree', algorithm: 'btree', columns: [
        'tag',
      ] },
    ],
    constraints: [
      { name: 'cargo_lot_lot_id_key', constraint: 'unique', columns: ['lotId'] },
    ],
  }, CargoLotRow),
  charterChallenge: __table({
    name: 'charter_challenge',
    indexes: [
      { accessor: 'challengeId', name: 'charter_challenge_challenge_id_idx_btree', algorithm: 'btree', columns: [
        'challengeId',
      ] },
      { accessor: 'challengeByGroup', name: 'charter_challenge_group_id_idx_btree', algorithm: 'btree', columns: [
        'groupId',
      ] },
    ],
    constraints: [
      { name: 'charter_challenge_challenge_id_key', constraint: 'unique', columns: ['challengeId'] },
    ],
  }, CharterChallengeRow),
  charterClause: __table({
    name: 'charter_clause',
    indexes: [
      { accessor: 'clauseId', name: 'charter_clause_clause_id_idx_btree', algorithm: 'btree', columns: [
        'clauseId',
      ] },
      { accessor: 'charterClauseBySettlement', name: 'charter_clause_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'charter_clause_clause_id_key', constraint: 'unique', columns: ['clauseId'] },
    ],
  }, CharterClauseRow),
  chatLang: __table({
    name: 'chat_lang',
    indexes: [
      { accessor: 'identity', name: 'chat_lang_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'chat_lang_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, ChatLangRow),
  chatMessage: __table({
    name: 'chat_message',
    indexes: [
      { accessor: 'msgId', name: 'chat_message_msg_id_idx_btree', algorithm: 'btree', columns: [
        'msgId',
      ] },
      { accessor: 'chatMessageByWorld', name: 'chat_message_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'chat_message_msg_id_key', constraint: 'unique', columns: ['msgId'] },
    ],
  }, ChatMessageRow),
  chatTranslateRequest: __table({
    name: 'chat_translate_request',
    indexes: [
      { accessor: 'requestId', name: 'chat_translate_request_request_id_idx_btree', algorithm: 'btree', columns: [
        'requestId',
      ] },
    ],
    constraints: [
      { name: 'chat_translate_request_request_id_key', constraint: 'unique', columns: ['requestId'] },
    ],
  }, ChatTranslateRequestRow),
  chatTranslation: __table({
    name: 'chat_translation',
    indexes: [
      { accessor: 'key', name: 'chat_translation_key_idx_btree', algorithm: 'btree', columns: [
        'key',
      ] },
      { accessor: 'chatTranslationByMsg', name: 'chat_translation_msg_id_idx_btree', algorithm: 'btree', columns: [
        'msgId',
      ] },
    ],
    constraints: [
      { name: 'chat_translation_key_key', constraint: 'unique', columns: ['key'] },
    ],
  }, ChatTranslationRow),
  cheatFlag: __table({
    name: 'cheat_flag',
    indexes: [
      { accessor: 'flagId', name: 'cheat_flag_flag_id_idx_btree', algorithm: 'btree', columns: [
        'flagId',
      ] },
      { accessor: 'cheatFlagByPlayer', name: 'cheat_flag_player_idx_btree', algorithm: 'btree', columns: [
        'player',
      ] },
      { accessor: 'cheatFlagBySession', name: 'cheat_flag_session_id_idx_btree', algorithm: 'btree', columns: [
        'sessionId',
      ] },
    ],
    constraints: [
      { name: 'cheat_flag_flag_id_key', constraint: 'unique', columns: ['flagId'] },
    ],
  }, CheatFlagRow),
  chronicle: __table({
    name: 'chronicle',
    indexes: [
      { accessor: 'chronicleByActor', name: 'chronicle_actor_id_idx_btree', algorithm: 'btree', columns: [
        'actorId',
      ] },
      { accessor: 'chronId', name: 'chronicle_chron_id_idx_btree', algorithm: 'btree', columns: [
        'chronId',
      ] },
      { accessor: 'chronicleBySettlement', name: 'chronicle_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'chronicle_chron_id_key', constraint: 'unique', columns: ['chronId'] },
    ],
  }, ChronicleRow),
  chroniclerEvent: __table({
    name: 'chronicler_event',
    indexes: [
      { accessor: 'eventId', name: 'chronicler_event_event_id_idx_btree', algorithm: 'btree', columns: [
        'eventId',
      ] },
      { accessor: 'chroniclerByKind', name: 'chronicler_event_kind_idx_btree', algorithm: 'btree', columns: [
        'kind',
      ] },
    ],
    constraints: [
      { name: 'chronicler_event_event_id_key', constraint: 'unique', columns: ['eventId'] },
    ],
  }, ChroniclerEventRow),
  citizen: __table({
    name: 'citizen',
    indexes: [
      { accessor: 'citizenId', name: 'citizen_citizen_id_idx_btree', algorithm: 'btree', columns: [
        'citizenId',
      ] },
      { accessor: 'citizenByCity', name: 'citizen_city_id_idx_btree', algorithm: 'btree', columns: [
        'cityId',
      ] },
      { accessor: 'citizenByIdentity', name: 'citizen_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'citizen_citizen_id_key', constraint: 'unique', columns: ['citizenId'] },
    ],
  }, CitizenRow),
  city: __table({
    name: 'city',
    indexes: [
      { accessor: 'cityId', name: 'city_city_id_idx_btree', algorithm: 'btree', columns: [
        'cityId',
      ] },
      { accessor: 'cityByMayor', name: 'city_mayor_idx_btree', algorithm: 'btree', columns: [
        'mayor',
      ] },
    ],
    constraints: [
      { name: 'city_city_id_key', constraint: 'unique', columns: ['cityId'] },
    ],
  }, CityRow),
  cityAllegiance: __table({
    name: 'city_allegiance',
    indexes: [
      { accessor: 'cityId', name: 'city_allegiance_city_id_idx_btree', algorithm: 'btree', columns: [
        'cityId',
      ] },
    ],
    constraints: [
      { name: 'city_allegiance_city_id_key', constraint: 'unique', columns: ['cityId'] },
    ],
  }, CityAllegianceRow),
  citySpec: __table({
    name: 'city_spec',
    indexes: [
      { accessor: 'settlementId', name: 'city_spec_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'city_spec_settlement_id_key', constraint: 'unique', columns: ['settlementId'] },
    ],
  }, CitySpecRow),
  cityTurretShot: __table({
    name: 'city_turret_shot',
    indexes: [
      { accessor: 'cityTurretShotByCity', name: 'city_turret_shot_city_id_idx_btree', algorithm: 'btree', columns: [
        'cityId',
      ] },
      { accessor: 'shotId', name: 'city_turret_shot_shot_id_idx_btree', algorithm: 'btree', columns: [
        'shotId',
      ] },
    ],
    constraints: [
      { name: 'city_turret_shot_shot_id_key', constraint: 'unique', columns: ['shotId'] },
    ],
  }, CityTurretShotRow),
  cityVersonaResident: __table({
    name: 'city_versona_resident',
    indexes: [
      { accessor: 'cityVersonaResidentByCity', name: 'city_versona_resident_city_id_idx_btree', algorithm: 'btree', columns: [
        'cityId',
      ] },
      { accessor: 'residentId', name: 'city_versona_resident_resident_id_idx_btree', algorithm: 'btree', columns: [
        'residentId',
      ] },
      { accessor: 'cityVersonaResidentByVersona', name: 'city_versona_resident_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'city_versona_resident_resident_id_key', constraint: 'unique', columns: ['residentId'] },
    ],
  }, CityVersonaResidentRow),
  civFlipLog: __table({
    name: 'civ_flip_log',
    indexes: [
      { accessor: 'flipId', name: 'civ_flip_log_flip_id_idx_btree', algorithm: 'btree', columns: [
        'flipId',
      ] },
      { accessor: 'civFlipBySettlement', name: 'civ_flip_log_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'civ_flip_log_flip_id_key', constraint: 'unique', columns: ['flipId'] },
    ],
  }, CivFlipLogRow),
  civOperation: __table({
    name: 'civ_operation',
    indexes: [
      { accessor: 'civOperationByCiv', name: 'civ_operation_civ_idx_btree', algorithm: 'btree', columns: [
        'civ',
      ] },
      { accessor: 'opId', name: 'civ_operation_op_id_idx_btree', algorithm: 'btree', columns: [
        'opId',
      ] },
    ],
    constraints: [
      { name: 'civ_operation_op_id_key', constraint: 'unique', columns: ['opId'] },
    ],
  }, CivOperationRow),
  civReserve: __table({
    name: 'civ_reserve',
    indexes: [
      { accessor: 'civ', name: 'civ_reserve_civ_idx_btree', algorithm: 'btree', columns: [
        'civ',
      ] },
    ],
    constraints: [
      { name: 'civ_reserve_civ_key', constraint: 'unique', columns: ['civ'] },
    ],
  }, CivReserveRow),
  civTreaty: __table({
    name: 'civ_treaty',
    indexes: [
      { accessor: 'treatyId', name: 'civ_treaty_treaty_id_idx_btree', algorithm: 'btree', columns: [
        'treatyId',
      ] },
    ],
    constraints: [
      { name: 'civ_treaty_treaty_id_key', constraint: 'unique', columns: ['treatyId'] },
    ],
  }, CivTreatyRow),
  civicSign: __table({
    name: 'civic_sign',
    indexes: [
      { accessor: 'civicSignByIdentity', name: 'civic_sign_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'civicSignByRef', name: 'civic_sign_ref_id_idx_btree', algorithm: 'btree', columns: [
        'refId',
      ] },
      { accessor: 'signId', name: 'civic_sign_sign_id_idx_btree', algorithm: 'btree', columns: [
        'signId',
      ] },
    ],
    constraints: [
      { name: 'civic_sign_sign_id_key', constraint: 'unique', columns: ['signId'] },
    ],
  }, CivicSignRow),
  civicStructure: __table({
    name: 'civic_structure',
    indexes: [
      { accessor: 'civicStructureByCity', name: 'civic_structure_city_id_idx_btree', algorithm: 'btree', columns: [
        'cityId',
      ] },
      { accessor: 'structureId', name: 'civic_structure_structure_id_idx_btree', algorithm: 'btree', columns: [
        'structureId',
      ] },
    ],
    constraints: [
      { name: 'civic_structure_structure_id_key', constraint: 'unique', columns: ['structureId'] },
    ],
  }, CivicStructureRow),
  coinIssuance: __table({
    name: 'coin_issuance',
    indexes: [
      { accessor: 'source', name: 'coin_issuance_source_idx_btree', algorithm: 'btree', columns: [
        'source',
      ] },
    ],
    constraints: [
      { name: 'coin_issuance_source_key', constraint: 'unique', columns: ['source'] },
    ],
  }, CoinIssuanceRow),
  combatAction: __table({
    name: 'combat_action',
    indexes: [
      { accessor: 'combatActionByAttacker', name: 'combat_action_attacker_idx_btree', algorithm: 'btree', columns: [
        'attacker',
      ] },
      { accessor: 'scheduledId', name: 'combat_action_scheduled_id_idx_btree', algorithm: 'btree', columns: [
        'scheduledId',
      ] },
      { accessor: 'combatActionByTargetPlayer', name: 'combat_action_target_player_idx_btree', algorithm: 'btree', columns: [
        'targetPlayer',
      ] },
    ],
    constraints: [
      { name: 'combat_action_scheduled_id_key', constraint: 'unique', columns: ['scheduledId'] },
    ],
  }, CombatActionRow),
  combatActor: __table({
    name: 'combat_actor',
    indexes: [
      { accessor: 'identity', name: 'combat_actor_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'combat_actor_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, CombatActorRow),
  combatResult: __table({
    name: 'combat_result',
    indexes: [
      { accessor: 'combatResultByAttacker', name: 'combat_result_attacker_idx_btree', algorithm: 'btree', columns: [
        'attacker',
      ] },
      { accessor: 'resultId', name: 'combat_result_result_id_idx_btree', algorithm: 'btree', columns: [
        'resultId',
      ] },
      { accessor: 'combatResultByTargetPlayer', name: 'combat_result_target_player_idx_btree', algorithm: 'btree', columns: [
        'targetPlayer',
      ] },
    ],
    constraints: [
      { name: 'combat_result_result_id_key', constraint: 'unique', columns: ['resultId'] },
    ],
  }, CombatResultRow),
  compass: __table({
    name: 'compass',
    indexes: [
      { accessor: 'identity', name: 'compass_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'compass_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, CompassRow),
  contactBlock: __table({
    name: 'contact_block',
    indexes: [
      { accessor: 'blockId', name: 'contact_block_block_id_idx_btree', algorithm: 'btree', columns: [
        'blockId',
      ] },
      { accessor: 'contactBlockByBlocked', name: 'contact_block_blocked_idx_btree', algorithm: 'btree', columns: [
        'blocked',
      ] },
      { accessor: 'contactBlockByBlocker', name: 'contact_block_blocker_idx_btree', algorithm: 'btree', columns: [
        'blocker',
      ] },
    ],
    constraints: [
      { name: 'contact_block_block_id_key', constraint: 'unique', columns: ['blockId'] },
    ],
  }, ContactBlockRow),
  contactEdge: __table({
    name: 'contact_edge',
    indexes: [
      { accessor: 'contactEdgeByA', name: 'contact_edge_a_idx_btree', algorithm: 'btree', columns: [
        'a',
      ] },
      { accessor: 'contactEdgeByB', name: 'contact_edge_b_idx_btree', algorithm: 'btree', columns: [
        'b',
      ] },
      { accessor: 'edgeId', name: 'contact_edge_edge_id_idx_btree', algorithm: 'btree', columns: [
        'edgeId',
      ] },
    ],
    constraints: [
      { name: 'contact_edge_edge_id_key', constraint: 'unique', columns: ['edgeId'] },
    ],
  }, ContactEdgeRow),
  containerItem: __table({
    name: 'container_item',
    indexes: [
      { accessor: 'containerItemByContainer', name: 'container_item_container_id_idx_btree', algorithm: 'btree', columns: [
        'containerId',
      ] },
      { accessor: 'entryId', name: 'container_item_entry_id_idx_btree', algorithm: 'btree', columns: [
        'entryId',
      ] },
      { accessor: 'containerItemByStructure', name: 'container_item_structure_id_idx_btree', algorithm: 'btree', columns: [
        'structureId',
      ] },
    ],
    constraints: [
      { name: 'container_item_entry_id_key', constraint: 'unique', columns: ['entryId'] },
    ],
  }, ContainerItemRow),
  contingentRequest: __table({
    name: 'contingent_request',
    indexes: [
      { accessor: 'contingentRequestByCiv', name: 'contingent_request_civ_idx_btree', algorithm: 'btree', columns: [
        'civ',
      ] },
      { accessor: 'requestId', name: 'contingent_request_request_id_idx_btree', algorithm: 'btree', columns: [
        'requestId',
      ] },
    ],
    constraints: [
      { name: 'contingent_request_request_id_key', constraint: 'unique', columns: ['requestId'] },
    ],
  }, ContingentRequestRow),
  contract: __table({
    name: 'contract',
    indexes: [
      { accessor: 'contractId', name: 'contract_contract_id_idx_btree', algorithm: 'btree', columns: [
        'contractId',
      ] },
      { accessor: 'contractByWorld', name: 'contract_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'contract_contract_id_key', constraint: 'unique', columns: ['contractId'] },
    ],
  }, ContractRow),
  contractEvent: __table({
    name: 'contract_event',
    indexes: [
      { accessor: 'contractEventByContract', name: 'contract_event_contract_id_idx_btree', algorithm: 'btree', columns: [
        'contractId',
      ] },
      { accessor: 'eventId', name: 'contract_event_event_id_idx_btree', algorithm: 'btree', columns: [
        'eventId',
      ] },
      { accessor: 'contractEventByWorld', name: 'contract_event_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'contract_event_event_id_key', constraint: 'unique', columns: ['eventId'] },
    ],
  }, ContractEventRow),
  contractState: __table({
    name: 'contract_state',
    indexes: [
      { accessor: 'contractId', name: 'contract_state_contract_id_idx_btree', algorithm: 'btree', columns: [
        'contractId',
      ] },
    ],
    constraints: [
      { name: 'contract_state_contract_id_key', constraint: 'unique', columns: ['contractId'] },
    ],
  }, ContractStateRow),
  councilAction: __table({
    name: 'council_action',
    indexes: [
      { accessor: 'actionId', name: 'council_action_action_id_idx_btree', algorithm: 'btree', columns: [
        'actionId',
      ] },
      { accessor: 'councilActionByActor', name: 'council_action_actor_idx_btree', algorithm: 'btree', columns: [
        'actor',
      ] },
    ],
    constraints: [
      { name: 'council_action_action_id_key', constraint: 'unique', columns: ['actionId'] },
    ],
  }, CouncilActionRow),
  councilSeat: __table({
    name: 'council_seat',
    indexes: [
      { accessor: 'councilSeatByHolder', name: 'council_seat_holder_idx_btree', algorithm: 'btree', columns: [
        'holder',
      ] },
      { accessor: 'seatId', name: 'council_seat_seat_id_idx_btree', algorithm: 'btree', columns: [
        'seatId',
      ] },
      { accessor: 'councilSeatByTerm', name: 'council_seat_term_id_idx_btree', algorithm: 'btree', columns: [
        'termId',
      ] },
    ],
    constraints: [
      { name: 'council_seat_seat_id_key', constraint: 'unique', columns: ['seatId'] },
    ],
  }, CouncilSeatRow),
  councilTerm: __table({
    name: 'council_term',
    indexes: [
      { accessor: 'termId', name: 'council_term_term_id_idx_btree', algorithm: 'btree', columns: [
        'termId',
      ] },
    ],
    constraints: [
      { name: 'council_term_term_id_key', constraint: 'unique', columns: ['termId'] },
    ],
  }, CouncilTermRow),
  councilVote: __table({
    name: 'council_vote',
    indexes: [
      { accessor: 'councilVoteByTerm', name: 'council_vote_term_id_idx_btree', algorithm: 'btree', columns: [
        'termId',
      ] },
      { accessor: 'voteId', name: 'council_vote_vote_id_idx_btree', algorithm: 'btree', columns: [
        'voteId',
      ] },
    ],
    constraints: [
      { name: 'council_vote_vote_id_key', constraint: 'unique', columns: ['voteId'] },
    ],
  }, CouncilVoteRow),
  courierContract: __table({
    name: 'courier_contract',
    indexes: [
      { accessor: 'contractId', name: 'courier_contract_contract_id_idx_btree', algorithm: 'btree', columns: [
        'contractId',
      ] },
      { accessor: 'courierByCourier', name: 'courier_contract_courier_idx_btree', algorithm: 'btree', columns: [
        'courier',
      ] },
      { accessor: 'courierByIssuer', name: 'courier_contract_issuer_idx_btree', algorithm: 'btree', columns: [
        'issuer',
      ] },
      { accessor: 'courierByState', name: 'courier_contract_state_idx_btree', algorithm: 'btree', columns: [
        'state',
      ] },
    ],
    constraints: [
      { name: 'courier_contract_contract_id_key', constraint: 'unique', columns: ['contractId'] },
    ],
  }, CourierContractRow),
  creatorCert: __table({
    name: 'creator_cert',
    indexes: [
      { accessor: 'identity', name: 'creator_cert_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'creator_cert_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, CreatorCertRow),
  creature: __table({
    name: 'creature',
    indexes: [
      { accessor: 'creatureId', name: 'creature_creature_id_idx_btree', algorithm: 'btree', columns: [
        'creatureId',
      ] },
      { accessor: 'creatureByDen', name: 'creature_den_key_idx_btree', algorithm: 'btree', columns: [
        'denKey',
      ] },
    ],
    constraints: [
      { name: 'creature_creature_id_key', constraint: 'unique', columns: ['creatureId'] },
    ],
  }, CreatureRow),
  creditFile: __table({
    name: 'credit_file',
    indexes: [
      { accessor: 'identity', name: 'credit_file_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'credit_file_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, CreditFileRow),
  crewLease: __table({
    name: 'crew_lease',
    indexes: [
      { accessor: 'crewLeaseByCaptain', name: 'crew_lease_captain_idx_btree', algorithm: 'btree', columns: [
        'captain',
      ] },
      { accessor: 'crewLeaseByHolder', name: 'crew_lease_holder_idx_btree', algorithm: 'btree', columns: [
        'holder',
      ] },
      { accessor: 'leaseId', name: 'crew_lease_lease_id_idx_btree', algorithm: 'btree', columns: [
        'leaseId',
      ] },
      { accessor: 'crewLeaseByShip', name: 'crew_lease_ship_id_idx_btree', algorithm: 'btree', columns: [
        'shipId',
      ] },
    ],
    constraints: [
      { name: 'crew_lease_lease_id_key', constraint: 'unique', columns: ['leaseId'] },
    ],
  }, CrewLeaseRow),
  crimeCase: __table({
    name: 'crime_case',
    indexes: [
      { accessor: 'caseId', name: 'crime_case_case_id_idx_btree', algorithm: 'btree', columns: [
        'caseId',
      ] },
      { accessor: 'crimeCaseBySettlement', name: 'crime_case_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'crime_case_case_id_key', constraint: 'unique', columns: ['caseId'] },
    ],
  }, CrimeCaseRow),
  dailySettlement: __table({
    name: 'daily_settlement',
    indexes: [
      { accessor: 'dailySettlementByCreator', name: 'daily_settlement_creator_idx_btree', algorithm: 'btree', columns: [
        'creator',
      ] },
      { accessor: 'settleId', name: 'daily_settlement_settle_id_idx_btree', algorithm: 'btree', columns: [
        'settleId',
      ] },
    ],
    constraints: [
      { name: 'daily_settlement_settle_id_key', constraint: 'unique', columns: ['settleId'] },
    ],
  }, DailySettlementRow),
  defeatReceipt: __table({
    name: 'defeat_receipt',
    indexes: [
      { accessor: 'receiptKey', name: 'defeat_receipt_receipt_key_idx_btree', algorithm: 'btree', columns: [
        'receiptKey',
      ] },
      { accessor: 'defeatReceiptByTarget', name: 'defeat_receipt_target_idx_btree', algorithm: 'btree', columns: [
        'target',
      ] },
    ],
    constraints: [
      { name: 'defeat_receipt_receipt_key_key', constraint: 'unique', columns: ['receiptKey'] },
    ],
  }, DefeatReceiptRow),
  denHull: __table({
    name: 'den_hull',
    indexes: [
      { accessor: 'hullId', name: 'den_hull_hull_id_idx_btree', algorithm: 'btree', columns: [
        'hullId',
      ] },
      { accessor: 'denHullBySystem', name: 'den_hull_system_id_idx_btree', algorithm: 'btree', columns: [
        'systemId',
      ] },
    ],
    constraints: [
      { name: 'den_hull_hull_id_key', constraint: 'unique', columns: ['hullId'] },
    ],
  }, DenHullRow),
  denSlot: __table({
    name: 'den_slot',
    indexes: [
      { accessor: 'slotId', name: 'den_slot_slot_id_idx_btree', algorithm: 'btree', columns: [
        'slotId',
      ] },
      { accessor: 'denSlotBySystem', name: 'den_slot_system_id_idx_btree', algorithm: 'btree', columns: [
        'systemId',
      ] },
    ],
    constraints: [
      { name: 'den_slot_slot_id_key', constraint: 'unique', columns: ['slotId'] },
    ],
  }, DenSlotRow),
  denState: __table({
    name: 'den_state',
    indexes: [
      { accessor: 'stateId', name: 'den_state_state_id_idx_btree', algorithm: 'btree', columns: [
        'stateId',
      ] },
      { accessor: 'denStateBySystem', name: 'den_state_system_id_idx_btree', algorithm: 'btree', columns: [
        'systemId',
      ] },
    ],
    constraints: [
      { name: 'den_state_state_id_key', constraint: 'unique', columns: ['stateId'] },
    ],
  }, DenStateRow),
  depotResupply: __table({
    name: 'depot_resupply',
    indexes: [
      { accessor: 'structId', name: 'depot_resupply_struct_id_idx_btree', algorithm: 'btree', columns: [
        'structId',
      ] },
    ],
    constraints: [
      { name: 'depot_resupply_struct_id_key', constraint: 'unique', columns: ['structId'] },
    ],
  }, DepotResupplyRow),
  deviceTierHint: __table({
    name: 'device_tier_hint',
    indexes: [
      { accessor: 'identity', name: 'device_tier_hint_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'device_tier_hint_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, DeviceTierHintRow),
  directMessage: __table({
    name: 'direct_message',
    indexes: [
      { accessor: 'msgId', name: 'direct_message_msg_id_idx_btree', algorithm: 'btree', columns: [
        'msgId',
      ] },
      { accessor: 'directMessageBySender', name: 'direct_message_sender_idx_btree', algorithm: 'btree', columns: [
        'sender',
      ] },
      { accessor: 'directMessageByTarget', name: 'direct_message_target_idx_btree', algorithm: 'btree', columns: [
        'target',
      ] },
    ],
    constraints: [
      { name: 'direct_message_msg_id_key', constraint: 'unique', columns: ['msgId'] },
    ],
  }, DirectMessageRow),
  discoveryPrefs: __table({
    name: 'discovery_prefs',
    indexes: [
      { accessor: 'creator', name: 'discovery_prefs_creator_idx_btree', algorithm: 'btree', columns: [
        'creator',
      ] },
    ],
    constraints: [
      { name: 'discovery_prefs_creator_key', constraint: 'unique', columns: ['creator'] },
    ],
  }, DiscoveryPrefsRow),
  displayNameChange: __table({
    name: 'display_name_change',
    indexes: [
      { accessor: 'identity', name: 'display_name_change_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'display_name_change_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, DisplayNameChangeRow),
  droidBrain: __table({
    name: 'droid_brain',
    indexes: [
      { accessor: 'droidId', name: 'droid_brain_droid_id_idx_btree', algorithm: 'btree', columns: [
        'droidId',
      ] },
      { accessor: 'droidBrainByOwner', name: 'droid_brain_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
    ],
    constraints: [
      { name: 'droid_brain_droid_id_key', constraint: 'unique', columns: ['droidId'] },
    ],
  }, DroidBrainRow),
  droidCargo: __table({
    name: 'droid_cargo',
    indexes: [
      { accessor: 'droidCargoByDroid', name: 'droid_cargo_droid_id_idx_btree', algorithm: 'btree', columns: [
        'droidId',
      ] },
      { accessor: 'entryId', name: 'droid_cargo_entry_id_idx_btree', algorithm: 'btree', columns: [
        'entryId',
      ] },
    ],
    constraints: [
      { name: 'droid_cargo_entry_id_key', constraint: 'unique', columns: ['entryId'] },
    ],
  }, DroidCargoRow),
  droidLog: __table({
    name: 'droid_log',
    indexes: [
      { accessor: 'droidId', name: 'droid_log_droid_id_idx_btree', algorithm: 'btree', columns: [
        'droidId',
      ] },
      { accessor: 'droidLogByOwner', name: 'droid_log_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
    ],
    constraints: [
      { name: 'droid_log_droid_id_key', constraint: 'unique', columns: ['droidId'] },
    ],
  }, DroidLogRow),
  droidPos: __table({
    name: 'droid_pos',
    indexes: [
      { accessor: 'droidId', name: 'droid_pos_droid_id_idx_btree', algorithm: 'btree', columns: [
        'droidId',
      ] },
    ],
    constraints: [
      { name: 'droid_pos_droid_id_key', constraint: 'unique', columns: ['droidId'] },
    ],
  }, DroidPosRow),
  droidPurse: __table({
    name: 'droid_purse',
    indexes: [
      { accessor: 'droidId', name: 'droid_purse_droid_id_idx_btree', algorithm: 'btree', columns: [
        'droidId',
      ] },
      { accessor: 'droidPurseByOwner', name: 'droid_purse_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
    ],
    constraints: [
      { name: 'droid_purse_droid_id_key', constraint: 'unique', columns: ['droidId'] },
    ],
  }, DroidPurseRow),
  droidReport: __table({
    name: 'droid_report',
    indexes: [
      { accessor: 'droidReportByDroid', name: 'droid_report_droid_id_idx_btree', algorithm: 'btree', columns: [
        'droidId',
      ] },
      { accessor: 'droidReportByOwner', name: 'droid_report_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'reportId', name: 'droid_report_report_id_idx_btree', algorithm: 'btree', columns: [
        'reportId',
      ] },
    ],
    constraints: [
      { name: 'droid_report_report_id_key', constraint: 'unique', columns: ['reportId'] },
    ],
  }, DroidReportRow),
  droidRoute: __table({
    name: 'droid_route',
    indexes: [
      { accessor: 'droidId', name: 'droid_route_droid_id_idx_btree', algorithm: 'btree', columns: [
        'droidId',
      ] },
    ],
    constraints: [
      { name: 'droid_route_droid_id_key', constraint: 'unique', columns: ['droidId'] },
    ],
  }, DroidRouteRow),
  droidSay: __table({
    name: 'droid_say',
    indexes: [
      { accessor: 'sayId', name: 'droid_say_say_id_idx_btree', algorithm: 'btree', columns: [
        'sayId',
      ] },
      { accessor: 'droidSayByWorld', name: 'droid_say_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'droid_say_say_id_key', constraint: 'unique', columns: ['sayId'] },
    ],
  }, DroidSayRow),
  droidSource: __table({
    name: 'droid_source',
    indexes: [
      { accessor: 'droidId', name: 'droid_source_droid_id_idx_btree', algorithm: 'btree', columns: [
        'droidId',
      ] },
      { accessor: 'droidSourceByOwner', name: 'droid_source_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
    ],
    constraints: [
      { name: 'droid_source_droid_id_key', constraint: 'unique', columns: ['droidId'] },
    ],
  }, DroidSourceRow),
  droidUnit: __table({
    name: 'droid_unit',
    indexes: [
      { accessor: 'droidId', name: 'droid_unit_droid_id_idx_btree', algorithm: 'btree', columns: [
        'droidId',
      ] },
      { accessor: 'droidUnitByOwner', name: 'droid_unit_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
    ],
    constraints: [
      { name: 'droid_unit_droid_id_key', constraint: 'unique', columns: ['droidId'] },
    ],
  }, DroidUnitRow),
  droidVitals: __table({
    name: 'droid_vitals',
    indexes: [
      { accessor: 'droidId', name: 'droid_vitals_droid_id_idx_btree', algorithm: 'btree', columns: [
        'droidId',
      ] },
      { accessor: 'droidVitalsByOwner', name: 'droid_vitals_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
    ],
    constraints: [
      { name: 'droid_vitals_droid_id_key', constraint: 'unique', columns: ['droidId'] },
    ],
  }, DroidVitalsRow),
  econHealth: __table({
    name: 'econ_health',
    indexes: [
      { accessor: 'key', name: 'econ_health_key_idx_btree', algorithm: 'btree', columns: [
        'key',
      ] },
    ],
    constraints: [
      { name: 'econ_health_key_key', constraint: 'unique', columns: ['key'] },
    ],
  }, EconHealthRow),
  electionRace: __table({
    name: 'election_race',
    indexes: [
      { accessor: 'raceId', name: 'election_race_race_id_idx_btree', algorithm: 'btree', columns: [
        'raceId',
      ] },
      { accessor: 'electionRaceBySettlement', name: 'election_race_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'election_race_race_id_key', constraint: 'unique', columns: ['raceId'] },
    ],
  }, ElectionRaceRow),
  entitlement: __table({
    name: 'entitlement',
    indexes: [
      { accessor: 'identity', name: 'entitlement_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'entitlement_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, EntitlementRow),
  escortExtraction: __table({
    name: 'escort_extraction',
    indexes: [
      { accessor: 'escortExtractionByCampaign', name: 'escort_extraction_campaign_id_idx_btree', algorithm: 'btree', columns: [
        'campaignId',
      ] },
      { accessor: 'extractKey', name: 'escort_extraction_extract_key_idx_btree', algorithm: 'btree', columns: [
        'extractKey',
      ] },
    ],
    constraints: [
      { name: 'escort_extraction_extract_key_key', constraint: 'unique', columns: ['extractKey'] },
    ],
  }, EscortExtractionRow),
  escrow: __table({
    name: 'escrow',
    indexes: [
      { accessor: 'escrowId', name: 'escrow_escrow_id_idx_btree', algorithm: 'btree', columns: [
        'escrowId',
      ] },
      { accessor: 'escrowByPayee', name: 'escrow_payee_idx_btree', algorithm: 'btree', columns: [
        'payee',
      ] },
      { accessor: 'escrowByPayer', name: 'escrow_payer_idx_btree', algorithm: 'btree', columns: [
        'payer',
      ] },
    ],
    constraints: [
      { name: 'escrow_escrow_id_key', constraint: 'unique', columns: ['escrowId'] },
    ],
  }, EscrowRow),
  essBank: __table({
    name: 'ess_bank',
    indexes: [
      { accessor: 'bankId', name: 'ess_bank_bank_id_idx_btree', algorithm: 'btree', columns: [
        'bankId',
      ] },
      { accessor: 'essBankBySystem', name: 'ess_bank_system_key_idx_btree', algorithm: 'btree', columns: [
        'systemKey',
      ] },
    ],
    constraints: [
      { name: 'ess_bank_bank_id_key', constraint: 'unique', columns: ['bankId'] },
    ],
  }, EssBankRow),
  event: __table({
    name: 'event',
    indexes: [
      { accessor: 'eventId', name: 'event_event_id_idx_btree', algorithm: 'btree', columns: [
        'eventId',
      ] },
      { accessor: 'eventByHost', name: 'event_host_idx_btree', algorithm: 'btree', columns: [
        'host',
      ] },
      { accessor: 'eventByWorld', name: 'event_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'event_event_id_key', constraint: 'unique', columns: ['eventId'] },
    ],
  }, EventRow),
  eventAttendance: __table({
    name: 'event_attendance',
    indexes: [
      { accessor: 'attendanceId', name: 'event_attendance_attendance_id_idx_btree', algorithm: 'btree', columns: [
        'attendanceId',
      ] },
      { accessor: 'attendanceByEvent', name: 'event_attendance_event_id_idx_btree', algorithm: 'btree', columns: [
        'eventId',
      ] },
      { accessor: 'attendanceByIdentity', name: 'event_attendance_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'event_attendance_attendance_id_key', constraint: 'unique', columns: ['attendanceId'] },
    ],
  }, EventAttendanceRow),
  ewEffect: __table({
    name: 'ew_effect',
    indexes: [
      { accessor: 'effectId', name: 'ew_effect_effect_id_idx_btree', algorithm: 'btree', columns: [
        'effectId',
      ] },
      { accessor: 'ewEffectBySource', name: 'ew_effect_source_idx_btree', algorithm: 'btree', columns: [
        'source',
      ] },
      { accessor: 'ewEffectByState', name: 'ew_effect_state_idx_btree', algorithm: 'btree', columns: [
        'state',
      ] },
      { accessor: 'ewEffectByTarget', name: 'ew_effect_target_idx_btree', algorithm: 'btree', columns: [
        'target',
      ] },
    ],
    constraints: [
      { name: 'ew_effect_effect_id_key', constraint: 'unique', columns: ['effectId'] },
    ],
  }, EwEffectRow),
  ewPilot: __table({
    name: 'ew_pilot',
    indexes: [
      { accessor: 'identity', name: 'ew_pilot_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'ew_pilot_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, EwPilotRow),
  exchangeOffice: __table({
    name: 'exchange_office',
    indexes: [
      { accessor: 'settlementId', name: 'exchange_office_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'exchange_office_settlement_id_key', constraint: 'unique', columns: ['settlementId'] },
    ],
  }, ExchangeOfficeRow),
  expeditionLog: __table({
    name: 'expedition_log',
    indexes: [
      { accessor: 'logId', name: 'expedition_log_log_id_idx_btree', algorithm: 'btree', columns: [
        'logId',
      ] },
      { accessor: 'expeditionLogByOwner', name: 'expedition_log_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
    ],
    constraints: [
      { name: 'expedition_log_log_id_key', constraint: 'unique', columns: ['logId'] },
    ],
  }, ExpeditionLogRow),
  expeditionProfile: __table({
    name: 'expedition_profile',
    indexes: [
      { accessor: 'identity', name: 'expedition_profile_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'expedition_profile_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, ExpeditionProfileRow),
  expeditionPublic: __table({
    name: 'expedition_public',
    indexes: [
      { accessor: 'logId', name: 'expedition_public_log_id_idx_btree', algorithm: 'btree', columns: [
        'logId',
      ] },
      { accessor: 'expeditionPublicByOwner', name: 'expedition_public_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
    ],
    constraints: [
      { name: 'expedition_public_log_id_key', constraint: 'unique', columns: ['logId'] },
    ],
  }, ExpeditionPublicRow),
  exploitAction: __table({
    name: 'exploit_action',
    indexes: [
      { accessor: 'eaId', name: 'exploit_action_ea_id_idx_btree', algorithm: 'btree', columns: [
        'eaId',
      ] },
      { accessor: 'exploitBySubject', name: 'exploit_action_subject_idx_btree', algorithm: 'btree', columns: [
        'subject',
      ] },
      { accessor: 'exploitByWorld', name: 'exploit_action_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'exploit_action_ea_id_key', constraint: 'unique', columns: ['eaId'] },
    ],
  }, ExploitActionRow),
  extractorMod: __table({
    name: 'extractor_mod',
    indexes: [
      { accessor: 'structureId', name: 'extractor_mod_structure_id_idx_btree', algorithm: 'btree', columns: [
        'structureId',
      ] },
    ],
    constraints: [
      { name: 'extractor_mod_structure_id_key', constraint: 'unique', columns: ['structureId'] },
    ],
  }, ExtractorModRow),
  extractorState: __table({
    name: 'extractor_state',
    indexes: [
      { accessor: 'structureId', name: 'extractor_state_structure_id_idx_btree', algorithm: 'btree', columns: [
        'structureId',
      ] },
    ],
    constraints: [
      { name: 'extractor_state_structure_id_key', constraint: 'unique', columns: ['structureId'] },
    ],
  }, ExtractorStateRow),
  fabJob: __table({
    name: 'fab_job',
    indexes: [
      { accessor: 'jobId', name: 'fab_job_job_id_idx_btree', algorithm: 'btree', columns: [
        'jobId',
      ] },
      { accessor: 'fabJobByOwner', name: 'fab_job_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'fabJobByStation', name: 'fab_job_station_key_idx_btree', algorithm: 'btree', columns: [
        'stationKey',
      ] },
    ],
    constraints: [
      { name: 'fab_job_job_id_key', constraint: 'unique', columns: ['jobId'] },
    ],
  }, FabJobRow),
  faithAdherence: __table({
    name: 'faith_adherence',
    indexes: [
      { accessor: 'versonaId', name: 'faith_adherence_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'faith_adherence_versona_id_key', constraint: 'unique', columns: ['versonaId'] },
    ],
  }, FaithAdherenceRow),
  federalBill: __table({
    name: 'federal_bill',
    indexes: [
      { accessor: 'billId', name: 'federal_bill_bill_id_idx_btree', algorithm: 'btree', columns: [
        'billId',
      ] },
      { accessor: 'federalBillByCiv', name: 'federal_bill_civ_idx_btree', algorithm: 'btree', columns: [
        'civ',
      ] },
    ],
    constraints: [
      { name: 'federal_bill_bill_id_key', constraint: 'unique', columns: ['billId'] },
    ],
  }, FederalBillRow),
  federalBlocVote: __table({
    name: 'federal_bloc_vote',
    indexes: [
      { accessor: 'federalBlocVoteByBill', name: 'federal_bloc_vote_bill_id_idx_btree', algorithm: 'btree', columns: [
        'billId',
      ] },
      { accessor: 'voteId', name: 'federal_bloc_vote_vote_id_idx_btree', algorithm: 'btree', columns: [
        'voteId',
      ] },
    ],
    constraints: [
      { name: 'federal_bloc_vote_vote_id_key', constraint: 'unique', columns: ['voteId'] },
    ],
  }, FederalBlocVoteRow),
  federalBudget: __table({
    name: 'federal_budget',
    indexes: [
      { accessor: 'civ', name: 'federal_budget_civ_idx_btree', algorithm: 'btree', columns: [
        'civ',
      ] },
    ],
    constraints: [
      { name: 'federal_budget_civ_key', constraint: 'unique', columns: ['civ'] },
    ],
  }, FederalBudgetRow),
  federalChoice: __table({
    name: 'federal_choice',
    indexes: [
      { accessor: 'choiceId', name: 'federal_choice_choice_id_idx_btree', algorithm: 'btree', columns: [
        'choiceId',
      ] },
    ],
    constraints: [
      { name: 'federal_choice_choice_id_key', constraint: 'unique', columns: ['choiceId'] },
    ],
  }, FederalChoiceRow),
  federalCityVote: __table({
    name: 'federal_city_vote',
    indexes: [
      { accessor: 'federalCityVoteByBill', name: 'federal_city_vote_bill_id_idx_btree', algorithm: 'btree', columns: [
        'billId',
      ] },
      { accessor: 'voteId', name: 'federal_city_vote_vote_id_idx_btree', algorithm: 'btree', columns: [
        'voteId',
      ] },
    ],
    constraints: [
      { name: 'federal_city_vote_vote_id_key', constraint: 'unique', columns: ['voteId'] },
    ],
  }, FederalCityVoteRow),
  federalMember: __table({
    name: 'federal_member',
    indexes: [
      { accessor: 'federalMemberByCiv', name: 'federal_member_civ_idx_btree', algorithm: 'btree', columns: [
        'civ',
      ] },
      { accessor: 'settlementId', name: 'federal_member_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'federal_member_settlement_id_key', constraint: 'unique', columns: ['settlementId'] },
    ],
  }, FederalMemberRow),
  federalOffice: __table({
    name: 'federal_office',
    indexes: [
      { accessor: 'federalOfficeByCiv', name: 'federal_office_civ_idx_btree', algorithm: 'btree', columns: [
        'civ',
      ] },
      { accessor: 'officeId', name: 'federal_office_office_id_idx_btree', algorithm: 'btree', columns: [
        'officeId',
      ] },
    ],
    constraints: [
      { name: 'federal_office_office_id_key', constraint: 'unique', columns: ['officeId'] },
    ],
  }, FederalOfficeRow),
  federalPref: __table({
    name: 'federal_pref',
    indexes: [
      { accessor: 'federalPrefByBill', name: 'federal_pref_bill_id_idx_btree', algorithm: 'btree', columns: [
        'billId',
      ] },
      { accessor: 'prefId', name: 'federal_pref_pref_id_idx_btree', algorithm: 'btree', columns: [
        'prefId',
      ] },
    ],
    constraints: [
      { name: 'federal_pref_pref_id_key', constraint: 'unique', columns: ['prefId'] },
    ],
  }, FederalPrefRow),
  federalPromise: __table({
    name: 'federal_promise',
    indexes: [
      { accessor: 'federalPromiseByCiv', name: 'federal_promise_civ_idx_btree', algorithm: 'btree', columns: [
        'civ',
      ] },
      { accessor: 'promiseId', name: 'federal_promise_promise_id_idx_btree', algorithm: 'btree', columns: [
        'promiseId',
      ] },
    ],
    constraints: [
      { name: 'federal_promise_promise_id_key', constraint: 'unique', columns: ['promiseId'] },
    ],
  }, FederalPromiseRow),
  federalState: __table({
    name: 'federal_state',
    indexes: [
      { accessor: 'civ', name: 'federal_state_civ_idx_btree', algorithm: 'btree', columns: [
        'civ',
      ] },
    ],
    constraints: [
      { name: 'federal_state_civ_key', constraint: 'unique', columns: ['civ'] },
    ],
  }, FederalStateRow),
  federalWork: __table({
    name: 'federal_work',
    indexes: [
      { accessor: 'federalWorkByCiv', name: 'federal_work_civ_idx_btree', algorithm: 'btree', columns: [
        'civ',
      ] },
      { accessor: 'workId', name: 'federal_work_work_id_idx_btree', algorithm: 'btree', columns: [
        'workId',
      ] },
    ],
    constraints: [
      { name: 'federal_work_work_id_key', constraint: 'unique', columns: ['workId'] },
    ],
  }, FederalWorkRow),
  feedRank: __table({
    name: 'feed_rank',
    indexes: [
      { accessor: 'rankPos', name: 'feed_rank_rank_pos_idx_btree', algorithm: 'btree', columns: [
        'rankPos',
      ] },
      { accessor: 'feedRankByWorld', name: 'feed_rank_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'feed_rank_rank_pos_key', constraint: 'unique', columns: ['rankPos'] },
    ],
  }, FeedRankRow),
  festivalAttendance: __table({
    name: 'festival_attendance',
    indexes: [
      { accessor: 'festivalAttendanceByIdentity', name: 'festival_attendance_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'key', name: 'festival_attendance_key_idx_btree', algorithm: 'btree', columns: [
        'key',
      ] },
    ],
    constraints: [
      { name: 'festival_attendance_key_key', constraint: 'unique', columns: ['key'] },
    ],
  }, FestivalAttendanceRow),
  festivalEntry: __table({
    name: 'festival_entry',
    indexes: [
      { accessor: 'festivalEntryByFestival', name: 'festival_entry_festival_key_idx_btree', algorithm: 'btree', columns: [
        'festivalKey',
      ] },
      { accessor: 'key', name: 'festival_entry_key_idx_btree', algorithm: 'btree', columns: [
        'key',
      ] },
    ],
    constraints: [
      { name: 'festival_entry_key_key', constraint: 'unique', columns: ['key'] },
    ],
  }, FestivalEntryRow),
  festivalKeepsake: __table({
    name: 'festival_keepsake',
    indexes: [
      { accessor: 'festivalKeepsakeByIdentity', name: 'festival_keepsake_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'key', name: 'festival_keepsake_key_idx_btree', algorithm: 'btree', columns: [
        'key',
      ] },
    ],
    constraints: [
      { name: 'festival_keepsake_key_key', constraint: 'unique', columns: ['key'] },
    ],
  }, FestivalKeepsakeRow),
  fieldGuide: __table({
    name: 'field_guide',
    indexes: [
      { accessor: 'fieldGuideByIdentity', name: 'field_guide_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'key', name: 'field_guide_key_idx_btree', algorithm: 'btree', columns: [
        'key',
      ] },
    ],
    constraints: [
      { name: 'field_guide_key_key', constraint: 'unique', columns: ['key'] },
    ],
  }, FieldGuideRow),
  fireworkLaunch: __table({
    name: 'firework_launch',
    indexes: [
      { accessor: 'launchId', name: 'firework_launch_launch_id_idx_btree', algorithm: 'btree', columns: [
        'launchId',
      ] },
      { accessor: 'fireworkLaunchByWorld', name: 'firework_launch_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'firework_launch_launch_id_key', constraint: 'unique', columns: ['launchId'] },
    ],
  }, FireworkLaunchRow),
  firmConsignment: __table({
    name: 'firm_consignment',
    indexes: [
      { accessor: 'consignId', name: 'firm_consignment_consign_id_idx_btree', algorithm: 'btree', columns: [
        'consignId',
      ] },
      { accessor: 'firmConsignmentByShipment', name: 'firm_consignment_shipment_id_idx_btree', algorithm: 'btree', columns: [
        'shipmentId',
      ] },
    ],
    constraints: [
      { name: 'firm_consignment_consign_id_key', constraint: 'unique', columns: ['consignId'] },
    ],
  }, FirmConsignmentRow),
  firmPlan: __table({
    name: 'firm_plan',
    indexes: [
      { accessor: 'firmId', name: 'firm_plan_firm_id_idx_btree', algorithm: 'btree', columns: [
        'firmId',
      ] },
    ],
    constraints: [
      { name: 'firm_plan_firm_id_key', constraint: 'unique', columns: ['firmId'] },
    ],
  }, FirmPlanRow),
  firmPolicy: __table({
    name: 'firm_policy',
    indexes: [
      { accessor: 'firmId', name: 'firm_policy_firm_id_idx_btree', algorithm: 'btree', columns: [
        'firmId',
      ] },
    ],
    constraints: [
      { name: 'firm_policy_firm_id_key', constraint: 'unique', columns: ['firmId'] },
    ],
  }, FirmPolicyRow),
  fishingCast: __table({
    name: 'fishing_cast',
    indexes: [
      { accessor: 'identity', name: 'fishing_cast_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'fishing_cast_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, FishingCastRow),
  forgeArtifact: __table({
    name: 'forge_artifact',
    indexes: [
      { accessor: 'artifactId', name: 'forge_artifact_artifact_id_idx_btree', algorithm: 'btree', columns: [
        'artifactId',
      ] },
      { accessor: 'forgeArtifactByBuild', name: 'forge_artifact_build_id_idx_btree', algorithm: 'btree', columns: [
        'buildId',
      ] },
    ],
    constraints: [
      { name: 'forge_artifact_artifact_id_key', constraint: 'unique', columns: ['artifactId'] },
    ],
  }, ForgeArtifactRow),
  forgeBuild: __table({
    name: 'forge_build',
    indexes: [
      { accessor: 'buildId', name: 'forge_build_build_id_idx_btree', algorithm: 'btree', columns: [
        'buildId',
      ] },
      { accessor: 'forgeBuildByProject', name: 'forge_build_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
    ],
    constraints: [
      { name: 'forge_build_build_id_key', constraint: 'unique', columns: ['buildId'] },
    ],
  }, ForgeBuildRow),
  forgeCompileJob: __table({
    name: 'forge_compile_job',
    indexes: [
      { accessor: 'jobId', name: 'forge_compile_job_job_id_idx_btree', algorithm: 'btree', columns: [
        'jobId',
      ] },
      { accessor: 'forgeCompileJobByProject', name: 'forge_compile_job_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
    ],
    constraints: [
      { name: 'forge_compile_job_job_id_key', constraint: 'unique', columns: ['jobId'] },
    ],
  }, ForgeCompileJobRow),
  forgeInstance: __table({
    name: 'forge_instance',
    indexes: [
      { accessor: 'instanceId', name: 'forge_instance_instance_id_idx_btree', algorithm: 'btree', columns: [
        'instanceId',
      ] },
      { accessor: 'forgeInstanceByParent', name: 'forge_instance_parent_id_idx_btree', algorithm: 'btree', columns: [
        'parentId',
      ] },
      { accessor: 'forgeInstanceByProject', name: 'forge_instance_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
    ],
    constraints: [
      { name: 'forge_instance_instance_id_key', constraint: 'unique', columns: ['instanceId'] },
    ],
  }, ForgeInstanceRow),
  forgeProject: __table({
    name: 'forge_project',
    indexes: [
      { accessor: 'forgeProjectByOwner', name: 'forge_project_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'projectId', name: 'forge_project_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
      { accessor: 'forgeProjectByWorld', name: 'forge_project_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'forge_project_project_id_key', constraint: 'unique', columns: ['projectId'] },
    ],
  }, ForgeProjectRow),
  forgeRelease: __table({
    name: 'forge_release',
    indexes: [
      { accessor: 'forgeReleaseByProject', name: 'forge_release_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
      { accessor: 'releaseId', name: 'forge_release_release_id_idx_btree', algorithm: 'btree', columns: [
        'releaseId',
      ] },
    ],
    constraints: [
      { name: 'forge_release_release_id_key', constraint: 'unique', columns: ['releaseId'] },
    ],
  }, ForgeReleaseRow),
  forgeScene: __table({
    name: 'forge_scene',
    indexes: [
      { accessor: 'forgeSceneByProject', name: 'forge_scene_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
      { accessor: 'sceneId', name: 'forge_scene_scene_id_idx_btree', algorithm: 'btree', columns: [
        'sceneId',
      ] },
    ],
    constraints: [
      { name: 'forge_scene_scene_id_key', constraint: 'unique', columns: ['sceneId'] },
    ],
  }, ForgeSceneRow),
  forgeScript: __table({
    name: 'forge_script',
    indexes: [
      { accessor: 'forgeScriptByInstance', name: 'forge_script_instance_id_idx_btree', algorithm: 'btree', columns: [
        'instanceId',
      ] },
      { accessor: 'forgeScriptByProject', name: 'forge_script_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
      { accessor: 'scriptId', name: 'forge_script_script_id_idx_btree', algorithm: 'btree', columns: [
        'scriptId',
      ] },
    ],
    constraints: [
      { name: 'forge_script_script_id_key', constraint: 'unique', columns: ['scriptId'] },
    ],
  }, ForgeScriptRow),
  forgeValidation: __table({
    name: 'forge_validation',
    indexes: [
      { accessor: 'forgeValidationByJob', name: 'forge_validation_job_id_idx_btree', algorithm: 'btree', columns: [
        'jobId',
      ] },
      { accessor: 'validationId', name: 'forge_validation_validation_id_idx_btree', algorithm: 'btree', columns: [
        'validationId',
      ] },
    ],
    constraints: [
      { name: 'forge_validation_validation_id_key', constraint: 'unique', columns: ['validationId'] },
    ],
  }, ForgeValidationRow),
  forkBallot: __table({
    name: 'fork_ballot',
    indexes: [
      { accessor: 'ballotId', name: 'fork_ballot_ballot_id_idx_btree', algorithm: 'btree', columns: [
        'ballotId',
      ] },
      { accessor: 'forkBallotByFork', name: 'fork_ballot_fork_id_idx_btree', algorithm: 'btree', columns: [
        'forkId',
      ] },
    ],
    constraints: [
      { name: 'fork_ballot_ballot_id_key', constraint: 'unique', columns: ['ballotId'] },
    ],
  }, ForkBallotRow),
  forkVote: __table({
    name: 'fork_vote',
    indexes: [
      { accessor: 'forkId', name: 'fork_vote_fork_id_idx_btree', algorithm: 'btree', columns: [
        'forkId',
      ] },
      { accessor: 'forkByGroup', name: 'fork_vote_group_id_idx_btree', algorithm: 'btree', columns: [
        'groupId',
      ] },
    ],
    constraints: [
      { name: 'fork_vote_fork_id_key', constraint: 'unique', columns: ['forkId'] },
    ],
  }, ForkVoteRow),
  freelanceProject: __table({
    name: 'freelance_project',
    indexes: [
      { accessor: 'freelanceByIssuer', name: 'freelance_project_issuer_idx_btree', algorithm: 'btree', columns: [
        'issuer',
      ] },
      { accessor: 'projectId', name: 'freelance_project_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
    ],
    constraints: [
      { name: 'freelance_project_project_id_key', constraint: 'unique', columns: ['projectId'] },
    ],
  }, FreelanceProjectRow),
  functionLedger: __table({
    name: 'function_ledger',
    indexes: [
      { accessor: 'fnLedgerId', name: 'function_ledger_fn_ledger_id_idx_btree', algorithm: 'btree', columns: [
        'fnLedgerId',
      ] },
      { accessor: 'functionLedgerBySettlement', name: 'function_ledger_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'function_ledger_fn_ledger_id_key', constraint: 'unique', columns: ['fnLedgerId'] },
    ],
  }, FunctionLedgerRow),
  gamePass: __table({
    name: 'game_pass',
    indexes: [
      { accessor: 'gamePassByCreator', name: 'game_pass_creator_idx_btree', algorithm: 'btree', columns: [
        'creator',
      ] },
      { accessor: 'passId', name: 'game_pass_pass_id_idx_btree', algorithm: 'btree', columns: [
        'passId',
      ] },
      { accessor: 'gamePassByWorld', name: 'game_pass_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'game_pass_pass_id_key', constraint: 'unique', columns: ['passId'] },
    ],
  }, GamePassRow),
  gamePassOwner: __table({
    name: 'game_pass_owner',
    indexes: [
      { accessor: 'gamePassOwnerByOwner', name: 'game_pass_owner_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'ownerRowId', name: 'game_pass_owner_owner_row_id_idx_btree', algorithm: 'btree', columns: [
        'ownerRowId',
      ] },
      { accessor: 'gamePassOwnerByPass', name: 'game_pass_owner_pass_id_idx_btree', algorithm: 'btree', columns: [
        'passId',
      ] },
    ],
    constraints: [
      { name: 'game_pass_owner_owner_row_id_key', constraint: 'unique', columns: ['ownerRowId'] },
    ],
  }, GamePassOwnerRow),
  gameSession: __table({
    name: 'game_session',
    indexes: [
      { accessor: 'gameSessionByGame', name: 'game_session_game_id_idx_btree', algorithm: 'btree', columns: [
        'gameId',
      ] },
      { accessor: 'sessionId', name: 'game_session_session_id_idx_btree', algorithm: 'btree', columns: [
        'sessionId',
      ] },
      { accessor: 'gameSessionByWorld', name: 'game_session_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'game_session_session_id_key', constraint: 'unique', columns: ['sessionId'] },
    ],
  }, GameSessionRow),
  governanceAudit: __table({
    name: 'governance_audit',
    indexes: [
      { accessor: 'auditId', name: 'governance_audit_audit_id_idx_btree', algorithm: 'btree', columns: [
        'auditId',
      ] },
      { accessor: 'governanceAuditByWorld', name: 'governance_audit_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'governance_audit_audit_id_key', constraint: 'unique', columns: ['auditId'] },
    ],
  }, GovernanceAuditRow),
  grave: __table({
    name: 'grave',
    indexes: [
      { accessor: 'graveId', name: 'grave_grave_id_idx_btree', algorithm: 'btree', columns: [
        'graveId',
      ] },
      { accessor: 'graveBySettlement', name: 'grave_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'grave_grave_id_key', constraint: 'unique', columns: ['graveId'] },
    ],
  }, GraveRow),
  groundContract: __table({
    name: 'ground_contract',
    indexes: [
      { accessor: 'contractId', name: 'ground_contract_contract_id_idx_btree', algorithm: 'btree', columns: [
        'contractId',
      ] },
      { accessor: 'groundContractByDest', name: 'ground_contract_dest_sid_idx_btree', algorithm: 'btree', columns: [
        'destSid',
      ] },
      { accessor: 'groundContractByIssuer', name: 'ground_contract_issuer_idx_btree', algorithm: 'btree', columns: [
        'issuer',
      ] },
      { accessor: 'groundContractByState', name: 'ground_contract_state_idx_btree', algorithm: 'btree', columns: [
        'state',
      ] },
      { accessor: 'groundContractByTaker', name: 'ground_contract_taker_idx_btree', algorithm: 'btree', columns: [
        'taker',
      ] },
    ],
    constraints: [
      { name: 'ground_contract_contract_id_key', constraint: 'unique', columns: ['contractId'] },
    ],
  }, GroundContractRow),
  groundEscort: __table({
    name: 'ground_escort',
    indexes: [
      { accessor: 'contractId', name: 'ground_escort_contract_id_idx_btree', algorithm: 'btree', columns: [
        'contractId',
      ] },
    ],
    constraints: [
      { name: 'ground_escort_contract_id_key', constraint: 'unique', columns: ['contractId'] },
    ],
  }, GroundEscortRow),
  groundParcel: __table({
    name: 'ground_parcel',
    indexes: [
      { accessor: 'groundParcelByContract', name: 'ground_parcel_contract_id_idx_btree', algorithm: 'btree', columns: [
        'contractId',
      ] },
      { accessor: 'parcelId', name: 'ground_parcel_parcel_id_idx_btree', algorithm: 'btree', columns: [
        'parcelId',
      ] },
    ],
    constraints: [
      { name: 'ground_parcel_parcel_id_key', constraint: 'unique', columns: ['parcelId'] },
    ],
  }, GroundParcelRow),
  groundWar: __table({
    name: 'ground_war',
    indexes: [
      { accessor: 'groundWarByState', name: 'ground_war_state_idx_btree', algorithm: 'btree', columns: [
        'state',
      ] },
      { accessor: 'warId', name: 'ground_war_war_id_idx_btree', algorithm: 'btree', columns: [
        'warId',
      ] },
    ],
    constraints: [
      { name: 'ground_war_war_id_key', constraint: 'unique', columns: ['warId'] },
    ],
  }, GroundWarRow),
  groundWarEvent: __table({
    name: 'ground_war_event',
    indexes: [
      { accessor: 'eventId', name: 'ground_war_event_event_id_idx_btree', algorithm: 'btree', columns: [
        'eventId',
      ] },
      { accessor: 'groundWarEventByWar', name: 'ground_war_event_war_id_idx_btree', algorithm: 'btree', columns: [
        'warId',
      ] },
    ],
    constraints: [
      { name: 'ground_war_event_event_id_key', constraint: 'unique', columns: ['eventId'] },
    ],
  }, GroundWarEventRow),
  group: __table({
    name: 'group',
    indexes: [
      { accessor: 'groupId', name: 'group_group_id_idx_btree', algorithm: 'btree', columns: [
        'groupId',
      ] },
      { accessor: 'groupByHall', name: 'group_hall_world_id_idx_btree', algorithm: 'btree', columns: [
        'hallWorldId',
      ] },
    ],
    constraints: [
      { name: 'group_group_id_key', constraint: 'unique', columns: ['groupId'] },
    ],
  }, GroupRow),
  groupMember: __table({
    name: 'group_member',
    indexes: [
      { accessor: 'groupMemberByGroup', name: 'group_member_group_id_idx_btree', algorithm: 'btree', columns: [
        'groupId',
      ] },
      { accessor: 'groupMemberByIdentity', name: 'group_member_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'memberId', name: 'group_member_member_id_idx_btree', algorithm: 'btree', columns: [
        'memberId',
      ] },
    ],
    constraints: [
      { name: 'group_member_member_id_key', constraint: 'unique', columns: ['memberId'] },
    ],
  }, GroupMemberRow),
  groupSignature: __table({
    name: 'group_signature',
    indexes: [
      { accessor: 'signatureByGroup', name: 'group_signature_group_id_idx_btree', algorithm: 'btree', columns: [
        'groupId',
      ] },
      { accessor: 'signatureId', name: 'group_signature_signature_id_idx_btree', algorithm: 'btree', columns: [
        'signatureId',
      ] },
    ],
    constraints: [
      { name: 'group_signature_signature_id_key', constraint: 'unique', columns: ['signatureId'] },
    ],
  }, GroupSignatureRow),
  groupSrp: __table({
    name: 'group_srp',
    indexes: [
      { accessor: 'groupId', name: 'group_srp_group_id_idx_btree', algorithm: 'btree', columns: [
        'groupId',
      ] },
    ],
    constraints: [
      { name: 'group_srp_group_id_key', constraint: 'unique', columns: ['groupId'] },
    ],
  }, GroupSrpRow),
  guideMessage: __table({
    name: 'guide_message',
    indexes: [
      { accessor: 'guideMessageByIdentity', name: 'guide_message_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'msgId', name: 'guide_message_msg_id_idx_btree', algorithm: 'btree', columns: [
        'msgId',
      ] },
    ],
    constraints: [
      { name: 'guide_message_msg_id_key', constraint: 'unique', columns: ['msgId'] },
    ],
  }, GuideMessageRow),
  guild: __table({
    name: 'guild',
    indexes: [
      { accessor: 'guildId', name: 'guild_guild_id_idx_btree', algorithm: 'btree', columns: [
        'guildId',
      ] },
      { accessor: 'guildByHall', name: 'guild_hall_structure_id_idx_btree', algorithm: 'btree', columns: [
        'hallStructureId',
      ] },
    ],
    constraints: [
      { name: 'guild_guild_id_key', constraint: 'unique', columns: ['guildId'] },
    ],
  }, GuildRow),
  guildApplication: __table({
    name: 'guild_application',
    indexes: [
      { accessor: 'appKey', name: 'guild_application_app_key_idx_btree', algorithm: 'btree', columns: [
        'appKey',
      ] },
      { accessor: 'guildApplicationByGuild', name: 'guild_application_guild_id_idx_btree', algorithm: 'btree', columns: [
        'guildId',
      ] },
    ],
    constraints: [
      { name: 'guild_application_app_key_key', constraint: 'unique', columns: ['appKey'] },
    ],
  }, GuildApplicationRow),
  guildCandidate: __table({
    name: 'guild_candidate',
    indexes: [
      { accessor: 'guildCandidateId', name: 'guild_candidate_guild_candidate_id_idx_btree', algorithm: 'btree', columns: [
        'guildCandidateId',
      ] },
      { accessor: 'guildCandidateByElection', name: 'guild_candidate_guild_election_id_idx_btree', algorithm: 'btree', columns: [
        'guildElectionId',
      ] },
    ],
    constraints: [
      { name: 'guild_candidate_guild_candidate_id_key', constraint: 'unique', columns: ['guildCandidateId'] },
    ],
  }, GuildCandidateRow),
  guildCourt: __table({
    name: 'guild_court',
    indexes: [
      { accessor: 'guildId', name: 'guild_court_guild_id_idx_btree', algorithm: 'btree', columns: [
        'guildId',
      ] },
    ],
    constraints: [
      { name: 'guild_court_guild_id_key', constraint: 'unique', columns: ['guildId'] },
    ],
  }, GuildCourtRow),
  guildElection: __table({
    name: 'guild_election',
    indexes: [
      { accessor: 'guildElectionId', name: 'guild_election_guild_election_id_idx_btree', algorithm: 'btree', columns: [
        'guildElectionId',
      ] },
      { accessor: 'guildElectionByGuild', name: 'guild_election_guild_id_idx_btree', algorithm: 'btree', columns: [
        'guildId',
      ] },
    ],
    constraints: [
      { name: 'guild_election_guild_election_id_key', constraint: 'unique', columns: ['guildElectionId'] },
    ],
  }, GuildElectionRow),
  guildMember: __table({
    name: 'guild_member',
    indexes: [
      { accessor: 'guildMemberByGuild', name: 'guild_member_guild_id_idx_btree', algorithm: 'btree', columns: [
        'guildId',
      ] },
      { accessor: 'guildMemberId', name: 'guild_member_guild_member_id_idx_btree', algorithm: 'btree', columns: [
        'guildMemberId',
      ] },
      { accessor: 'guildMemberByIdentity', name: 'guild_member_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'guild_member_guild_member_id_key', constraint: 'unique', columns: ['guildMemberId'] },
    ],
  }, GuildMemberRow),
  guildMotion: __table({
    name: 'guild_motion',
    indexes: [
      { accessor: 'guildMotionByGuild', name: 'guild_motion_guild_id_idx_btree', algorithm: 'btree', columns: [
        'guildId',
      ] },
      { accessor: 'motionId', name: 'guild_motion_motion_id_idx_btree', algorithm: 'btree', columns: [
        'motionId',
      ] },
    ],
    constraints: [
      { name: 'guild_motion_motion_id_key', constraint: 'unique', columns: ['motionId'] },
    ],
  }, GuildMotionRow),
  guildMotionVote: __table({
    name: 'guild_motion_vote',
    indexes: [
      { accessor: 'guildMotionVoteByMotion', name: 'guild_motion_vote_motion_id_idx_btree', algorithm: 'btree', columns: [
        'motionId',
      ] },
      { accessor: 'voteKey', name: 'guild_motion_vote_vote_key_idx_btree', algorithm: 'btree', columns: [
        'voteKey',
      ] },
    ],
    constraints: [
      { name: 'guild_motion_vote_vote_key_key', constraint: 'unique', columns: ['voteKey'] },
    ],
  }, GuildMotionVoteRow),
  guildStore: __table({
    name: 'guild_store',
    indexes: [
      { accessor: 'gsId', name: 'guild_store_gs_id_idx_btree', algorithm: 'btree', columns: [
        'gsId',
      ] },
      { accessor: 'guildStoreByGuild', name: 'guild_store_guild_id_idx_btree', algorithm: 'btree', columns: [
        'guildId',
      ] },
    ],
    constraints: [
      { name: 'guild_store_gs_id_key', constraint: 'unique', columns: ['gsId'] },
    ],
  }, GuildStoreRow),
  guildStructure: __table({
    name: 'guild_structure',
    indexes: [
      { accessor: 'guildStructureByGuild', name: 'guild_structure_guild_id_idx_btree', algorithm: 'btree', columns: [
        'guildId',
      ] },
      { accessor: 'structureId', name: 'guild_structure_structure_id_idx_btree', algorithm: 'btree', columns: [
        'structureId',
      ] },
    ],
    constraints: [
      { name: 'guild_structure_structure_id_key', constraint: 'unique', columns: ['structureId'] },
    ],
  }, GuildStructureRow),
  guildTerritory: __table({
    name: 'guild_territory',
    indexes: [
      { accessor: 'territoryKey', name: 'guild_territory_territory_key_idx_btree', algorithm: 'btree', columns: [
        'territoryKey',
      ] },
      { accessor: 'guildTerritoryByWorld', name: 'guild_territory_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'guild_territory_territory_key_key', constraint: 'unique', columns: ['territoryKey'] },
    ],
  }, GuildTerritoryRow),
  guildVersona: __table({
    name: 'guild_versona',
    indexes: [
      { accessor: 'guildVersonaByGuild', name: 'guild_versona_guild_id_idx_btree', algorithm: 'btree', columns: [
        'guildId',
      ] },
      { accessor: 'gvId', name: 'guild_versona_gv_id_idx_btree', algorithm: 'btree', columns: [
        'gvId',
      ] },
      { accessor: 'guildVersonaByVersona', name: 'guild_versona_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'guild_versona_gv_id_key', constraint: 'unique', columns: ['gvId'] },
    ],
  }, GuildVersonaRow),
  guildVote: __table({
    name: 'guild_vote',
    indexes: [
      { accessor: 'guildVoteByElection', name: 'guild_vote_guild_election_id_idx_btree', algorithm: 'btree', columns: [
        'guildElectionId',
      ] },
      { accessor: 'guildVoteId', name: 'guild_vote_guild_vote_id_idx_btree', algorithm: 'btree', columns: [
        'guildVoteId',
      ] },
    ],
    constraints: [
      { name: 'guild_vote_guild_vote_id_key', constraint: 'unique', columns: ['guildVoteId'] },
    ],
  }, GuildVoteRow),
  guildWar: __table({
    name: 'guild_war',
    indexes: [
      { accessor: 'guildWarByA', name: 'guild_war_guild_a_idx_btree', algorithm: 'btree', columns: [
        'guildA',
      ] },
      { accessor: 'guildWarByB', name: 'guild_war_guild_b_idx_btree', algorithm: 'btree', columns: [
        'guildB',
      ] },
      { accessor: 'gwId', name: 'guild_war_gw_id_idx_btree', algorithm: 'btree', columns: [
        'gwId',
      ] },
    ],
    constraints: [
      { name: 'guild_war_gw_id_key', constraint: 'unique', columns: ['gwId'] },
    ],
  }, GuildWarRow),
  household: __table({
    name: 'household',
    indexes: [
      { accessor: 'householdId', name: 'household_household_id_idx_btree', algorithm: 'btree', columns: [
        'householdId',
      ] },
      { accessor: 'householdBySettlement', name: 'household_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'household_household_id_key', constraint: 'unique', columns: ['householdId'] },
    ],
  }, HouseholdRow),
  householdMember: __table({
    name: 'household_member',
    indexes: [
      { accessor: 'householdMemberByHousehold', name: 'household_member_household_id_idx_btree', algorithm: 'btree', columns: [
        'householdId',
      ] },
      { accessor: 'memberId', name: 'household_member_member_id_idx_btree', algorithm: 'btree', columns: [
        'memberId',
      ] },
      { accessor: 'householdMemberByVersona', name: 'household_member_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'household_member_member_id_key', constraint: 'unique', columns: ['memberId'] },
    ],
  }, HouseholdMemberRow),
  incursionState: __table({
    name: 'incursion_state',
    indexes: [
      { accessor: 'incursionStateByEpoch', name: 'incursion_state_epoch_idx_btree', algorithm: 'btree', columns: [
        'epoch',
      ] },
      { accessor: 'stateId', name: 'incursion_state_state_id_idx_btree', algorithm: 'btree', columns: [
        'stateId',
      ] },
    ],
    constraints: [
      { name: 'incursion_state_state_id_key', constraint: 'unique', columns: ['stateId'] },
    ],
  }, IncursionStateRow),
  instanceGroup: __table({
    name: 'instance_group',
    indexes: [
      { accessor: 'instanceGroupByAsset', name: 'instance_group_asset_id_idx_btree', algorithm: 'btree', columns: [
        'assetId',
      ] },
      { accessor: 'groupId', name: 'instance_group_group_id_idx_btree', algorithm: 'btree', columns: [
        'groupId',
      ] },
      { accessor: 'instanceGroupByWorld', name: 'instance_group_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'instance_group_group_id_key', constraint: 'unique', columns: ['groupId'] },
    ],
  }, InstanceGroupRow),
  intelLicence: __table({
    name: 'intel_licence',
    indexes: [
      { accessor: 'intelLicenceByBuyer', name: 'intel_licence_buyer_idx_btree', algorithm: 'btree', columns: [
        'buyer',
      ] },
      { accessor: 'licenceId', name: 'intel_licence_licence_id_idx_btree', algorithm: 'btree', columns: [
        'licenceId',
      ] },
      { accessor: 'intelLicenceByOffer', name: 'intel_licence_offer_id_idx_btree', algorithm: 'btree', columns: [
        'offerId',
      ] },
      { accessor: 'intelLicenceBySeller', name: 'intel_licence_seller_idx_btree', algorithm: 'btree', columns: [
        'seller',
      ] },
    ],
    constraints: [
      { name: 'intel_licence_licence_id_key', constraint: 'unique', columns: ['licenceId'] },
    ],
  }, IntelLicenceRow),
  intelOffer: __table({
    name: 'intel_offer',
    indexes: [
      { accessor: 'offerId', name: 'intel_offer_offer_id_idx_btree', algorithm: 'btree', columns: [
        'offerId',
      ] },
      { accessor: 'intelOfferBySeller', name: 'intel_offer_seller_idx_btree', algorithm: 'btree', columns: [
        'seller',
      ] },
      { accessor: 'intelOfferBySig', name: 'intel_offer_sig_key_idx_btree', algorithm: 'btree', columns: [
        'sigKey',
      ] },
    ],
    constraints: [
      { name: 'intel_offer_offer_id_key', constraint: 'unique', columns: ['offerId'] },
    ],
  }, IntelOfferRow),
  interiorMarker: __table({
    name: 'interior_marker',
    indexes: [
      { accessor: 'markerId', name: 'interior_marker_marker_id_idx_btree', algorithm: 'btree', columns: [
        'markerId',
      ] },
      { accessor: 'interiorMarkerByWorld', name: 'interior_marker_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'interior_marker_marker_id_key', constraint: 'unique', columns: ['markerId'] },
    ],
  }, InteriorMarkerRow),
  interiorOccupant: __table({
    name: 'interior_occupant',
    indexes: [
      { accessor: 'interiorOccupantByBuilding', name: 'interior_occupant_building_id_idx_btree', algorithm: 'btree', columns: [
        'buildingId',
      ] },
      { accessor: 'identity', name: 'interior_occupant_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'interior_occupant_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, InteriorOccupantRow),
  inventoryItem: __table({
    name: 'inventory_item',
    indexes: [
      { accessor: 'inventoryItemByAsset', name: 'inventory_item_asset_id_idx_btree', algorithm: 'btree', columns: [
        'assetId',
      ] },
      { accessor: 'itemId', name: 'inventory_item_item_id_idx_btree', algorithm: 'btree', columns: [
        'itemId',
      ] },
      { accessor: 'inventoryItemByOwner', name: 'inventory_item_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
    ],
    constraints: [
      { name: 'inventory_item_item_id_key', constraint: 'unique', columns: ['itemId'] },
    ],
  }, InventoryItemRow),
  jobSlot: __table({
    name: 'job_slot',
    indexes: [
      { accessor: 'jobSlotBySettlement', name: 'job_slot_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
      { accessor: 'slotId', name: 'job_slot_slot_id_idx_btree', algorithm: 'btree', columns: [
        'slotId',
      ] },
    ],
    constraints: [
      { name: 'job_slot_slot_id_key', constraint: 'unique', columns: ['slotId'] },
    ],
  }, JobSlotRow),
  killRecord: __table({
    name: 'kill_record',
    indexes: [
      { accessor: 'killId', name: 'kill_record_kill_id_idx_btree', algorithm: 'btree', columns: [
        'killId',
      ] },
      { accessor: 'killByVictim', name: 'kill_record_victim_idx_btree', algorithm: 'btree', columns: [
        'victim',
      ] },
    ],
    constraints: [
      { name: 'kill_record_kill_id_key', constraint: 'unique', columns: ['killId'] },
    ],
  }, KillRecordRow),
  kinship: __table({
    name: 'kinship',
    indexes: [
      { accessor: 'kinshipByA', name: 'kinship_a_id_idx_btree', algorithm: 'btree', columns: [
        'aId',
      ] },
      { accessor: 'kinshipByB', name: 'kinship_b_id_idx_btree', algorithm: 'btree', columns: [
        'bId',
      ] },
      { accessor: 'kinId', name: 'kinship_kin_id_idx_btree', algorithm: 'btree', columns: [
        'kinId',
      ] },
    ],
    constraints: [
      { name: 'kinship_kin_id_key', constraint: 'unique', columns: ['kinId'] },
    ],
  }, KinshipRow),
  leaderboard: __table({
    name: 'leaderboard',
    indexes: [
      { accessor: 'leaderboardByGame', name: 'leaderboard_game_id_idx_btree', algorithm: 'btree', columns: [
        'gameId',
      ] },
      { accessor: 'lbId', name: 'leaderboard_lb_id_idx_btree', algorithm: 'btree', columns: [
        'lbId',
      ] },
      { accessor: 'leaderboardByPlayer', name: 'leaderboard_player_idx_btree', algorithm: 'btree', columns: [
        'player',
      ] },
    ],
    constraints: [
      { name: 'leaderboard_lb_id_key', constraint: 'unique', columns: ['lbId'] },
    ],
  }, LeaderboardRow),
  leaderboardSnapshot: __table({
    name: 'leaderboard_snapshot',
    indexes: [
      { accessor: 'leaderboardSnapshotByGame', name: 'leaderboard_snapshot_game_id_idx_btree', algorithm: 'btree', columns: [
        'gameId',
      ] },
      { accessor: 'snapshotId', name: 'leaderboard_snapshot_snapshot_id_idx_btree', algorithm: 'btree', columns: [
        'snapshotId',
      ] },
    ],
    constraints: [
      { name: 'leaderboard_snapshot_snapshot_id_key', constraint: 'unique', columns: ['snapshotId'] },
    ],
  }, LeaderboardSnapshotRow),
  ledgerEntry: __table({
    name: 'ledger_entry',
    indexes: [
      { accessor: 'ledgerByAccount', name: 'ledger_entry_account_idx_btree', algorithm: 'btree', columns: [
        'account',
      ] },
      { accessor: 'entryId', name: 'ledger_entry_entry_id_idx_btree', algorithm: 'btree', columns: [
        'entryId',
      ] },
      { accessor: 'ledgerByTx', name: 'ledger_entry_tx_id_idx_btree', algorithm: 'btree', columns: [
        'txId',
      ] },
    ],
    constraints: [
      { name: 'ledger_entry_entry_id_key', constraint: 'unique', columns: ['entryId'] },
    ],
  }, LedgerEntryRow),
  ledgerTx: __table({
    name: 'ledger_tx',
    indexes: [
      { accessor: 'txId', name: 'ledger_tx_tx_id_idx_btree', algorithm: 'btree', columns: [
        'txId',
      ] },
    ],
    constraints: [
      { name: 'ledger_tx_tx_id_key', constraint: 'unique', columns: ['txId'] },
    ],
  }, LedgerTxRow),
  legacyGrant: __table({
    name: 'legacy_grant',
    indexes: [
      { accessor: 'worldId', name: 'legacy_grant_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'legacy_grant_world_id_key', constraint: 'unique', columns: ['worldId'] },
    ],
  }, LegacyGrantRow),
  linkset: __table({
    name: 'linkset',
    indexes: [
      { accessor: 'linksetId', name: 'linkset_linkset_id_idx_btree', algorithm: 'btree', columns: [
        'linksetId',
      ] },
      { accessor: 'linksetByWorld', name: 'linkset_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'linkset_linkset_id_key', constraint: 'unique', columns: ['linksetId'] },
    ],
  }, LinksetRow),
  livingEvent: __table({
    name: 'living_event',
    indexes: [
      { accessor: 'eventId', name: 'living_event_event_id_idx_btree', algorithm: 'btree', columns: [
        'eventId',
      ] },
      { accessor: 'livingEventBySettlement', name: 'living_event_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'living_event_event_id_key', constraint: 'unique', columns: ['eventId'] },
    ],
  }, LivingEventRow),
  lotBudget: __table({
    name: 'lot_budget',
    indexes: [
      { accessor: 'identity', name: 'lot_budget_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'lot_budget_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, LotBudgetRow),
  marketBookRev: __table({
    name: 'market_book_rev',
    indexes: [
      { accessor: 'key', name: 'market_book_rev_key_idx_btree', algorithm: 'btree', columns: [
        'key',
      ] },
      { accessor: 'marketBookRevByStation', name: 'market_book_rev_station_key_idx_btree', algorithm: 'btree', columns: [
        'stationKey',
      ] },
    ],
    constraints: [
      { name: 'market_book_rev_key_key', constraint: 'unique', columns: ['key'] },
    ],
  }, MarketBookRevRow),
  marketFill: __table({
    name: 'market_fill',
    indexes: [
      { accessor: 'fillId', name: 'market_fill_fill_id_idx_btree', algorithm: 'btree', columns: [
        'fillId',
      ] },
      { accessor: 'marketFillByStation', name: 'market_fill_station_key_idx_btree', algorithm: 'btree', columns: [
        'stationKey',
      ] },
    ],
    constraints: [
      { name: 'market_fill_fill_id_key', constraint: 'unique', columns: ['fillId'] },
    ],
  }, MarketFillRow),
  marketLink: __table({
    name: 'market_link',
    indexes: [
      { accessor: 'settlementId', name: 'market_link_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'market_link_settlement_id_key', constraint: 'unique', columns: ['settlementId'] },
    ],
  }, MarketLinkRow),
  marketListing: __table({
    name: 'market_listing',
    indexes: [
      { accessor: 'listingByAsset', name: 'market_listing_asset_id_idx_btree', algorithm: 'btree', columns: [
        'assetId',
      ] },
      { accessor: 'listingId', name: 'market_listing_listing_id_idx_btree', algorithm: 'btree', columns: [
        'listingId',
      ] },
      { accessor: 'listingBySeller', name: 'market_listing_seller_idx_btree', algorithm: 'btree', columns: [
        'seller',
      ] },
    ],
    constraints: [
      { name: 'market_listing_listing_id_key', constraint: 'unique', columns: ['listingId'] },
    ],
  }, MarketListingRow),
  marketObservation: __table({
    name: 'market_observation',
    indexes: [
      { accessor: 'stationKey', name: 'market_observation_station_key_idx_btree', algorithm: 'btree', columns: [
        'stationKey',
      ] },
    ],
    constraints: [
      { name: 'market_observation_station_key_key', constraint: 'unique', columns: ['stationKey'] },
    ],
  }, MarketObservationRow),
  marketOrder: __table({
    name: 'market_order',
    indexes: [
      { accessor: 'orderId', name: 'market_order_order_id_idx_btree', algorithm: 'btree', columns: [
        'orderId',
      ] },
      { accessor: 'marketOrderByOwner', name: 'market_order_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'marketOrderByStation', name: 'market_order_station_key_idx_btree', algorithm: 'btree', columns: [
        'stationKey',
      ] },
    ],
    constraints: [
      { name: 'market_order_order_id_key', constraint: 'unique', columns: ['orderId'] },
    ],
  }, MarketOrderRow),
  marketReceipt: __table({
    name: 'market_receipt',
    indexes: [
      { accessor: 'marketReceiptByOwner', name: 'market_receipt_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'receiptId', name: 'market_receipt_receipt_id_idx_btree', algorithm: 'btree', columns: [
        'receiptId',
      ] },
    ],
    constraints: [
      { name: 'market_receipt_receipt_id_key', constraint: 'unique', columns: ['receiptId'] },
    ],
  }, MarketReceiptRow),
  marketRound: __table({
    name: 'market_round',
    indexes: [
      { accessor: 'roundId', name: 'market_round_round_id_idx_btree', algorithm: 'btree', columns: [
        'roundId',
      ] },
      { accessor: 'marketRoundBySettlement', name: 'market_round_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'market_round_round_id_key', constraint: 'unique', columns: ['roundId'] },
    ],
  }, MarketRoundRow),
  marketSummary: __table({
    name: 'market_summary',
    indexes: [
      { accessor: 'key', name: 'market_summary_key_idx_btree', algorithm: 'btree', columns: [
        'key',
      ] },
      { accessor: 'marketSummaryByStation', name: 'market_summary_station_key_idx_btree', algorithm: 'btree', columns: [
        'stationKey',
      ] },
    ],
    constraints: [
      { name: 'market_summary_key_key', constraint: 'unique', columns: ['key'] },
    ],
  }, MarketSummaryRow),
  matchEvent: __table({
    name: 'match_event',
    indexes: [
      { accessor: 'eventId', name: 'match_event_event_id_idx_btree', algorithm: 'btree', columns: [
        'eventId',
      ] },
      { accessor: 'matchEventByPlayer', name: 'match_event_player_idx_btree', algorithm: 'btree', columns: [
        'player',
      ] },
      { accessor: 'matchEventBySession', name: 'match_event_session_id_idx_btree', algorithm: 'btree', columns: [
        'sessionId',
      ] },
    ],
    constraints: [
      { name: 'match_event_event_id_key', constraint: 'unique', columns: ['eventId'] },
    ],
  }, MatchEventRow),
  matchParticipant: __table({
    name: 'match_participant',
    indexes: [
      { accessor: 'participantId', name: 'match_participant_participant_id_idx_btree', algorithm: 'btree', columns: [
        'participantId',
      ] },
      { accessor: 'matchParticipantByPlayer', name: 'match_participant_player_idx_btree', algorithm: 'btree', columns: [
        'player',
      ] },
      { accessor: 'matchParticipantBySession', name: 'match_participant_session_id_idx_btree', algorithm: 'btree', columns: [
        'sessionId',
      ] },
    ],
    constraints: [
      { name: 'match_participant_participant_id_key', constraint: 'unique', columns: ['participantId'] },
    ],
  }, MatchParticipantRow),
  matchProposal: __table({
    name: 'match_proposal',
    indexes: [
      { accessor: 'matchProposalByGame', name: 'match_proposal_game_id_idx_btree', algorithm: 'btree', columns: [
        'gameId',
      ] },
      { accessor: 'proposalId', name: 'match_proposal_proposal_id_idx_btree', algorithm: 'btree', columns: [
        'proposalId',
      ] },
    ],
    constraints: [
      { name: 'match_proposal_proposal_id_key', constraint: 'unique', columns: ['proposalId'] },
    ],
  }, MatchProposalRow),
  matchResult: __table({
    name: 'match_result',
    indexes: [
      { accessor: 'sessionId', name: 'match_result_session_id_idx_btree', algorithm: 'btree', columns: [
        'sessionId',
      ] },
    ],
    constraints: [
      { name: 'match_result_session_id_key', constraint: 'unique', columns: ['sessionId'] },
    ],
  }, MatchResultRow),
  matchScore: __table({
    name: 'match_score',
    indexes: [
      { accessor: 'matchScoreByPlayer', name: 'match_score_player_idx_btree', algorithm: 'btree', columns: [
        'player',
      ] },
      { accessor: 'scoreId', name: 'match_score_score_id_idx_btree', algorithm: 'btree', columns: [
        'scoreId',
      ] },
      { accessor: 'matchScoreBySession', name: 'match_score_session_id_idx_btree', algorithm: 'btree', columns: [
        'sessionId',
      ] },
    ],
    constraints: [
      { name: 'match_score_score_id_key', constraint: 'unique', columns: ['scoreId'] },
    ],
  }, MatchScoreRow),
  matchTicket: __table({
    name: 'match_ticket',
    indexes: [
      { accessor: 'matchTicketByGame', name: 'match_ticket_game_id_idx_btree', algorithm: 'btree', columns: [
        'gameId',
      ] },
      { accessor: 'matchTicketByPlayer', name: 'match_ticket_player_idx_btree', algorithm: 'btree', columns: [
        'player',
      ] },
      { accessor: 'ticketId', name: 'match_ticket_ticket_id_idx_btree', algorithm: 'btree', columns: [
        'ticketId',
      ] },
    ],
    constraints: [
      { name: 'match_ticket_ticket_id_key', constraint: 'unique', columns: ['ticketId'] },
    ],
  }, MatchTicketRow),
  matchVerdict: __table({
    name: 'match_verdict',
    indexes: [
      { accessor: 'sessionId', name: 'match_verdict_session_id_idx_btree', algorithm: 'btree', columns: [
        'sessionId',
      ] },
    ],
    constraints: [
      { name: 'match_verdict_session_id_key', constraint: 'unique', columns: ['sessionId'] },
    ],
  }, MatchVerdictRow),
  mayorAudit: __table({
    name: 'mayor_audit',
    indexes: [
      { accessor: 'auditId', name: 'mayor_audit_audit_id_idx_btree', algorithm: 'btree', columns: [
        'auditId',
      ] },
      { accessor: 'mayorAuditBySettlement', name: 'mayor_audit_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'mayor_audit_audit_id_key', constraint: 'unique', columns: ['auditId'] },
    ],
  }, MayorAuditRow),
  mayorElection: __table({
    name: 'mayor_election',
    indexes: [
      { accessor: 'mayorElectionByCity', name: 'mayor_election_city_id_idx_btree', algorithm: 'btree', columns: [
        'cityId',
      ] },
      { accessor: 'electionId', name: 'mayor_election_election_id_idx_btree', algorithm: 'btree', columns: [
        'electionId',
      ] },
    ],
    constraints: [
      { name: 'mayor_election_election_id_key', constraint: 'unique', columns: ['electionId'] },
    ],
  }, MayorElectionRow),
  mayorRecord: __table({
    name: 'mayor_record',
    indexes: [
      { accessor: 'recId', name: 'mayor_record_rec_id_idx_btree', algorithm: 'btree', columns: [
        'recId',
      ] },
      { accessor: 'mayorRecordBySettlement', name: 'mayor_record_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'mayor_record_rec_id_key', constraint: 'unique', columns: ['recId'] },
    ],
  }, MayorRecordRow),
  mayorVote: __table({
    name: 'mayor_vote',
    indexes: [
      { accessor: 'mayorVoteByElection', name: 'mayor_vote_election_id_idx_btree', algorithm: 'btree', columns: [
        'electionId',
      ] },
      { accessor: 'voteId', name: 'mayor_vote_vote_id_idx_btree', algorithm: 'btree', columns: [
        'voteId',
      ] },
    ],
    constraints: [
      { name: 'mayor_vote_vote_id_key', constraint: 'unique', columns: ['voteId'] },
    ],
  }, MayorVoteRow),
  memoryEntry: __table({
    name: 'memory_entry',
    indexes: [
      { accessor: 'memoryByAuthor', name: 'memory_entry_author_idx_btree', algorithm: 'btree', columns: [
        'author',
      ] },
      { accessor: 'entryId', name: 'memory_entry_entry_id_idx_btree', algorithm: 'btree', columns: [
        'entryId',
      ] },
      { accessor: 'memoryByWorld', name: 'memory_entry_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'memory_entry_entry_id_key', constraint: 'unique', columns: ['entryId'] },
    ],
  }, MemoryEntryRow),
  memoryProvenance: __table({
    name: 'memory_provenance',
    indexes: [
      { accessor: 'memoryId', name: 'memory_provenance_memory_id_idx_btree', algorithm: 'btree', columns: [
        'memoryId',
      ] },
      { accessor: 'memoryProvenanceByVersona', name: 'memory_provenance_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'memory_provenance_memory_id_key', constraint: 'unique', columns: ['memoryId'] },
    ],
  }, MemoryProvenanceRow),
  merchantHold: __table({
    name: 'merchant_hold',
    indexes: [
      { accessor: 'holdId', name: 'merchant_hold_hold_id_idx_btree', algorithm: 'btree', columns: [
        'holdId',
      ] },
      { accessor: 'merchantHoldByListing', name: 'merchant_hold_listing_id_idx_btree', algorithm: 'btree', columns: [
        'listingId',
      ] },
    ],
    constraints: [
      { name: 'merchant_hold_hold_id_key', constraint: 'unique', columns: ['holdId'] },
    ],
  }, MerchantHoldRow),
  merchantListing: __table({
    name: 'merchant_listing',
    indexes: [
      { accessor: 'listingId', name: 'merchant_listing_listing_id_idx_btree', algorithm: 'btree', columns: [
        'listingId',
      ] },
      { accessor: 'merchantListingByLot', name: 'merchant_listing_lot_id_idx_btree', algorithm: 'btree', columns: [
        'lotId',
      ] },
    ],
    constraints: [
      { name: 'merchant_listing_listing_id_key', constraint: 'unique', columns: ['listingId'] },
    ],
  }, MerchantListingRow),
  merchantLot: __table({
    name: 'merchant_lot',
    indexes: [
      { accessor: 'lotId', name: 'merchant_lot_lot_id_idx_btree', algorithm: 'btree', columns: [
        'lotId',
      ] },
      { accessor: 'merchantLotByRenter', name: 'merchant_lot_renter_idx_btree', algorithm: 'btree', columns: [
        'renter',
      ] },
    ],
    constraints: [
      { name: 'merchant_lot_lot_id_key', constraint: 'unique', columns: ['lotId'] },
    ],
  }, MerchantLotRow),
  merchantQueue: __table({
    name: 'merchant_queue',
    indexes: [
      { accessor: 'queueId', name: 'merchant_queue_queue_id_idx_btree', algorithm: 'btree', columns: [
        'queueId',
      ] },
      { accessor: 'merchantQueueByVersona', name: 'merchant_queue_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'merchant_queue_queue_id_key', constraint: 'unique', columns: ['queueId'] },
    ],
  }, MerchantQueueRow),
  merchantReceipt: __table({
    name: 'merchant_receipt',
    indexes: [
      { accessor: 'merchantReceiptByIdentity', name: 'merchant_receipt_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'receiptId', name: 'merchant_receipt_receipt_id_idx_btree', algorithm: 'btree', columns: [
        'receiptId',
      ] },
    ],
    constraints: [
      { name: 'merchant_receipt_receipt_id_key', constraint: 'unique', columns: ['receiptId'] },
    ],
  }, MerchantReceiptRow),
  merchantSale: __table({
    name: 'merchant_sale',
    indexes: [
      { accessor: 'merchantSaleByBuyer', name: 'merchant_sale_buyer_idx_btree', algorithm: 'btree', columns: [
        'buyer',
      ] },
      { accessor: 'merchantSaleByLot', name: 'merchant_sale_lot_id_idx_btree', algorithm: 'btree', columns: [
        'lotId',
      ] },
      { accessor: 'saleId', name: 'merchant_sale_sale_id_idx_btree', algorithm: 'btree', columns: [
        'saleId',
      ] },
    ],
    constraints: [
      { name: 'merchant_sale_sale_id_key', constraint: 'unique', columns: ['saleId'] },
    ],
  }, MerchantSaleRow),
  merchantService: __table({
    name: 'merchant_service',
    indexes: [
      { accessor: 'versonaId', name: 'merchant_service_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'merchant_service_versona_id_key', constraint: 'unique', columns: ['versonaId'] },
    ],
  }, MerchantServiceRow),
  migrationLog: __table({
    name: 'migration_log',
    indexes: [
      { accessor: 'moveId', name: 'migration_log_move_id_idx_btree', algorithm: 'btree', columns: [
        'moveId',
      ] },
      { accessor: 'migrationByVersona', name: 'migration_log_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'migration_log_move_id_key', constraint: 'unique', columns: ['moveId'] },
    ],
  }, MigrationLogRow),
  missionHold: __table({
    name: 'mission_hold',
    indexes: [
      { accessor: 'missionHoldByIdentity', name: 'mission_hold_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'missionHoldId', name: 'mission_hold_mission_hold_id_idx_btree', algorithm: 'btree', columns: [
        'missionHoldId',
      ] },
    ],
    constraints: [
      { name: 'mission_hold_mission_hold_id_key', constraint: 'unique', columns: ['missionHoldId'] },
    ],
  }, MissionHoldRow),
  moderationQueue: __table({
    name: 'moderation_queue',
    indexes: [
      { accessor: 'assetId', name: 'moderation_queue_asset_id_idx_btree', algorithm: 'btree', columns: [
        'assetId',
      ] },
      { accessor: 'moderationByState', name: 'moderation_queue_state_idx_btree', algorithm: 'btree', columns: [
        'state',
      ] },
    ],
    constraints: [
      { name: 'moderation_queue_asset_id_key', constraint: 'unique', columns: ['assetId'] },
    ],
  }, ModerationQueueRow),
  mourning: __table({
    name: 'mourning',
    indexes: [
      { accessor: 'versonaId', name: 'mourning_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'mourning_versona_id_key', constraint: 'unique', columns: ['versonaId'] },
    ],
  }, MourningRow),
  mysteryClue: __table({
    name: 'mystery_clue',
    indexes: [
      { accessor: 'clueId', name: 'mystery_clue_clue_id_idx_btree', algorithm: 'btree', columns: [
        'clueId',
      ] },
      { accessor: 'mysteryClueByIdentity', name: 'mystery_clue_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'mystery_clue_clue_id_key', constraint: 'unique', columns: ['clueId'] },
    ],
  }, MysteryClueRow),
  mysteryState: __table({
    name: 'mystery_state',
    indexes: [
      { accessor: 'mysteryKey', name: 'mystery_state_mystery_key_idx_btree', algorithm: 'btree', columns: [
        'mysteryKey',
      ] },
    ],
    constraints: [
      { name: 'mystery_state_mystery_key_key', constraint: 'unique', columns: ['mysteryKey'] },
    ],
  }, MysteryStateRow),
  needSatisfier: __table({
    name: 'need_satisfier',
    indexes: [
      { accessor: 'worldId', name: 'need_satisfier_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'need_satisfier_world_id_key', constraint: 'unique', columns: ['worldId'] },
    ],
  }, NeedSatisfierRow),
  noBuildZone: __table({
    name: 'no_build_zone',
    indexes: [
      { accessor: 'noBuildZoneByWorld', name: 'no_build_zone_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
      { accessor: 'zoneId', name: 'no_build_zone_zone_id_idx_btree', algorithm: 'btree', columns: [
        'zoneId',
      ] },
    ],
    constraints: [
      { name: 'no_build_zone_zone_id_key', constraint: 'unique', columns: ['zoneId'] },
    ],
  }, NoBuildZoneRow),
  npcAgent: __table({
    name: 'npc_agent',
    indexes: [
      { accessor: 'npcAgentBySettlement', name: 'npc_agent_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
      { accessor: 'versonaId', name: 'npc_agent_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
      { accessor: 'npcAgentByWorld', name: 'npc_agent_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'npc_agent_versona_id_key', constraint: 'unique', columns: ['versonaId'] },
    ],
  }, NpcAgentRow),
  npcCombat: __table({
    name: 'npc_combat',
    indexes: [
      { accessor: 'npcKey', name: 'npc_combat_npc_key_idx_btree', algorithm: 'btree', columns: [
        'npcKey',
      ] },
    ],
    constraints: [
      { name: 'npc_combat_npc_key_key', constraint: 'unique', columns: ['npcKey'] },
    ],
  }, NpcCombatRow),
  npcEvent: __table({
    name: 'npc_event',
    indexes: [
      { accessor: 'eventId', name: 'npc_event_event_id_idx_btree', algorithm: 'btree', columns: [
        'eventId',
      ] },
      { accessor: 'npcEventBySettlement', name: 'npc_event_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
      { accessor: 'npcEventByWorld', name: 'npc_event_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'npc_event_event_id_key', constraint: 'unique', columns: ['eventId'] },
    ],
  }, NpcEventRow),
  npcHost: __table({
    name: 'npc_host',
    indexes: [
      { accessor: 'npcId', name: 'npc_host_npc_id_idx_btree', algorithm: 'btree', columns: [
        'npcId',
      ] },
      { accessor: 'npcByRitual', name: 'npc_host_ritual_id_idx_btree', algorithm: 'btree', columns: [
        'ritualId',
      ] },
      { accessor: 'npcByWorld', name: 'npc_host_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'npc_host_npc_id_key', constraint: 'unique', columns: ['npcId'] },
    ],
  }, NpcHostRow),
  npcMind: __table({
    name: 'npc_mind',
    indexes: [
      { accessor: 'versonaId', name: 'npc_mind_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'npc_mind_versona_id_key', constraint: 'unique', columns: ['versonaId'] },
    ],
  }, NpcMindRow),
  npcMood: __table({
    name: 'npc_mood',
    indexes: [
      { accessor: 'versonaId', name: 'npc_mood_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'npc_mood_versona_id_key', constraint: 'unique', columns: ['versonaId'] },
    ],
  }, NpcMoodRow),
  npcPack: __table({
    name: 'npc_pack',
    indexes: [
      { accessor: 'packId', name: 'npc_pack_pack_id_idx_btree', algorithm: 'btree', columns: [
        'packId',
      ] },
      { accessor: 'npcPackByVersona', name: 'npc_pack_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'npc_pack_pack_id_key', constraint: 'unique', columns: ['packId'] },
    ],
  }, NpcPackRow),
  npcPantry: __table({
    name: 'npc_pantry',
    indexes: [
      { accessor: 'versonaId', name: 'npc_pantry_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'npc_pantry_versona_id_key', constraint: 'unique', columns: ['versonaId'] },
    ],
  }, NpcPantryRow),
  npcSkill: __table({
    name: 'npc_skill',
    indexes: [
      { accessor: 'skillId', name: 'npc_skill_skill_id_idx_btree', algorithm: 'btree', columns: [
        'skillId',
      ] },
      { accessor: 'npcSkillByVersona', name: 'npc_skill_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'npc_skill_skill_id_key', constraint: 'unique', columns: ['skillId'] },
    ],
  }, NpcSkillRow),
  npcStrike: __table({
    name: 'npc_strike',
    indexes: [
      { accessor: 'npcStrikeByAttacker', name: 'npc_strike_attacker_key_idx_btree', algorithm: 'btree', columns: [
        'attackerKey',
      ] },
      { accessor: 'scheduledId', name: 'npc_strike_scheduled_id_idx_btree', algorithm: 'btree', columns: [
        'scheduledId',
      ] },
      { accessor: 'npcStrikeByTarget', name: 'npc_strike_target_player_idx_btree', algorithm: 'btree', columns: [
        'targetPlayer',
      ] },
    ],
    constraints: [
      { name: 'npc_strike_scheduled_id_key', constraint: 'unique', columns: ['scheduledId'] },
    ],
  }, NpcStrikeRow),
  npcUnit: __table({
    name: 'npc_unit',
    indexes: [
      { accessor: 'npcId', name: 'npc_unit_npc_id_idx_btree', algorithm: 'btree', columns: [
        'npcId',
      ] },
      { accessor: 'npcUnitByWorld', name: 'npc_unit_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'npc_unit_npc_id_key', constraint: 'unique', columns: ['npcId'] },
    ],
  }, NpcUnitRow),
  occupation: __table({
    name: 'occupation',
    indexes: [
      { accessor: 'settlementId', name: 'occupation_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'occupation_settlement_id_key', constraint: 'unique', columns: ['settlementId'] },
    ],
  }, OccupationRow),
  onboarding: __table({
    name: 'onboarding',
    indexes: [
      { accessor: 'identity', name: 'onboarding_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'onboarding_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, OnboardingRow),
  opEnrollment: __table({
    name: 'op_enrollment',
    indexes: [
      { accessor: 'enrollKey', name: 'op_enrollment_enroll_key_idx_btree', algorithm: 'btree', columns: [
        'enrollKey',
      ] },
      { accessor: 'opEnrollmentByIdentity', name: 'op_enrollment_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'opEnrollmentByOp', name: 'op_enrollment_op_id_idx_btree', algorithm: 'btree', columns: [
        'opId',
      ] },
    ],
    constraints: [
      { name: 'op_enrollment_enroll_key_key', constraint: 'unique', columns: ['enrollKey'] },
    ],
  }, OpEnrollmentRow),
  opMeter: __table({
    name: 'op_meter',
    indexes: [
      { accessor: 'meterKey', name: 'op_meter_meter_key_idx_btree', algorithm: 'btree', columns: [
        'meterKey',
      ] },
      { accessor: 'opMeterByOp', name: 'op_meter_op_id_idx_btree', algorithm: 'btree', columns: [
        'opId',
      ] },
    ],
    constraints: [
      { name: 'op_meter_meter_key_key', constraint: 'unique', columns: ['meterKey'] },
    ],
  }, OpMeterRow),
  opObjective: __table({
    name: 'op_objective',
    indexes: [
      { accessor: 'objKey', name: 'op_objective_obj_key_idx_btree', algorithm: 'btree', columns: [
        'objKey',
      ] },
      { accessor: 'opObjectiveByOp', name: 'op_objective_op_id_idx_btree', algorithm: 'btree', columns: [
        'opId',
      ] },
    ],
    constraints: [
      { name: 'op_objective_obj_key_key', constraint: 'unique', columns: ['objKey'] },
    ],
  }, OpObjectiveRow),
  opReceipt: __table({
    name: 'op_receipt',
    indexes: [
      { accessor: 'opReceiptByBeneficiary', name: 'op_receipt_beneficiary_idx_btree', algorithm: 'btree', columns: [
        'beneficiary',
      ] },
      { accessor: 'opReceiptByOp', name: 'op_receipt_op_id_idx_btree', algorithm: 'btree', columns: [
        'opId',
      ] },
      { accessor: 'receiptKey', name: 'op_receipt_receipt_key_idx_btree', algorithm: 'btree', columns: [
        'receiptKey',
      ] },
    ],
    constraints: [
      { name: 'op_receipt_receipt_key_key', constraint: 'unique', columns: ['receiptKey'] },
    ],
  }, OpReceiptRow),
  orbit: __table({
    name: 'orbit',
    indexes: [
      { accessor: 'orbitId', name: 'orbit_orbit_id_idx_btree', algorithm: 'btree', columns: [
        'orbitId',
      ] },
    ],
    constraints: [
      { name: 'orbit_orbit_id_key', constraint: 'unique', columns: ['orbitId'] },
    ],
  }, OrbitRow),
  orbitMember: __table({
    name: 'orbit_member',
    indexes: [
      { accessor: 'orbitMemberByIdentity', name: 'orbit_member_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'memberId', name: 'orbit_member_member_id_idx_btree', algorithm: 'btree', columns: [
        'memberId',
      ] },
      { accessor: 'orbitMemberByOrbit', name: 'orbit_member_orbit_id_idx_btree', algorithm: 'btree', columns: [
        'orbitId',
      ] },
    ],
    constraints: [
      { name: 'orbit_member_member_id_key', constraint: 'unique', columns: ['memberId'] },
    ],
  }, OrbitMemberRow),
  part: __table({
    name: 'part',
    indexes: [
      { accessor: 'partByLinkset', name: 'part_linkset_id_idx_btree', algorithm: 'btree', columns: [
        'linksetId',
      ] },
      { accessor: 'partId', name: 'part_part_id_idx_btree', algorithm: 'btree', columns: [
        'partId',
      ] },
      { accessor: 'partByWorld', name: 'part_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'part_part_id_key', constraint: 'unique', columns: ['partId'] },
    ],
  }, PartRow),
  partScript: __table({
    name: 'part_script',
    indexes: [
      { accessor: 'partScriptByPart', name: 'part_script_part_id_idx_btree', algorithm: 'btree', columns: [
        'partId',
      ] },
      { accessor: 'scriptId', name: 'part_script_script_id_idx_btree', algorithm: 'btree', columns: [
        'scriptId',
      ] },
      { accessor: 'partScriptByWorld', name: 'part_script_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'part_script_script_id_key', constraint: 'unique', columns: ['scriptId'] },
    ],
  }, PartScriptRow),
  party: __table({
    name: 'party',
    indexes: [
      { accessor: 'partyByLeader', name: 'party_leader_idx_btree', algorithm: 'btree', columns: [
        'leader',
      ] },
      { accessor: 'partyId', name: 'party_party_id_idx_btree', algorithm: 'btree', columns: [
        'partyId',
      ] },
    ],
    constraints: [
      { name: 'party_party_id_key', constraint: 'unique', columns: ['partyId'] },
    ],
  }, PartyRow),
  partyHistory: __table({
    name: 'party_history',
    indexes: [
      { accessor: 'histId', name: 'party_history_hist_id_idx_btree', algorithm: 'btree', columns: [
        'histId',
      ] },
      { accessor: 'partyHistoryByIdentity', name: 'party_history_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'party_history_hist_id_key', constraint: 'unique', columns: ['histId'] },
    ],
  }, PartyHistoryRow),
  partyInvite: __table({
    name: 'party_invite',
    indexes: [
      { accessor: 'inviteId', name: 'party_invite_invite_id_idx_btree', algorithm: 'btree', columns: [
        'inviteId',
      ] },
      { accessor: 'partyInviteByInvitee', name: 'party_invite_invitee_idx_btree', algorithm: 'btree', columns: [
        'invitee',
      ] },
      { accessor: 'partyInviteByParty', name: 'party_invite_party_id_idx_btree', algorithm: 'btree', columns: [
        'partyId',
      ] },
    ],
    constraints: [
      { name: 'party_invite_invite_id_key', constraint: 'unique', columns: ['inviteId'] },
    ],
  }, PartyInviteRow),
  partyMember: __table({
    name: 'party_member',
    indexes: [
      { accessor: 'partyMemberByIdentity', name: 'party_member_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'memberId', name: 'party_member_member_id_idx_btree', algorithm: 'btree', columns: [
        'memberId',
      ] },
      { accessor: 'partyMemberByParty', name: 'party_member_party_id_idx_btree', algorithm: 'btree', columns: [
        'partyId',
      ] },
    ],
    constraints: [
      { name: 'party_member_member_id_key', constraint: 'unique', columns: ['memberId'] },
    ],
  }, PartyMemberRow),
  partyMessage: __table({
    name: 'party_message',
    indexes: [
      { accessor: 'msgId', name: 'party_message_msg_id_idx_btree', algorithm: 'btree', columns: [
        'msgId',
      ] },
      { accessor: 'partyMessageByParty', name: 'party_message_party_id_idx_btree', algorithm: 'btree', columns: [
        'partyId',
      ] },
    ],
    constraints: [
      { name: 'party_message_msg_id_key', constraint: 'unique', columns: ['msgId'] },
    ],
  }, PartyMessageRow),
  partyPing: __table({
    name: 'party_ping',
    indexes: [
      { accessor: 'partyPingByParty', name: 'party_ping_party_id_idx_btree', algorithm: 'btree', columns: [
        'partyId',
      ] },
      { accessor: 'pingId', name: 'party_ping_ping_id_idx_btree', algorithm: 'btree', columns: [
        'pingId',
      ] },
      { accessor: 'partyPingBySender', name: 'party_ping_sender_idx_btree', algorithm: 'btree', columns: [
        'sender',
      ] },
    ],
    constraints: [
      { name: 'party_ping_ping_id_key', constraint: 'unique', columns: ['pingId'] },
    ],
  }, PartyPingRow),
  partyQueueIntent: __table({
    name: 'party_queue_intent',
    indexes: [
      { accessor: 'partyQueueIntentByIdentity', name: 'party_queue_intent_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'intentId', name: 'party_queue_intent_intent_id_idx_btree', algorithm: 'btree', columns: [
        'intentId',
      ] },
      { accessor: 'partyQueueIntentByParty', name: 'party_queue_intent_party_id_idx_btree', algorithm: 'btree', columns: [
        'partyId',
      ] },
    ],
    constraints: [
      { name: 'party_queue_intent_intent_id_key', constraint: 'unique', columns: ['intentId'] },
    ],
  }, PartyQueueIntentRow),
  perfLeg: __table({
    name: 'perf_leg',
    indexes: [
      { accessor: 'legId', name: 'perf_leg_leg_id_idx_btree', algorithm: 'btree', columns: [
        'legId',
      ] },
      { accessor: 'perfLegByKey', name: 'perf_leg_leg_key_idx_btree', algorithm: 'btree', columns: [
        'legKey',
      ] },
      { accessor: 'perfLegByRun', name: 'perf_leg_run_key_idx_btree', algorithm: 'btree', columns: [
        'runKey',
      ] },
    ],
    constraints: [
      { name: 'perf_leg_leg_id_key', constraint: 'unique', columns: ['legId'] },
    ],
  }, PerfLegRow),
  perfRun: __table({
    name: 'perf_run',
    indexes: [
      { accessor: 'runId', name: 'perf_run_run_id_idx_btree', algorithm: 'btree', columns: [
        'runId',
      ] },
      { accessor: 'perfRunByKey', name: 'perf_run_run_key_idx_btree', algorithm: 'btree', columns: [
        'runKey',
      ] },
    ],
    constraints: [
      { name: 'perf_run_run_id_key', constraint: 'unique', columns: ['runId'] },
    ],
  }, PerfRunRow),
  perfSample: __table({
    name: 'perf_sample',
    indexes: [
      { accessor: 'perfSampleByLeg', name: 'perf_sample_leg_key_idx_btree', algorithm: 'btree', columns: [
        'legKey',
      ] },
      { accessor: 'perfSampleByRun', name: 'perf_sample_run_key_idx_btree', algorithm: 'btree', columns: [
        'runKey',
      ] },
      { accessor: 'sampleId', name: 'perf_sample_sample_id_idx_btree', algorithm: 'btree', columns: [
        'sampleId',
      ] },
    ],
    constraints: [
      { name: 'perf_sample_sample_id_key', constraint: 'unique', columns: ['sampleId'] },
    ],
  }, PerfSampleRow),
  pilotLoyalty: __table({
    name: 'pilot_loyalty',
    indexes: [
      { accessor: 'identity', name: 'pilot_loyalty_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'pilot_loyalty_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, PilotLoyaltyRow),
  pilotMission: __table({
    name: 'pilot_mission',
    indexes: [
      { accessor: 'pilotMissionByIdentity', name: 'pilot_mission_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'missionId', name: 'pilot_mission_mission_id_idx_btree', algorithm: 'btree', columns: [
        'missionId',
      ] },
    ],
    constraints: [
      { name: 'pilot_mission_mission_id_key', constraint: 'unique', columns: ['missionId'] },
    ],
  }, PilotMissionRow),
  pilotSkill: __table({
    name: 'pilot_skill',
    indexes: [
      { accessor: 'pilotSkillByIdentity', name: 'pilot_skill_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'rowId', name: 'pilot_skill_row_id_idx_btree', algorithm: 'btree', columns: [
        'rowId',
      ] },
    ],
    constraints: [
      { name: 'pilot_skill_row_id_key', constraint: 'unique', columns: ['rowId'] },
    ],
  }, PilotSkillRow),
  pilotState: __table({
    name: 'pilot_state',
    indexes: [
      { accessor: 'pilotStateByFaction', name: 'pilot_state_faction_key_idx_btree', algorithm: 'btree', columns: [
        'factionKey',
      ] },
      { accessor: 'identity', name: 'pilot_state_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'pilot_state_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, PilotStateRow),
  pilotTraining: __table({
    name: 'pilot_training',
    indexes: [
      { accessor: 'identity', name: 'pilot_training_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'pilot_training_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, PilotTrainingRow),
  planetaryPort: __table({
    name: 'planetary_port',
    indexes: [
      { accessor: 'portId', name: 'planetary_port_port_id_idx_btree', algorithm: 'btree', columns: [
        'portId',
      ] },
      { accessor: 'planetaryPortBySettlement', name: 'planetary_port_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'planetary_port_port_id_key', constraint: 'unique', columns: ['portId'] },
    ],
  }, PlanetaryPortRow),
  platformFlag: __table({
    name: 'platform_flag',
    indexes: [
      { accessor: 'key', name: 'platform_flag_key_idx_btree', algorithm: 'btree', columns: [
        'key',
      ] },
    ],
    constraints: [
      { name: 'platform_flag_key_key', constraint: 'unique', columns: ['key'] },
    ],
  }, PlatformFlagRow),
  playerAction: __table({
    name: 'player_action',
    indexes: [
      { accessor: 'identity', name: 'player_action_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'player_action_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, PlayerActionRow),
  playerBounty: __table({
    name: 'player_bounty',
    indexes: [
      { accessor: 'bountyId', name: 'player_bounty_bounty_id_idx_btree', algorithm: 'btree', columns: [
        'bountyId',
      ] },
      { accessor: 'playerBountyByPlacer', name: 'player_bounty_placed_by_idx_btree', algorithm: 'btree', columns: [
        'placedBy',
      ] },
      { accessor: 'playerBountyByState', name: 'player_bounty_state_idx_btree', algorithm: 'btree', columns: [
        'state',
      ] },
      { accessor: 'playerBountyByTarget', name: 'player_bounty_target_idx_btree', algorithm: 'btree', columns: [
        'target',
      ] },
    ],
    constraints: [
      { name: 'player_bounty_bounty_id_key', constraint: 'unique', columns: ['bountyId'] },
    ],
  }, PlayerBountyRow),
  playerBountyHunter: __table({
    name: 'player_bounty_hunter',
    indexes: [
      { accessor: 'playerBountyHunterByBounty', name: 'player_bounty_hunter_bounty_id_idx_btree', algorithm: 'btree', columns: [
        'bountyId',
      ] },
      { accessor: 'playerBountyHunterByHunter', name: 'player_bounty_hunter_hunter_idx_btree', algorithm: 'btree', columns: [
        'hunter',
      ] },
      { accessor: 'takeId', name: 'player_bounty_hunter_take_id_idx_btree', algorithm: 'btree', columns: [
        'takeId',
      ] },
    ],
    constraints: [
      { name: 'player_bounty_hunter_take_id_key', constraint: 'unique', columns: ['takeId'] },
    ],
  }, PlayerBountyHunterRow),
  playerBountyTrace: __table({
    name: 'player_bounty_trace',
    indexes: [
      { accessor: 'playerBountyTraceByHunter', name: 'player_bounty_trace_hunter_idx_btree', algorithm: 'btree', columns: [
        'hunter',
      ] },
      { accessor: 'traceKey', name: 'player_bounty_trace_trace_key_idx_btree', algorithm: 'btree', columns: [
        'traceKey',
      ] },
    ],
    constraints: [
      { name: 'player_bounty_trace_trace_key_key', constraint: 'unique', columns: ['traceKey'] },
    ],
  }, PlayerBountyTraceRow),
  playerCamp: __table({
    name: 'player_camp',
    indexes: [
      { accessor: 'campId', name: 'player_camp_camp_id_idx_btree', algorithm: 'btree', columns: [
        'campId',
      ] },
      { accessor: 'playerCampByOwner', name: 'player_camp_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'playerCampByWorld', name: 'player_camp_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'player_camp_camp_id_key', constraint: 'unique', columns: ['campId'] },
    ],
  }, PlayerCampRow),
  playerCiv: __table({
    name: 'player_civ',
    indexes: [
      { accessor: 'civId', name: 'player_civ_civ_id_idx_btree', algorithm: 'btree', columns: [
        'civId',
      ] },
    ],
    constraints: [
      { name: 'player_civ_civ_id_key', constraint: 'unique', columns: ['civId'] },
    ],
  }, PlayerCivRow),
  playerCivMember: __table({
    name: 'player_civ_member',
    indexes: [
      { accessor: 'playerCivMemberByCity', name: 'player_civ_member_city_id_idx_btree', algorithm: 'btree', columns: [
        'cityId',
      ] },
      { accessor: 'playerCivMemberByCiv', name: 'player_civ_member_civ_id_idx_btree', algorithm: 'btree', columns: [
        'civId',
      ] },
      { accessor: 'memberId', name: 'player_civ_member_member_id_idx_btree', algorithm: 'btree', columns: [
        'memberId',
      ] },
    ],
    constraints: [
      { name: 'player_civ_member_member_id_key', constraint: 'unique', columns: ['memberId'] },
    ],
  }, PlayerCivMemberRow),
  playerCivStyle: __table({
    name: 'player_civ_style',
    indexes: [
      { accessor: 'civId', name: 'player_civ_style_civ_id_idx_btree', algorithm: 'btree', columns: [
        'civId',
      ] },
    ],
    constraints: [
      { name: 'player_civ_style_civ_id_key', constraint: 'unique', columns: ['civId'] },
    ],
  }, PlayerCivStyleRow),
  playerEquipment: __table({
    name: 'player_equipment',
    indexes: [
      { accessor: 'equipId', name: 'player_equipment_equip_id_idx_btree', algorithm: 'btree', columns: [
        'equipId',
      ] },
      { accessor: 'playerEquipmentByOwner', name: 'player_equipment_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
    ],
    constraints: [
      { name: 'player_equipment_equip_id_key', constraint: 'unique', columns: ['equipId'] },
    ],
  }, PlayerEquipmentRow),
  playerFavor: __table({
    name: 'player_favor',
    indexes: [
      { accessor: 'favorId', name: 'player_favor_favor_id_idx_btree', algorithm: 'btree', columns: [
        'favorId',
      ] },
      { accessor: 'playerFavorByIdentity', name: 'player_favor_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'playerFavorByVersona', name: 'player_favor_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'player_favor_favor_id_key', constraint: 'unique', columns: ['favorId'] },
    ],
  }, PlayerFavorRow),
  playerInterior: __table({
    name: 'player_interior',
    indexes: [
      { accessor: 'playerInteriorByBuilding', name: 'player_interior_building_id_idx_btree', algorithm: 'btree', columns: [
        'buildingId',
      ] },
      { accessor: 'identity', name: 'player_interior_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'player_interior_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, PlayerInteriorRow),
  playerInvite: __table({
    name: 'player_invite',
    indexes: [
      { accessor: 'playerInviteByInviter', name: 'player_invite_inviter_idx_btree', algorithm: 'btree', columns: [
        'inviter',
      ] },
      { accessor: 'token', name: 'player_invite_token_idx_btree', algorithm: 'btree', columns: [
        'token',
      ] },
    ],
    constraints: [
      { name: 'player_invite_token_key', constraint: 'unique', columns: ['token'] },
    ],
  }, PlayerInviteRow),
  playerItem: __table({
    name: 'player_item',
    indexes: [
      { accessor: 'itemId', name: 'player_item_item_id_idx_btree', algorithm: 'btree', columns: [
        'itemId',
      ] },
      { accessor: 'playerItemByOwner', name: 'player_item_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
    ],
    constraints: [
      { name: 'player_item_item_id_key', constraint: 'unique', columns: ['itemId'] },
    ],
  }, PlayerItemRow),
  playerPost: __table({
    name: 'player_post',
    indexes: [
      { accessor: 'identity', name: 'player_post_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'playerPostBySettlement', name: 'player_post_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'player_post_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, PlayerPostRow),
  playerRelation: __table({
    name: 'player_relation',
    indexes: [
      { accessor: 'playerRelationByIdentity', name: 'player_relation_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'playerRelationByNemesis', name: 'player_relation_nemesis_idx_btree', algorithm: 'btree', columns: [
        'nemesis',
      ] },
      { accessor: 'relId', name: 'player_relation_rel_id_idx_btree', algorithm: 'btree', columns: [
        'relId',
      ] },
      { accessor: 'playerRelationByVersona', name: 'player_relation_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'player_relation_rel_id_key', constraint: 'unique', columns: ['relId'] },
    ],
  }, PlayerRelationRow),
  playerRelationEvent: __table({
    name: 'player_relation_event',
    indexes: [
      { accessor: 'eventId', name: 'player_relation_event_event_id_idx_btree', algorithm: 'btree', columns: [
        'eventId',
      ] },
      { accessor: 'relEventByIdentity', name: 'player_relation_event_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'relEventByVersona', name: 'player_relation_event_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'player_relation_event_event_id_key', constraint: 'unique', columns: ['eventId'] },
    ],
  }, PlayerRelationEventRow),
  playerReport: __table({
    name: 'player_report',
    indexes: [
      { accessor: 'reportId', name: 'player_report_report_id_idx_btree', algorithm: 'btree', columns: [
        'reportId',
      ] },
      { accessor: 'playerReportByReporter', name: 'player_report_reporter_idx_btree', algorithm: 'btree', columns: [
        'reporter',
      ] },
      { accessor: 'playerReportByTarget', name: 'player_report_target_idx_btree', algorithm: 'btree', columns: [
        'target',
      ] },
    ],
    constraints: [
      { name: 'player_report_report_id_key', constraint: 'unique', columns: ['reportId'] },
    ],
  }, PlayerReportRow),
  playerResource: __table({
    name: 'player_resource',
    indexes: [
      { accessor: 'playerResourceByOwner', name: 'player_resource_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'stackId', name: 'player_resource_stack_id_idx_btree', algorithm: 'btree', columns: [
        'stackId',
      ] },
    ],
    constraints: [
      { name: 'player_resource_stack_id_key', constraint: 'unique', columns: ['stackId'] },
    ],
  }, PlayerResourceRow),
  playerSchematic: __table({
    name: 'player_schematic',
    indexes: [
      { accessor: 'playerSchematicByOwner', name: 'player_schematic_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'schemId', name: 'player_schematic_schem_id_idx_btree', algorithm: 'btree', columns: [
        'schemId',
      ] },
    ],
    constraints: [
      { name: 'player_schematic_schem_id_key', constraint: 'unique', columns: ['schemId'] },
    ],
  }, PlayerSchematicRow),
  playerShip: __table({
    name: 'player_ship',
    indexes: [
      { accessor: 'playerShipByOwner', name: 'player_ship_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'shipId', name: 'player_ship_ship_id_idx_btree', algorithm: 'btree', columns: [
        'shipId',
      ] },
    ],
    constraints: [
      { name: 'player_ship_ship_id_key', constraint: 'unique', columns: ['shipId'] },
    ],
  }, PlayerShipRow),
  playerStance: __table({
    name: 'player_stance',
    indexes: [
      { accessor: 'identity', name: 'player_stance_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'player_stance_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, PlayerStanceRow),
  playerStanding: __table({
    name: 'player_standing',
    indexes: [
      { accessor: 'playerStandingByIdentity', name: 'player_standing_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'playerStandingBySettlement', name: 'player_standing_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
      { accessor: 'standingId', name: 'player_standing_standing_id_idx_btree', algorithm: 'btree', columns: [
        'standingId',
      ] },
    ],
    constraints: [
      { name: 'player_standing_standing_id_key', constraint: 'unique', columns: ['standingId'] },
    ],
  }, PlayerStandingRow),
  playerState: __table({
    name: 'player_state',
    indexes: [
      { accessor: 'playerStateByCellX', name: 'player_state_cell_x_idx_btree', algorithm: 'btree', columns: [
        'cellX',
      ] },
      { accessor: 'playerStateByCellZ', name: 'player_state_cell_z_idx_btree', algorithm: 'btree', columns: [
        'cellZ',
      ] },
      { accessor: 'identity', name: 'player_state_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'playerStateByWorldCell', name: 'player_state_world_id_cell_x_cell_z_idx_btree', algorithm: 'btree', columns: [
        'worldId',
        'cellX',
        'cellZ',
      ] },
      { accessor: 'playerStateByWorld', name: 'player_state_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'player_state_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, PlayerStateRow),
  playerTale: __table({
    name: 'player_tale',
    indexes: [
      { accessor: 'identity', name: 'player_tale_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'player_tale_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, PlayerTaleRow),
  playerVitals: __table({
    name: 'player_vitals',
    indexes: [
      { accessor: 'identity', name: 'player_vitals_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'player_vitals_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, PlayerVitalsRow),
  portHaul: __table({
    name: 'port_haul',
    indexes: [
      { accessor: 'haulId', name: 'port_haul_haul_id_idx_btree', algorithm: 'btree', columns: [
        'haulId',
      ] },
      { accessor: 'portHaulByPort', name: 'port_haul_port_id_idx_btree', algorithm: 'btree', columns: [
        'portId',
      ] },
      { accessor: 'portHaulByState', name: 'port_haul_state_idx_btree', algorithm: 'btree', columns: [
        'state',
      ] },
    ],
    constraints: [
      { name: 'port_haul_haul_id_key', constraint: 'unique', columns: ['haulId'] },
    ],
  }, PortHaulRow),
  portHaulTerms: __table({
    name: 'port_haul_terms',
    indexes: [
      { accessor: 'haulId', name: 'port_haul_terms_haul_id_idx_btree', algorithm: 'btree', columns: [
        'haulId',
      ] },
      { accessor: 'portHaulTermsByPort', name: 'port_haul_terms_port_id_idx_btree', algorithm: 'btree', columns: [
        'portId',
      ] },
    ],
    constraints: [
      { name: 'port_haul_terms_haul_id_key', constraint: 'unique', columns: ['haulId'] },
    ],
  }, PortHaulTermsRow),
  portReceipt: __table({
    name: 'port_receipt',
    indexes: [
      { accessor: 'haulId', name: 'port_receipt_haul_id_idx_btree', algorithm: 'btree', columns: [
        'haulId',
      ] },
      { accessor: 'portReceiptByPort', name: 'port_receipt_port_id_idx_btree', algorithm: 'btree', columns: [
        'portId',
      ] },
      { accessor: 'portReceiptByStage', name: 'port_receipt_stage_idx_btree', algorithm: 'btree', columns: [
        'stage',
      ] },
    ],
    constraints: [
      { name: 'port_receipt_haul_id_key', constraint: 'unique', columns: ['haulId'] },
    ],
  }, PortReceiptRow),
  portStatus: __table({
    name: 'port_status',
    indexes: [
      { accessor: 'portId', name: 'port_status_port_id_idx_btree', algorithm: 'btree', columns: [
        'portId',
      ] },
    ],
    constraints: [
      { name: 'port_status_port_id_key', constraint: 'unique', columns: ['portId'] },
    ],
  }, PortStatusRow),
  postRequest: __table({
    name: 'post_request',
    indexes: [
      { accessor: 'postRequestByHolder', name: 'post_request_holder_idx_btree', algorithm: 'btree', columns: [
        'holder',
      ] },
      { accessor: 'requestId', name: 'post_request_request_id_idx_btree', algorithm: 'btree', columns: [
        'requestId',
      ] },
      { accessor: 'postRequestByVersona', name: 'post_request_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'post_request_request_id_key', constraint: 'unique', columns: ['requestId'] },
    ],
  }, PostRequestRow),
  prefabModel: __table({
    name: 'prefab_model',
    indexes: [
      { accessor: 'prefabModelByAsset', name: 'prefab_model_asset_id_idx_btree', algorithm: 'btree', columns: [
        'assetId',
      ] },
      { accessor: 'prefabModelByCategory', name: 'prefab_model_category_idx_btree', algorithm: 'btree', columns: [
        'category',
      ] },
      { accessor: 'prefabModelByKey', name: 'prefab_model_prefab_key_idx_btree', algorithm: 'btree', columns: [
        'prefabKey',
      ] },
      { accessor: 'prefabModelId', name: 'prefab_model_prefab_model_id_idx_btree', algorithm: 'btree', columns: [
        'prefabModelId',
      ] },
    ],
    constraints: [
      { name: 'prefab_model_prefab_model_id_key', constraint: 'unique', columns: ['prefabModelId'] },
    ],
  }, PrefabModelRow),
  presence: __table({
    name: 'presence',
    indexes: [
      { accessor: 'identity', name: 'presence_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'presence_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, PresenceRow),
  priceBelief: __table({
    name: 'price_belief',
    indexes: [
      { accessor: 'beliefId', name: 'price_belief_belief_id_idx_btree', algorithm: 'btree', columns: [
        'beliefId',
      ] },
      { accessor: 'priceBeliefByVersona', name: 'price_belief_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'price_belief_belief_id_key', constraint: 'unique', columns: ['beliefId'] },
    ],
  }, PriceBeliefRow),
  provenanceEvent: __table({
    name: 'provenance_event',
    indexes: [
      { accessor: 'provenanceEventByActor', name: 'provenance_event_actor_idx_btree', algorithm: 'btree', columns: [
        'actor',
      ] },
      { accessor: 'provenanceEventByAsset', name: 'provenance_event_asset_id_idx_btree', algorithm: 'btree', columns: [
        'assetId',
      ] },
      { accessor: 'eventId', name: 'provenance_event_event_id_idx_btree', algorithm: 'btree', columns: [
        'eventId',
      ] },
    ],
    constraints: [
      { name: 'provenance_event_event_id_key', constraint: 'unique', columns: ['eventId'] },
    ],
  }, ProvenanceEventRow),
  publishedExperience: __table({
    name: 'published_experience',
    indexes: [
      { accessor: 'publishedExperienceByProject', name: 'published_experience_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
      { accessor: 'worldId', name: 'published_experience_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'published_experience_world_id_key', constraint: 'unique', columns: ['worldId'] },
    ],
  }, PublishedExperienceRow),
  pulse: __table({
    name: 'pulse',
    indexes: [
      { accessor: 'identity', name: 'pulse_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'pulse_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, PulseRow),
  pvpArenaMatch: __table({
    name: 'pvp_arena_match',
    indexes: [
      { accessor: 'matchId', name: 'pvp_arena_match_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
      { accessor: 'pvpArenaMatchByState', name: 'pvp_arena_match_state_idx_btree', algorithm: 'btree', columns: [
        'state',
      ] },
    ],
    constraints: [
      { name: 'pvp_arena_match_match_id_key', constraint: 'unique', columns: ['matchId'] },
    ],
  }, PvpArenaMatchRow),
  pvpArenaMember: __table({
    name: 'pvp_arena_member',
    indexes: [
      { accessor: 'pvpArenaMemberByIdentity', name: 'pvp_arena_member_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'pvpArenaMemberByMatch', name: 'pvp_arena_member_match_id_idx_btree', algorithm: 'btree', columns: [
        'matchId',
      ] },
      { accessor: 'memberId', name: 'pvp_arena_member_member_id_idx_btree', algorithm: 'btree', columns: [
        'memberId',
      ] },
    ],
    constraints: [
      { name: 'pvp_arena_member_member_id_key', constraint: 'unique', columns: ['memberId'] },
    ],
  }, PvpArenaMemberRow),
  pvpArenaQueue: __table({
    name: 'pvp_arena_queue',
    indexes: [
      { accessor: 'identity', name: 'pvp_arena_queue_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'pvp_arena_queue_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, PvpArenaQueueRow),
  pvpDuel: __table({
    name: 'pvp_duel',
    indexes: [
      { accessor: 'pvpDuelByA', name: 'pvp_duel_a_idx_btree', algorithm: 'btree', columns: [
        'a',
      ] },
      { accessor: 'pvpDuelByB', name: 'pvp_duel_b_idx_btree', algorithm: 'btree', columns: [
        'b',
      ] },
      { accessor: 'duelId', name: 'pvp_duel_duel_id_idx_btree', algorithm: 'btree', columns: [
        'duelId',
      ] },
      { accessor: 'pvpDuelByState', name: 'pvp_duel_state_idx_btree', algorithm: 'btree', columns: [
        'state',
      ] },
    ],
    constraints: [
      { name: 'pvp_duel_duel_id_key', constraint: 'unique', columns: ['duelId'] },
    ],
  }, PvpDuelRow),
  pvpEnrollment: __table({
    name: 'pvp_enrollment',
    indexes: [
      { accessor: 'identity', name: 'pvp_enrollment_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'pvpEnrollmentBySector', name: 'pvp_enrollment_sector_id_idx_btree', algorithm: 'btree', columns: [
        'sectorId',
      ] },
    ],
    constraints: [
      { name: 'pvp_enrollment_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, PvpEnrollmentRow),
  pvpObjectiveReceipt: __table({
    name: 'pvp_objective_receipt',
    indexes: [
      { accessor: 'receiptKey', name: 'pvp_objective_receipt_receipt_key_idx_btree', algorithm: 'btree', columns: [
        'receiptKey',
      ] },
    ],
    constraints: [
      { name: 'pvp_objective_receipt_receipt_key_key', constraint: 'unique', columns: ['receiptKey'] },
    ],
  }, PvpObjectiveReceiptRow),
  pvpRecord: __table({
    name: 'pvp_record',
    indexes: [
      { accessor: 'identity', name: 'pvp_record_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'pvp_record_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, PvpRecordRow),
  pvpSector: __table({
    name: 'pvp_sector',
    indexes: [
      { accessor: 'sectorId', name: 'pvp_sector_sector_id_idx_btree', algorithm: 'btree', columns: [
        'sectorId',
      ] },
    ],
    constraints: [
      { name: 'pvp_sector_sector_id_key', constraint: 'unique', columns: ['sectorId'] },
    ],
  }, PvpSectorRow),
  raceEntry: __table({
    name: 'race_entry',
    indexes: [
      { accessor: 'entryId', name: 'race_entry_entry_id_idx_btree', algorithm: 'btree', columns: [
        'entryId',
      ] },
      { accessor: 'raceEntryByIdentity', name: 'race_entry_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'raceEntryByRace', name: 'race_entry_race_id_idx_btree', algorithm: 'btree', columns: [
        'raceId',
      ] },
    ],
    constraints: [
      { name: 'race_entry_entry_id_key', constraint: 'unique', columns: ['entryId'] },
    ],
  }, RaceEntryRow),
  raceEvent: __table({
    name: 'race_event',
    indexes: [
      { accessor: 'raceId', name: 'race_event_race_id_idx_btree', algorithm: 'btree', columns: [
        'raceId',
      ] },
      { accessor: 'raceEventByState', name: 'race_event_state_idx_btree', algorithm: 'btree', columns: [
        'state',
      ] },
    ],
    constraints: [
      { name: 'race_event_race_id_key', constraint: 'unique', columns: ['raceId'] },
    ],
  }, RaceEventRow),
  raceStanding: __table({
    name: 'race_standing',
    indexes: [
      { accessor: 'raceStandingBySeason', name: 'race_standing_season_idx_btree', algorithm: 'btree', columns: [
        'season',
      ] },
      { accessor: 'standingKey', name: 'race_standing_standing_key_idx_btree', algorithm: 'btree', columns: [
        'standingKey',
      ] },
    ],
    constraints: [
      { name: 'race_standing_standing_key_key', constraint: 'unique', columns: ['standingKey'] },
    ],
  }, RaceStandingRow),
  rating: __table({
    name: 'rating',
    indexes: [
      { accessor: 'ratingByGame', name: 'rating_game_id_idx_btree', algorithm: 'btree', columns: [
        'gameId',
      ] },
      { accessor: 'ratingByPlayer', name: 'rating_player_idx_btree', algorithm: 'btree', columns: [
        'player',
      ] },
      { accessor: 'ratingId', name: 'rating_rating_id_idx_btree', algorithm: 'btree', columns: [
        'ratingId',
      ] },
    ],
    constraints: [
      { name: 'rating_rating_id_key', constraint: 'unique', columns: ['ratingId'] },
    ],
  }, RatingRow),
  recallPetition: __table({
    name: 'recall_petition',
    indexes: [
      { accessor: 'petitionId', name: 'recall_petition_petition_id_idx_btree', algorithm: 'btree', columns: [
        'petitionId',
      ] },
      { accessor: 'recallPetitionBySettlement', name: 'recall_petition_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'recall_petition_petition_id_key', constraint: 'unique', columns: ['petitionId'] },
    ],
  }, RecallPetitionRow),
  regionAssetSet: __table({
    name: 'region_asset_set',
    indexes: [
      { accessor: 'setId', name: 'region_asset_set_set_id_idx_btree', algorithm: 'btree', columns: [
        'setId',
      ] },
      { accessor: 'regionAssetSetByWorld', name: 'region_asset_set_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'region_asset_set_set_id_key', constraint: 'unique', columns: ['setId'] },
    ],
  }, RegionAssetSetRow),
  renderAsset: __table({
    name: 'render_asset',
    indexes: [
      { accessor: 'renderAssetByHash', name: 'render_asset_content_hash_idx_btree', algorithm: 'btree', columns: [
        'contentHash',
      ] },
      { accessor: 'renderAssetByCreator', name: 'render_asset_creator_idx_btree', algorithm: 'btree', columns: [
        'creator',
      ] },
      { accessor: 'renderAssetByKind', name: 'render_asset_kind_idx_btree', algorithm: 'btree', columns: [
        'kind',
      ] },
      { accessor: 'renderAssetId', name: 'render_asset_render_asset_id_idx_btree', algorithm: 'btree', columns: [
        'renderAssetId',
      ] },
    ],
    constraints: [
      { name: 'render_asset_render_asset_id_key', constraint: 'unique', columns: ['renderAssetId'] },
    ],
  }, RenderAssetRow),
  renderAssetTextureTier: __table({
    name: 'render_asset_texture_tier',
    indexes: [
      { accessor: 'renderAssetTextureTierByAsset', name: 'render_asset_texture_tier_render_asset_id_idx_btree', algorithm: 'btree', columns: [
        'renderAssetId',
      ] },
      { accessor: 'tierId', name: 'render_asset_texture_tier_tier_id_idx_btree', algorithm: 'btree', columns: [
        'tierId',
      ] },
    ],
    constraints: [
      { name: 'render_asset_texture_tier_tier_id_key', constraint: 'unique', columns: ['tierId'] },
    ],
  }, RenderAssetTextureTierRow),
  renderAssetVariant: __table({
    name: 'render_asset_variant',
    indexes: [
      { accessor: 'renderAssetVariantByAsset', name: 'render_asset_variant_render_asset_id_idx_btree', algorithm: 'btree', columns: [
        'renderAssetId',
      ] },
      { accessor: 'variantId', name: 'render_asset_variant_variant_id_idx_btree', algorithm: 'btree', columns: [
        'variantId',
      ] },
    ],
    constraints: [
      { name: 'render_asset_variant_variant_id_key', constraint: 'unique', columns: ['variantId'] },
    ],
  }, RenderAssetVariantRow),
  rental: __table({
    name: 'rental',
    indexes: [
      { accessor: 'rentalByOwner', name: 'rental_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'rentalId', name: 'rental_rental_id_idx_btree', algorithm: 'btree', columns: [
        'rentalId',
      ] },
      { accessor: 'rentalByRenter', name: 'rental_renter_idx_btree', algorithm: 'btree', columns: [
        'renter',
      ] },
      { accessor: 'rentalByWorld', name: 'rental_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'rental_rental_id_key', constraint: 'unique', columns: ['rentalId'] },
    ],
  }, RentalRow),
  rentalContainer: __table({
    name: 'rental_container',
    indexes: [
      { accessor: 'containerId', name: 'rental_container_container_id_idx_btree', algorithm: 'btree', columns: [
        'containerId',
      ] },
      { accessor: 'rentalContainerByLease', name: 'rental_container_lease_id_idx_btree', algorithm: 'btree', columns: [
        'leaseId',
      ] },
      { accessor: 'rentalContainerByTenant', name: 'rental_container_tenant_idx_btree', algorithm: 'btree', columns: [
        'tenant',
      ] },
    ],
    constraints: [
      { name: 'rental_container_container_id_key', constraint: 'unique', columns: ['containerId'] },
    ],
  }, RentalContainerRow),
  rentalLease: __table({
    name: 'rental_lease',
    indexes: [
      { accessor: 'leaseId', name: 'rental_lease_lease_id_idx_btree', algorithm: 'btree', columns: [
        'leaseId',
      ] },
      { accessor: 'rentalLeaseByStructure', name: 'rental_lease_structure_id_idx_btree', algorithm: 'btree', columns: [
        'structureId',
      ] },
      { accessor: 'rentalLeaseByTenant', name: 'rental_lease_tenant_idx_btree', algorithm: 'btree', columns: [
        'tenant',
      ] },
      { accessor: 'rentalLeaseByUnit', name: 'rental_lease_unit_row_id_idx_btree', algorithm: 'btree', columns: [
        'unitRowId',
      ] },
    ],
    constraints: [
      { name: 'rental_lease_lease_id_key', constraint: 'unique', columns: ['leaseId'] },
    ],
  }, RentalLeaseRow),
  rentalReceipt: __table({
    name: 'rental_receipt',
    indexes: [
      { accessor: 'rentalReceiptByLease', name: 'rental_receipt_lease_id_idx_btree', algorithm: 'btree', columns: [
        'leaseId',
      ] },
      { accessor: 'rentalReceiptByOwner', name: 'rental_receipt_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'receiptId', name: 'rental_receipt_receipt_id_idx_btree', algorithm: 'btree', columns: [
        'receiptId',
      ] },
      { accessor: 'rentalReceiptByTenant', name: 'rental_receipt_tenant_idx_btree', algorithm: 'btree', columns: [
        'tenant',
      ] },
    ],
    constraints: [
      { name: 'rental_receipt_receipt_id_key', constraint: 'unique', columns: ['receiptId'] },
    ],
  }, RentalReceiptRow),
  rentalStored: __table({
    name: 'rental_stored',
    indexes: [
      { accessor: 'rentalStoredByContainer', name: 'rental_stored_container_id_idx_btree', algorithm: 'btree', columns: [
        'containerId',
      ] },
      { accessor: 'entryId', name: 'rental_stored_entry_id_idx_btree', algorithm: 'btree', columns: [
        'entryId',
      ] },
      { accessor: 'rentalStoredByLease', name: 'rental_stored_lease_id_idx_btree', algorithm: 'btree', columns: [
        'leaseId',
      ] },
      { accessor: 'rentalStoredByTenant', name: 'rental_stored_tenant_idx_btree', algorithm: 'btree', columns: [
        'tenant',
      ] },
    ],
    constraints: [
      { name: 'rental_stored_entry_id_key', constraint: 'unique', columns: ['entryId'] },
    ],
  }, RentalStoredRow),
  rentalUnit: __table({
    name: 'rental_unit',
    indexes: [
      { accessor: 'rentalUnitByStructure', name: 'rental_unit_structure_id_idx_btree', algorithm: 'btree', columns: [
        'structureId',
      ] },
      { accessor: 'unitRowId', name: 'rental_unit_unit_row_id_idx_btree', algorithm: 'btree', columns: [
        'unitRowId',
      ] },
    ],
    constraints: [
      { name: 'rental_unit_unit_row_id_key', constraint: 'unique', columns: ['unitRowId'] },
    ],
  }, RentalUnitRow),
  reputation: __table({
    name: 'reputation',
    indexes: [
      { accessor: 'identity', name: 'reputation_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'reputation_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, ReputationRow),
  researchPost: __table({
    name: 'research_post',
    indexes: [
      { accessor: 'stationKey', name: 'research_post_station_key_idx_btree', algorithm: 'btree', columns: [
        'stationKey',
      ] },
    ],
    constraints: [
      { name: 'research_post_station_key_key', constraint: 'unique', columns: ['stationKey'] },
    ],
  }, ResearchPostRow),
  researchTender: __table({
    name: 'research_tender',
    indexes: [
      { accessor: 'researchTenderByTaker', name: 'research_tender_accepted_by_idx_btree', algorithm: 'btree', columns: [
        'acceptedBy',
      ] },
      { accessor: 'researchTenderByPost', name: 'research_tender_post_key_idx_btree', algorithm: 'btree', columns: [
        'postKey',
      ] },
      { accessor: 'researchTenderBySig', name: 'research_tender_sig_key_idx_btree', algorithm: 'btree', columns: [
        'sigKey',
      ] },
      { accessor: 'tenderId', name: 'research_tender_tender_id_idx_btree', algorithm: 'btree', columns: [
        'tenderId',
      ] },
    ],
    constraints: [
      { name: 'research_tender_tender_id_key', constraint: 'unique', columns: ['tenderId'] },
    ],
  }, ResearchTenderRow),
  residency: __table({
    name: 'residency',
    indexes: [
      { accessor: 'identity', name: 'residency_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'residencyBySettlement', name: 'residency_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'residency_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, ResidencyRow),
  resourceListing: __table({
    name: 'resource_listing',
    indexes: [
      { accessor: 'listingId', name: 'resource_listing_listing_id_idx_btree', algorithm: 'btree', columns: [
        'listingId',
      ] },
      { accessor: 'resourceListingBySeller', name: 'resource_listing_seller_idx_btree', algorithm: 'btree', columns: [
        'seller',
      ] },
    ],
    constraints: [
      { name: 'resource_listing_listing_id_key', constraint: 'unique', columns: ['listingId'] },
    ],
  }, ResourceListingRow),
  resourceNode: __table({
    name: 'resource_node',
    indexes: [
      { accessor: 'nodeId', name: 'resource_node_node_id_idx_btree', algorithm: 'btree', columns: [
        'nodeId',
      ] },
      { accessor: 'resourceNodeBySettlement', name: 'resource_node_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'resource_node_node_id_key', constraint: 'unique', columns: ['nodeId'] },
    ],
  }, ResourceNodeRow),
  resourceSpawn: __table({
    name: 'resource_spawn',
    indexes: [
      { accessor: 'resourceSpawnByFamily', name: 'resource_spawn_family_key_idx_btree', algorithm: 'btree', columns: [
        'familyKey',
      ] },
      { accessor: 'spawnId', name: 'resource_spawn_spawn_id_idx_btree', algorithm: 'btree', columns: [
        'spawnId',
      ] },
    ],
    constraints: [
      { name: 'resource_spawn_spawn_id_key', constraint: 'unique', columns: ['spawnId'] },
    ],
  }, ResourceSpawnRow),
  review: __table({
    name: 'review',
    indexes: [
      { accessor: 'reviewId', name: 'review_review_id_idx_btree', algorithm: 'btree', columns: [
        'reviewId',
      ] },
      { accessor: 'reviewByReviewer', name: 'review_reviewer_idx_btree', algorithm: 'btree', columns: [
        'reviewer',
      ] },
      { accessor: 'reviewBySubject', name: 'review_subject_idx_btree', algorithm: 'btree', columns: [
        'subject',
      ] },
    ],
    constraints: [
      { name: 'review_review_id_key', constraint: 'unique', columns: ['reviewId'] },
    ],
  }, ReviewRow),
  rewardReceipt: __table({
    name: 'reward_receipt',
    indexes: [
      { accessor: 'rewardReceiptByIdentity', name: 'reward_receipt_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'receiptKey', name: 'reward_receipt_receipt_key_idx_btree', algorithm: 'btree', columns: [
        'receiptKey',
      ] },
    ],
    constraints: [
      { name: 'reward_receipt_receipt_key_key', constraint: 'unique', columns: ['receiptKey'] },
    ],
  }, RewardReceiptRow),
  ritual: __table({
    name: 'ritual',
    indexes: [
      { accessor: 'ritualByEvent', name: 'ritual_event_id_idx_btree', algorithm: 'btree', columns: [
        'eventId',
      ] },
      { accessor: 'ritualId', name: 'ritual_ritual_id_idx_btree', algorithm: 'btree', columns: [
        'ritualId',
      ] },
    ],
    constraints: [
      { name: 'ritual_ritual_id_key', constraint: 'unique', columns: ['ritualId'] },
    ],
  }, RitualRow),
  ritualMute: __table({
    name: 'ritual_mute',
    indexes: [
      { accessor: 'muteByIdentity', name: 'ritual_mute_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'muteId', name: 'ritual_mute_mute_id_idx_btree', algorithm: 'btree', columns: [
        'muteId',
      ] },
      { accessor: 'muteByRitual', name: 'ritual_mute_ritual_id_idx_btree', algorithm: 'btree', columns: [
        'ritualId',
      ] },
    ],
    constraints: [
      { name: 'ritual_mute_mute_id_key', constraint: 'unique', columns: ['muteId'] },
    ],
  }, RitualMuteRow),
  royalty: __table({
    name: 'royalty',
    indexes: [
      { accessor: 'royaltyByAsset', name: 'royalty_asset_id_idx_btree', algorithm: 'btree', columns: [
        'assetId',
      ] },
      { accessor: 'royaltyBySaleTx', name: 'royalty_from_sale_tx_idx_btree', algorithm: 'btree', columns: [
        'fromSaleTx',
      ] },
      { accessor: 'royaltyByCreator', name: 'royalty_original_creator_idx_btree', algorithm: 'btree', columns: [
        'originalCreator',
      ] },
      { accessor: 'royaltyId', name: 'royalty_royalty_id_idx_btree', algorithm: 'btree', columns: [
        'royaltyId',
      ] },
    ],
    constraints: [
      { name: 'royalty_royalty_id_key', constraint: 'unique', columns: ['royaltyId'] },
    ],
  }, RoyaltyRow),
  scanState: __table({
    name: 'scan_state',
    indexes: [
      { accessor: 'identity', name: 'scan_state_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'scan_state_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, ScanStateRow),
  season: __table({
    name: 'season',
    indexes: [
      { accessor: 'seasonId', name: 'season_season_id_idx_btree', algorithm: 'btree', columns: [
        'seasonId',
      ] },
    ],
    constraints: [
      { name: 'season_season_id_key', constraint: 'unique', columns: ['seasonId'] },
    ],
  }, SeasonRow),
  seasonFestival: __table({
    name: 'season_festival',
    indexes: [
      { accessor: 'seasonFestivalByEpoch', name: 'season_festival_epoch_idx_btree', algorithm: 'btree', columns: [
        'epoch',
      ] },
      { accessor: 'key', name: 'season_festival_key_idx_btree', algorithm: 'btree', columns: [
        'key',
      ] },
    ],
    constraints: [
      { name: 'season_festival_key_key', constraint: 'unique', columns: ['key'] },
    ],
  }, SeasonFestivalRow),
  seasonScore: __table({
    name: 'season_score',
    indexes: [
      { accessor: 'seasonScoreByGame', name: 'season_score_game_id_idx_btree', algorithm: 'btree', columns: [
        'gameId',
      ] },
      { accessor: 'seasonScoreByPlayer', name: 'season_score_player_idx_btree', algorithm: 'btree', columns: [
        'player',
      ] },
      { accessor: 'seasonScoreBySeason', name: 'season_score_season_id_idx_btree', algorithm: 'btree', columns: [
        'seasonId',
      ] },
      { accessor: 'ssId', name: 'season_score_ss_id_idx_btree', algorithm: 'btree', columns: [
        'ssId',
      ] },
    ],
    constraints: [
      { name: 'season_score_ss_id_key', constraint: 'unique', columns: ['ssId'] },
    ],
  }, SeasonScoreRow),
  sectorControl: __table({
    name: 'sector_control',
    indexes: [
      { accessor: 'systemId', name: 'sector_control_system_id_idx_btree', algorithm: 'btree', columns: [
        'systemId',
      ] },
    ],
    constraints: [
      { name: 'sector_control_system_id_key', constraint: 'unique', columns: ['systemId'] },
    ],
  }, SectorControlRow),
  serviceJob: __table({
    name: 'service_job',
    indexes: [
      { accessor: 'jobId', name: 'service_job_job_id_idx_btree', algorithm: 'btree', columns: [
        'jobId',
      ] },
      { accessor: 'serviceJobByOwner', name: 'service_job_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'serviceJobByStation', name: 'service_job_station_key_idx_btree', algorithm: 'btree', columns: [
        'stationKey',
      ] },
    ],
    constraints: [
      { name: 'service_job_job_id_key', constraint: 'unique', columns: ['jobId'] },
    ],
  }, ServiceJobRow),
  serviceQuote: __table({
    name: 'service_quote',
    indexes: [
      { accessor: 'serviceQuoteByOwner', name: 'service_quote_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'quoteId', name: 'service_quote_quote_id_idx_btree', algorithm: 'btree', columns: [
        'quoteId',
      ] },
    ],
    constraints: [
      { name: 'service_quote_quote_id_key', constraint: 'unique', columns: ['quoteId'] },
    ],
  }, ServiceQuoteRow),
  settlementCiv: __table({
    name: 'settlement_civ',
    indexes: [
      { accessor: 'settlementId', name: 'settlement_civ_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'settlement_civ_settlement_id_key', constraint: 'unique', columns: ['settlementId'] },
    ],
  }, SettlementCivRow),
  settlementEcon: __table({
    name: 'settlement_econ',
    indexes: [
      { accessor: 'settlementId', name: 'settlement_econ_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'settlement_econ_settlement_id_key', constraint: 'unique', columns: ['settlementId'] },
    ],
  }, SettlementEconRow),
  settlementGoodwill: __table({
    name: 'settlement_goodwill',
    indexes: [
      { accessor: 'settlementGoodwillByA', name: 'settlement_goodwill_a_id_idx_btree', algorithm: 'btree', columns: [
        'aId',
      ] },
      { accessor: 'settlementGoodwillByB', name: 'settlement_goodwill_b_id_idx_btree', algorithm: 'btree', columns: [
        'bId',
      ] },
      { accessor: 'goodwillId', name: 'settlement_goodwill_goodwill_id_idx_btree', algorithm: 'btree', columns: [
        'goodwillId',
      ] },
    ],
    constraints: [
      { name: 'settlement_goodwill_goodwill_id_key', constraint: 'unique', columns: ['goodwillId'] },
    ],
  }, SettlementGoodwillRow),
  settlementMind: __table({
    name: 'settlement_mind',
    indexes: [
      { accessor: 'settlementId', name: 'settlement_mind_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'settlement_mind_settlement_id_key', constraint: 'unique', columns: ['settlementId'] },
    ],
  }, SettlementMindRow),
  settlementName: __table({
    name: 'settlement_name',
    indexes: [
      { accessor: 'siteId', name: 'settlement_name_site_id_idx_btree', algorithm: 'btree', columns: [
        'siteId',
      ] },
    ],
    constraints: [
      { name: 'settlement_name_site_id_key', constraint: 'unique', columns: ['siteId'] },
    ],
  }, SettlementNameRow),
  settlementNorm: __table({
    name: 'settlement_norm',
    indexes: [
      { accessor: 'normId', name: 'settlement_norm_norm_id_idx_btree', algorithm: 'btree', columns: [
        'normId',
      ] },
      { accessor: 'settlementNormBySettlement', name: 'settlement_norm_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'settlement_norm_norm_id_key', constraint: 'unique', columns: ['normId'] },
    ],
  }, SettlementNormRow),
  settlementOffice: __table({
    name: 'settlement_office',
    indexes: [
      { accessor: 'officeId', name: 'settlement_office_office_id_idx_btree', algorithm: 'btree', columns: [
        'officeId',
      ] },
      { accessor: 'settlementOfficeBySettlement', name: 'settlement_office_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'settlement_office_office_id_key', constraint: 'unique', columns: ['officeId'] },
    ],
  }, SettlementOfficeRow),
  settlementParty: __table({
    name: 'settlement_party',
    indexes: [
      { accessor: 'partyId', name: 'settlement_party_party_id_idx_btree', algorithm: 'btree', columns: [
        'partyId',
      ] },
      { accessor: 'settlementPartyBySettlement', name: 'settlement_party_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'settlement_party_party_id_key', constraint: 'unique', columns: ['partyId'] },
    ],
  }, SettlementPartyRow),
  settlementResidue: __table({
    name: 'settlement_residue',
    indexes: [
      { accessor: 'settlementId', name: 'settlement_residue_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'settlement_residue_settlement_id_key', constraint: 'unique', columns: ['settlementId'] },
    ],
  }, SettlementResidueRow),
  settlementRivalry: __table({
    name: 'settlement_rivalry',
    indexes: [
      { accessor: 'settlementRivalryByA', name: 'settlement_rivalry_a_id_idx_btree', algorithm: 'btree', columns: [
        'aId',
      ] },
      { accessor: 'settlementRivalryByB', name: 'settlement_rivalry_b_id_idx_btree', algorithm: 'btree', columns: [
        'bId',
      ] },
      { accessor: 'rivalryId', name: 'settlement_rivalry_rivalry_id_idx_btree', algorithm: 'btree', columns: [
        'rivalryId',
      ] },
    ],
    constraints: [
      { name: 'settlement_rivalry_rivalry_id_key', constraint: 'unique', columns: ['rivalryId'] },
    ],
  }, SettlementRivalryRow),
  settlementScore: __table({
    name: 'settlement_score',
    indexes: [
      { accessor: 'settlementId', name: 'settlement_score_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'settlement_score_settlement_id_key', constraint: 'unique', columns: ['settlementId'] },
    ],
  }, SettlementScoreRow),
  settlementStock: __table({
    name: 'settlement_stock',
    indexes: [
      { accessor: 'settlementStockBySettlement', name: 'settlement_stock_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
      { accessor: 'stockId', name: 'settlement_stock_stock_id_idx_btree', algorithm: 'btree', columns: [
        'stockId',
      ] },
    ],
    constraints: [
      { name: 'settlement_stock_stock_id_key', constraint: 'unique', columns: ['stockId'] },
    ],
  }, SettlementStockRow),
  settlementTreaty: __table({
    name: 'settlement_treaty',
    indexes: [
      { accessor: 'settlementTreatyByA', name: 'settlement_treaty_a_id_idx_btree', algorithm: 'btree', columns: [
        'aId',
      ] },
      { accessor: 'settlementTreatyByB', name: 'settlement_treaty_b_id_idx_btree', algorithm: 'btree', columns: [
        'bId',
      ] },
      { accessor: 'treatyId', name: 'settlement_treaty_treaty_id_idx_btree', algorithm: 'btree', columns: [
        'treatyId',
      ] },
    ],
    constraints: [
      { name: 'settlement_treaty_treaty_id_key', constraint: 'unique', columns: ['treatyId'] },
    ],
  }, SettlementTreatyRow),
  shipBerth: __table({
    name: 'ship_berth',
    indexes: [
      { accessor: 'identity', name: 'ship_berth_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'ship_berth_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, ShipBerthRow),
  shipComponent: __table({
    name: 'ship_component',
    indexes: [
      { accessor: 'compId', name: 'ship_component_comp_id_idx_btree', algorithm: 'btree', columns: [
        'compId',
      ] },
      { accessor: 'shipComponentByShip', name: 'ship_component_ship_id_idx_btree', algorithm: 'btree', columns: [
        'shipId',
      ] },
    ],
    constraints: [
      { name: 'ship_component_comp_id_key', constraint: 'unique', columns: ['compId'] },
    ],
  }, ShipComponentRow),
  shipDeckItem: __table({
    name: 'ship_deck_item',
    indexes: [
      { accessor: 'deckItemId', name: 'ship_deck_item_deck_item_id_idx_btree', algorithm: 'btree', columns: [
        'deckItemId',
      ] },
      { accessor: 'shipDeckItemByShip', name: 'ship_deck_item_ship_id_idx_btree', algorithm: 'btree', columns: [
        'shipId',
      ] },
    ],
    constraints: [
      { name: 'ship_deck_item_deck_item_id_key', constraint: 'unique', columns: ['deckItemId'] },
    ],
  }, ShipDeckItemRow),
  shipInsurance: __table({
    name: 'ship_insurance',
    indexes: [
      { accessor: 'shipId', name: 'ship_insurance_ship_id_idx_btree', algorithm: 'btree', columns: [
        'shipId',
      ] },
    ],
    constraints: [
      { name: 'ship_insurance_ship_id_key', constraint: 'unique', columns: ['shipId'] },
    ],
  }, ShipInsuranceRow),
  shipPower: __table({
    name: 'ship_power',
    indexes: [
      { accessor: 'shipId', name: 'ship_power_ship_id_idx_btree', algorithm: 'btree', columns: [
        'shipId',
      ] },
    ],
    constraints: [
      { name: 'ship_power_ship_id_key', constraint: 'unique', columns: ['shipId'] },
    ],
  }, ShipPowerRow),
  shipSubsystem: __table({
    name: 'ship_subsystem',
    indexes: [
      { accessor: 'shipSubsystemByOwner', name: 'ship_subsystem_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'shipId', name: 'ship_subsystem_ship_id_idx_btree', algorithm: 'btree', columns: [
        'shipId',
      ] },
    ],
    constraints: [
      { name: 'ship_subsystem_ship_id_key', constraint: 'unique', columns: ['shipId'] },
    ],
  }, ShipSubsystemRow),
  shipWreck: __table({
    name: 'ship_wreck',
    indexes: [
      { accessor: 'shipWreckBySystem', name: 'ship_wreck_system_id_idx_btree', algorithm: 'btree', columns: [
        'systemId',
      ] },
      { accessor: 'wreckId', name: 'ship_wreck_wreck_id_idx_btree', algorithm: 'btree', columns: [
        'wreckId',
      ] },
    ],
    constraints: [
      { name: 'ship_wreck_wreck_id_key', constraint: 'unique', columns: ['wreckId'] },
    ],
  }, ShipWreckRow),
  sigReveal: __table({
    name: 'sig_reveal',
    indexes: [
      { accessor: 'sigRevealByIdentity', name: 'sig_reveal_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'revealId', name: 'sig_reveal_reveal_id_idx_btree', algorithm: 'btree', columns: [
        'revealId',
      ] },
    ],
    constraints: [
      { name: 'sig_reveal_reveal_id_key', constraint: 'unique', columns: ['revealId'] },
    ],
  }, SigRevealRow),
  simLod: __table({
    name: 'sim_lod',
    indexes: [
      { accessor: 'systemId', name: 'sim_lod_system_id_idx_btree', algorithm: 'btree', columns: [
        'systemId',
      ] },
    ],
    constraints: [
      { name: 'sim_lod_system_id_key', constraint: 'unique', columns: ['systemId'] },
    ],
  }, SimLodRow),
  simTickLedger: __table({
    name: 'sim_tick_ledger',
    indexes: [
      { accessor: 'name', name: 'sim_tick_ledger_name_idx_btree', algorithm: 'btree', columns: [
        'name',
      ] },
    ],
    constraints: [
      { name: 'sim_tick_ledger_name_key', constraint: 'unique', columns: ['name'] },
    ],
  }, SimTickLedgerRow),
  skyLightingProfile: __table({
    name: 'sky_lighting_profile',
    indexes: [
      { accessor: 'skyLightingProfileByBand', name: 'sky_lighting_profile_band_idx_btree', algorithm: 'btree', columns: [
        'band',
      ] },
      { accessor: 'profileId', name: 'sky_lighting_profile_profile_id_idx_btree', algorithm: 'btree', columns: [
        'profileId',
      ] },
    ],
    constraints: [
      { name: 'sky_lighting_profile_profile_id_key', constraint: 'unique', columns: ['profileId'] },
    ],
  }, SkyLightingProfileRow),
  skyShipState: __table({
    name: 'sky_ship_state',
    indexes: [
      { accessor: 'identity', name: 'sky_ship_state_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'sky_ship_state_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, SkyShipStateRow),
  skyState: __table({
    name: 'sky_state',
    indexes: [
      { accessor: 'worldId', name: 'sky_state_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'sky_state_world_id_key', constraint: 'unique', columns: ['worldId'] },
    ],
  }, SkyStateRow),
  spaceAdvice: __table({
    name: 'space_advice',
    indexes: [
      { accessor: 'adviceId', name: 'space_advice_advice_id_idx_btree', algorithm: 'btree', columns: [
        'adviceId',
      ] },
      { accessor: 'spaceAdviceByCiv', name: 'space_advice_civ_idx_btree', algorithm: 'btree', columns: [
        'civ',
      ] },
    ],
    constraints: [
      { name: 'space_advice_advice_id_key', constraint: 'unique', columns: ['adviceId'] },
    ],
  }, SpaceAdviceRow),
  spaceAmbush: __table({
    name: 'space_ambush',
    indexes: [
      { accessor: 'ambushId', name: 'space_ambush_ambush_id_idx_btree', algorithm: 'btree', columns: [
        'ambushId',
      ] },
      { accessor: 'spaceAmbushByShipment', name: 'space_ambush_shipment_id_idx_btree', algorithm: 'btree', columns: [
        'shipmentId',
      ] },
      { accessor: 'spaceAmbushByState', name: 'space_ambush_state_idx_btree', algorithm: 'btree', columns: [
        'state',
      ] },
    ],
    constraints: [
      { name: 'space_ambush_ambush_id_key', constraint: 'unique', columns: ['ambushId'] },
    ],
  }, SpaceAmbushRow),
  spaceBookmark: __table({
    name: 'space_bookmark',
    indexes: [
      { accessor: 'bookmarkId', name: 'space_bookmark_bookmark_id_idx_btree', algorithm: 'btree', columns: [
        'bookmarkId',
      ] },
      { accessor: 'spaceBookmarkByCiv', name: 'space_bookmark_civ_idx_btree', algorithm: 'btree', columns: [
        'civ',
      ] },
      { accessor: 'spaceBookmarkByOwner', name: 'space_bookmark_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'spaceBookmarkBySystem', name: 'space_bookmark_system_id_idx_btree', algorithm: 'btree', columns: [
        'systemId',
      ] },
    ],
    constraints: [
      { name: 'space_bookmark_bookmark_id_key', constraint: 'unique', columns: ['bookmarkId'] },
    ],
  }, SpaceBookmarkRow),
  spaceBounty: __table({
    name: 'space_bounty',
    indexes: [
      { accessor: 'spaceBountyByIdentity', name: 'space_bounty_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'spaceBountyId', name: 'space_bounty_space_bounty_id_idx_btree', algorithm: 'btree', columns: [
        'spaceBountyId',
      ] },
    ],
    constraints: [
      { name: 'space_bounty_space_bounty_id_key', constraint: 'unique', columns: ['spaceBountyId'] },
    ],
  }, SpaceBountyRow),
  spaceCampaign: __table({
    name: 'space_campaign',
    indexes: [
      { accessor: 'campaignId', name: 'space_campaign_campaign_id_idx_btree', algorithm: 'btree', columns: [
        'campaignId',
      ] },
      { accessor: 'spaceCampaignByState', name: 'space_campaign_state_idx_btree', algorithm: 'btree', columns: [
        'state',
      ] },
    ],
    constraints: [
      { name: 'space_campaign_campaign_id_key', constraint: 'unique', columns: ['campaignId'] },
    ],
  }, SpaceCampaignRow),
  spaceClaim: __table({
    name: 'space_claim',
    indexes: [
      { accessor: 'claimId', name: 'space_claim_claim_id_idx_btree', algorithm: 'btree', columns: [
        'claimId',
      ] },
      { accessor: 'spaceClaimByIdentity', name: 'space_claim_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'space_claim_claim_id_key', constraint: 'unique', columns: ['claimId'] },
    ],
  }, SpaceClaimRow),
  spaceCrew: __table({
    name: 'space_crew',
    indexes: [
      { accessor: 'spaceCrewByCaptain', name: 'space_crew_captain_idx_btree', algorithm: 'btree', columns: [
        'captain',
      ] },
      { accessor: 'crewId', name: 'space_crew_crew_id_idx_btree', algorithm: 'btree', columns: [
        'crewId',
      ] },
      { accessor: 'spaceCrewByCrew', name: 'space_crew_crew_idx_btree', algorithm: 'btree', columns: [
        'crew',
      ] },
    ],
    constraints: [
      { name: 'space_crew_crew_id_key', constraint: 'unique', columns: ['crewId'] },
    ],
  }, SpaceCrewRow),
  spaceDeposit: __table({
    name: 'space_deposit',
    indexes: [
      { accessor: 'depositId', name: 'space_deposit_deposit_id_idx_btree', algorithm: 'btree', columns: [
        'depositId',
      ] },
      { accessor: 'spaceDepositBySystem', name: 'space_deposit_system_id_idx_btree', algorithm: 'btree', columns: [
        'systemId',
      ] },
    ],
    constraints: [
      { name: 'space_deposit_deposit_id_key', constraint: 'unique', columns: ['depositId'] },
    ],
  }, SpaceDepositRow),
  spaceFirm: __table({
    name: 'space_firm',
    indexes: [
      { accessor: 'firmId', name: 'space_firm_firm_id_idx_btree', algorithm: 'btree', columns: [
        'firmId',
      ] },
    ],
    constraints: [
      { name: 'space_firm_firm_id_key', constraint: 'unique', columns: ['firmId'] },
    ],
  }, SpaceFirmRow),
  spaceIntel: __table({
    name: 'space_intel',
    indexes: [
      { accessor: 'spaceIntelByCiv', name: 'space_intel_civ_idx_btree', algorithm: 'btree', columns: [
        'civ',
      ] },
      { accessor: 'intelId', name: 'space_intel_intel_id_idx_btree', algorithm: 'btree', columns: [
        'intelId',
      ] },
      { accessor: 'spaceIntelByObserver', name: 'space_intel_observer_idx_btree', algorithm: 'btree', columns: [
        'observer',
      ] },
      { accessor: 'spaceIntelBySystem', name: 'space_intel_system_id_idx_btree', algorithm: 'btree', columns: [
        'systemId',
      ] },
    ],
    constraints: [
      { name: 'space_intel_intel_id_key', constraint: 'unique', columns: ['intelId'] },
    ],
  }, SpaceIntelRow),
  spaceLocation: __table({
    name: 'space_location',
    indexes: [
      { accessor: 'identity', name: 'space_location_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'space_location_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, SpaceLocationRow),
  spaceMarketDepth: __table({
    name: 'space_market_depth',
    indexes: [
      { accessor: 'depthId', name: 'space_market_depth_depth_id_idx_btree', algorithm: 'btree', columns: [
        'depthId',
      ] },
      { accessor: 'spaceMarketDepthByStation', name: 'space_market_depth_station_key_idx_btree', algorithm: 'btree', columns: [
        'stationKey',
      ] },
    ],
    constraints: [
      { name: 'space_market_depth_depth_id_key', constraint: 'unique', columns: ['depthId'] },
    ],
  }, SpaceMarketDepthRow),
  spaceOperation: __table({
    name: 'space_operation',
    indexes: [
      { accessor: 'spaceOperationByCampaign', name: 'space_operation_campaign_id_idx_btree', algorithm: 'btree', columns: [
        'campaignId',
      ] },
      { accessor: 'spaceOperationByGuild', name: 'space_operation_guild_id_idx_btree', algorithm: 'btree', columns: [
        'guildId',
      ] },
      { accessor: 'opId', name: 'space_operation_op_id_idx_btree', algorithm: 'btree', columns: [
        'opId',
      ] },
      { accessor: 'spaceOperationByState', name: 'space_operation_state_idx_btree', algorithm: 'btree', columns: [
        'state',
      ] },
    ],
    constraints: [
      { name: 'space_operation_op_id_key', constraint: 'unique', columns: ['opId'] },
    ],
  }, SpaceOperationRow),
  spacePresence: __table({
    name: 'space_presence',
    indexes: [
      { accessor: 'identity', name: 'space_presence_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'space_presence_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, SpacePresenceRow),
  spacePriceMod: __table({
    name: 'space_price_mod',
    indexes: [
      { accessor: 'modId', name: 'space_price_mod_mod_id_idx_btree', algorithm: 'btree', columns: [
        'modId',
      ] },
      { accessor: 'spacePriceModByStation', name: 'space_price_mod_station_key_idx_btree', algorithm: 'btree', columns: [
        'stationKey',
      ] },
    ],
    constraints: [
      { name: 'space_price_mod_mod_id_key', constraint: 'unique', columns: ['modId'] },
    ],
  }, SpacePriceModRow),
  spacePvpHit: __table({
    name: 'space_pvp_hit',
    indexes: [
      { accessor: 'hitId', name: 'space_pvp_hit_hit_id_idx_btree', algorithm: 'btree', columns: [
        'hitId',
      ] },
      { accessor: 'spacePvpHitByTarget', name: 'space_pvp_hit_target_idx_btree', algorithm: 'btree', columns: [
        'target',
      ] },
    ],
    constraints: [
      { name: 'space_pvp_hit_hit_id_key', constraint: 'unique', columns: ['hitId'] },
    ],
  }, SpacePvpHitRow),
  spaceSession: __table({
    name: 'space_session',
    indexes: [
      { accessor: 'identity', name: 'space_session_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'space_session_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, SpaceSessionRow),
  spaceShipment: __table({
    name: 'space_shipment',
    indexes: [
      { accessor: 'shipmentId', name: 'space_shipment_shipment_id_idx_btree', algorithm: 'btree', columns: [
        'shipmentId',
      ] },
      { accessor: 'spaceShipmentByState', name: 'space_shipment_state_idx_btree', algorithm: 'btree', columns: [
        'state',
      ] },
    ],
    constraints: [
      { name: 'space_shipment_shipment_id_key', constraint: 'unique', columns: ['shipmentId'] },
    ],
  }, SpaceShipmentRow),
  spaceStructure: __table({
    name: 'space_structure',
    indexes: [
      { accessor: 'spaceStructureByOwner', name: 'space_structure_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'structId', name: 'space_structure_struct_id_idx_btree', algorithm: 'btree', columns: [
        'structId',
      ] },
    ],
    constraints: [
      { name: 'space_structure_struct_id_key', constraint: 'unique', columns: ['structId'] },
    ],
  }, SpaceStructureRow),
  spaceTackle: __table({
    name: 'space_tackle',
    indexes: [
      { accessor: 'identity', name: 'space_tackle_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'space_tackle_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, SpaceTackleRow),
  spendVote: __table({
    name: 'spend_vote',
    indexes: [
      { accessor: 'spendVoteBySpend', name: 'spend_vote_spend_id_idx_btree', algorithm: 'btree', columns: [
        'spendId',
      ] },
      { accessor: 'voteId', name: 'spend_vote_vote_id_idx_btree', algorithm: 'btree', columns: [
        'voteId',
      ] },
    ],
    constraints: [
      { name: 'spend_vote_vote_id_key', constraint: 'unique', columns: ['voteId'] },
    ],
  }, SpendVoteRow),
  spyMission: __table({
    name: 'spy_mission',
    indexes: [
      { accessor: 'spyId', name: 'spy_mission_spy_id_idx_btree', algorithm: 'btree', columns: [
        'spyId',
      ] },
      { accessor: 'spyMissionByTarget', name: 'spy_mission_to_sid_idx_btree', algorithm: 'btree', columns: [
        'toSid',
      ] },
    ],
    constraints: [
      { name: 'spy_mission_spy_id_key', constraint: 'unique', columns: ['spyId'] },
    ],
  }, SpyMissionRow),
  starterKit: __table({
    name: 'starter_kit',
    indexes: [
      { accessor: 'identity', name: 'starter_kit_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'starter_kit_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, StarterKitRow),
  stationMuster: __table({
    name: 'station_muster',
    indexes: [
      { accessor: 'stationMusterByCyc', name: 'station_muster_cyc_idx_btree', algorithm: 'btree', columns: [
        'cyc',
      ] },
      { accessor: 'key', name: 'station_muster_key_idx_btree', algorithm: 'btree', columns: [
        'key',
      ] },
    ],
    constraints: [
      { name: 'station_muster_key_key', constraint: 'unique', columns: ['key'] },
    ],
  }, StationMusterRow),
  stationService: __table({
    name: 'station_service',
    indexes: [
      { accessor: 'stationKey', name: 'station_service_station_key_idx_btree', algorithm: 'btree', columns: [
        'stationKey',
      ] },
    ],
    constraints: [
      { name: 'station_service_station_key_key', constraint: 'unique', columns: ['stationKey'] },
    ],
  }, StationServiceRow),
  structure: __table({
    name: 'structure',
    indexes: [
      { accessor: 'structureByCellX', name: 'structure_cell_x_idx_btree', algorithm: 'btree', columns: [
        'cellX',
      ] },
      { accessor: 'structureByCellZ', name: 'structure_cell_z_idx_btree', algorithm: 'btree', columns: [
        'cellZ',
      ] },
      { accessor: 'structureByCity', name: 'structure_city_id_idx_btree', algorithm: 'btree', columns: [
        'cityId',
      ] },
      { accessor: 'structureByOwner', name: 'structure_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'structureId', name: 'structure_structure_id_idx_btree', algorithm: 'btree', columns: [
        'structureId',
      ] },
      { accessor: 'structureByWorld', name: 'structure_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'structure_structure_id_key', constraint: 'unique', columns: ['structureId'] },
    ],
  }, StructureRow),
  structureContainer: __table({
    name: 'structure_container',
    indexes: [
      { accessor: 'containerId', name: 'structure_container_container_id_idx_btree', algorithm: 'btree', columns: [
        'containerId',
      ] },
      { accessor: 'structureContainerByStructure', name: 'structure_container_structure_id_idx_btree', algorithm: 'btree', columns: [
        'structureId',
      ] },
    ],
    constraints: [
      { name: 'structure_container_container_id_key', constraint: 'unique', columns: ['containerId'] },
    ],
  }, StructureContainerRow),
  structureDeed: __table({
    name: 'structure_deed',
    indexes: [
      { accessor: 'deedId', name: 'structure_deed_deed_id_idx_btree', algorithm: 'btree', columns: [
        'deedId',
      ] },
      { accessor: 'structureDeedByOwner', name: 'structure_deed_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
    ],
    constraints: [
      { name: 'structure_deed_deed_id_key', constraint: 'unique', columns: ['deedId'] },
    ],
  }, StructureDeedRow),
  structureFurnish: __table({
    name: 'structure_furnish',
    indexes: [
      { accessor: 'structureId', name: 'structure_furnish_structure_id_idx_btree', algorithm: 'btree', columns: [
        'structureId',
      ] },
    ],
    constraints: [
      { name: 'structure_furnish_structure_id_key', constraint: 'unique', columns: ['structureId'] },
    ],
  }, StructureFurnishRow),
  structureItem: __table({
    name: 'structure_item',
    indexes: [
      { accessor: 'itemId', name: 'structure_item_item_id_idx_btree', algorithm: 'btree', columns: [
        'itemId',
      ] },
      { accessor: 'structureItemByStructure', name: 'structure_item_structure_id_idx_btree', algorithm: 'btree', columns: [
        'structureId',
      ] },
    ],
    constraints: [
      { name: 'structure_item_item_id_key', constraint: 'unique', columns: ['itemId'] },
    ],
  }, StructureItemRow),
  structureLayout: __table({
    name: 'structure_layout',
    indexes: [
      { accessor: 'structureId', name: 'structure_layout_structure_id_idx_btree', algorithm: 'btree', columns: [
        'structureId',
      ] },
    ],
    constraints: [
      { name: 'structure_layout_structure_id_key', constraint: 'unique', columns: ['structureId'] },
    ],
  }, StructureLayoutRow),
  structureMeta: __table({
    name: 'structure_meta',
    indexes: [
      { accessor: 'structureId', name: 'structure_meta_structure_id_idx_btree', algorithm: 'btree', columns: [
        'structureId',
      ] },
    ],
    constraints: [
      { name: 'structure_meta_structure_id_key', constraint: 'unique', columns: ['structureId'] },
    ],
  }, StructureMetaRow),
  structureNote: __table({
    name: 'structure_note',
    indexes: [
      { accessor: 'noteId', name: 'structure_note_note_id_idx_btree', algorithm: 'btree', columns: [
        'noteId',
      ] },
      { accessor: 'structureNoteByStructure', name: 'structure_note_structure_id_idx_btree', algorithm: 'btree', columns: [
        'structureId',
      ] },
    ],
    constraints: [
      { name: 'structure_note_note_id_key', constraint: 'unique', columns: ['noteId'] },
    ],
  }, StructureNoteRow),
  structurePermission: __table({
    name: 'structure_permission',
    indexes: [
      { accessor: 'permId', name: 'structure_permission_perm_id_idx_btree', algorithm: 'btree', columns: [
        'permId',
      ] },
      { accessor: 'structurePermissionByStructure', name: 'structure_permission_structure_id_idx_btree', algorithm: 'btree', columns: [
        'structureId',
      ] },
    ],
    constraints: [
      { name: 'structure_permission_perm_id_key', constraint: 'unique', columns: ['permId'] },
    ],
  }, StructurePermissionRow),
  structurePlanter: __table({
    name: 'structure_planter',
    indexes: [
      { accessor: 'planterId', name: 'structure_planter_planter_id_idx_btree', algorithm: 'btree', columns: [
        'planterId',
      ] },
      { accessor: 'structurePlanterByStructure', name: 'structure_planter_structure_id_idx_btree', algorithm: 'btree', columns: [
        'structureId',
      ] },
    ],
    constraints: [
      { name: 'structure_planter_planter_id_key', constraint: 'unique', columns: ['planterId'] },
    ],
  }, StructurePlanterRow),
  structureSiege: __table({
    name: 'structure_siege',
    indexes: [
      { accessor: 'structureId', name: 'structure_siege_structure_id_idx_btree', algorithm: 'btree', columns: [
        'structureId',
      ] },
    ],
    constraints: [
      { name: 'structure_siege_structure_id_key', constraint: 'unique', columns: ['structureId'] },
    ],
  }, StructureSiegeRow),
  subscription: __table({
    name: 'subscription',
    indexes: [
      { accessor: 'subscriptionByCreator', name: 'subscription_creator_idx_btree', algorithm: 'btree', columns: [
        'creator',
      ] },
      { accessor: 'subscriptionByPatron', name: 'subscription_patron_idx_btree', algorithm: 'btree', columns: [
        'patron',
      ] },
      { accessor: 'subId', name: 'subscription_sub_id_idx_btree', algorithm: 'btree', columns: [
        'subId',
      ] },
    ],
    constraints: [
      { name: 'subscription_sub_id_key', constraint: 'unique', columns: ['subId'] },
    ],
  }, SubscriptionRow),
  subsystemAim: __table({
    name: 'subsystem_aim',
    indexes: [
      { accessor: 'identity', name: 'subsystem_aim_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'subsystem_aim_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, SubsystemAimRow),
  subsystemJob: __table({
    name: 'subsystem_job',
    indexes: [
      { accessor: 'subsystemJobByActor', name: 'subsystem_job_actor_idx_btree', algorithm: 'btree', columns: [
        'actor',
      ] },
      { accessor: 'jobId', name: 'subsystem_job_job_id_idx_btree', algorithm: 'btree', columns: [
        'jobId',
      ] },
      { accessor: 'subsystemJobByOwner', name: 'subsystem_job_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'subsystemJobByShip', name: 'subsystem_job_ship_id_idx_btree', algorithm: 'btree', columns: [
        'shipId',
      ] },
    ],
    constraints: [
      { name: 'subsystem_job_job_id_key', constraint: 'unique', columns: ['jobId'] },
    ],
  }, SubsystemJobRow),
  subsystemReceipt: __table({
    name: 'subsystem_receipt',
    indexes: [
      { accessor: 'subsystemReceiptByActor', name: 'subsystem_receipt_actor_idx_btree', algorithm: 'btree', columns: [
        'actor',
      ] },
      { accessor: 'subsystemReceiptByOwner', name: 'subsystem_receipt_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'receiptKey', name: 'subsystem_receipt_receipt_key_idx_btree', algorithm: 'btree', columns: [
        'receiptKey',
      ] },
    ],
    constraints: [
      { name: 'subsystem_receipt_receipt_key_key', constraint: 'unique', columns: ['receiptKey'] },
    ],
  }, SubsystemReceiptRow),
  surveyLease: __table({
    name: 'survey_lease',
    indexes: [
      { accessor: 'surveyLeaseByClaimant', name: 'survey_lease_claimant_idx_btree', algorithm: 'btree', columns: [
        'claimant',
      ] },
      { accessor: 'leaseId', name: 'survey_lease_lease_id_idx_btree', algorithm: 'btree', columns: [
        'leaseId',
      ] },
      { accessor: 'surveyLeaseBySig', name: 'survey_lease_sig_key_idx_btree', algorithm: 'btree', columns: [
        'sigKey',
      ] },
      { accessor: 'surveyLeaseBySystem', name: 'survey_lease_system_id_idx_btree', algorithm: 'btree', columns: [
        'systemId',
      ] },
    ],
    constraints: [
      { name: 'survey_lease_lease_id_key', constraint: 'unique', columns: ['leaseId'] },
    ],
  }, SurveyLeaseRow),
  surveyView: __table({
    name: 'survey_view',
    indexes: [
      { accessor: 'surveyViewByIdentity', name: 'survey_view_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'surveyViewBySig', name: 'survey_view_sig_key_idx_btree', algorithm: 'btree', columns: [
        'sigKey',
      ] },
      { accessor: 'viewId', name: 'survey_view_view_id_idx_btree', algorithm: 'btree', columns: [
        'viewId',
      ] },
    ],
    constraints: [
      { name: 'survey_view_view_id_key', constraint: 'unique', columns: ['viewId'] },
    ],
  }, SurveyViewRow),
  terrainEdit: __table({
    name: 'terrain_edit',
    indexes: [
      { accessor: 'editId', name: 'terrain_edit_edit_id_idx_btree', algorithm: 'btree', columns: [
        'editId',
      ] },
      { accessor: 'terrainEditByWorld', name: 'terrain_edit_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'terrain_edit_edit_id_key', constraint: 'unique', columns: ['editId'] },
    ],
  }, TerrainEditRow),
  terrainRegion: __table({
    name: 'terrain_region',
    indexes: [
      { accessor: 'regionId', name: 'terrain_region_region_id_idx_btree', algorithm: 'btree', columns: [
        'regionId',
      ] },
      { accessor: 'terrainRegionByWorld', name: 'terrain_region_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'terrain_region_region_id_key', constraint: 'unique', columns: ['regionId'] },
    ],
  }, TerrainRegionRow),
  ticketParty: __table({
    name: 'ticket_party',
    indexes: [
      { accessor: 'ticketPartyByGame', name: 'ticket_party_game_id_idx_btree', algorithm: 'btree', columns: [
        'gameId',
      ] },
      { accessor: 'partyId', name: 'ticket_party_party_id_idx_btree', algorithm: 'btree', columns: [
        'partyId',
      ] },
    ],
    constraints: [
      { name: 'ticket_party_party_id_key', constraint: 'unique', columns: ['partyId'] },
    ],
  }, TicketPartyRow),
  tipRecord: __table({
    name: 'tip_record',
    indexes: [
      { accessor: 'tipByFrom', name: 'tip_record_from_identity_idx_btree', algorithm: 'btree', columns: [
        'fromIdentity',
      ] },
      { accessor: 'tipId', name: 'tip_record_tip_id_idx_btree', algorithm: 'btree', columns: [
        'tipId',
      ] },
      { accessor: 'tipByTo', name: 'tip_record_to_identity_idx_btree', algorithm: 'btree', columns: [
        'toIdentity',
      ] },
    ],
    constraints: [
      { name: 'tip_record_tip_id_key', constraint: 'unique', columns: ['tipId'] },
    ],
  }, TipRecordRow),
  trade: __table({
    name: 'trade',
    indexes: [
      { accessor: 'tradeByA', name: 'trade_a_idx_btree', algorithm: 'btree', columns: [
        'a',
      ] },
      { accessor: 'tradeByB', name: 'trade_b_idx_btree', algorithm: 'btree', columns: [
        'b',
      ] },
      { accessor: 'tradeId', name: 'trade_trade_id_idx_btree', algorithm: 'btree', columns: [
        'tradeId',
      ] },
    ],
    constraints: [
      { name: 'trade_trade_id_key', constraint: 'unique', columns: ['tradeId'] },
    ],
  }, TradeRow),
  tradeOrder: __table({
    name: 'trade_order',
    indexes: [
      { accessor: 'orderId', name: 'trade_order_order_id_idx_btree', algorithm: 'btree', columns: [
        'orderId',
      ] },
      { accessor: 'tradeOrderBySettlement', name: 'trade_order_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'trade_order_order_id_key', constraint: 'unique', columns: ['orderId'] },
    ],
  }, TradeOrderRow),
  travelOrder: __table({
    name: 'travel_order',
    indexes: [
      { accessor: 'travelOrderByIdentity', name: 'travel_order_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'travelId', name: 'travel_order_travel_id_idx_btree', algorithm: 'btree', columns: [
        'travelId',
      ] },
    ],
    constraints: [
      { name: 'travel_order_travel_id_key', constraint: 'unique', columns: ['travelId'] },
    ],
  }, TravelOrderRow),
  travelReturn: __table({
    name: 'travel_return',
    indexes: [
      { accessor: 'identity', name: 'travel_return_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'travel_return_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, TravelReturnRow),
  treasurySpend: __table({
    name: 'treasury_spend',
    indexes: [
      { accessor: 'spendByGroup', name: 'treasury_spend_group_id_idx_btree', algorithm: 'btree', columns: [
        'groupId',
      ] },
      { accessor: 'spendId', name: 'treasury_spend_spend_id_idx_btree', algorithm: 'btree', columns: [
        'spendId',
      ] },
    ],
    constraints: [
      { name: 'treasury_spend_spend_id_key', constraint: 'unique', columns: ['spendId'] },
    ],
  }, TreasurySpendRow),
  tribunalCase: __table({
    name: 'tribunal_case',
    indexes: [
      { accessor: 'caseId', name: 'tribunal_case_case_id_idx_btree', algorithm: 'btree', columns: [
        'caseId',
      ] },
      { accessor: 'tribunalCaseByCiv', name: 'tribunal_case_civ_idx_btree', algorithm: 'btree', columns: [
        'civ',
      ] },
    ],
    constraints: [
      { name: 'tribunal_case_case_id_key', constraint: 'unique', columns: ['caseId'] },
    ],
  }, TribunalCaseRow),
  unitCondition: __table({
    name: 'unit_condition',
    indexes: [
      { accessor: 'unitConditionByBattle', name: 'unit_condition_battle_id_idx_btree', algorithm: 'btree', columns: [
        'battleId',
      ] },
      { accessor: 'versonaId', name: 'unit_condition_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'unit_condition_versona_id_key', constraint: 'unique', columns: ['versonaId'] },
    ],
  }, UnitConditionRow),
  unstickRescueState: __table({
    name: 'unstick_rescue_state',
    indexes: [
      { accessor: 'identity', name: 'unstick_rescue_state_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'unstick_rescue_state_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, UnstickRescueStateRow),
  unstickState: __table({
    name: 'unstick_state',
    indexes: [
      { accessor: 'identity', name: 'unstick_state_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'unstick_state_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, UnstickStateRow),
  versona: __table({
    name: 'versona',
    indexes: [
      { accessor: 'versonaByCity', name: 'versona_home_city_id_idx_btree', algorithm: 'btree', columns: [
        'homeCityId',
      ] },
      { accessor: 'versonaId', name: 'versona_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
      { accessor: 'versonaByWorld', name: 'versona_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'versona_versona_id_key', constraint: 'unique', columns: ['versonaId'] },
    ],
  }, VersonaRow),
  versonaAspiration: __table({
    name: 'versona_aspiration',
    indexes: [
      { accessor: 'versonaId', name: 'versona_aspiration_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'versona_aspiration_versona_id_key', constraint: 'unique', columns: ['versonaId'] },
    ],
  }, VersonaAspirationRow),
  versonaBelief: __table({
    name: 'versona_belief',
    indexes: [
      { accessor: 'beliefId', name: 'versona_belief_belief_id_idx_btree', algorithm: 'btree', columns: [
        'beliefId',
      ] },
      { accessor: 'versonaBeliefByVersona', name: 'versona_belief_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'versona_belief_belief_id_key', constraint: 'unique', columns: ['beliefId'] },
    ],
  }, VersonaBeliefRow),
  versonaChat: __table({
    name: 'versona_chat',
    indexes: [
      { accessor: 'chatId', name: 'versona_chat_chat_id_idx_btree', algorithm: 'btree', columns: [
        'chatId',
      ] },
      { accessor: 'versonaChatByVersona', name: 'versona_chat_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
      { accessor: 'versonaChatByWorld', name: 'versona_chat_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'versona_chat_chat_id_key', constraint: 'unique', columns: ['chatId'] },
    ],
  }, VersonaChatRow),
  versonaDeliberation: __table({
    name: 'versona_deliberation',
    indexes: [
      { accessor: 'delibId', name: 'versona_deliberation_delib_id_idx_btree', algorithm: 'btree', columns: [
        'delibId',
      ] },
      { accessor: 'versonaDeliberationByWorld', name: 'versona_deliberation_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'versona_deliberation_delib_id_key', constraint: 'unique', columns: ['delibId'] },
    ],
  }, VersonaDeliberationRow),
  versonaEmotion: __table({
    name: 'versona_emotion',
    indexes: [
      { accessor: 'emotionId', name: 'versona_emotion_emotion_id_idx_btree', algorithm: 'btree', columns: [
        'emotionId',
      ] },
      { accessor: 'versonaEmotionByVersona', name: 'versona_emotion_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'versona_emotion_emotion_id_key', constraint: 'unique', columns: ['emotionId'] },
    ],
  }, VersonaEmotionRow),
  versonaEncounter: __table({
    name: 'versona_encounter',
    indexes: [
      { accessor: 'versonaEncounterByA', name: 'versona_encounter_a_id_idx_btree', algorithm: 'btree', columns: [
        'aId',
      ] },
      { accessor: 'versonaEncounterByB', name: 'versona_encounter_b_id_idx_btree', algorithm: 'btree', columns: [
        'bId',
      ] },
      { accessor: 'encounterId', name: 'versona_encounter_encounter_id_idx_btree', algorithm: 'btree', columns: [
        'encounterId',
      ] },
      { accessor: 'versonaEncounterByWorld', name: 'versona_encounter_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'versona_encounter_encounter_id_key', constraint: 'unique', columns: ['encounterId'] },
    ],
  }, VersonaEncounterRow),
  versonaEquipment: __table({
    name: 'versona_equipment',
    indexes: [
      { accessor: 'equipId', name: 'versona_equipment_equip_id_idx_btree', algorithm: 'btree', columns: [
        'equipId',
      ] },
      { accessor: 'versonaEquipmentByVersona', name: 'versona_equipment_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'versona_equipment_equip_id_key', constraint: 'unique', columns: ['equipId'] },
    ],
  }, VersonaEquipmentRow),
  versonaFavor: __table({
    name: 'versona_favor',
    indexes: [
      { accessor: 'versonaFavorByA', name: 'versona_favor_a_id_idx_btree', algorithm: 'btree', columns: [
        'aId',
      ] },
      { accessor: 'versonaFavorByB', name: 'versona_favor_b_id_idx_btree', algorithm: 'btree', columns: [
        'bId',
      ] },
      { accessor: 'favorId', name: 'versona_favor_favor_id_idx_btree', algorithm: 'btree', columns: [
        'favorId',
      ] },
    ],
    constraints: [
      { name: 'versona_favor_favor_id_key', constraint: 'unique', columns: ['favorId'] },
    ],
  }, VersonaFavorRow),
  versonaGoal: __table({
    name: 'versona_goal',
    indexes: [
      { accessor: 'versonaId', name: 'versona_goal_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'versona_goal_versona_id_key', constraint: 'unique', columns: ['versonaId'] },
    ],
  }, VersonaGoalRow),
  versonaGrudge: __table({
    name: 'versona_grudge',
    indexes: [
      { accessor: 'grudgeId', name: 'versona_grudge_grudge_id_idx_btree', algorithm: 'btree', columns: [
        'grudgeId',
      ] },
      { accessor: 'versonaGrudgeByVersona', name: 'versona_grudge_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'versona_grudge_grudge_id_key', constraint: 'unique', columns: ['grudgeId'] },
    ],
  }, VersonaGrudgeRow),
  versonaGuild: __table({
    name: 'versona_guild',
    indexes: [
      { accessor: 'versonaGuildBySettlement', name: 'versona_guild_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
      { accessor: 'vguildId', name: 'versona_guild_vguild_id_idx_btree', algorithm: 'btree', columns: [
        'vguildId',
      ] },
    ],
    constraints: [
      { name: 'versona_guild_vguild_id_key', constraint: 'unique', columns: ['vguildId'] },
    ],
  }, VersonaGuildRow),
  versonaGuildMember: __table({
    name: 'versona_guild_member',
    indexes: [
      { accessor: 'versonaGuildMemberByVersona', name: 'versona_guild_member_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
      { accessor: 'vgmKey', name: 'versona_guild_member_vgm_key_idx_btree', algorithm: 'btree', columns: [
        'vgmKey',
      ] },
      { accessor: 'versonaGuildMemberByGuild', name: 'versona_guild_member_vguild_id_idx_btree', algorithm: 'btree', columns: [
        'vguildId',
      ] },
    ],
    constraints: [
      { name: 'versona_guild_member_vgm_key_key', constraint: 'unique', columns: ['vgmKey'] },
    ],
  }, VersonaGuildMemberRow),
  versonaInjury: __table({
    name: 'versona_injury',
    indexes: [
      { accessor: 'versonaId', name: 'versona_injury_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'versona_injury_versona_id_key', constraint: 'unique', columns: ['versonaId'] },
    ],
  }, VersonaInjuryRow),
  versonaIntent: __table({
    name: 'versona_intent',
    indexes: [
      { accessor: 'versonaId', name: 'versona_intent_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'versona_intent_versona_id_key', constraint: 'unique', columns: ['versonaId'] },
    ],
  }, VersonaIntentRow),
  versonaJourney: __table({
    name: 'versona_journey',
    indexes: [
      { accessor: 'versonaId', name: 'versona_journey_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
      { accessor: 'versonaJourneyByWorld', name: 'versona_journey_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'versona_journey_versona_id_key', constraint: 'unique', columns: ['versonaId'] },
    ],
  }, VersonaJourneyRow),
  versonaLineage: __table({
    name: 'versona_lineage',
    indexes: [
      { accessor: 'childId', name: 'versona_lineage_child_id_idx_btree', algorithm: 'btree', columns: [
        'childId',
      ] },
      { accessor: 'versonaLineageByParentA', name: 'versona_lineage_parent_a_idx_btree', algorithm: 'btree', columns: [
        'parentA',
      ] },
      { accessor: 'versonaLineageByParentB', name: 'versona_lineage_parent_b_idx_btree', algorithm: 'btree', columns: [
        'parentB',
      ] },
    ],
    constraints: [
      { name: 'versona_lineage_child_id_key', constraint: 'unique', columns: ['childId'] },
    ],
  }, VersonaLineageRow),
  versonaListing: __table({
    name: 'versona_listing',
    indexes: [
      { accessor: 'listingId', name: 'versona_listing_listing_id_idx_btree', algorithm: 'btree', columns: [
        'listingId',
      ] },
      { accessor: 'versonaListingBySettlement', name: 'versona_listing_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'versona_listing_listing_id_key', constraint: 'unique', columns: ['listingId'] },
    ],
  }, VersonaListingRow),
  versonaMadeItem: __table({
    name: 'versona_made_item',
    indexes: [
      { accessor: 'itemId', name: 'versona_made_item_item_id_idx_btree', algorithm: 'btree', columns: [
        'itemId',
      ] },
      { accessor: 'versonaMadeItemBySettlement', name: 'versona_made_item_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
      { accessor: 'versonaMadeItemByVersona', name: 'versona_made_item_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'versona_made_item_item_id_key', constraint: 'unique', columns: ['itemId'] },
    ],
  }, VersonaMadeItemRow),
  versonaMemory: __table({
    name: 'versona_memory',
    indexes: [
      { accessor: 'memoryId', name: 'versona_memory_memory_id_idx_btree', algorithm: 'btree', columns: [
        'memoryId',
      ] },
      { accessor: 'versonaMemoryByVersona', name: 'versona_memory_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'versona_memory_memory_id_key', constraint: 'unique', columns: ['memoryId'] },
    ],
  }, VersonaMemoryRow),
  versonaOpinion: __table({
    name: 'versona_opinion',
    indexes: [
      { accessor: 'versonaId', name: 'versona_opinion_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'versona_opinion_versona_id_key', constraint: 'unique', columns: ['versonaId'] },
    ],
  }, VersonaOpinionRow),
  versonaOrigin: __table({
    name: 'versona_origin',
    indexes: [
      { accessor: 'versonaId', name: 'versona_origin_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'versona_origin_versona_id_key', constraint: 'unique', columns: ['versonaId'] },
    ],
  }, VersonaOriginRow),
  versonaPair: __table({
    name: 'versona_pair',
    indexes: [
      { accessor: 'versonaPairByA', name: 'versona_pair_a_id_idx_btree', algorithm: 'btree', columns: [
        'aId',
      ] },
      { accessor: 'versonaPairByB', name: 'versona_pair_b_id_idx_btree', algorithm: 'btree', columns: [
        'bId',
      ] },
      { accessor: 'pairId', name: 'versona_pair_pair_id_idx_btree', algorithm: 'btree', columns: [
        'pairId',
      ] },
    ],
    constraints: [
      { name: 'versona_pair_pair_id_key', constraint: 'unique', columns: ['pairId'] },
    ],
  }, VersonaPairRow),
  versonaProfile: __table({
    name: 'versona_profile',
    indexes: [
      { accessor: 'versonaId', name: 'versona_profile_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
      { accessor: 'versonaProfileByWorld', name: 'versona_profile_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'versona_profile_versona_id_key', constraint: 'unique', columns: ['versonaId'] },
    ],
  }, VersonaProfileRow),
  versonaRoute: __table({
    name: 'versona_route',
    indexes: [
      { accessor: 'versonaId', name: 'versona_route_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
      { accessor: 'versonaRouteByWorld', name: 'versona_route_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'versona_route_versona_id_key', constraint: 'unique', columns: ['versonaId'] },
    ],
  }, VersonaRouteRow),
  versonaStance: __table({
    name: 'versona_stance',
    indexes: [
      { accessor: 'versonaId', name: 'versona_stance_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'versona_stance_versona_id_key', constraint: 'unique', columns: ['versonaId'] },
    ],
  }, VersonaStanceRow),
  versonaState: __table({
    name: 'versona_state',
    indexes: [
      { accessor: 'versonaId', name: 'versona_state_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
      { accessor: 'versonaStateByWorld', name: 'versona_state_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'versona_state_versona_id_key', constraint: 'unique', columns: ['versonaId'] },
    ],
  }, VersonaStateRow),
  versonaThought: __table({
    name: 'versona_thought',
    indexes: [
      { accessor: 'versonaId', name: 'versona_thought_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
    ],
    constraints: [
      { name: 'versona_thought_versona_id_key', constraint: 'unique', columns: ['versonaId'] },
    ],
  }, VersonaThoughtRow),
  voiceRoom: __table({
    name: 'voice_room',
    indexes: [
      { accessor: 'voiceRoomByRef', name: 'voice_room_ref_key_idx_btree', algorithm: 'btree', columns: [
        'refKey',
      ] },
      { accessor: 'roomId', name: 'voice_room_room_id_idx_btree', algorithm: 'btree', columns: [
        'roomId',
      ] },
    ],
    constraints: [
      { name: 'voice_room_room_id_key', constraint: 'unique', columns: ['roomId'] },
    ],
  }, VoiceRoomRow),
  voiceRoomBan: __table({
    name: 'voice_room_ban',
    indexes: [
      { accessor: 'banKey', name: 'voice_room_ban_ban_key_idx_btree', algorithm: 'btree', columns: [
        'banKey',
      ] },
      { accessor: 'voiceRoomBanByRoom', name: 'voice_room_ban_room_id_idx_btree', algorithm: 'btree', columns: [
        'roomId',
      ] },
    ],
    constraints: [
      { name: 'voice_room_ban_ban_key_key', constraint: 'unique', columns: ['banKey'] },
    ],
  }, VoiceRoomBanRow),
  voiceRoomInvite: __table({
    name: 'voice_room_invite',
    indexes: [
      { accessor: 'inviteKey', name: 'voice_room_invite_invite_key_idx_btree', algorithm: 'btree', columns: [
        'inviteKey',
      ] },
      { accessor: 'voiceRoomInviteByInvitee', name: 'voice_room_invite_invitee_idx_btree', algorithm: 'btree', columns: [
        'invitee',
      ] },
      { accessor: 'voiceRoomInviteByRoom', name: 'voice_room_invite_room_id_idx_btree', algorithm: 'btree', columns: [
        'roomId',
      ] },
    ],
    constraints: [
      { name: 'voice_room_invite_invite_key_key', constraint: 'unique', columns: ['inviteKey'] },
    ],
  }, VoiceRoomInviteRow),
  voiceRoomMember: __table({
    name: 'voice_room_member',
    indexes: [
      { accessor: 'voiceRoomMemberByIdentity', name: 'voice_room_member_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'memberKey', name: 'voice_room_member_member_key_idx_btree', algorithm: 'btree', columns: [
        'memberKey',
      ] },
      { accessor: 'voiceRoomMemberByRoom', name: 'voice_room_member_room_id_idx_btree', algorithm: 'btree', columns: [
        'roomId',
      ] },
    ],
    constraints: [
      { name: 'voice_room_member_member_key_key', constraint: 'unique', columns: ['memberKey'] },
    ],
  }, VoiceRoomMemberRow),
  voiceSfuAdmission: __table({
    name: 'voice_sfu_admission',
    indexes: [
      { accessor: 'token', name: 'voice_sfu_admission_token_idx_btree', algorithm: 'btree', columns: [
        'token',
      ] },
    ],
    constraints: [
      { name: 'voice_sfu_admission_token_key', constraint: 'unique', columns: ['token'] },
    ],
  }, VoiceSfuAdmissionRow),
  voiceSfuBlock: __table({
    name: 'voice_sfu_block',
    indexes: [
      { accessor: 'pairKey', name: 'voice_sfu_block_pair_key_idx_btree', algorithm: 'btree', columns: [
        'pairKey',
      ] },
      { accessor: 'voiceSfuBlockBySfu', name: 'voice_sfu_block_sfu_idx_btree', algorithm: 'btree', columns: [
        'sfu',
      ] },
    ],
    constraints: [
      { name: 'voice_sfu_block_pair_key_key', constraint: 'unique', columns: ['pairKey'] },
    ],
  }, VoiceSfuBlockRow),
  voiceSfuState: __table({
    name: 'voice_sfu_state',
    indexes: [
      { accessor: 'key', name: 'voice_sfu_state_key_idx_btree', algorithm: 'btree', columns: [
        'key',
      ] },
    ],
    constraints: [
      { name: 'voice_sfu_state_key_key', constraint: 'unique', columns: ['key'] },
    ],
  }, VoiceSfuStateRow),
  voiceSignal: __table({
    name: 'voice_signal',
    indexes: [
      { accessor: 'signalId', name: 'voice_signal_signal_id_idx_btree', algorithm: 'btree', columns: [
        'signalId',
      ] },
    ],
    constraints: [
      { name: 'voice_signal_signal_id_key', constraint: 'unique', columns: ['signalId'] },
    ],
  }, VoiceSignalRow),
  voiceTicket: __table({
    name: 'voice_ticket',
    indexes: [
      { accessor: 'voiceTicketByIdentity', name: 'voice_ticket_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'voiceTicketByRoom', name: 'voice_ticket_room_id_idx_btree', algorithm: 'btree', columns: [
        'roomId',
      ] },
      { accessor: 'token', name: 'voice_ticket_token_idx_btree', algorithm: 'btree', columns: [
        'token',
      ] },
    ],
    constraints: [
      { name: 'voice_ticket_token_key', constraint: 'unique', columns: ['token'] },
    ],
  }, VoiceTicketRow),
  vouch: __table({
    name: 'vouch',
    indexes: [
      { accessor: 'vouchId', name: 'vouch_vouch_id_idx_btree', algorithm: 'btree', columns: [
        'vouchId',
      ] },
      { accessor: 'vouchByVouchee', name: 'vouch_vouchee_idx_btree', algorithm: 'btree', columns: [
        'vouchee',
      ] },
      { accessor: 'vouchByVoucher', name: 'vouch_voucher_idx_btree', algorithm: 'btree', columns: [
        'voucher',
      ] },
    ],
    constraints: [
      { name: 'vouch_vouch_id_key', constraint: 'unique', columns: ['vouchId'] },
    ],
  }, VouchRow),
  wallet: __table({
    name: 'wallet',
    indexes: [
      { accessor: 'identity', name: 'wallet_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'wallet_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, WalletRow),
  warAirClock: __table({
    name: 'war_air_clock',
    indexes: [
      { accessor: 'warId', name: 'war_air_clock_war_id_idx_btree', algorithm: 'btree', columns: [
        'warId',
      ] },
    ],
    constraints: [
      { name: 'war_air_clock_war_id_key', constraint: 'unique', columns: ['warId'] },
    ],
  }, WarAirClockRow),
  warAirDuel: __table({
    name: 'war_air_duel',
    indexes: [
      { accessor: 'warId', name: 'war_air_duel_war_id_idx_btree', algorithm: 'btree', columns: [
        'warId',
      ] },
    ],
    constraints: [
      { name: 'war_air_duel_war_id_key', constraint: 'unique', columns: ['warId'] },
    ],
  }, WarAirDuelRow),
  warAirUnit: __table({
    name: 'war_air_unit',
    indexes: [
      { accessor: 'airId', name: 'war_air_unit_air_id_idx_btree', algorithm: 'btree', columns: [
        'airId',
      ] },
      { accessor: 'warAirByWar', name: 'war_air_unit_war_id_idx_btree', algorithm: 'btree', columns: [
        'warId',
      ] },
    ],
    constraints: [
      { name: 'war_air_unit_air_id_key', constraint: 'unique', columns: ['airId'] },
    ],
  }, WarAirUnitRow),
  warAssignment: __table({
    name: 'war_assignment',
    indexes: [
      { accessor: 'versonaId', name: 'war_assignment_versona_id_idx_btree', algorithm: 'btree', columns: [
        'versonaId',
      ] },
      { accessor: 'warAssignmentByWar', name: 'war_assignment_war_id_idx_btree', algorithm: 'btree', columns: [
        'warId',
      ] },
    ],
    constraints: [
      { name: 'war_assignment_versona_id_key', constraint: 'unique', columns: ['versonaId'] },
    ],
  }, WarAssignmentRow),
  warAuthority: __table({
    name: 'war_authority',
    indexes: [
      { accessor: 'campaignId', name: 'war_authority_campaign_id_idx_btree', algorithm: 'btree', columns: [
        'campaignId',
      ] },
    ],
    constraints: [
      { name: 'war_authority_campaign_id_key', constraint: 'unique', columns: ['campaignId'] },
    ],
  }, WarAuthorityRow),
  warBond: __table({
    name: 'war_bond',
    indexes: [
      { accessor: 'bondId', name: 'war_bond_bond_id_idx_btree', algorithm: 'btree', columns: [
        'bondId',
      ] },
      { accessor: 'warBondByCiv', name: 'war_bond_civ_idx_btree', algorithm: 'btree', columns: [
        'civ',
      ] },
    ],
    constraints: [
      { name: 'war_bond_bond_id_key', constraint: 'unique', columns: ['bondId'] },
    ],
  }, WarBondRow),
  warClash: __table({
    name: 'war_clash',
    indexes: [
      { accessor: 'clashId', name: 'war_clash_clash_id_idx_btree', algorithm: 'btree', columns: [
        'clashId',
      ] },
    ],
    constraints: [
      { name: 'war_clash_clash_id_key', constraint: 'unique', columns: ['clashId'] },
    ],
  }, WarClashRow),
  warLife: __table({
    name: 'war_life',
    indexes: [
      { accessor: 'warLifeByCampaign', name: 'war_life_campaign_id_idx_btree', algorithm: 'btree', columns: [
        'campaignId',
      ] },
      { accessor: 'lifeKey', name: 'war_life_life_key_idx_btree', algorithm: 'btree', columns: [
        'lifeKey',
      ] },
    ],
    constraints: [
      { name: 'war_life_life_key_key', constraint: 'unique', columns: ['lifeKey'] },
    ],
  }, WarLifeRow),
  warMemorial: __table({
    name: 'war_memorial',
    indexes: [
      { accessor: 'memId', name: 'war_memorial_mem_id_idx_btree', algorithm: 'btree', columns: [
        'memId',
      ] },
      { accessor: 'warMemorialBySettlement', name: 'war_memorial_settlement_id_idx_btree', algorithm: 'btree', columns: [
        'settlementId',
      ] },
    ],
    constraints: [
      { name: 'war_memorial_mem_id_key', constraint: 'unique', columns: ['memId'] },
    ],
  }, WarMemorialRow),
  warPetition: __table({
    name: 'war_petition',
    indexes: [
      { accessor: 'warId', name: 'war_petition_war_id_idx_btree', algorithm: 'btree', columns: [
        'warId',
      ] },
    ],
    constraints: [
      { name: 'war_petition_war_id_key', constraint: 'unique', columns: ['warId'] },
    ],
  }, WarPetitionRow),
  warReadiness: __table({
    name: 'war_readiness',
    indexes: [
      { accessor: 'warId', name: 'war_readiness_war_id_idx_btree', algorithm: 'btree', columns: [
        'warId',
      ] },
    ],
    constraints: [
      { name: 'war_readiness_war_id_key', constraint: 'unique', columns: ['warId'] },
    ],
  }, WarReadinessRow),
  warSchedule: __table({
    name: 'war_schedule',
    indexes: [
      { accessor: 'warId', name: 'war_schedule_war_id_idx_btree', algorithm: 'btree', columns: [
        'warId',
      ] },
    ],
    constraints: [
      { name: 'war_schedule_war_id_key', constraint: 'unique', columns: ['warId'] },
    ],
  }, WarScheduleRow),
  warStake: __table({
    name: 'war_stake',
    indexes: [
      { accessor: 'warId', name: 'war_stake_war_id_idx_btree', algorithm: 'btree', columns: [
        'warId',
      ] },
    ],
    constraints: [
      { name: 'war_stake_war_id_key', constraint: 'unique', columns: ['warId'] },
    ],
  }, WarStakeRow),
  warState: __table({
    name: 'war_state',
    indexes: [
      { accessor: 'warId', name: 'war_state_war_id_idx_btree', algorithm: 'btree', columns: [
        'warId',
      ] },
    ],
    constraints: [
      { name: 'war_state_war_id_key', constraint: 'unique', columns: ['warId'] },
    ],
  }, WarStateRow),
  warSupplyRun: __table({
    name: 'war_supply_run',
    indexes: [
      { accessor: 'warSupplyRunByBattle', name: 'war_supply_run_battle_id_idx_btree', algorithm: 'btree', columns: [
        'battleId',
      ] },
      { accessor: 'runId', name: 'war_supply_run_run_id_idx_btree', algorithm: 'btree', columns: [
        'runId',
      ] },
      { accessor: 'warSupplyRunByState', name: 'war_supply_run_state_idx_btree', algorithm: 'btree', columns: [
        'state',
      ] },
    ],
    constraints: [
      { name: 'war_supply_run_run_id_key', constraint: 'unique', columns: ['runId'] },
    ],
  }, WarSupplyRunRow),
  wave: __table({
    name: 'wave',
    indexes: [
      { accessor: 'waveByFrom', name: 'wave_from_identity_idx_btree', algorithm: 'btree', columns: [
        'fromIdentity',
      ] },
      { accessor: 'waveByTo', name: 'wave_to_identity_idx_btree', algorithm: 'btree', columns: [
        'toIdentity',
      ] },
      { accessor: 'waveId', name: 'wave_wave_id_idx_btree', algorithm: 'btree', columns: [
        'waveId',
      ] },
    ],
    constraints: [
      { name: 'wave_wave_id_key', constraint: 'unique', columns: ['waveId'] },
    ],
  }, WaveRow),
  waypoint: __table({
    name: 'waypoint',
    indexes: [
      { accessor: 'waypointByOwner', name: 'waypoint_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'waypointId', name: 'waypoint_waypoint_id_idx_btree', algorithm: 'btree', columns: [
        'waypointId',
      ] },
    ],
    constraints: [
      { name: 'waypoint_waypoint_id_key', constraint: 'unique', columns: ['waypointId'] },
    ],
  }, WaypointRow),
  weaponFeed: __table({
    name: 'weapon_feed',
    indexes: [
      { accessor: 'feedKey', name: 'weapon_feed_feed_key_idx_btree', algorithm: 'btree', columns: [
        'feedKey',
      ] },
      { accessor: 'weaponFeedByOwner', name: 'weapon_feed_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
    ],
    constraints: [
      { name: 'weapon_feed_feed_key_key', constraint: 'unique', columns: ['feedKey'] },
    ],
  }, WeaponFeedRow),
  weaponState: __table({
    name: 'weapon_state',
    indexes: [
      { accessor: 'identity', name: 'weapon_state_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'weapon_state_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, WeaponStateRow),
  weatherProfile: __table({
    name: 'weather_profile',
    indexes: [
      { accessor: 'profileId', name: 'weather_profile_profile_id_idx_btree', algorithm: 'btree', columns: [
        'profileId',
      ] },
      { accessor: 'weatherProfileByWeather', name: 'weather_profile_weather_idx_btree', algorithm: 'btree', columns: [
        'weather',
      ] },
    ],
    constraints: [
      { name: 'weather_profile_profile_id_key', constraint: 'unique', columns: ['profileId'] },
    ],
  }, WeatherProfileRow),
  wildsState: __table({
    name: 'wilds_state',
    indexes: [
      { accessor: 'id', name: 'wilds_state_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'wilds_state_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, WildsStateRow),
  world: __table({
    name: 'world',
    indexes: [
      { accessor: 'worldByKind', name: 'world_kind_idx_btree', algorithm: 'btree', columns: [
        'kind',
      ] },
      { accessor: 'worldByOwner', name: 'world_owner_idx_btree', algorithm: 'btree', columns: [
        'owner',
      ] },
      { accessor: 'worldId', name: 'world_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'world_world_id_key', constraint: 'unique', columns: ['worldId'] },
    ],
  }, WorldRow),
  worldBuildBudget: __table({
    name: 'world_build_budget',
    indexes: [
      { accessor: 'worldId', name: 'world_build_budget_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'world_build_budget_world_id_key', constraint: 'unique', columns: ['worldId'] },
    ],
  }, WorldBuildBudgetRow),
  worldCoAuthor: __table({
    name: 'world_co_author',
    indexes: [
      { accessor: 'coAuthorId', name: 'world_co_author_co_author_id_idx_btree', algorithm: 'btree', columns: [
        'coAuthorId',
      ] },
      { accessor: 'worldCoAuthorByWorld', name: 'world_co_author_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'world_co_author_co_author_id_key', constraint: 'unique', columns: ['coAuthorId'] },
    ],
  }, WorldCoAuthorRow),
  worldDevice: __table({
    name: 'world_device',
    indexes: [
      { accessor: 'deviceId', name: 'world_device_device_id_idx_btree', algorithm: 'btree', columns: [
        'deviceId',
      ] },
      { accessor: 'worldDeviceByWorld', name: 'world_device_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'world_device_device_id_key', constraint: 'unique', columns: ['deviceId'] },
    ],
  }, WorldDeviceRow),
  worldEnvironment: __table({
    name: 'world_environment',
    indexes: [
      { accessor: 'worldId', name: 'world_environment_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'world_environment_world_id_key', constraint: 'unique', columns: ['worldId'] },
    ],
  }, WorldEnvironmentRow),
  worldGovernance: __table({
    name: 'world_governance',
    indexes: [
      { accessor: 'worldId', name: 'world_governance_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'world_governance_world_id_key', constraint: 'unique', columns: ['worldId'] },
    ],
  }, WorldGovernanceRow),
  worldMetric: __table({
    name: 'world_metric',
    indexes: [
      { accessor: 'worldId', name: 'world_metric_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'world_metric_world_id_key', constraint: 'unique', columns: ['worldId'] },
    ],
  }, WorldMetricRow),
  worldObject: __table({
    name: 'world_object',
    indexes: [
      { accessor: 'worldObjectByCellX', name: 'world_object_cell_x_idx_btree', algorithm: 'btree', columns: [
        'cellX',
      ] },
      { accessor: 'worldObjectByCellZ', name: 'world_object_cell_z_idx_btree', algorithm: 'btree', columns: [
        'cellZ',
      ] },
      { accessor: 'objectId', name: 'world_object_object_id_idx_btree', algorithm: 'btree', columns: [
        'objectId',
      ] },
      { accessor: 'worldObjectBySourceAsset', name: 'world_object_source_asset_id_idx_btree', algorithm: 'btree', columns: [
        'sourceAssetId',
      ] },
      { accessor: 'worldObjectByWorldCell', name: 'world_object_world_id_cell_x_cell_z_idx_btree', algorithm: 'btree', columns: [
        'worldId',
        'cellX',
        'cellZ',
      ] },
      { accessor: 'worldObjectByWorld', name: 'world_object_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'world_object_object_id_key', constraint: 'unique', columns: ['objectId'] },
    ],
  }, WorldObjectRow),
  worldPatch: __table({
    name: 'world_patch',
    indexes: [
      { accessor: 'patchId', name: 'world_patch_patch_id_idx_btree', algorithm: 'btree', columns: [
        'patchId',
      ] },
      { accessor: 'worldPatchByWorld', name: 'world_patch_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'world_patch_patch_id_key', constraint: 'unique', columns: ['patchId'] },
    ],
  }, WorldPatchRow),
  worldPreset: __table({
    name: 'world_preset',
    indexes: [
      { accessor: 'worldId', name: 'world_preset_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'world_preset_world_id_key', constraint: 'unique', columns: ['worldId'] },
    ],
  }, WorldPresetRow),
  worldRating: __table({
    name: 'world_rating',
    indexes: [
      { accessor: 'worldRatingByRater', name: 'world_rating_rater_idx_btree', algorithm: 'btree', columns: [
        'rater',
      ] },
      { accessor: 'ratingRowId', name: 'world_rating_rating_row_id_idx_btree', algorithm: 'btree', columns: [
        'ratingRowId',
      ] },
      { accessor: 'worldRatingByWorld', name: 'world_rating_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'world_rating_rating_row_id_key', constraint: 'unique', columns: ['ratingRowId'] },
    ],
  }, WorldRatingRow),
  worldReport: __table({
    name: 'world_report',
    indexes: [
      { accessor: 'reportId', name: 'world_report_report_id_idx_btree', algorithm: 'btree', columns: [
        'reportId',
      ] },
      { accessor: 'worldReportByWorld', name: 'world_report_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'world_report_report_id_key', constraint: 'unique', columns: ['reportId'] },
    ],
  }, WorldReportRow),
  worldRole: __table({
    name: 'world_role',
    indexes: [
      { accessor: 'worldRoleByIdentity', name: 'world_role_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'roleId', name: 'world_role_role_id_idx_btree', algorithm: 'btree', columns: [
        'roleId',
      ] },
      { accessor: 'worldRoleByWorld', name: 'world_role_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'world_role_role_id_key', constraint: 'unique', columns: ['roleId'] },
    ],
  }, WorldRoleRow),
  worldRules: __table({
    name: 'world_rules',
    indexes: [
      { accessor: 'worldId', name: 'world_rules_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'world_rules_world_id_key', constraint: 'unique', columns: ['worldId'] },
    ],
  }, WorldRulesRow),
  worldScript: __table({
    name: 'world_script',
    indexes: [
      { accessor: 'scriptId', name: 'world_script_script_id_idx_btree', algorithm: 'btree', columns: [
        'scriptId',
      ] },
      { accessor: 'worldScriptByWorld', name: 'world_script_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'world_script_script_id_key', constraint: 'unique', columns: ['scriptId'] },
    ],
  }, WorldScriptRow),
  worldSnapshot: __table({
    name: 'world_snapshot',
    indexes: [
      { accessor: 'snapshotId', name: 'world_snapshot_snapshot_id_idx_btree', algorithm: 'btree', columns: [
        'snapshotId',
      ] },
      { accessor: 'worldSnapshotByWorld', name: 'world_snapshot_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'world_snapshot_snapshot_id_key', constraint: 'unique', columns: ['snapshotId'] },
    ],
  }, WorldSnapshotRow),
  worldVisit: __table({
    name: 'world_visit',
    indexes: [
      { accessor: 'visitRowId', name: 'world_visit_visit_row_id_idx_btree', algorithm: 'btree', columns: [
        'visitRowId',
      ] },
      { accessor: 'worldVisitByVisitor', name: 'world_visit_visitor_idx_btree', algorithm: 'btree', columns: [
        'visitor',
      ] },
      { accessor: 'worldVisitByWorld', name: 'world_visit_world_id_idx_btree', algorithm: 'btree', columns: [
        'worldId',
      ] },
    ],
    constraints: [
      { name: 'world_visit_visit_row_id_key', constraint: 'unique', columns: ['visitRowId'] },
    ],
  }, WorldVisitRow),
  wormholeFlux: __table({
    name: 'wormhole_flux',
    indexes: [
      { accessor: 'fluxId', name: 'wormhole_flux_flux_id_idx_btree', algorithm: 'btree', columns: [
        'fluxId',
      ] },
      { accessor: 'wormholeFluxByKey', name: 'wormhole_flux_wh_key_idx_btree', algorithm: 'btree', columns: [
        'whKey',
      ] },
    ],
    constraints: [
      { name: 'wormhole_flux_flux_id_key', constraint: 'unique', columns: ['fluxId'] },
    ],
  }, WormholeFluxRow),
  zoningGrant: __table({
    name: 'zoning_grant',
    indexes: [
      { accessor: 'zoningGrantByCity', name: 'zoning_grant_city_id_idx_btree', algorithm: 'btree', columns: [
        'cityId',
      ] },
      { accessor: 'grantId', name: 'zoning_grant_grant_id_idx_btree', algorithm: 'btree', columns: [
        'grantId',
      ] },
      { accessor: 'zoningGrantByGrantee', name: 'zoning_grant_grantee_idx_btree', algorithm: 'btree', columns: [
        'grantee',
      ] },
    ],
    constraints: [
      { name: 'zoning_grant_grant_id_key', constraint: 'unique', columns: ['grantId'] },
    ],
  }, ZoningGrantRow),
});

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("abandon_duty_mission", AbandonDutyMissionReducer),
  __reducerSchema("abandon_ground_contract", AbandonGroundContractReducer),
  __reducerSchema("abandon_mission", AbandonMissionReducer),
  __reducerSchema("abandon_research_tender", AbandonResearchTenderReducer),
  __reducerSchema("abandon_war_supply", AbandonWarSupplyReducer),
  __reducerSchema("abort_travel", AbortTravelReducer),
  __reducerSchema("accept_courier_contract", AcceptCourierContractReducer),
  __reducerSchema("accept_favor", AcceptFavorReducer),
  __reducerSchema("accept_research_tender", AcceptResearchTenderReducer),
  __reducerSchema("accept_station_service", AcceptStationServiceReducer),
  __reducerSchema("add_bookmark", AddBookmarkReducer),
  __reducerSchema("add_forge_instance", AddForgeInstanceReducer),
  __reducerSchema("add_memory_entry", AddMemoryEntryReducer),
  __reducerSchema("add_render_asset_texture_tier", AddRenderAssetTextureTierReducer),
  __reducerSchema("add_render_asset_variant", AddRenderAssetVariantReducer),
  __reducerSchema("admin_delete_object", AdminDeleteObjectReducer),
  __reducerSchema("admin_place_object", AdminPlaceObjectReducer),
  __reducerSchema("admin_transform_object", AdminTransformObjectReducer),
  __reducerSchema("advance_faction_arc", AdvanceFactionArcReducer),
  __reducerSchema("advance_onboarding", AdvanceOnboardingReducer),
  __reducerSchema("air_support_kill", AirSupportKillReducer),
  __reducerSchema("ambush_kill", AmbushKillReducer),
  __reducerSchema("answer_ground_war", AnswerGroundWarReducer),
  __reducerSchema("answer_guild_application", AnswerGuildApplicationReducer),
  __reducerSchema("apologize_to_versona", ApologizeToVersonaReducer),
  __reducerSchema("appeal_quarantine", AppealQuarantineReducer),
  __reducerSchema("apply_for_loan", ApplyForLoanReducer),
  __reducerSchema("apply_to_guild", ApplyToGuildReducer),
  __reducerSchema("approach_merchant", ApproachMerchantReducer),
  __reducerSchema("archive_ephemeral_world", ArchiveEphemeralWorldReducer),
  __reducerSchema("arena_leave", ArenaLeaveReducer),
  __reducerSchema("arena_queue_join", ArenaQueueJoinReducer),
  __reducerSchema("arena_queue_leave", ArenaQueueLeaveReducer),
  __reducerSchema("arena_ready", ArenaReadyReducer),
  __reducerSchema("ascend_to_space", AscendToSpaceReducer),
  __reducerSchema("assign_guild_job", AssignGuildJobReducer),
  __reducerSchema("assign_versona_to_city", AssignVersonaToCityReducer),
  __reducerSchema("attach_script", AttachScriptReducer),
  __reducerSchema("attack_space_structure", AttackSpaceStructureReducer),
  __reducerSchema("auth_bump_epoch", AuthBumpEpochReducer),
  __reducerSchema("auth_claim", AuthClaimReducer),
  __reducerSchema("auth_record_failure", AuthRecordFailureReducer),
  __reducerSchema("auth_record_success", AuthRecordSuccessReducer),
  __reducerSchema("auth_register", AuthRegisterReducer),
  __reducerSchema("auth_set_recovery", AuthSetRecoveryReducer),
  __reducerSchema("auth_set_reset", AuthSetResetReducer),
  __reducerSchema("auth_set_secret", AuthSetSecretReducer),
  __reducerSchema("backfill_match", BackfillMatchReducer),
  __reducerSchema("bank_deposit", BankDepositReducer),
  __reducerSchema("bank_transfer", BankTransferReducer),
  __reducerSchema("bank_withdraw", BankWithdrawReducer),
  __reducerSchema("begin_upload", BeginUploadReducer),
  __reducerSchema("block_player", BlockPlayerReducer),
  __reducerSchema("board_ship", BoardShipReducer),
  __reducerSchema("board_turret", BoardTurretReducer),
  __reducerSchema("bounty_hunter_hit", BountyHunterHitReducer),
  __reducerSchema("bounty_hunter_windup", BountyHunterWindupReducer),
  __reducerSchema("bounty_hunter_won", BountyHunterWonReducer),
  __reducerSchema("bounty_report_shelter", BountyReportShelterReducer),
  __reducerSchema("box_store_item", BoxStoreItemReducer),
  __reducerSchema("box_store_stack", BoxStoreStackReducer),
  __reducerSchema("box_take", BoxTakeReducer),
  __reducerSchema("break_term_deposit", BreakTermDepositReducer),
  __reducerSchema("bridge_asset", BridgeAssetReducer),
  __reducerSchema("broker_reunification", BrokerReunificationReducer),
  __reducerSchema("buy_abyssal_filament", BuyAbyssalFilamentReducer),
  __reducerSchema("buy_from_droid", BuyFromDroidReducer),
  __reducerSchema("buy_furnish_pack", BuyFurnishPackReducer),
  __reducerSchema("buy_game_pass", BuyGamePassReducer),
  __reducerSchema("buy_here", BuyHereReducer),
  __reducerSchema("buy_intel_licence", BuyIntelLicenceReducer),
  __reducerSchema("buy_listing", BuyListingReducer),
  __reducerSchema("buy_listing_2", BuyListing2Reducer),
  __reducerSchema("buy_merchant_listing", BuyMerchantListingReducer),
  __reducerSchema("buy_repo_lot", BuyRepoLotReducer),
  __reducerSchema("buy_schematic", BuySchematicReducer),
  __reducerSchema("buy_ship", BuyShipReducer),
  __reducerSchema("buy_ticket", BuyTicketReducer),
  __reducerSchema("buy_versona_listing", BuyVersonaListingReducer),
  __reducerSchema("campaign_kill", CampaignKillReducer),
  __reducerSchema("cancel_courier_contract", CancelCourierContractReducer),
  __reducerSchema("cancel_fab_job", CancelFabJobReducer),
  __reducerSchema("cancel_freelance_project", CancelFreelanceProjectReducer),
  __reducerSchema("cancel_ground_contract", CancelGroundContractReducer),
  __reducerSchema("cancel_guild_order", CancelGuildOrderReducer),
  __reducerSchema("cancel_listing", CancelListingReducer),
  __reducerSchema("cancel_market_order", CancelMarketOrderReducer),
  __reducerSchema("cancel_player_bounty", CancelPlayerBountyReducer),
  __reducerSchema("cancel_ship_repair", CancelShipRepairReducer),
  __reducerSchema("cancel_space_operation", CancelSpaceOperationReducer),
  __reducerSchema("cancel_station_service", CancelStationServiceReducer),
  __reducerSchema("carry_campaign_message", CarryCampaignMessageReducer),
  __reducerSchema("cast_city_federal_vote", CastCityFederalVoteReducer),
  __reducerSchema("cast_civic_vote", CastCivicVoteReducer),
  __reducerSchema("cast_council_vote", CastCouncilVoteReducer),
  __reducerSchema("cast_federal_preference", CastFederalPreferenceReducer),
  __reducerSchema("cast_guild_vote", CastGuildVoteReducer),
  __reducerSchema("cast_line", CastLineReducer),
  __reducerSchema("cast_mayor_preference", CastMayorPreferenceReducer),
  __reducerSchema("challenge_charter", ChallengeCharterReducer),
  __reducerSchema("change_display_name", ChangeDisplayNameReducer),
  __reducerSchema("charge_subscriptions", ChargeSubscriptionsReducer),
  __reducerSchema("chargeback_escrow", ChargebackEscrowReducer),
  __reducerSchema("charter_city_bank", CharterCityBankReducer),
  __reducerSchema("check_in", CheckInReducer),
  __reducerSchema("city_bank_profit", CityBankProfitReducer),
  __reducerSchema("claim_abyssal_room", ClaimAbyssalRoomReducer),
  __reducerSchema("claim_daily_pulse_reward", ClaimDailyPulseRewardReducer),
  __reducerSchema("claim_duty_mission", ClaimDutyMissionReducer),
  __reducerSchema("claim_freelance_kills", ClaimFreelanceKillsReducer),
  __reducerSchema("clear_furnish_pack", ClearFurnishPackReducer),
  __reducerSchema("close_city_bank", CloseCityBankReducer),
  __reducerSchema("close_conflict_sector", CloseConflictSectorReducer),
  __reducerSchema("close_mayor_election", CloseMayorElectionReducer),
  __reducerSchema("close_voice_room", CloseVoiceRoomReducer),
  __reducerSchema("collect_extractor", CollectExtractorReducer),
  __reducerSchema("collect_fab_job", CollectFabJobReducer),
  __reducerSchema("collect_guild_lots", CollectGuildLotsReducer),
  __reducerSchema("collect_guild_store", CollectGuildStoreReducer),
  __reducerSchema("collect_moon_chunk", CollectMoonChunkReducer),
  __reducerSchema("collect_parcel", CollectParcelReducer),
  __reducerSchema("compile_contract", CompileContractReducer),
  __reducerSchema("compile_forge", CompileForgeReducer),
  __reducerSchema("compile_lua_contract", CompileLuaContractReducer),
  __reducerSchema("complete_escort", CompleteEscortReducer),
  __reducerSchema("complete_mission", CompleteMissionReducer),
  __reducerSchema("complete_safety_tutorial", CompleteSafetyTutorialReducer),
  __reducerSchema("complete_station_service", CompleteStationServiceReducer),
  __reducerSchema("complete_travel", CompleteTravelReducer),
  __reducerSchema("complete_war_banner", CompleteWarBannerReducer),
  __reducerSchema("converse_with_versona", ConverseWithVersonaReducer),
  __reducerSchema("council_act", CouncilActReducer),
  __reducerSchema("craft_item", CraftItemReducer),
  __reducerSchema("crash_ship", CrashShipReducer),
  __reducerSchema("create_account", CreateAccountReducer),
  __reducerSchema("create_asset", CreateAssetReducer),
  __reducerSchema("create_audio_zone", CreateAudioZoneReducer),
  __reducerSchema("create_courier_contract", CreateCourierContractReducer),
  __reducerSchema("create_event", CreateEventReducer),
  __reducerSchema("create_forge_project", CreateForgeProjectReducer),
  __reducerSchema("create_freelance_project", CreateFreelanceProjectReducer),
  __reducerSchema("create_game_pass", CreateGamePassReducer),
  __reducerSchema("create_guild", CreateGuildReducer),
  __reducerSchema("create_invite", CreateInviteReducer),
  __reducerSchema("create_voice_room", CreateVoiceRoomReducer),
  __reducerSchema("create_waypoint", CreateWaypointReducer),
  __reducerSchema("crew_accept", CrewAcceptReducer),
  __reducerSchema("crew_decline", CrewDeclineReducer),
  __reducerSchema("crew_invite", CrewInviteReducer),
  __reducerSchema("crew_release", CrewReleaseReducer),
  __reducerSchema("crew_revoke", CrewRevokeReducer),
  __reducerSchema("crew_route_power", CrewRoutePowerReducer),
  __reducerSchema("debug_add_citizen", DebugAddCitizenReducer),
  __reducerSchema("debug_add_versona_resident", DebugAddVersonaResidentReducer),
  __reducerSchema("debug_admin_grant_sov", DebugAdminGrantSovReducer),
  __reducerSchema("debug_advance_receipts", DebugAdvanceReceiptsReducer),
  __reducerSchema("debug_age_ambush", DebugAgeAmbushReducer),
  __reducerSchema("debug_age_battle", DebugAgeBattleReducer),
  __reducerSchema("debug_age_bounty_takes", DebugAgeBountyTakesReducer),
  __reducerSchema("debug_age_den", DebugAgeDenReducer),
  __reducerSchema("debug_age_den_slot", DebugAgeDenSlotReducer),
  __reducerSchema("debug_age_depot", DebugAgeDepotReducer),
  __reducerSchema("debug_age_expedition_log", DebugAgeExpeditionLogReducer),
  __reducerSchema("debug_age_fab_job", DebugAgeFabJobReducer),
  __reducerSchema("debug_age_federal", DebugAgeFederalReducer),
  __reducerSchema("debug_age_ground_contract", DebugAgeGroundContractReducer),
  __reducerSchema("debug_age_haul", DebugAgeHaulReducer),
  __reducerSchema("debug_age_intel", DebugAgeIntelReducer),
  __reducerSchema("debug_age_lod", DebugAgeLodReducer),
  __reducerSchema("debug_age_pair", DebugAgePairReducer),
  __reducerSchema("debug_age_planter", DebugAgePlanterReducer),
  __reducerSchema("debug_age_post", DebugAgePostReducer),
  __reducerSchema("debug_age_service_job", DebugAgeServiceJobReducer),
  __reducerSchema("debug_age_shipment", DebugAgeShipmentReducer),
  __reducerSchema("debug_age_travel", DebugAgeTravelReducer),
  __reducerSchema("debug_age_war_supply", DebugAgeWarSupplyReducer),
  __reducerSchema("debug_air_exchange", DebugAirExchangeReducer),
  __reducerSchema("debug_backdate_bounty", DebugBackdateBountyReducer),
  __reducerSchema("debug_backdate_case", DebugBackdateCaseReducer),
  __reducerSchema("debug_backdate_charter_vote", DebugBackdateCharterVoteReducer),
  __reducerSchema("debug_backdate_chronicler", DebugBackdateChroniclerReducer),
  __reducerSchema("debug_backdate_city", DebugBackdateCityReducer),
  __reducerSchema("debug_backdate_election", DebugBackdateElectionReducer),
  __reducerSchema("debug_backdate_escrow", DebugBackdateEscrowReducer),
  __reducerSchema("debug_backdate_extractor", DebugBackdateExtractorReducer),
  __reducerSchema("debug_backdate_group_review", DebugBackdateGroupReviewReducer),
  __reducerSchema("debug_backdate_last_seen", DebugBackdateLastSeenReducer),
  __reducerSchema("debug_backdate_onboarding", DebugBackdateOnboardingReducer),
  __reducerSchema("debug_backdate_orbit", DebugBackdateOrbitReducer),
  __reducerSchema("debug_backdate_pulse", DebugBackdatePulseReducer),
  __reducerSchema("debug_backdate_race", DebugBackdateRaceReducer),
  __reducerSchema("debug_backdate_session", DebugBackdateSessionReducer),
  __reducerSchema("debug_backdate_settlement", DebugBackdateSettlementReducer),
  __reducerSchema("debug_backdate_sky", DebugBackdateSkyReducer),
  __reducerSchema("debug_backdate_social", DebugBackdateSocialReducer),
  __reducerSchema("debug_backdate_structure_maint", DebugBackdateStructureMaintReducer),
  __reducerSchema("debug_backdate_subscription", DebugBackdateSubscriptionReducer),
  __reducerSchema("debug_backdate_ticket", DebugBackdateTicketReducer),
  __reducerSchema("debug_backdate_war", DebugBackdateWarReducer),
  __reducerSchema("debug_backdate_world_created", DebugBackdateWorldCreatedReducer),
  __reducerSchema("debug_bank_age", DebugBankAgeReducer),
  __reducerSchema("debug_bank_age_repo", DebugBankAgeRepoReducer),
  __reducerSchema("debug_bank_sweep", DebugBankSweepReducer),
  __reducerSchema("debug_bank_write_off", DebugBankWriteOffReducer),
  __reducerSchema("debug_battle_advise", DebugBattleAdviseReducer),
  __reducerSchema("debug_battle_muster", DebugBattleMusterReducer),
  __reducerSchema("debug_battle_rounds", DebugBattleRoundsReducer),
  __reducerSchema("debug_battle_withdraw", DebugBattleWithdrawReducer),
  __reducerSchema("debug_battle_wound", DebugBattleWoundReducer),
  __reducerSchema("debug_bounty_inspect", DebugBountyInspectReducer),
  __reducerSchema("debug_bounty_nudge", DebugBountyNudgeReducer),
  __reducerSchema("debug_bump_checked_in_count", DebugBumpCheckedInCountReducer),
  __reducerSchema("debug_bump_sequences", DebugBumpSequencesReducer),
  __reducerSchema("debug_campaign_age", DebugCampaignAgeReducer),
  __reducerSchema("debug_campaign_delete", DebugCampaignDeleteReducer),
  __reducerSchema("debug_campaign_open", DebugCampaignOpenReducer),
  __reducerSchema("debug_campaign_reopen", DebugCampaignReopenReducer),
  __reducerSchema("debug_campaign_resolve", DebugCampaignResolveReducer),
  __reducerSchema("debug_campaign_sandbox", DebugCampaignSandboxReducer),
  __reducerSchema("debug_campaign_set_alive", DebugCampaignSetAliveReducer),
  __reducerSchema("debug_campaign_set_escorts", DebugCampaignSetEscortsReducer),
  __reducerSchema("debug_campaign_set_stance", DebugCampaignSetStanceReducer),
  __reducerSchema("debug_campaign_step", DebugCampaignStepReducer),
  __reducerSchema("debug_campaign_sweep", DebugCampaignSweepReducer),
  __reducerSchema("debug_campaign_unsettle", DebugCampaignUnsettleReducer),
  __reducerSchema("debug_certify", DebugCertifyReducer),
  __reducerSchema("debug_charter_versona_guild", DebugCharterVersonaGuildReducer),
  __reducerSchema("debug_clear_affect", DebugClearAffectReducer),
  __reducerSchema("debug_clear_droid_load", DebugClearDroidLoadReducer),
  __reducerSchema("debug_clear_inventory", DebugClearInventoryReducer),
  __reducerSchema("debug_clear_seeded_worlds", DebugClearSeededWorldsReducer),
  __reducerSchema("debug_close_guild_election", DebugCloseGuildElectionReducer),
  __reducerSchema("debug_corrupt_contract_bytecode", DebugCorruptContractBytecodeReducer),
  __reducerSchema("debug_corrupt_forge_artifact", DebugCorruptForgeArtifactReducer),
  __reducerSchema("debug_corrupt_forge_build", DebugCorruptForgeBuildReducer),
  __reducerSchema("debug_corrupt_ranks", DebugCorruptRanksReducer),
  __reducerSchema("debug_despawn_creatures", DebugDespawnCreaturesReducer),
  __reducerSchema("debug_disband_city", DebugDisbandCityReducer),
  __reducerSchema("debug_dissolve_guild", DebugDissolveGuildReducer),
  __reducerSchema("debug_dissolve_union", DebugDissolveUnionReducer),
  __reducerSchema("debug_dissolve_versona_guild", DebugDissolveVersonaGuildReducer),
  __reducerSchema("debug_down_convoy", DebugDownConvoyReducer),
  __reducerSchema("debug_down_war_air", DebugDownWarAirReducer),
  __reducerSchema("debug_droid_advance", DebugDroidAdvanceReducer),
  __reducerSchema("debug_droid_corrupt", DebugDroidCorruptReducer),
  __reducerSchema("debug_droid_damage", DebugDroidDamageReducer),
  __reducerSchema("debug_elicit_emotion", DebugElicitEmotionReducer),
  __reducerSchema("debug_end_event", DebugEndEventReducer),
  __reducerSchema("debug_engineering_age", DebugEngineeringAgeReducer),
  __reducerSchema("debug_enter_space", DebugEnterSpaceReducer),
  __reducerSchema("debug_equip_versona", DebugEquipVersonaReducer),
  __reducerSchema("debug_escort_sample", DebugEscortSampleReducer),
  __reducerSchema("debug_ew_reset", DebugEwResetReducer),
  __reducerSchema("debug_ew_sweep", DebugEwSweepReducer),
  __reducerSchema("debug_expire_abyssal", DebugExpireAbyssalReducer),
  __reducerSchema("debug_expire_merchant_lot", DebugExpireMerchantLotReducer),
  __reducerSchema("debug_expire_player_bounty", DebugExpirePlayerBountyReducer),
  __reducerSchema("debug_feed_reserves", DebugFeedReservesReducer),
  __reducerSchema("debug_festival_attend", DebugFestivalAttendReducer),
  __reducerSchema("debug_finish_training", DebugFinishTrainingReducer),
  __reducerSchema("debug_fish_bite", DebugFishBiteReducer),
  __reducerSchema("debug_footprint_probe", DebugFootprintProbeReducer),
  __reducerSchema("debug_force_apprentice", DebugForceApprenticeReducer),
  __reducerSchema("debug_force_battle", DebugForceBattleReducer),
  __reducerSchema("debug_force_birth", DebugForceBirthReducer),
  __reducerSchema("debug_force_bounty", DebugForceBountyReducer),
  __reducerSchema("debug_force_caravan", DebugForceCaravanReducer),
  __reducerSchema("debug_force_cargo_convoy", DebugForceCargoConvoyReducer),
  __reducerSchema("debug_force_civic_sweep", DebugForceCivicSweepReducer),
  __reducerSchema("debug_force_clash", DebugForceClashReducer),
  __reducerSchema("debug_force_colony", DebugForceColonyReducer),
  __reducerSchema("debug_force_congress", DebugForceCongressReducer),
  __reducerSchema("debug_force_crier", DebugForceCrierReducer),
  __reducerSchema("debug_force_deliberation", DebugForceDeliberationReducer),
  __reducerSchema("debug_force_diplomacy", DebugForceDiplomacyReducer),
  __reducerSchema("debug_force_feast", DebugForceFeastReducer),
  __reducerSchema("debug_force_federal_session", DebugForceFederalSessionReducer),
  __reducerSchema("debug_force_gossip", DebugForceGossipReducer),
  __reducerSchema("debug_force_guildmaster", DebugForceGuildmasterReducer),
  __reducerSchema("debug_force_introduce", DebugForceIntroduceReducer),
  __reducerSchema("debug_force_legend_night", DebugForceLegendNightReducer),
  __reducerSchema("debug_force_market_day", DebugForceMarketDayReducer),
  __reducerSchema("debug_force_migration", DebugForceMigrationReducer),
  __reducerSchema("debug_force_natural_death", DebugForceNaturalDeathReducer),
  __reducerSchema("debug_force_persuade", DebugForcePersuadeReducer),
  __reducerSchema("debug_force_polity_sweep", DebugForcePolitySweepReducer),
  __reducerSchema("debug_force_rent", DebugForceRentReducer),
  __reducerSchema("debug_force_retrain", DebugForceRetrainReducer),
  __reducerSchema("debug_force_rite", DebugForceRiteReducer),
  __reducerSchema("debug_force_rumor", DebugForceRumorReducer),
  __reducerSchema("debug_force_slander", DebugForceSlanderReducer),
  __reducerSchema("debug_force_society_day", DebugForceSocietyDayReducer),
  __reducerSchema("debug_force_spy", DebugForceSpyReducer),
  __reducerSchema("debug_force_theft", DebugForceTheftReducer),
  __reducerSchema("debug_force_trial", DebugForceTrialReducer),
  __reducerSchema("debug_force_tribunal_scan", DebugForceTribunalScanReducer),
  __reducerSchema("debug_force_union", DebugForceUnionReducer),
  __reducerSchema("debug_force_versona_craft", DebugForceVersonaCraftReducer),
  __reducerSchema("debug_force_war_council", DebugForceWarCouncilReducer),
  __reducerSchema("debug_forget_lane_losses", DebugForgetLaneLossesReducer),
  __reducerSchema("debug_forget_memory", DebugForgetMemoryReducer),
  __reducerSchema("debug_forget_schematic", DebugForgetSchematicReducer),
  __reducerSchema("debug_forget_stations", DebugForgetStationsReducer),
  __reducerSchema("debug_found_versona_guilds", DebugFoundVersonaGuildsReducer),
  __reducerSchema("debug_fund_guild", DebugFundGuildReducer),
  __reducerSchema("debug_fund_treasury", DebugFundTreasuryReducer),
  __reducerSchema("debug_grant_cargo", DebugGrantCargoReducer),
  __reducerSchema("debug_grant_commons_admin", DebugGrantCommonsAdminReducer),
  __reducerSchema("debug_grant_fab_ore", DebugGrantFabOreReducer),
  __reducerSchema("debug_grant_firm_ore", DebugGrantFirmOreReducer),
  __reducerSchema("debug_grant_inf", DebugGrantInfReducer),
  __reducerSchema("debug_grant_item", DebugGrantItemReducer),
  __reducerSchema("debug_grant_lots", DebugGrantLotsReducer),
  __reducerSchema("debug_grant_resource", DebugGrantResourceReducer),
  __reducerSchema("debug_grant_schematic", DebugGrantSchematicReducer),
  __reducerSchema("debug_grant_ship", DebugGrantShipReducer),
  __reducerSchema("debug_grant_sov", DebugGrantSovReducer),
  __reducerSchema("debug_ground_contract_sweep", DebugGroundContractSweepReducer),
  __reducerSchema("debug_ground_war_age", DebugGroundWarAgeReducer),
  __reducerSchema("debug_guild_age", DebugGuildAgeReducer),
  __reducerSchema("debug_guild_age_history", DebugGuildAgeHistoryReducer),
  __reducerSchema("debug_guild_sweep", DebugGuildSweepReducer),
  __reducerSchema("debug_guild_work_tick", DebugGuildWorkTickReducer),
  __reducerSchema("debug_incursion_seed", DebugIncursionSeedReducer),
  __reducerSchema("debug_indoor_bench", DebugIndoorBenchReducer),
  __reducerSchema("debug_indoor_sight", DebugIndoorSightReducer),
  __reducerSchema("debug_inject_event", DebugInjectEventReducer),
  __reducerSchema("debug_inject_rating", DebugInjectRatingReducer),
  __reducerSchema("debug_inject_review", DebugInjectReviewReducer),
  __reducerSchema("debug_interior_age", DebugInteriorAgeReducer),
  __reducerSchema("debug_interior_relation", DebugInteriorRelationReducer),
  __reducerSchema("debug_interior_sweep", DebugInteriorSweepReducer),
  __reducerSchema("debug_journeyman", DebugJourneymanReducer),
  __reducerSchema("debug_lapse_hire", DebugLapseHireReducer),
  __reducerSchema("debug_lod_sweep", DebugLodSweepReducer),
  __reducerSchema("debug_market_sweeps", DebugMarketSweepsReducer),
  __reducerSchema("debug_offer_favor", DebugOfferFavorReducer),
  __reducerSchema("debug_open_city_bank", DebugOpenCityBankReducer),
  __reducerSchema("debug_open_election_race", DebugOpenElectionRaceReducer),
  __reducerSchema("debug_ops_age_extraction", DebugOpsAgeExtractionReducer),
  __reducerSchema("debug_ops_delete", DebugOpsDeleteReducer),
  __reducerSchema("debug_ops_pin_campaign", DebugOpsPinCampaignReducer),
  __reducerSchema("debug_port_reset_drain", DebugPortResetDrainReducer),
  __reducerSchema("debug_port_tick", DebugPortTickReducer),
  __reducerSchema("debug_post_customer", DebugPostCustomerReducer),
  __reducerSchema("debug_post_war_supply", DebugPostWarSupplyReducer),
  __reducerSchema("debug_profile_droid_tick", DebugProfileDroidTickReducer),
  __reducerSchema("debug_profile_sim_tick", DebugProfileSimTickReducer),
  __reducerSchema("debug_profile_versona_ai", DebugProfileVersonaAiReducer),
  __reducerSchema("debug_prune_project_placements", DebugPruneProjectPlacementsReducer),
  __reducerSchema("debug_prune_wild_structures", DebugPruneWildStructuresReducer),
  __reducerSchema("debug_pvp_backdate", DebugPvpBackdateReducer),
  __reducerSchema("debug_qualify_legacy", DebugQualifyLegacyReducer),
  __reducerSchema("debug_race_backdate", DebugRaceBackdateReducer),
  __reducerSchema("debug_race_schedule", DebugRaceScheduleReducer),
  __reducerSchema("debug_reap_orphan_cognition", DebugReapOrphanCognitionReducer),
  __reducerSchema("debug_record_match_result", DebugRecordMatchResultReducer),
  __reducerSchema("debug_refill_weapon_feed", DebugRefillWeaponFeedReducer),
  __reducerSchema("debug_remove_structure", DebugRemoveStructureReducer),
  __reducerSchema("debug_remove_synthetic_citizens", DebugRemoveSyntheticCitizensReducer),
  __reducerSchema("debug_rental_age", DebugRentalAgeReducer),
  __reducerSchema("debug_rental_sweep", DebugRentalSweepReducer),
  __reducerSchema("debug_replot_graves", DebugReplotGravesReducer),
  __reducerSchema("debug_reset_mystery", DebugResetMysteryReducer),
  __reducerSchema("debug_resolve_battle_as", DebugResolveBattleAsReducer),
  __reducerSchema("debug_resolve_festival", DebugResolveFestivalReducer),
  __reducerSchema("debug_reveal_sig", DebugRevealSigReducer),
  __reducerSchema("debug_room_plan", DebugRoomPlanReducer),
  __reducerSchema("debug_rotate_spawns", DebugRotateSpawnsReducer),
  __reducerSchema("debug_seed_low_pulse", DebugSeedLowPulseReducer),
  __reducerSchema("debug_seed_schisms", DebugSeedSchismsReducer),
  __reducerSchema("debug_seed_verified_score", DebugSeedVerifiedScoreReducer),
  __reducerSchema("debug_seed_worlds", DebugSeedWorldsReducer),
  __reducerSchema("debug_set_agent_job", DebugSetAgentJobReducer),
  __reducerSchema("debug_set_agent_stat", DebugSetAgentStatReducer),
  __reducerSchema("debug_set_arcade_tab", DebugSetArcadeTabReducer),
  __reducerSchema("debug_set_bounty_hunter_hp", DebugSetBountyHunterHpReducer),
  __reducerSchema("debug_set_delisted", DebugSetDelistedReducer),
  __reducerSchema("debug_set_den", DebugSetDenReducer),
  __reducerSchema("debug_set_deposit", DebugSetDepositReducer),
  __reducerSchema("debug_set_federal_war", DebugSetFederalWarReducer),
  __reducerSchema("debug_set_firm_hulls", DebugSetFirmHullsReducer),
  __reducerSchema("debug_set_firm_sov", DebugSetFirmSovReducer),
  __reducerSchema("debug_set_fund", DebugSetFundReducer),
  __reducerSchema("debug_set_goodwill", DebugSetGoodwillReducer),
  __reducerSchema("debug_set_grievance", DebugSetGrievanceReducer),
  __reducerSchema("debug_set_grudge", DebugSetGrudgeReducer),
  __reducerSchema("debug_set_item_count", DebugSetItemCountReducer),
  __reducerSchema("debug_set_lean", DebugSetLeanReducer),
  __reducerSchema("debug_set_li_max", DebugSetLiMaxReducer),
  __reducerSchema("debug_set_memory", DebugSetMemoryReducer),
  __reducerSchema("debug_set_occupation", DebugSetOccupationReducer),
  __reducerSchema("debug_set_pair", DebugSetPairReducer),
  __reducerSchema("debug_set_port_coins", DebugSetPortCoinsReducer),
  __reducerSchema("debug_set_port_exported", DebugSetPortExportedReducer),
  __reducerSchema("debug_set_port_state", DebugSetPortStateReducer),
  __reducerSchema("debug_set_rating", DebugSetRatingReducer),
  __reducerSchema("debug_set_relation", DebugSetRelationReducer),
  __reducerSchema("debug_set_relation_for", DebugSetRelationForReducer),
  __reducerSchema("debug_set_relief", DebugSetReliefReducer),
  __reducerSchema("debug_set_reserve", DebugSetReserveReducer),
  __reducerSchema("debug_set_session_result", DebugSetSessionResultReducer),
  __reducerSchema("debug_set_shelf", DebugSetShelfReducer),
  __reducerSchema("debug_set_shipment_ambush", DebugSetShipmentAmbushReducer),
  __reducerSchema("debug_set_shipment_roll", DebugSetShipmentRollReducer),
  __reducerSchema("debug_set_siege", DebugSetSiegeReducer),
  __reducerSchema("debug_set_skill", DebugSetSkillReducer),
  __reducerSchema("debug_set_sky_cycle", DebugSetSkyCycleReducer),
  __reducerSchema("debug_set_sky_time", DebugSetSkyTimeReducer),
  __reducerSchema("debug_set_stance", DebugSetStanceReducer),
  __reducerSchema("debug_set_standing", DebugSetStandingReducer),
  __reducerSchema("debug_set_standing_for", DebugSetStandingForReducer),
  __reducerSchema("debug_set_subsystems", DebugSetSubsystemsReducer),
  __reducerSchema("debug_set_town_score", DebugSetTownScoreReducer),
  __reducerSchema("debug_set_treaty", DebugSetTreatyReducer),
  __reducerSchema("debug_set_trust", DebugSetTrustReducer),
  __reducerSchema("debug_set_vitals", DebugSetVitalsReducer),
  __reducerSchema("debug_set_war_petition", DebugSetWarPetitionReducer),
  __reducerSchema("debug_set_world_size", DebugSetWorldSizeReducer),
  __reducerSchema("debug_set_world_template", DebugSetWorldTemplateReducer),
  __reducerSchema("debug_site_version", DebugSiteVersionReducer),
  __reducerSchema("debug_space_advise", DebugSpaceAdviseReducer),
  __reducerSchema("debug_space_economy_tick", DebugSpaceEconomyTickReducer),
  __reducerSchema("debug_space_intel_sweep", DebugSpaceIntelSweepReducer),
  __reducerSchema("debug_space_ops_reset", DebugSpaceOpsResetReducer),
  __reducerSchema("debug_space_ops_sweep", DebugSpaceOpsSweepReducer),
  __reducerSchema("debug_space_ops_tick", DebugSpaceOpsTickReducer),
  __reducerSchema("debug_space_teleport", DebugSpaceTeleportReducer),
  __reducerSchema("debug_spawn_creature", DebugSpawnCreatureReducer),
  __reducerSchema("debug_spawn_droid_load", DebugSpawnDroidLoadReducer),
  __reducerSchema("debug_stage_event", DebugStageEventReducer),
  __reducerSchema("debug_stage_festival", DebugStageFestivalReducer),
  __reducerSchema("debug_start_battle_at", DebugStartBattleAtReducer),
  __reducerSchema("debug_start_journey", DebugStartJourneyReducer),
  __reducerSchema("debug_start_war_at", DebugStartWarAtReducer),
  __reducerSchema("debug_station_service_sweep", DebugStationServiceSweepReducer),
  __reducerSchema("debug_stock_stall", DebugStockStallReducer),
  __reducerSchema("debug_strike", DebugStrikeReducer),
  __reducerSchema("debug_survey_age", DebugSurveyAgeReducer),
  __reducerSchema("debug_survey_sweep", DebugSurveySweepReducer),
  __reducerSchema("debug_teleport", DebugTeleportReducer),
  __reducerSchema("debug_teleport_to_versona", DebugTeleportToVersonaReducer),
  __reducerSchema("debug_trade_sweep", DebugTradeSweepReducer),
  __reducerSchema("debug_versona_guild_tick", DebugVersonaGuildTickReducer),
  __reducerSchema("debug_voice_age", DebugVoiceAgeReducer),
  __reducerSchema("debug_voice_sweep", DebugVoiceSweepReducer),
  __reducerSchema("debug_war_authority_clear", DebugWarAuthorityClearReducer),
  __reducerSchema("debug_war_authority_pin", DebugWarAuthorityPinReducer),
  __reducerSchema("debug_war_life_hp", DebugWarLifeHpReducer),
  __reducerSchema("debug_war_sky_clear", DebugWarSkyClearReducer),
  __reducerSchema("debug_war_sky_sweep", DebugWarSkySweepReducer),
  __reducerSchema("debug_war_sky_write", DebugWarSkyWriteReducer),
  __reducerSchema("decay_and_satisfy_pulse", DecayAndSatisfyPulseReducer),
  __reducerSchema("declare_city_allegiance", DeclareCityAllegianceReducer),
  __reducerSchema("declare_ground_war", DeclareGroundWarReducer),
  __reducerSchema("declare_guild_war", DeclareGuildWarReducer),
  __reducerSchema("declare_instance_group", DeclareInstanceGroupReducer),
  __reducerSchema("declare_residence", DeclareResidenceReducer),
  __reducerSchema("delete_audio_zone", DeleteAudioZoneReducer),
  __reducerSchema("delete_device", DeleteDeviceReducer),
  __reducerSchema("delete_droid_report", DeleteDroidReportReducer),
  __reducerSchema("delete_npc", DeleteNpcReducer),
  __reducerSchema("delete_part", DeletePartReducer),
  __reducerSchema("delete_versona", DeleteVersonaReducer),
  __reducerSchema("delete_waypoint", DeleteWaypointReducer),
  __reducerSchema("delete_world", DeleteWorldReducer),
  __reducerSchema("delete_world_script", DeleteWorldScriptReducer),
  __reducerSchema("deliver_courier", DeliverCourierReducer),
  __reducerSchema("deliver_courier_contract", DeliverCourierContractReducer),
  __reducerSchema("deliver_freelance_goods", DeliverFreelanceGoodsReducer),
  __reducerSchema("deliver_research_tender", DeliverResearchTenderReducer),
  __reducerSchema("deliver_supply", DeliverSupplyReducer),
  __reducerSchema("deliver_war_supply", DeliverWarSupplyReducer),
  __reducerSchema("den_hull_sync", DenHullSyncReducer),
  __reducerSchema("deploy_droid", DeployDroidReducer),
  __reducerSchema("deploy_space_structure", DeploySpaceStructureReducer),
  __reducerSchema("deploy_structure", DeployStructureReducer),
  __reducerSchema("descend_to_atmosphere", DescendToAtmosphereReducer),
  __reducerSchema("describe_asset", DescribeAssetReducer),
  __reducerSchema("designate_militia", DesignateMilitiaReducer),
  __reducerSchema("dismiss_guild_versona", DismissGuildVersonaReducer),
  __reducerSchema("dismount_vehicle", DismountVehicleReducer),
  __reducerSchema("dock_at_station", DockAtStationReducer),
  __reducerSchema("donate_to_guild", DonateToGuildReducer),
  __reducerSchema("donate_treasury", DonateTreasuryReducer),
  __reducerSchema("droid_command", DroidCommandReducer),
  __reducerSchema("droid_defund", DroidDefundReducer),
  __reducerSchema("droid_fund", DroidFundReducer),
  __reducerSchema("droid_load_item", DroidLoadItemReducer),
  __reducerSchema("droid_load_stack", DroidLoadStackReducer),
  __reducerSchema("droid_program", DroidProgramReducer),
  __reducerSchema("droid_repair", DroidRepairReducer),
  __reducerSchema("droid_set_price", DroidSetPriceReducer),
  __reducerSchema("droid_unload", DroidUnloadReducer),
  __reducerSchema("drop_player_bounty", DropPlayerBountyReducer),
  __reducerSchema("duel_cancel", DuelCancelReducer),
  __reducerSchema("duel_invite", DuelInviteReducer),
  __reducerSchema("duel_ready", DuelReadyReducer),
  __reducerSchema("duel_respond", DuelRespondReducer),
  __reducerSchema("duel_surrender", DuelSurrenderReducer),
  __reducerSchema("edit_device", EditDeviceReducer),
  __reducerSchema("edit_npc", EditNpcReducer),
  __reducerSchema("edit_part", EditPartReducer),
  __reducerSchema("edit_terrain", EditTerrainReducer),
  __reducerSchema("emit_world_event", EmitWorldEventReducer),
  __reducerSchema("end_rental", EndRentalReducer),
  __reducerSchema("enqueue_match", EnqueueMatchReducer),
  __reducerSchema("enqueue_party", EnqueuePartyReducer),
  __reducerSchema("enroll_space_operation", EnrollSpaceOperationReducer),
  __reducerSchema("ensure_commons_reserve", EnsureCommonsReserveReducer),
  __reducerSchema("ensure_merchant_hive", EnsureMerchantHiveReducer),
  __reducerSchema("enter_abyssal", EnterAbyssalReducer),
  __reducerSchema("enter_festival_contest", EnterFestivalContestReducer),
  __reducerSchema("enter_interior_room", EnterInteriorRoomReducer),
  __reducerSchema("enter_space", EnterSpaceReducer),
  __reducerSchema("enter_world", EnterWorldReducer),
  __reducerSchema("equip_ship_component", EquipShipComponentReducer),
  __reducerSchema("escort_shipment", EscortShipmentReducer),
  __reducerSchema("evict_tenant", EvictTenantReducer),
  __reducerSchema("evict_versona_resident", EvictVersonaResidentReducer),
  __reducerSchema("ew_burst", EwBurstReducer),
  __reducerSchema("ew_jam", EwJamReducer),
  __reducerSchema("execute_spend", ExecuteSpendReducer),
  __reducerSchema("exit_abyssal", ExitAbyssalReducer),
  __reducerSchema("exit_space", ExitSpaceReducer),
  __reducerSchema("expire_orbits", ExpireOrbitsReducer),
  __reducerSchema("export_to_forge", ExportToForgeReducer),
  __reducerSchema("fail_chat_translation", FailChatTranslationReducer),
  __reducerSchema("festival_presence", FestivalPresenceReducer),
  __reducerSchema("field_enroll", FieldEnrollReducer),
  __reducerSchema("field_leave", FieldLeaveReducer),
  __reducerSchema("file_scout_report", FileScoutReportReducer),
  __reducerSchema("finalize_upload_asset", FinalizeUploadAssetReducer),
  __reducerSchema("fire_weapon", FireWeaponReducer),
  __reducerSchema("fly_move", FlyMoveReducer),
  __reducerSchema("form_orbit", FormOrbitReducer),
  __reducerSchema("found_city", FoundCityReducer),
  __reducerSchema("friend_remove", FriendRemoveReducer),
  __reducerSchema("friend_request", FriendRequestReducer),
  __reducerSchema("friend_respond", FriendRespondReducer),
  __reducerSchema("fulfill_favor", FulfillFavorReducer),
  __reducerSchema("fund_port", FundPortReducer),
  __reducerSchema("fund_research_post", FundResearchPostReducer),
  __reducerSchema("get_compile_result", GetCompileResultReducer),
  __reducerSchema("give_gift_to_versona", GiveGiftToVersonaReducer),
  __reducerSchema("grant_contract_caps", GrantContractCapsReducer),
  __reducerSchema("grant_deed", GrantDeedReducer),
  __reducerSchema("grant_legacy", GrantLegacyReducer),
  __reducerSchema("grant_new_player", GrantNewPlayerReducer),
  __reducerSchema("grant_voice_sfu_role", GrantVoiceSfuRoleReducer),
  __reducerSchema("grant_zoning", GrantZoningReducer),
  __reducerSchema("hand_in_relay", HandInRelayReducer),
  __reducerSchema("harvest_planter", HarvestPlanterReducer),
  __reducerSchema("hire_bounty_hunter", HireBountyHunterReducer),
  __reducerSchema("hold_escrow", HoldEscrowReducer),
  __reducerSchema("hold_merchant_listing", HoldMerchantListingReducer),
  __reducerSchema("import_mesh", ImportMeshReducer),
  __reducerSchema("import_to_canvas", ImportToCanvasReducer),
  __reducerSchema("incursion_kill", IncursionKillReducer),
  __reducerSchema("init_onboarding", InitOnboardingReducer),
  __reducerSchema("initiate_fork", InitiateForkReducer),
  __reducerSchema("instantiate_template", InstantiateTemplateReducer),
  __reducerSchema("institutionalize_ritual", InstitutionalizeRitualReducer),
  __reducerSchema("insure_ship", InsureShipReducer),
  __reducerSchema("invite_party_member", InvitePartyMemberReducer),
  __reducerSchema("invite_to_voice_room", InviteToVoiceRoomReducer),
  __reducerSchema("invite_versona_to_city", InviteVersonaToCityReducer),
  __reducerSchema("join_civilization", JoinCivilizationReducer),
  __reducerSchema("join_guild", JoinGuildReducer),
  __reducerSchema("join_race_queue", JoinRaceQueueReducer),
  __reducerSchema("join_team_voice", JoinTeamVoiceReducer),
  __reducerSchema("join_voice_room", JoinVoiceRoomReducer),
  __reducerSchema("kick_from_voice_room", KickFromVoiceRoomReducer),
  __reducerSchema("kick_guild_member", KickGuildMemberReducer),
  __reducerSchema("land_on_world", LandOnWorldReducer),
  __reducerSchema("land_ship", LandShipReducer),
  __reducerSchema("launch_firework", LaunchFireworkReducer),
  __reducerSchema("launch_firework_show", LaunchFireworkShowReducer),
  __reducerSchema("lease_residency", LeaseResidencyReducer),
  __reducerSchema("lease_site", LeaseSiteReducer),
  __reducerSchema("leave_city", LeaveCityReducer),
  __reducerSchema("leave_civilization", LeaveCivilizationReducer),
  __reducerSchema("leave_guild", LeaveGuildReducer),
  __reducerSchema("leave_interior", LeaveInteriorReducer),
  __reducerSchema("leave_merchant", LeaveMerchantReducer),
  __reducerSchema("leave_race_queue", LeaveRaceQueueReducer),
  __reducerSchema("leave_rental", LeaveRentalReducer),
  __reducerSchema("leave_service_post", LeaveServicePostReducer),
  __reducerSchema("leave_session", LeaveSessionReducer),
  __reducerSchema("leave_space_operation", LeaveSpaceOperationReducer),
  __reducerSchema("leave_turret", LeaveTurretReducer),
  __reducerSchema("leave_voice_room", LeaveVoiceRoomReducer),
  __reducerSchema("link_parts", LinkPartsReducer),
  __reducerSchema("list_asset", ListAssetReducer),
  __reducerSchema("list_deed", ListDeedReducer),
  __reducerSchema("list_item", ListItemReducer),
  __reducerSchema("list_rental_unit", ListRentalUnitReducer),
  __reducerSchema("list_resource", ListResourceReducer),
  __reducerSchema("load_cargo", LoadCargoReducer),
  __reducerSchema("load_hold_from_ground", LoadHoldFromGroundReducer),
  __reducerSchema("load_published_experience", LoadPublishedExperienceReducer),
  __reducerSchema("loot_cargo_wreck", LootCargoWreckReducer),
  __reducerSchema("mark_bounty_strike", MarkBountyStrikeReducer),
  __reducerSchema("mark_orbit_interaction", MarkOrbitInteractionReducer),
  __reducerSchema("matchmake", MatchmakeReducer),
  __reducerSchema("migrate_droid_purses", MigrateDroidPursesReducer),
  __reducerSchema("moderate_asset", ModerateAssetReducer),
  __reducerSchema("move", MoveReducer),
  __reducerSchema("move_steps", MoveStepsReducer),
  __reducerSchema("move_steps_2", MoveSteps2Reducer),
  __reducerSchema("move_structure_item", MoveStructureItemReducer),
  __reducerSchema("move_versona", MoveVersonaReducer),
  __reducerSchema("muster_at_fort", MusterAtFortReducer),
  __reducerSchema("mute_ritual_invites", MuteRitualInvitesReducer),
  __reducerSchema("npc_ask_versona", NpcAskVersonaReducer),
  __reducerSchema("npc_sim_tick", NpcSimTickReducer),
  __reducerSchema("offer_intel_licence", OfferIntelLicenceReducer),
  __reducerSchema("office_buy_goods", OfficeBuyGoodsReducer),
  __reducerSchema("office_sell_goods", OfficeSellGoodsReducer),
  __reducerSchema("op_extraction_beat", OpExtractionBeatReducer),
  __reducerSchema("op_scout_beat", OpScoutBeatReducer),
  __reducerSchema("op_start_extraction", OpStartExtractionReducer),
  __reducerSchema("op_submit_evidence", OpSubmitEvidenceReducer),
  __reducerSchema("open_conflict_sector", OpenConflictSectorReducer),
  __reducerSchema("open_container", OpenContainerReducer),
  __reducerSchema("open_council_term", OpenCouncilTermReducer),
  __reducerSchema("open_guild_election", OpenGuildElectionReducer),
  __reducerSchema("open_mayor_election", OpenMayorElectionReducer),
  __reducerSchema("open_rental_storage", OpenRentalStorageReducer),
  __reducerSchema("open_session", OpenSessionReducer),
  __reducerSchema("open_term_deposit", OpenTermDepositReducer),
  __reducerSchema("party_create", PartyCreateReducer),
  __reducerSchema("party_disband", PartyDisbandReducer),
  __reducerSchema("party_kick", PartyKickReducer),
  __reducerSchema("party_leave", PartyLeaveReducer),
  __reducerSchema("party_ping_clear", PartyPingClearReducer),
  __reducerSchema("party_queue_accept", PartyQueueAcceptReducer),
  __reducerSchema("party_queue_revoke", PartyQueueRevokeReducer),
  __reducerSchema("party_ready", PartyReadyReducer),
  __reducerSchema("party_respond", PartyRespondReducer),
  __reducerSchema("party_transfer_lead", PartyTransferLeadReducer),
  __reducerSchema("pay_maintenance", PayMaintenanceReducer),
  __reducerSchema("pay_rent", PayRentReducer),
  __reducerSchema("pay_sale_royalty", PaySaleRoyaltyReducer),
  __reducerSchema("penalize_cheater", PenalizeCheaterReducer),
  __reducerSchema("perf_leg_end", PerfLegEndReducer),
  __reducerSchema("perf_leg_start", PerfLegStartReducer),
  __reducerSchema("perf_prune", PerfPruneReducer),
  __reducerSchema("perf_record_sample", PerfRecordSampleReducer),
  __reducerSchema("perf_run_end", PerfRunEndReducer),
  __reducerSchema("perf_run_start", PerfRunStartReducer),
  __reducerSchema("pickup_furniture", PickupFurnitureReducer),
  __reducerSchema("pin_arcade_game", PinArcadeGameReducer),
  __reducerSchema("ping", PingReducer),
  __reducerSchema("pirate_cargo_convoy", PirateCargoConvoyReducer),
  __reducerSchema("pitch_camp", PitchCampReducer),
  __reducerSchema("place_bounty", PlaceBountyReducer),
  __reducerSchema("place_civic_structure", PlaceCivicStructureReducer),
  __reducerSchema("place_deck_item", PlaceDeckItemReducer),
  __reducerSchema("place_device", PlaceDeviceReducer),
  __reducerSchema("place_furniture", PlaceFurnitureReducer),
  __reducerSchema("place_guild_structure", PlaceGuildStructureReducer),
  __reducerSchema("place_market_order", PlaceMarketOrderReducer),
  __reducerSchema("place_npc", PlaceNpcReducer),
  __reducerSchema("place_object", PlaceObjectReducer),
  __reducerSchema("place_structure_item", PlaceStructureItemReducer),
  __reducerSchema("place_versona", PlaceVersonaReducer),
  __reducerSchema("plant_seed", PlantSeedReducer),
  __reducerSchema("plant_war_banner", PlantWarBannerReducer),
  __reducerSchema("platform_delete_world", PlatformDeleteWorldReducer),
  __reducerSchema("port_accept", PortAcceptReducer),
  __reducerSchema("port_accept_terms", PortAcceptTermsReducer),
  __reducerSchema("port_deliver", PortDeliverReducer),
  __reducerSchema("port_relay", PortRelayReducer),
  __reducerSchema("port_relay_offer", PortRelayOfferReducer),
  __reducerSchema("port_relay_revoke", PortRelayRevokeReducer),
  __reducerSchema("post_courier_contract", PostCourierContractReducer),
  __reducerSchema("post_duty_ping", PostDutyPingReducer),
  __reducerSchema("post_escort_contract", PostEscortContractReducer),
  __reducerSchema("post_ledger", PostLedgerReducer),
  __reducerSchema("post_player_bounty", PostPlayerBountyReducer),
  __reducerSchema("propose_civilization", ProposeCivilizationReducer),
  __reducerSchema("propose_ground_peace", ProposeGroundPeaceReducer),
  __reducerSchema("propose_group", ProposeGroupReducer),
  __reducerSchema("propose_guild_bid", ProposeGuildBidReducer),
  __reducerSchema("propose_guild_motion", ProposeGuildMotionReducer),
  __reducerSchema("propose_space_operation", ProposeSpaceOperationReducer),
  __reducerSchema("propose_spend", ProposeSpendReducer),
  __reducerSchema("publish_forge", PublishForgeReducer),
  __reducerSchema("put_chat_translation", PutChatTranslationReducer),
  __reducerSchema("quote_station_repair", QuoteStationRepairReducer),
  __reducerSchema("quote_wreck_recovery", QuoteWreckRecoveryReducer),
  __reducerSchema("race_gate", RaceGateReducer),
  __reducerSchema("raid_ess_bank", RaidEssBankReducer),
  __reducerSchema("raise_voice_hand", RaiseVoiceHandReducer),
  __reducerSchema("rank_hot_feed", RankHotFeedReducer),
  __reducerSchema("rate_world", RateWorldReducer),
  __reducerSchema("read_relay_log", ReadRelayLogReducer),
  __reducerSchema("read_survey_census", ReadSurveyCensusReducer),
  __reducerSchema("rebuild_leaderboard_index", RebuildLeaderboardIndexReducer),
  __reducerSchema("recall_droid", RecallDroidReducer),
  __reducerSchema("recall_ship", RecallShipReducer),
  __reducerSchema("recompute_region_asset_sets", RecomputeRegionAssetSetsReducer),
  __reducerSchema("recompute_reputation_hourly", RecomputeReputationHourlyReducer),
  __reducerSchema("recompute_world_metrics", RecomputeWorldMetricsReducer),
  __reducerSchema("recook_render_asset", RecookRenderAssetReducer),
  __reducerSchema("record_betrayal", RecordBetrayalReducer),
  __reducerSchema("record_embezzlement", RecordEmbezzlementReducer),
  __reducerSchema("record_satisfaction", RecordSatisfactionReducer),
  __reducerSchema("record_sighting", RecordSightingReducer),
  __reducerSchema("record_visit", RecordVisitReducer),
  __reducerSchema("recruit_guild_versona", RecruitGuildVersonaReducer),
  __reducerSchema("redeed_structure", RedeedStructureReducer),
  __reducerSchema("redeem_fleet_tokens", RedeemFleetTokensReducer),
  __reducerSchema("redeem_invite", RedeemInviteReducer),
  __reducerSchema("redeem_loyalty", RedeemLoyaltyReducer),
  __reducerSchema("reel_in", ReelInReducer),
  __reducerSchema("refine_item", RefineItemReducer),
  __reducerSchema("refit_structure_layout", RefitStructureLayoutReducer),
  __reducerSchema("register_arcade_game", RegisterArcadeGameReducer),
  __reducerSchema("register_asset_pack", RegisterAssetPackReducer),
  __reducerSchema("register_render_asset", RegisterRenderAssetReducer),
  __reducerSchema("release_escrow", ReleaseEscrowReducer),
  __reducerSchema("release_guild_structure", ReleaseGuildStructureReducer),
  __reducerSchema("release_merchant_lot", ReleaseMerchantLotReducer),
  __reducerSchema("release_site_lease", ReleaseSiteLeaseReducer),
  __reducerSchema("reload_weapon", ReloadWeaponReducer),
  __reducerSchema("remix_asset", RemixAssetReducer),
  __reducerSchema("remove_bookmark", RemoveBookmarkReducer),
  __reducerSchema("remove_deck_item", RemoveDeckItemReducer),
  __reducerSchema("remove_merchant_listing", RemoveMerchantListingReducer),
  __reducerSchema("remove_structure_item", RemoveStructureItemReducer),
  __reducerSchema("remove_structure_permission", RemoveStructurePermissionReducer),
  __reducerSchema("rename_ship", RenameShipReducer),
  __reducerSchema("rename_waypoint", RenameWaypointReducer),
  __reducerSchema("renew_merchant_lot", RenewMerchantLotReducer),
  __reducerSchema("rent_merchant_lot", RentMerchantLotReducer),
  __reducerSchema("rent_unit", RentUnitReducer),
  __reducerSchema("repair_space_structure", RepairSpaceStructureReducer),
  __reducerSchema("repay_loan", RepayLoanReducer),
  __reducerSchema("report_player", ReportPlayerReducer),
  __reducerSchema("report_ship_damage", ReportShipDamageReducer),
  __reducerSchema("report_world", ReportWorldReducer),
  __reducerSchema("request_chat_translation", RequestChatTranslationReducer),
  __reducerSchema("request_creator_cert", RequestCreatorCertReducer),
  __reducerSchema("request_travel", RequestTravelReducer),
  __reducerSchema("request_voice_ticket", RequestVoiceTicketReducer),
  __reducerSchema("reserve_fab_job", ReserveFabJobReducer),
  __reducerSchema("reset_npc_economy", ResetNpcEconomyReducer),
  __reducerSchema("reset_world_environment", ResetWorldEnvironmentReducer),
  __reducerSchema("reset_world_rules", ResetWorldRulesReducer),
  __reducerSchema("resolve_deliberation", ResolveDeliberationReducer),
  __reducerSchema("resolve_fork", ResolveForkReducer),
  __reducerSchema("resolve_structure_model", ResolveStructureModelReducer),
  __reducerSchema("rest_on_bed", RestOnBedReducer),
  __reducerSchema("restore_subsystems_at_dock", RestoreSubsystemsAtDockReducer),
  __reducerSchema("resupply_at_depot", ResupplyAtDepotReducer),
  __reducerSchema("return_from_travel", ReturnFromTravelReducer),
  __reducerSchema("reveal_the_lie", RevealTheLieReducer),
  __reducerSchema("reverse_engineer_item", ReverseEngineerItemReducer),
  __reducerSchema("reverse_engineer_ship", ReverseEngineerShipReducer),
  __reducerSchema("revoke_invite", RevokeInviteReducer),
  __reducerSchema("revoke_voice_sfu_role", RevokeVoiceSfuRoleReducer),
  __reducerSchema("revoke_vouch", RevokeVouchReducer),
  __reducerSchema("rez_catalog_part", RezCatalogPartReducer),
  __reducerSchema("rez_in_world", RezInWorldReducer),
  __reducerSchema("rez_object", RezObjectReducer),
  __reducerSchema("rez_part", RezPartReducer),
  __reducerSchema("rez_uploaded_part", RezUploadedPartReducer),
  __reducerSchema("rollback_forge", RollbackForgeReducer),
  __reducerSchema("rollover_arcade_season", RolloverArcadeSeasonReducer),
  __reducerSchema("rollover_season", RolloverSeasonReducer),
  __reducerSchema("rotate_compass", RotateCompassReducer),
  __reducerSchema("rotate_structure_item", RotateStructureItemReducer),
  __reducerSchema("run_compile_job", RunCompileJobReducer),
  __reducerSchema("run_contract_tick", RunContractTickReducer),
  __reducerSchema("run_exploit_canon", RunExploitCanonReducer),
  __reducerSchema("run_for_guild_office", RunForGuildOfficeReducer),
  __reducerSchema("sample_resource", SampleResourceReducer),
  __reducerSchema("say_to_versona", SayToVersonaReducer),
  __reducerSchema("scan_ping", ScanPingReducer),
  __reducerSchema("scoop_space_structure", ScoopSpaceStructureReducer),
  __reducerSchema("scrap_ship", ScrapShipReducer),
  __reducerSchema("seat_council", SeatCouncilReducer),
  __reducerSchema("seed_commons_environment", SeedCommonsEnvironmentReducer),
  __reducerSchema("seed_commons_settlements", SeedCommonsSettlementsReducer),
  __reducerSchema("seed_link_secret", SeedLinkSecretReducer),
  __reducerSchema("seed_npc_agents", SeedNpcAgentsReducer),
  __reducerSchema("sell_resource_to_town", SellResourceToTownReducer),
  __reducerSchema("send_chat", SendChatReducer),
  __reducerSchema("send_fleet_chat", SendFleetChatReducer),
  __reducerSchema("send_local_chat", SendLocalChatReducer),
  __reducerSchema("send_party_message", SendPartyMessageReducer),
  __reducerSchema("send_party_ping", SendPartyPingReducer),
  __reducerSchema("send_standing_invites", SendStandingInvitesReducer),
  __reducerSchema("send_voice_signal", SendVoiceSignalReducer),
  __reducerSchema("send_wave", SendWaveReducer),
  __reducerSchema("send_whisper", SendWhisperReducer),
  __reducerSchema("serve_post_request", ServePostRequestReducer),
  __reducerSchema("set_active_ship", SetActiveShipReducer),
  __reducerSchema("set_arcade_jurisdiction", SetArcadeJurisdictionReducer),
  __reducerSchema("set_asset_collider", SetAssetColliderReducer),
  __reducerSchema("set_avatar", SetAvatarReducer),
  __reducerSchema("set_cast_shadow", SetCastShadowReducer),
  __reducerSchema("set_chat_language", SetChatLanguageReducer),
  __reducerSchema("set_city_bank_terms", SetCityBankTermsReducer),
  __reducerSchema("set_city_coin_tax", SetCityCoinTaxReducer),
  __reducerSchema("set_city_tax", SetCityTaxReducer),
  __reducerSchema("set_civ_building_tradition", SetCivBuildingTraditionReducer),
  __reducerSchema("set_civ_tithe", SetCivTitheReducer),
  __reducerSchema("set_compass_public", SetCompassPublicReducer),
  __reducerSchema("set_contract_budget", SetContractBudgetReducer),
  __reducerSchema("set_device_tier", SetDeviceTierReducer),
  __reducerSchema("set_discovery_prefs", SetDiscoveryPrefsReducer),
  __reducerSchema("set_expedition_public", SetExpeditionPublicReducer),
  __reducerSchema("set_fidelity_tier", SetFidelityTierReducer),
  __reducerSchema("set_forge_monetization", SetForgeMonetizationReducer),
  __reducerSchema("set_forge_script", SetForgeScriptReducer),
  __reducerSchema("set_governance", SetGovernanceReducer),
  __reducerSchema("set_group_srp", SetGroupSrpReducer),
  __reducerSchema("set_guard", SetGuardReducer),
  __reducerSchema("set_guild_motd", SetGuildMotdReducer),
  __reducerSchema("set_interior_marker", SetInteriorMarkerReducer),
  __reducerSchema("set_lifecycle", SetLifecycleReducer),
  __reducerSchema("set_loan_autopay", SetLoanAutopayReducer),
  __reducerSchema("set_merchant_listing", SetMerchantListingReducer),
  __reducerSchema("set_need_satisfier", SetNeedSatisfierReducer),
  __reducerSchema("set_no_build_zone", SetNoBuildZoneReducer),
  __reducerSchema("set_npc_script", SetNpcScriptReducer),
  __reducerSchema("set_pilot_faction", SetPilotFactionReducer),
  __reducerSchema("set_platform_flag", SetPlatformFlagReducer),
  __reducerSchema("set_prefab_model", SetPrefabModelReducer),
  __reducerSchema("set_prefer_instanced", SetPreferInstancedReducer),
  __reducerSchema("set_pulse_visibility", SetPulseVisibilityReducer),
  __reducerSchema("set_region_asset_set", SetRegionAssetSetReducer),
  __reducerSchema("set_render_asset_status", SetRenderAssetStatusReducer),
  __reducerSchema("set_session_state", SetSessionStateReducer),
  __reducerSchema("set_settlement_name", SetSettlementNameReducer),
  __reducerSchema("set_sky_lighting_profile", SetSkyLightingProfileReducer),
  __reducerSchema("set_specialization", SetSpecializationReducer),
  __reducerSchema("set_structure_entry", SetStructureEntryReducer),
  __reducerSchema("set_structure_name", SetStructureNameReducer),
  __reducerSchema("set_structure_permission", SetStructurePermissionReducer),
  __reducerSchema("set_subsystem_aim", SetSubsystemAimReducer),
  __reducerSchema("set_terrain_region", SetTerrainRegionReducer),
  __reducerSchema("set_tier", SetTierReducer),
  __reducerSchema("set_upload_status", SetUploadStatusReducer),
  __reducerSchema("set_validation_limits", SetValidationLimitsReducer),
  __reducerSchema("set_versona_bias", SetVersonaBiasReducer),
  __reducerSchema("set_versona_goal", SetVersonaGoalReducer),
  __reducerSchema("set_versona_profile", SetVersonaProfileReducer),
  __reducerSchema("set_voice_role", SetVoiceRoleReducer),
  __reducerSchema("set_voice_room", SetVoiceRoomReducer),
  __reducerSchema("set_voice_server_mute", SetVoiceServerMuteReducer),
  __reducerSchema("set_weather", SetWeatherReducer),
  __reducerSchema("set_weather_profile", SetWeatherProfileReducer),
  __reducerSchema("set_world_environment", SetWorldEnvironmentReducer),
  __reducerSchema("set_world_preset", SetWorldPresetReducer),
  __reducerSchema("set_world_role", SetWorldRoleReducer),
  __reducerSchema("set_world_rules", SetWorldRulesReducer),
  __reducerSchema("set_world_script", SetWorldScriptReducer),
  __reducerSchema("set_world_visibility", SetWorldVisibilityReducer),
  __reducerSchema("settle_daily", SettleDailyReducer),
  __reducerSchema("settle_merchant_hold", SettleMerchantHoldReducer),
  __reducerSchema("ship_repair_beat", ShipRepairBeatReducer),
  __reducerSchema("ship_set_power", ShipSetPowerReducer),
  __reducerSchema("ship_strike_creature", ShipStrikeCreatureReducer),
  __reducerSchema("shoot_bounty_hunter", ShootBountyHunterReducer),
  __reducerSchema("shoot_war_air_unit", ShootWarAirUnitReducer),
  __reducerSchema("shuttle_travel", ShuttleTravelReducer),
  __reducerSchema("sign_charter", SignCharterReducer),
  __reducerSchema("sign_guestbook", SignGuestbookReducer),
  __reducerSchema("sign_recall_petition", SignRecallPetitionReducer),
  __reducerSchema("sign_war_petition", SignWarPetitionReducer),
  __reducerSchema("sky_ship_lift", SkyShipLiftReducer),
  __reducerSchema("slot_rig_core", SlotRigCoreReducer),
  __reducerSchema("space_eject", SpaceEjectReducer),
  __reducerSchema("space_hit", SpaceHitReducer),
  __reducerSchema("space_kill", SpaceKillReducer),
  __reducerSchema("space_market_buy", SpaceMarketBuyReducer),
  __reducerSchema("space_market_sell", SpaceMarketSellReducer),
  __reducerSchema("space_mine", SpaceMineReducer),
  __reducerSchema("space_move", SpaceMoveReducer),
  __reducerSchema("space_presence_ping", SpacePresencePingReducer),
  __reducerSchema("space_pvp_strike", SpacePvpStrikeReducer),
  __reducerSchema("space_refine", SpaceRefineReducer),
  __reducerSchema("space_repair", SpaceRepairReducer),
  __reducerSchema("space_salvage", SpaceSalvageReducer),
  __reducerSchema("space_scan_loot", SpaceScanLootReducer),
  __reducerSchema("space_ship_destroyed", SpaceShipDestroyedReducer),
  __reducerSchema("space_strip_wreck", SpaceStripWreckReducer),
  __reducerSchema("spawn_versona", SpawnVersonaReducer),
  __reducerSchema("spawn_world", SpawnWorldReducer),
  __reducerSchema("spread_rumor", SpreadRumorReducer),
  __reducerSchema("spread_settlement_life", SpreadSettlementLifeReducer),
  __reducerSchema("stamp_structure_layout", StampStructureLayoutReducer),
  __reducerSchema("start_rental", StartRentalReducer),
  __reducerSchema("start_ship_repair", StartShipRepairReducer),
  __reducerSchema("store_item", StoreItemReducer),
  __reducerSchema("store_rental_item", StoreRentalItemReducer),
  __reducerSchema("store_rental_stack", StoreRentalStackReducer),
  __reducerSchema("store_stack", StoreStackReducer),
  __reducerSchema("strike_bounty_hunter", StrikeBountyHunterReducer),
  __reducerSchema("strike_camp", StrikeCampReducer),
  __reducerSchema("strike_creature", StrikeCreatureReducer),
  __reducerSchema("strike_line", StrikeLineReducer),
  __reducerSchema("strike_player", StrikePlayerReducer),
  __reducerSchema("strike_versona", StrikeVersonaReducer),
  __reducerSchema("submit_for_moderation", SubmitForModerationReducer),
  __reducerSchema("submit_intent", SubmitIntentReducer),
  __reducerSchema("submit_match_result", SubmitMatchResultReducer),
  __reducerSchema("submit_review", SubmitReviewReducer),
  __reducerSchema("subscribe", SubscribeReducer),
  __reducerSchema("suggest_beginner_mixers", SuggestBeginnerMixersReducer),
  __reducerSchema("surrender_ground_war", SurrenderGroundWarReducer),
  __reducerSchema("surrender_guild_war", SurrenderGuildWarReducer),
  __reducerSchema("survey_work", SurveyWorkReducer),
  __reducerSchema("swap_weapon", SwapWeaponReducer),
  __reducerSchema("sync_interior_occupant", SyncInteriorOccupantReducer),
  __reducerSchema("tackle_pilot", TacklePilotReducer),
  __reducerSchema("take_duty_mission", TakeDutyMissionReducer),
  __reducerSchema("take_ground_contract", TakeGroundContractReducer),
  __reducerSchema("take_item", TakeItemReducer),
  __reducerSchema("take_mission", TakeMissionReducer),
  __reducerSchema("take_player_bounty", TakePlayerBountyReducer),
  __reducerSchema("take_rental_item", TakeRentalItemReducer),
  __reducerSchema("take_rental_stack", TakeRentalStackReducer),
  __reducerSchema("take_service_post", TakeServicePostReducer),
  __reducerSchema("take_stack", TakeStackReducer),
  __reducerSchema("take_war_supply", TakeWarSupplyReducer),
  __reducerSchema("tally_guild_election", TallyGuildElectionReducer),
  __reducerSchema("terrain_edit_clear", TerrainEditClearReducer),
  __reducerSchema("terrain_edit_undo", TerrainEditUndoReducer),
  __reducerSchema("terrain_sculpt", TerrainSculptReducer),
  __reducerSchema("tick_chronicler", TickChroniclerReducer),
  __reducerSchema("tick_city_update", TickCityUpdateReducer),
  __reducerSchema("tick_droids", TickDroidsReducer),
  __reducerSchema("tick_guarded", TickGuardedReducer),
  __reducerSchema("tick_sky", TickSkyReducer),
  __reducerSchema("tick_structure_maintenance", TickStructureMaintenanceReducer),
  __reducerSchema("tick_versona_ai", TickVersonaAiReducer),
  __reducerSchema("tick_versona_travel", TickVersonaTravelReducer),
  __reducerSchema("tip", TipReducer),
  __reducerSchema("top_up_settlement_life", TopUpSettlementLifeReducer),
  __reducerSchema("trace_player_bounty", TracePlayerBountyReducer),
  __reducerSchema("trade_cancel", TradeCancelReducer),
  __reducerSchema("trade_confirm", TradeConfirmReducer),
  __reducerSchema("trade_offer", TradeOfferReducer),
  __reducerSchema("trade_request", TradeRequestReducer),
  __reducerSchema("trade_respond", TradeRespondReducer),
  __reducerSchema("train_skill", TrainSkillReducer),
  __reducerSchema("transfer_item", TransferItemReducer),
  __reducerSchema("travel_to_merchant_hive", TravelToMerchantHiveReducer),
  __reducerSchema("tune_extractor", TuneExtractorReducer),
  __reducerSchema("unblock_player", UnblockPlayerReducer),
  __reducerSchema("undo_world_edit", UndoWorldEditReducer),
  __reducerSchema("undock", UndockReducer),
  __reducerSchema("unequip_item", UnequipItemReducer),
  __reducerSchema("unequip_ship_component", UnequipShipComponentReducer),
  __reducerSchema("unlink_parts", UnlinkPartsReducer),
  __reducerSchema("unlist_rental_unit", UnlistRentalUnitReducer),
  __reducerSchema("unload_cargo", UnloadCargoReducer),
  __reducerSchema("unlock_arcade_tab", UnlockArcadeTabReducer),
  __reducerSchema("unstick_nudge", UnstickNudgeReducer),
  __reducerSchema("unstick_rescue", UnstickRescueReducer),
  __reducerSchema("update_forge_instance", UpdateForgeInstanceReducer),
  __reducerSchema("update_leaderboard", UpdateLeaderboardReducer),
  __reducerSchema("update_ratings", UpdateRatingsReducer),
  __reducerSchema("use_device", UseDeviceReducer),
  __reducerSchema("use_item", UseItemReducer),
  __reducerSchema("use_rollback_token", UseRollbackTokenReducer),
  __reducerSchema("vehicle_move", VehicleMoveReducer),
  __reducerSchema("verify_match", VerifyMatchReducer),
  __reducerSchema("versona_say", VersonaSayReducer),
  __reducerSchema("voice_sfu_admit", VoiceSfuAdmitReducer),
  __reducerSchema("voice_sfu_beat", VoiceSfuBeatReducer),
  __reducerSchema("voice_sfu_connected", VoiceSfuConnectedReducer),
  __reducerSchema("voice_sfu_disconnected", VoiceSfuDisconnectedReducer),
  __reducerSchema("voice_sfu_hello", VoiceSfuHelloReducer),
  __reducerSchema("voice_sfu_reset", VoiceSfuResetReducer),
  __reducerSchema("voice_sfu_roster", VoiceSfuRosterReducer),
  __reducerSchema("vote_fork", VoteForkReducer),
  __reducerSchema("vote_guild_motion", VoteGuildMotionReducer),
  __reducerSchema("vote_mayor", VoteMayorReducer),
  __reducerSchema("vote_spend", VoteSpendReducer),
  __reducerSchema("vouch_for", VouchForReducer),
  __reducerSchema("war_contribution", WarContributionReducer),
  __reducerSchema("war_shot", WarShotReducer),
  __reducerSchema("warm_by_fire", WarmByFireReducer),
  __reducerSchema("warp_to_world", WarpToWorldReducer),
  __reducerSchema("wilds_tick", WildsTickReducer),
  __reducerSchema("withdraw_federal_preference", WithdrawFederalPreferenceReducer),
  __reducerSchema("withdraw_guild_approval", WithdrawGuildApprovalReducer),
  __reducerSchema("withdraw_intel_offer", WithdrawIntelOfferReducer),
  __reducerSchema("witness_civic_event", WitnessCivicEventReducer),
  __reducerSchema("wormhole_jump", WormholeJumpReducer),
  __reducerSchema("xr_teleport", XrTeleportReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
);

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "2.7.1" as const,
  },
  tables: tablesSchema.schemaType.tables,
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  typeof tablesSchema.schemaType,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

/** The tables available in this remote SpacetimeDB module. Each table reference doubles as a query builder. */
export const tables: __QueryBuilder<typeof tablesSchema.schemaType> = __makeQueryBuilder(tablesSchema.schemaType);

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The procedures available in this remote SpacetimeDB module. */
export const procedures = __convertToAccessorMap(proceduresSchema.procedures);

/** The context type returned in callbacks for all possible events. */
export type EventContext = __EventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = __ReducerEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = __SubscriptionEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for error events. */
export type ErrorContext = __ErrorContextInterface<typeof REMOTE_MODULE>;
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

